import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Float64: { input: any; output: any; }
  Int64: { input: any; output: any; }
  Map: { input: any; output: any; }
  QuestionContent: { input: any; output: any; }
  Time: { input: string; output: string; }
  ULID: { input: string; output: string; }
  URL: { input: any; output: any; }
  Uint: { input: any; output: any; }
  Uint32: { input: any; output: any; }
  Uint64: { input: number; output: number; }
  Upload: { input: File; output: File; }
};

export type AbTestDelivery = {
  __typename?: 'AbTestDelivery';
  abTestDeliveryDetails: Array<AbTestDeliveryDetail>;
  deviceType: DeviceType;
  /** 指定日の23時59分59秒 */
  endDate: Scalars['Time']['output'];
  originURL: Scalars['URL']['output'];
  /** 指定日の0時 */
  startDate: Scalars['Time']['output'];
  /** リダイレクトされない比率も含めた全配信比率の合計 */
  totalRate: Scalars['Int']['output'];
};

export type AbTestDeliveryDetail = {
  __typename?: 'AbTestDeliveryDetail';
  deliveryRate: Scalars['Int']['output'];
  deliveryURL: Scalars['URL']['output'];
};

export type AbTestSetting = {
  __typename?: 'AbTestSetting';
  abTestSettingDevices: Array<AbTestSettingDevice>;
  createdAt: Scalars['Time']['output'];
  /** 指定日の23時59分59秒 */
  endDate: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  note: Scalars['String']['output'];
  originURL: Scalars['URL']['output'];
  /** 指定日の0時 */
  startDate: Scalars['Time']['output'];
  status: Valid;
  targetDeviceType: TargetDeviceType;
  updatedAt: Scalars['Time']['output'];
};

export type AbTestSettingDevice = {
  __typename?: 'AbTestSettingDevice';
  abTestSettingDeviceDestinations: Array<AbTestSettingDeviceDestination>;
  abTestSettingID: Scalars['ULID']['output'];
  createdAt: Scalars['Time']['output'];
  deviceType: DeviceType;
  id: Scalars['ULID']['output'];
  originRate: Scalars['Uint']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type AbTestSettingDeviceDestination = {
  __typename?: 'AbTestSettingDeviceDestination';
  abTestSettingDeviceID: Scalars['ULID']['output'];
  createdAt: Scalars['Time']['output'];
  destinationRate: Scalars['Uint']['output'];
  destinationURL: Scalars['URL']['output'];
  id: Scalars['ULID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type Admin = {
  __typename?: 'Admin';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  status: Valid;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['Uint64']['output'];
};

export type AdminAbTestSettingDeviceDestinationInput = {
  destinationRate: Scalars['Uint']['input'];
  destinationURL: Scalars['URL']['input'];
};

export type AdminAbTestSettingDeviceInput = {
  abTestSettingDeviceDestinationInputs: Array<AdminAbTestSettingDeviceDestinationInput>;
  deviceType: DeviceType;
  originRate: Scalars['Uint']['input'];
};

export type AdminAbTestSettingInput = {
  abTestSettingDeviceInputs: Array<AdminAbTestSettingDeviceInput>;
  endDate: Scalars['Time']['input'];
  note: Scalars['String']['input'];
  originURL: Scalars['URL']['input'];
  startDate: Scalars['Time']['input'];
  status: Valid;
  targetDeviceType: TargetDeviceType;
};

export type AdminAbTestSettingSearchInput = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type AdminAbTestSettingSearchResponse = {
  __typename?: 'AdminAbTestSettingSearchResponse';
  items: Array<AbTestSetting>;
  total: Scalars['Int64']['output'];
};

export type AdminAssignLogSearchInput = {
  courseID?: InputMaybe<Scalars['Uint64']['input']>;
  id?: InputMaybe<Scalars['Uint64']['input']>;
  instructorID?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

/** バナーCID-Admin-登録・編集パラメーター */
export type AdminBannerCidInput = {
  bannerID: Scalars['Uint64']['input'];
  cid: Scalars['String']['input'];
  deviceType: BannerCidDeviceType;
  status: Valid;
  type: BannerCidType;
};

/** バナーCID-Admin-検索パラメーター */
export type AdminBannerCidSearchInput = {
  bannerID?: InputMaybe<Scalars['Uint64']['input']>;
  cid?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<BannerCidDeviceType>;
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  status?: InputMaybe<Valid>;
  type?: InputMaybe<BannerCidType>;
};

export type AdminBannerCidSearchResponse = {
  __typename?: 'AdminBannerCidSearchResponse';
  items: Array<BannerCid>;
  total: Scalars['Uint64']['output'];
};

/** バナー-Admin-登録・編集パラメーター */
export type AdminBannerInput = {
  imageURL: Scalars['String']['input'];
  isNotLoginUser: Scalars['Boolean']['input'];
  isTargetFree: Scalars['Boolean']['input'];
  isTargetGraduate: Scalars['Boolean']['input'];
  isTargetInstructor: Scalars['Boolean']['input'];
  isTargetStudent: Scalars['Boolean']['input'];
  isTargetSubscriptionUser: Scalars['Boolean']['input'];
  isTargetTeamUser: Scalars['Boolean']['input'];
  link: Scalars['String']['input'];
  sort: Scalars['Uint64']['input'];
  status: Valid;
  title: Scalars['String']['input'];
};

/** バナー-Admin-検索パラメーター */
export type AdminBannerSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  imageURL?: InputMaybe<Scalars['String']['input']>;
  isNotLoginUser?: InputMaybe<Scalars['Boolean']['input']>;
  isTargetFree?: InputMaybe<Scalars['Boolean']['input']>;
  isTargetGraduate?: InputMaybe<Scalars['Boolean']['input']>;
  isTargetInstructor?: InputMaybe<Scalars['Boolean']['input']>;
  isTargetStudent?: InputMaybe<Scalars['Boolean']['input']>;
  isTargetSubscriptionUser?: InputMaybe<Scalars['Boolean']['input']>;
  isTargetTeamUser?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Uint64']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Uint64']['input'];
  sort?: InputMaybe<Scalars['Uint64']['input']>;
  status?: InputMaybe<Valid>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminBannerSearchResponse = {
  __typename?: 'AdminBannerSearchResponse';
  items: Array<Banner>;
  total: Scalars['Uint64']['output'];
};

/** キャンペーン-Admin-検索パラメーター */
export type AdminCampaignSearchInput = {
  date?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  status?: InputMaybe<Valid>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminChapter = {
  __typename?: 'AdminChapter';
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Uint64']['output'];
  key: Scalars['String']['output'];
  number: Scalars['Uint64']['output'];
  programElement: ProgramElement;
  qaKey?: Maybe<Scalars['String']['output']>;
  requireTime: Scalars['Uint64']['output'];
  /** 管理画面用 */
  sortNumber?: Maybe<Scalars['Int64']['output']>;
  status: Valid;
  title: Scalars['String']['output'];
  type: AuthorizationType;
  updatedAt: Scalars['Time']['output'];
};

export type AdminChapterInput = {
  content: Scalars['String']['input'];
  description: Scalars['String']['input'];
  key: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int64']['input']>;
  programID: Scalars['Uint64']['input'];
  qaKey?: InputMaybe<Scalars['String']['input']>;
  requireTime: Scalars['Uint64']['input'];
  sortNumber?: InputMaybe<Scalars['Int64']['input']>;
  status?: InputMaybe<Valid>;
  title: Scalars['String']['input'];
  type: AuthorizationType;
};

export type AdminChapterSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  programID?: InputMaybe<Scalars['Uint64']['input']>;
  qaKey?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Valid>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthorizationType>;
};

export type AdminChapterSearchResponse = {
  __typename?: 'AdminChapterSearchResponse';
  items: Array<AdminChapter>;
  total: Scalars['Uint64']['output'];
};

export type AdminChatMessageInput = {
  content: Scalars['String']['input'];
  status: Valid;
};

export type AdminChatMessageResponse = {
  __typename?: 'AdminChatMessageResponse';
  items: Array<ChatMessage>;
  total: Scalars['Int64']['output'];
};

export type AdminChatMessageSearchInput = {
  chatRoomID?: InputMaybe<Scalars['Uint64']['input']>;
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  periodEnd?: InputMaybe<Scalars['Time']['input']>;
  periodStart?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Valid>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminChatRoomCreateInput = {
  status: Valid;
  title: Scalars['String']['input'];
  users?: InputMaybe<Array<Scalars['Uint64']['input']>>;
};

export type AdminChatRoomInput = {
  id: Scalars['Uint64']['input'];
  status: Valid;
  title: Scalars['String']['input'];
  users?: InputMaybe<Array<Scalars['Uint64']['input']>>;
};

export type AdminChatRoomSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  status?: InputMaybe<Valid>;
  studentID?: InputMaybe<Scalars['Uint64']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminChatRoomsResponse = {
  __typename?: 'AdminChatRoomsResponse';
  items: Array<ChatRoom>;
  total: Scalars['Int64']['output'];
};

export type AdminClaimCreateInput = {
  adminClaimInput: AdminClaimInput;
  instructorID: Scalars['Uint64']['input'];
};

export type AdminClaimDetailInput = {
  additionalPayment?: InputMaybe<Scalars['Uint64']['input']>;
  amount: Scalars['Uint64']['input'];
  claimCategoryID: Scalars['Uint64']['input'];
  claimID: Scalars['Uint64']['input'];
  courseID?: InputMaybe<Scalars['Uint64']['input']>;
  date: Scalars['Time']['input'];
  lessonID?: InputMaybe<Scalars['Uint64']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  spotLessonID?: InputMaybe<Scalars['Uint64']['input']>;
  status: Valid;
  unitPrice: Scalars['Uint64']['input'];
};

export type AdminClaimDetailSearchInput = {
  applyStatus?: InputMaybe<ClaimApplyStatus>;
  claimCategoryID?: InputMaybe<Scalars['Uint64']['input']>;
  claimID?: InputMaybe<Scalars['Uint64']['input']>;
  courseID?: InputMaybe<Scalars['Uint64']['input']>;
  id?: InputMaybe<Scalars['Uint64']['input']>;
  instructorID?: InputMaybe<Scalars['Uint64']['input']>;
  lessonID?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  month?: InputMaybe<Scalars['Time']['input']>;
  page: Scalars['Int']['input'];
  spotLessonID?: InputMaybe<Scalars['Uint64']['input']>;
  status?: InputMaybe<Valid>;
};

export type AdminClaimInput = {
  appliedAt?: InputMaybe<Scalars['Time']['input']>;
  applyStatus: ClaimApplyStatus;
  month: Scalars['Time']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  status: Valid;
};

export type AdminClaimSearchInput = {
  appliedAt?: InputMaybe<Scalars['Time']['input']>;
  applyStatus?: InputMaybe<ClaimApplyStatus>;
  id?: InputMaybe<Scalars['Uint64']['input']>;
  instructorID?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  month?: InputMaybe<Scalars['Time']['input']>;
  page: Scalars['Int']['input'];
  status?: InputMaybe<Valid>;
};

export type AdminCoachingSearchInput = {
  coachID?: InputMaybe<Scalars['Uint64']['input']>;
  courseID?: InputMaybe<Scalars['Uint64']['input']>;
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type AdminCourseInput = {
  careerSupport?: InputMaybe<Scalars['Uint64']['input']>;
  contractType?: InputMaybe<Scalars['Uint64']['input']>;
  curriculum?: InputMaybe<Scalars['String']['input']>;
  customerAcquisition?: InputMaybe<Scalars['Uint64']['input']>;
  /** 受講生のメモ */
  instructorMemo: Scalars['String']['input'];
  job?: InputMaybe<Scalars['String']['input']>;
  jobChange?: InputMaybe<Scalars['Uint64']['input']>;
  lessonPlace?: InputMaybe<Scalars['String']['input']>;
  lessonType: CourseLessonType;
  objective?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminCourseProgramInput = {
  content: Scalars['String']['input'];
  description: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['Uint64']['input'];
  overview: Scalars['String']['input'];
  status: Valid;
  title: Scalars['String']['input'];
};

export type AdminCourseProgramSearchInput = {
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  status?: InputMaybe<Valid>;
};

export type AdminCourseProgramStepInput = {
  courseProgramID: Scalars['ULID']['input'];
  courseProgramStepItems: Array<AdminCourseProgramStepItemInput>;
  description: Scalars['String']['input'];
  number: Scalars['Uint64']['input'];
  status: Valid;
  title: Scalars['String']['input'];
};

export type AdminCourseProgramStepItemInput = {
  number: Scalars['Uint64']['input'];
  programID: Scalars['Uint64']['input'];
};

export type AdminCourseProgramStepSearchInput = {
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  status?: InputMaybe<Valid>;
};

export type AdminCourseSearchInput = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['Uint64']['input']>;
  instructorID?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  planID?: InputMaybe<Scalars['Uint64']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['Uint64']['input']>;
  studentID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminCreateInput = {
  email: Scalars['String']['input'];
  image: Scalars['Upload']['input'];
  kanaName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nickName?: InputMaybe<Scalars['String']['input']>;
  skypeID?: InputMaybe<Scalars['String']['input']>;
};

export type AdminInstructorInput = {
  firstKanaName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  googleMeetURL: Scalars['String']['input'];
  lastKanaName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  zoomUserID: Scalars['String']['input'];
};

export type AdminInstructorScheduleInput = {
  endAt: Scalars['Time']['input'];
  startAt: Scalars['Time']['input'];
  userID: Scalars['Uint64']['input'];
};

export type AdminInstructorScheduleSearchInput = {
  endAt?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  startAt?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Valid>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminInstructorSearchInput = {
  confirmChannelID?: InputMaybe<Scalars['String']['input']>;
  googleMeetURL?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  /** 姓・名・姓カナ、名カナのいずれかで検索 */
  name?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  scInstructorID?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Uint64']['input']>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
  zoomUserID?: InputMaybe<Scalars['String']['input']>;
};

export type AdminInvoiceItemSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  invoiceID?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  priceID?: InputMaybe<Scalars['Uint64']['input']>;
  status?: InputMaybe<Valid>;
};

/** Invoice-Admin-請求検索パラメーター */
export type AdminInvoiceSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  providerInvoiceID?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminLessonInput = {
  assistanceDetail: Scalars['String']['input'];
  completed: Scalars['Uint64']['input'];
  courseID: Scalars['Uint64']['input'];
  delayReason: Scalars['String']['input'];
  endAt: Scalars['Time']['input'];
  homework: Scalars['String']['input'];
  instructorAssistance: Array<Scalars['Uint64']['input']>;
  instructorID: Scalars['Uint64']['input'];
  lessonsAssistances: Array<Scalars['Uint64']['input']>;
  phase: Scalars['Uint64']['input'];
  prepare: Scalars['String']['input'];
  progress: Scalars['Uint64']['input'];
  startAt: Scalars['Time']['input'];
  studentAssistance: Array<Scalars['Uint64']['input']>;
  taughtSkill: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: Scalars['Uint64']['input'];
};

export type AdminLessonSearchInput = {
  canceled?: InputMaybe<Bool>;
  completed?: InputMaybe<Bool>;
  courseID?: InputMaybe<Scalars['Uint64']['input']>;
  endAt?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['Uint64']['input']>;
  instructorID?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  phase?: InputMaybe<Scalars['Uint64']['input']>;
  startAt?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Valid>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['Uint64']['input']>;
};

/** Admin-メール設定更新パラメーター */
export type AdminMailSettingInput = {
  attendanceStatusChanged: Valid;
  backSchool: Valid;
  claimApplied: Valid;
  lessonLogUnregistered: Valid;
  lessonRegistered: Valid;
  lessonRemind: Valid;
  lessonScheduleUpdated: Valid;
  lessonUnregistered: Valid;
  messageReceived: Valid;
  notice: Valid;
  practiceSubmitDetailReviewCommentRegistered: Valid;
  practiceSubmitReRegistered: Valid;
  practiceSubmitRegistered: Valid;
  questionAnswerRegistered: Valid;
  questionCommentRegistered: Valid;
  questionRegistered: Valid;
  sessionRemind: Valid;
  spotLessonCancel: Valid;
  spotLessonLogUnregistered: Valid;
  spotLessonRegistered: Valid;
  spotLessonRemind: Valid;
  studyReportAchieved: Valid;
  studyReportCommentRegistered: Valid;
  ticketRemind: Valid;
};

/** Admin-メール設定検索パラメーター */
export type AdminMailSettingSearchInput = {
  attendanceStatusChanged?: InputMaybe<Valid>;
  backSchool?: InputMaybe<Valid>;
  claimApplied?: InputMaybe<Valid>;
  id?: InputMaybe<Scalars['Uint64']['input']>;
  lessonLogUnregistered?: InputMaybe<Valid>;
  lessonRegistered?: InputMaybe<Valid>;
  lessonRemind?: InputMaybe<Valid>;
  lessonScheduleUpdated?: InputMaybe<Valid>;
  lessonUnregistered?: InputMaybe<Valid>;
  limit: Scalars['Uint64']['input'];
  messageReceived?: InputMaybe<Valid>;
  notice?: InputMaybe<Valid>;
  page: Scalars['Uint64']['input'];
  practiceSubmitDetailReviewCommentRegistered?: InputMaybe<Valid>;
  practiceSubmitReRegistered?: InputMaybe<Valid>;
  practiceSubmitRegistered?: InputMaybe<Valid>;
  questionAnswerRegistered?: InputMaybe<Valid>;
  questionCommentRegistered?: InputMaybe<Valid>;
  questionRegistered?: InputMaybe<Valid>;
  sessionRemind?: InputMaybe<Valid>;
  spotLessonCancel?: InputMaybe<Valid>;
  spotLessonLogUnregistered?: InputMaybe<Valid>;
  spotLessonRegistered?: InputMaybe<Valid>;
  spotLessonRemind?: InputMaybe<Valid>;
  studyReportAchieved?: InputMaybe<Valid>;
  studyReportCommentRegistered?: InputMaybe<Valid>;
  ticketRemind?: InputMaybe<Valid>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

/** アナウンス-Admin-登録・編集パラメーター */
export type AdminNoticeInput = {
  content: Scalars['String']['input'];
  /** メールを送る */
  sendMail: Scalars['Boolean']['input'];
  status: Valid;
  title: Scalars['String']['input'];
  userRoles: Array<UserRole>;
};

/** アナウンス-Admin-一覧検索パラメーター */
export type AdminNoticeSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  notified?: InputMaybe<NoticeNotified>;
  page: Scalars['Uint64']['input'];
  status?: InputMaybe<Valid>;
  title?: InputMaybe<Scalars['String']['input']>;
  userRole?: InputMaybe<UserRole>;
};

/** PaymentIntent-Admin-課金履歴検索パラメーター */
export type AdminPaymentIntentSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  providerPaymentIntentID?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Valid>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminPaymentMethodSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  isAvailable?: InputMaybe<Bool>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  providerPaymentMethodID?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Valid>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminPlanInput = {
  isExtension: Bool;
  isFlexibleCurriculum: Bool;
  isLessonPreparationAllowed: Bool;
  isQuestionAllowed: Bool;
  lessonMinutes?: InputMaybe<Scalars['Uint64']['input']>;
  name: Scalars['String']['input'];
  status: Valid;
};

export type AdminPlanSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  isExtension?: InputMaybe<Bool>;
  isFlexibleCurriculum?: InputMaybe<Bool>;
  isLessonPreparationAllowed?: InputMaybe<Bool>;
  isQuestionAllowed?: InputMaybe<Bool>;
  lessonMinutes?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  status?: InputMaybe<Valid>;
};

export type AdminPractice = {
  __typename?: 'AdminPractice';
  answer?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  difficulty: PracticeDifficulty;
  id: Scalars['ULID']['output'];
  isAiReviewEnabled: Scalars['Boolean']['output'];
  isSubmittable: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  programID: Scalars['Uint64']['output'];
  requireTime: Scalars['Int64']['output'];
  /** 管理画面用 */
  sortNumber?: Maybe<Scalars['Int64']['output']>;
  status: Valid;
  title: Scalars['String']['output'];
  type: AuthorizationType;
  updatedAt: Scalars['Time']['output'];
};

export type AdminPracticeInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  difficulty: PracticeDifficulty;
  isAiReviewEnabled: Scalars['Boolean']['input'];
  isSubmittable: Scalars['Boolean']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  programID: Scalars['Uint64']['input'];
  requireTime: Scalars['Int64']['input'];
  sortNumber?: InputMaybe<Scalars['Int64']['input']>;
  status: Valid;
  title: Scalars['String']['input'];
  type: AuthorizationType;
};

export type AdminPracticeSearchInput = {
  id?: InputMaybe<Scalars['ULID']['input']>;
  isAiReviewEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  programID?: InputMaybe<Scalars['Uint64']['input']>;
  status?: InputMaybe<Valid>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthorizationType>;
};

export type AdminPracticeSearchResponse = {
  __typename?: 'AdminPracticeSearchResponse';
  items: Array<AdminPractice>;
  total: Scalars['Int64']['output'];
};

export type AdminPracticeSubmitDetailSearchInput = {
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  practiceSubmitID?: InputMaybe<Scalars['ULID']['input']>;
  reviewStatus?: InputMaybe<PracticeSubmitDetailReviewStatus>;
  status?: InputMaybe<Valid>;
};

export type AdminPracticeSubmitInput = {
  practiceID: Scalars['ULID']['input'];
  status: Valid;
  userID: Scalars['Uint64']['input'];
};

export type AdminPracticeSubmitSearchInput = {
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  practiceID?: InputMaybe<Scalars['ULID']['input']>;
  status?: InputMaybe<Valid>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminPracticeSubmitSearchResponse = {
  __typename?: 'AdminPracticeSubmitSearchResponse';
  items: Array<PracticeSubmit>;
  total: Scalars['Int64']['output'];
};

/** Price-Admin-Price検索パラメーター */
export type AdminPriceSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  productID?: InputMaybe<Scalars['Uint64']['input']>;
  providerPriceID?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Valid>;
};

export type AdminProductSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  providerProductID?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Valid>;
};

export type AdminProgramInput = {
  category: ProgramCategory;
  description: Scalars['String']['input'];
  icon: Scalars['String']['input'];
  number: Scalars['Uint64']['input'];
  repository: Scalars['String']['input'];
  skill1: Scalars['String']['input'];
  skill2: Scalars['String']['input'];
  skill3: Scalars['String']['input'];
  status: Valid;
  summary: Scalars['String']['input'];
  summaryImage1: Scalars['String']['input'];
  summaryImage2: Scalars['String']['input'];
  summaryImage3: Scalars['String']['input'];
  summaryImage4: Scalars['String']['input'];
  summaryImage5: Scalars['String']['input'];
  tags: Array<Scalars['Uint64']['input']>;
  thumbnail: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: ProgramType;
  userRoles: Array<UserRole>;
};

/** ProgramSample-Admin-教材サンプル登録/更新パラメーター */
export type AdminProgramSampleInput = {
  description: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Uint64']['input']>;
  programID: Scalars['Uint64']['input'];
  status: Valid;
  thumbnail: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** ProgramSample-Admin-教材サンプル検索パラメーター */
export type AdminProgramSampleSearchInput = {
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  programID?: InputMaybe<Scalars['Uint64']['input']>;
  status?: InputMaybe<Valid>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminProgramSearchInput = {
  /** カテゴリー */
  category?: InputMaybe<ProgramCategory>;
  /** ProgramID */
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit?: InputMaybe<Scalars['Int64']['input']>;
  page?: InputMaybe<Scalars['Int64']['input']>;
  /** Prgoramステータス */
  status?: InputMaybe<Valid>;
  /** Programタイプ　1:一般、2:インストラクター向け */
  type?: InputMaybe<ProgramType>;
  userRole?: InputMaybe<UserRole>;
  /** 検索ワード、Like検索を行う */
  word?: InputMaybe<Scalars['String']['input']>;
};

export type AdminPromotionCodeInput = {
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  pvdActive?: InputMaybe<Bool>;
  pvdCode?: InputMaybe<Scalars['String']['input']>;
  pvdID?: InputMaybe<Scalars['String']['input']>;
  spCouponID?: InputMaybe<Scalars['ULID']['input']>;
};

export type AdminPromotionCodeTransactionSearchInput = {
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  spPromotionCodeID?: InputMaybe<Scalars['ULID']['input']>;
  subscriptionID?: InputMaybe<Scalars['Uint64']['input']>;
  usedUserID?: InputMaybe<Scalars['Uint64']['input']>;
};

/** QA-Admin-回答更新パラメーター */
export type AdminQuestionAnswerInput = {
  content: Scalars['String']['input'];
  status: QuestionAnswerStatus;
};

/** QA-Admin-回答検索パラメーター */
export type AdminQuestionAnswerSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  questionID?: InputMaybe<Scalars['Uint64']['input']>;
  status?: InputMaybe<QuestionAnswerStatus>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

/** QA-Admin-コメント更新パラメーター */
export type AdminQuestionCommentInput = {
  content: Scalars['String']['input'];
  status: QuestionCommentStatus;
};

/** QA-Admin-コメント検索パラメーター */
export type AdminQuestionCommentSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  questionAnswerID?: InputMaybe<Scalars['Uint64']['input']>;
  status?: InputMaybe<QuestionCommentStatus>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

/** QA-Admin-質問更新パラメーター */
export type AdminQuestionInput = {
  content: Scalars['String']['input'];
  /** 解決済み true:解決済み/false:未解決 */
  solved: Scalars['Boolean']['input'];
  status: QuestionStatus;
  title: Scalars['String']['input'];
};

/** QA-Admin-質問検索パラメーター */
export type AdminQuestionSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  /** 解決済み true:解決済み/false:未解決 */
  solved?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<QuestionStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  status?: InputMaybe<Valid>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminSearchResponse = {
  __typename?: 'AdminSearchResponse';
  items: Array<Admin>;
  total: Scalars['Int64']['output'];
};

export type AdminSessionInput = {
  assignedCoachID: Scalars['Uint64']['input'];
  /** CoachingIDよりもCourseIDの方が管理画面から参照しやすいためCourseID指定とする */
  courseID: Scalars['Uint64']['input'];
  endAt: Scalars['Time']['input'];
  phase: SessionPhase;
  startAt: Scalars['Time']['input'];
  status: Valid;
  title: Scalars['String']['input'];
};

export type AdminSessionReportInput = {
  announcements: Array<SessionReportAnnouncementInput>;
  coachingMemo?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  delayReason?: InputMaybe<Scalars['String']['input']>;
  hasAnnouncementsDetail?: InputMaybe<Scalars['String']['input']>;
  isOnSchedule: IsOnScheduleType;
  preparationOthers?: InputMaybe<Scalars['String']['input']>;
  preparations: Array<SessionReportPreparationInput>;
  responseDeadline?: InputMaybe<ResponseDeadlineType>;
  sessionID: Scalars['ULID']['input'];
  sessionPhase: SessionPhase;
  status: Valid;
};

export type AdminSessionReportSearchInput = {
  coachingID?: InputMaybe<Scalars['ULID']['input']>;
  courseID?: InputMaybe<Scalars['Uint64']['input']>;
  id?: InputMaybe<Scalars['ULID']['input']>;
  instructorID?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sessionID?: InputMaybe<Scalars['ULID']['input']>;
  sessionPhase?: InputMaybe<SessionPhase>;
  status?: InputMaybe<Valid>;
  studentID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminSessionSearchInput = {
  Phase?: InputMaybe<SessionPhase>;
  coachingID?: InputMaybe<Scalars['ULID']['input']>;
  courseID?: InputMaybe<Scalars['Uint64']['input']>;
  endAt?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['ULID']['input']>;
  instructorID?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  startAt?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Valid>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminSpCouponInput = {
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  pvdID?: InputMaybe<Scalars['String']['input']>;
  pvdName?: InputMaybe<Scalars['String']['input']>;
  pvdValid?: InputMaybe<Valid>;
};

export type AdminSpDiscountCouponSearchInput = {
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  spDiscountID?: InputMaybe<Scalars['ULID']['input']>;
};

export type AdminSpDiscountSearchInput = {
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  subscriptionID?: InputMaybe<Scalars['Uint64']['input']>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminSpotLessonInput = {
  categories: Array<Scalars['Uint64']['input']>;
  instructorUserID: Scalars['Uint64']['input'];
  researchContent: Scalars['String']['input'];
  startAt: Scalars['Time']['input'];
  troubleContent: Scalars['String']['input'];
  userID: Scalars['Uint64']['input'];
};

export type AdminSpotLessonSearchInput = {
  URL?: InputMaybe<Scalars['String']['input']>;
  cancelType?: InputMaybe<SpotLessonCancelType>;
  canceledAt?: InputMaybe<Scalars['Time']['input']>;
  endAt?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['Uint64']['input']>;
  instructorUserID?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  phases?: InputMaybe<Array<SpotLessonPhase>>;
  startAt?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Valid>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminSpotLessonUpdateInput = {
  cancelType?: InputMaybe<SpotLessonCancelType>;
  canceledAt?: InputMaybe<Scalars['Time']['input']>;
  instructorScheduleID?: InputMaybe<Scalars['Uint64']['input']>;
  instructorUserID?: InputMaybe<Scalars['Uint64']['input']>;
  phase?: InputMaybe<SpotLessonPhase>;
  status?: InputMaybe<Valid>;
};

export type AdminStripeCustomerSearchInput = {
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  stripeCustomerType?: InputMaybe<StripeCustomerType>;
  teamID?: InputMaybe<Scalars['ULID']['input']>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminStripeSubscriptionLogSearchInput = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  stripeSubscriptionID?: InputMaybe<Scalars['ULID']['input']>;
};

export type AdminStripeSubscriptionSearchInput = {
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  providerCustomerID?: InputMaybe<Scalars['String']['input']>;
  providerID?: InputMaybe<Scalars['String']['input']>;
  providerStatus?: InputMaybe<ProviderSubscriptionStatus>;
  stripeCustomerID?: InputMaybe<Scalars['ULID']['input']>;
  stripeCustomerType?: InputMaybe<StripeCustomerType>;
  teamID?: InputMaybe<Scalars['ULID']['input']>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminStudentInput = {
  firstName: Scalars['String']['input'];
  kanaName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName: Scalars['String']['input'];
  scStudentID: Scalars['String']['input'];
  status: Scalars['Uint64']['input'];
};

export type AdminStudentSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  /** 姓・名・ミドルネーム、氏名カナのいずれかで検索 */
  name?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  scStudentID?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Uint64']['input']>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminStudyFavoriteSummarySearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

/** StudyReportComment-Admin-学習ログコメント登録/更新パラメーター */
export type AdminStudyReportCommentInput = {
  content: Scalars['String']['input'];
  status: Valid;
  studyReportID: Scalars['Uint64']['input'];
  userID: Scalars['Uint64']['input'];
};

/** StudyReportComment-Admin-学習ログコメント検索パラメーター */
export type AdminStudyReportCommentSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  status?: InputMaybe<Valid>;
  studyReportID?: InputMaybe<Scalars['Uint64']['input']>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

/** StudyReportDetail-Admin-学習ログ詳細登録/更新パラメーター */
export type AdminStudyReportDetailInput = {
  programID?: InputMaybe<Scalars['Uint64']['input']>;
  studyReportID: Scalars['Uint64']['input'];
  tagID: Scalars['Uint64']['input'];
  time: Scalars['Uint64']['input'];
};

/** StudyReportDetail-Admin-学習ログ詳細検索パラメーター */
export type AdminStudyReportDetailSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  programID?: InputMaybe<Scalars['Uint64']['input']>;
  studyReportID?: InputMaybe<Scalars['Uint64']['input']>;
  tagID?: InputMaybe<Scalars['Uint64']['input']>;
  time?: InputMaybe<Scalars['Uint64']['input']>;
};

/** StudyReport-Admin-学習ログ登録/更新パラメーター */
export type AdminStudyReportInput = {
  content: Scalars['String']['input'];
  date: Scalars['Time']['input'];
  status: Valid;
  studyReportDetails?: InputMaybe<Array<InputMaybe<StudyReportDetailInput>>>;
  userID: Scalars['Uint64']['input'];
};

/** StudyReport-Admin-学習ログ検索パラメーター */
export type AdminStudyReportSearchInput = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  startDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Valid>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminStudySummarySearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminStudyTagSummarySearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  tagID?: InputMaybe<Scalars['Uint64']['input']>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminSubscriptionChangeHistorySearchInput = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  stripeCustomerID?: InputMaybe<Scalars['ULID']['input']>;
  stripeSubscriptionIDForStripeSubscriptionLog?: InputMaybe<Scalars['ULID']['input']>;
};

export type AdminSubscriptionContractLogSearchInput = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  subscriptionContractID?: InputMaybe<Scalars['ULID']['input']>;
};

export type AdminSubscriptionContractSearchInput = {
  cancelAtPeriodEnd?: InputMaybe<Scalars['Boolean']['input']>;
  exitFeeStatus?: InputMaybe<ExitFeeStatus>;
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  phase?: InputMaybe<SubscriptionContractPhase>;
  priceID?: InputMaybe<Scalars['Uint64']['input']>;
  providerSubscriptionID?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerID?: InputMaybe<Scalars['ULID']['input']>;
  stripeSubscriptionID?: InputMaybe<Scalars['ULID']['input']>;
  teamID?: InputMaybe<Scalars['ULID']['input']>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminSubscriptionHistorySearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  status?: InputMaybe<Valid>;
  subscriptionID?: InputMaybe<Scalars['Uint64']['input']>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminSubscriptionSearchInput = {
  cancelAtPeriodEnd?: InputMaybe<Bool>;
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  phase?: InputMaybe<SubscriptionPhase>;
  providerSubscriptionID?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Valid>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

/** タグ-Admin-登録/更新パラメーター */
export type AdminTagInput = {
  name: Scalars['String']['input'];
  overview?: InputMaybe<Scalars['String']['input']>;
  status: Valid;
  userRoles: Array<UserRole>;
};

/** タグ-Admin-質問検索パラメーター */
export type AdminTagSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  /** タグ名(完全一致) */
  name?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  status?: InputMaybe<Valid>;
  userRole?: InputMaybe<UserRole>;
};

export type AdminTeamMemberSearchInput = {
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  role?: InputMaybe<TeamMemberRole>;
  status?: InputMaybe<Valid>;
  teamID?: InputMaybe<Scalars['ULID']['input']>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminTeamSearchInput = {
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  status?: InputMaybe<Valid>;
};

export type AdminTermChangeLogSearchInput = {
  courseID?: InputMaybe<Scalars['Uint64']['input']>;
  id?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  termChangeReasonID?: InputMaybe<Scalars['Uint64']['input']>;
};

/** チケット-Admin-新規作成パラメーター */
export type AdminTicketCreateInput = {
  expireAt: Scalars['Int']['input'];
  userID: Scalars['Uint64']['input'];
};

/** チケット-Admin-編集パラメーター */
export type AdminTicketInput = {
  expireAt: Scalars['Time']['input'];
  isUsed: Scalars['Uint64']['input'];
  type: Scalars['Uint64']['input'];
  userID: Scalars['Uint64']['input'];
};

/** チケット-Admin-検索パラメーター */
export type AdminTicketSearchInput = {
  id?: InputMaybe<Scalars['Uint64']['input']>;
  isUsed?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  type?: InputMaybe<Scalars['Uint64']['input']>;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type AdminUpdateInput = {
  status: Valid;
};

export type AdminUpdateInstructorScheduleInput = {
  endAt: Scalars['Time']['input'];
  startAt: Scalars['Time']['input'];
  status?: InputMaybe<Valid>;
};

export type AdminUserInput = {
  birthday?: InputMaybe<Scalars['Time']['input']>;
  /** プロフィール画像画像 指定しなかった場合は更新しない */
  image?: InputMaybe<Scalars['Upload']['input']>;
  kanaName?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nickName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['Uint64']['input']>;
  skypeID?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUserSearchInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Uint64']['input']>;
  isAdmin?: InputMaybe<Bool>;
  isInstructor?: InputMaybe<Bool>;
  isStudent?: InputMaybe<Bool>;
  limit: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  providerCustomerID?: InputMaybe<Scalars['String']['input']>;
  skypeID?: InputMaybe<Scalars['String']['input']>;
  snsType?: InputMaybe<Scalars['Uint64']['input']>;
  status?: InputMaybe<Valid>;
  sub?: InputMaybe<Scalars['String']['input']>;
};

export type AnswerExamInput = {
  answerRequests?: InputMaybe<Array<AnswerInput>>;
  chapterID: Scalars['Uint64']['input'];
};

export type AnswerInput = {
  answerID: Scalars['ULID']['input'];
  questionID: Scalars['ULID']['input'];
};

export enum AnswerRequestType {
  Ai = 'AI',
  Escalation = 'ESCALATION',
  WaitingToEscalation = 'WAITING_TO_ESCALATION'
}

export type AnswerResponse = {
  __typename?: 'AnswerResponse';
  answerID: Scalars['ULID']['output'];
  questionID: Scalars['ULID']['output'];
  result: Scalars['Boolean']['output'];
};

export enum AnswerType {
  Ai = 'AI',
  AutoEscalation = 'AUTO_ESCALATION',
  Escalation = 'ESCALATION'
}

export type AssignLog = {
  __typename?: 'AssignLog';
  course: Course;
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  instructor: Instructor;
  updatedAt: Scalars['Time']['output'];
};

export type AssignLogSearchResponse = {
  __typename?: 'AssignLogSearchResponse';
  items: Array<AssignLog>;
  total: Scalars['Uint64']['output'];
};

/** 認可タイプ */
export enum AuthorizationType {
  Basic = 'BASIC',
  Light = 'LIGHT',
  Premium = 'PREMIUM',
  Public = 'PUBLIC',
  Registered = 'REGISTERED'
}

export type Banner = {
  __typename?: 'Banner';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  imageURL: Scalars['String']['output'];
  /** ログインしていない人 */
  isNotLoginUser: Scalars['Boolean']['output'];
  /** サブスク未課金の人 */
  isTargetFree: Scalars['Boolean']['output'];
  /** 卒業生アカウント */
  isTargetGraduate: Scalars['Boolean']['output'];
  /** 講師アカウント */
  isTargetInstructor: Scalars['Boolean']['output'];
  /** 受講生アカウント */
  isTargetStudent: Scalars['Boolean']['output'];
  /** サブスク課金中の人 */
  isTargetSubscriptionUser: Scalars['Boolean']['output'];
  /** 法人アカウント */
  isTargetTeamUser: Scalars['Boolean']['output'];
  link: Scalars['String']['output'];
  sort: Scalars['Uint64']['output'];
  status: Valid;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type BannerCid = {
  __typename?: 'BannerCid';
  banner: Banner;
  bannerID: Scalars['Uint64']['output'];
  cid: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  deviceType: BannerCidDeviceType;
  id: Scalars['Uint64']['output'];
  status: Valid;
  type: BannerCidType;
  updatedAt: Scalars['Time']['output'];
};

/** deviceType */
export enum BannerCidDeviceType {
  /** PC */
  Pc = 'PC',
  /** PC&SP */
  PcAndSp = 'PC_AND_SP',
  /** SP */
  Sp = 'SP'
}

/** バナーCID-検索パラメーター */
export type BannerCidSearchInput = {
  cidTypes: Array<BannerCidType>;
  limit: Scalars['Uint64']['input'];
  targetType: BannerTargetType;
};

/** バナーCid */
export enum BannerCidType {
  /** ニュース画面 */
  News = 'NEWS',
  /** 教材画面 */
  Program = 'PROGRAM',
  /** Q&A詳細 */
  Qa = 'QA',
  /** ホーム画面中央 */
  TopCenter = 'TOP_CENTER'
}

/** バナー表示対象区分(検索用) */
export enum BannerTargetType {
  /** サブスク未課金の人 */
  Free = 'FREE',
  /** 卒業生アカウント */
  Graduate = 'GRADUATE',
  /** 講師アカウント */
  Instructor = 'INSTRUCTOR',
  /** ログインしていない人 */
  NotLoggedIn = 'NOT_LOGGED_IN',
  /** 受講生アカウント */
  Student = 'STUDENT',
  /** サブスク課金中の人 */
  Subscription = 'SUBSCRIPTION',
  /** 法人アカウント */
  Team = 'TEAM'
}

export enum Bool {
  False = 'FALSE',
  True = 'TRUE'
}

export type Campaign = {
  __typename?: 'Campaign';
  createdAt: Scalars['Time']['output'];
  endDate: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  imageURL: Scalars['String']['output'];
  startDate: Scalars['Time']['output'];
  status: Valid;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** キャンペーン登録/更新パラメーター */
export type CampaignInput = {
  endDate: Scalars['Time']['input'];
  imageURL: Scalars['String']['input'];
  startDate: Scalars['Time']['input'];
  status: Valid;
  title: Scalars['String']['input'];
};

export type CampaignsResponse = {
  __typename?: 'CampaignsResponse';
  items: Array<Campaign>;
  total: Scalars['Uint64']['output'];
};

export type Category = {
  __typename?: 'Category';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Uint64']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type Chapter = {
  __typename?: 'Chapter';
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  examQuestions?: Maybe<Array<ExamQuestion>>;
  examScores?: Maybe<Array<ExamScore>>;
  id: Scalars['Uint64']['output'];
  key: Scalars['String']['output'];
  number: Scalars['Uint64']['output'];
  programElement: ProgramElement;
  qaKey?: Maybe<Scalars['String']['output']>;
  requireTime: Scalars['Uint64']['output'];
  status: Valid;
  studyLog?: Maybe<StudyLog>;
  title: Scalars['String']['output'];
  type: AuthorizationType;
  updatedAt: Scalars['Time']['output'];
};

export type ChapterSearchInput = {
  limit?: InputMaybe<Scalars['Uint64']['input']>;
  page?: InputMaybe<Scalars['Uint64']['input']>;
  /** ProgramIDが指定された場合は指定ProgramIDに紐づくChapterを取得する */
  programID?: InputMaybe<Scalars['Uint64']['input']>;
  /** Wordが指定された場合はtitle, description. contentから曖昧検索する */
  word?: InputMaybe<Scalars['String']['input']>;
};

export type ChapterSearchResponse = {
  __typename?: 'ChapterSearchResponse';
  items: Array<Chapter>;
  total: Scalars['Uint64']['output'];
};

export type Charge = {
  __typename?: 'Charge';
  amount: Scalars['Uint64']['output'];
  createdAt: Scalars['Time']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['Uint64']['output'];
  paymentIntent: PaymentIntent;
  phase: ChargePhase;
  providerChargeID: Scalars['String']['output'];
  receiptURL?: Maybe<Scalars['String']['output']>;
  refunded?: Maybe<Bool>;
  status: Valid;
  updatedAt: Scalars['Time']['output'];
};

export enum ChargePhase {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export type ChatMember = {
  __typename?: 'ChatMember';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  status: Valid;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  chatRoom: ChatRoom;
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  status: Valid;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userChatMessage?: Maybe<UserChatMessage>;
};

export type ChatMessageConnection = {
  __typename?: 'ChatMessageConnection';
  edges: Array<ChatMessageEdge>;
  pageInfo: PageInfo;
};

export type ChatMessageCreateInput = {
  chatRoomID: Scalars['Uint64']['input'];
  content: Scalars['String']['input'];
};

export type ChatMessageDraft = {
  __typename?: 'ChatMessageDraft';
  chatRoomID: Scalars['Uint64']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  updatedAt: Scalars['Time']['output'];
  userID: Scalars['Uint64']['output'];
};

export type ChatMessageEdge = {
  __typename?: 'ChatMessageEdge';
  cursor: Scalars['String']['output'];
  node: ChatMessage;
};

export type ChatMessageUpdateInput = {
  content: Scalars['String']['input'];
};

export type ChatRoom = {
  __typename?: 'ChatRoom';
  chatMembers: Array<ChatMember>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  lastMessage?: Maybe<ChatMessage>;
  status: Valid;
  title: Scalars['String']['output'];
  unreadCount: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type ChatRoomsResponse = {
  __typename?: 'ChatRoomsResponse';
  items: Array<ChatRoom>;
  pageInfo: PageInfo;
};

export type CheckUpgradePlanResult = {
  __typename?: 'CheckUpgradePlanResult';
  endDate: Scalars['Time']['output'];
  price?: Maybe<Price>;
  priceID: Scalars['Uint64']['output'];
  startDate: Scalars['Time']['output'];
  subscriptionUpgradeType: SubscriptionUpgradeType;
};

export type Claim = {
  __typename?: 'Claim';
  appliedAt?: Maybe<Scalars['Time']['output']>;
  applyStatus: ClaimApplyStatus;
  claimDetails: Array<ClaimDetail>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  instructor?: Maybe<Instructor>;
  month: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  status: Valid;
  updatedAt: Scalars['Time']['output'];
};

export enum ClaimApplyStatus {
  Applied = 'APPLIED',
  Approved = 'APPROVED',
  Editable = 'EDITABLE'
}

export type ClaimCategory = {
  __typename?: 'ClaimCategory';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type ClaimDetail = {
  __typename?: 'ClaimDetail';
  additionalPayment?: Maybe<Scalars['Uint64']['output']>;
  amount?: Maybe<Scalars['Uint64']['output']>;
  claim: Claim;
  claimCategory: ClaimCategory;
  course?: Maybe<Course>;
  createdAt: Scalars['Time']['output'];
  date: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  lesson?: Maybe<Lesson>;
  outAmount?: Maybe<Scalars['Uint64']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  spotLesson?: Maybe<SpotLesson>;
  status: Valid;
  subTotal: Scalars['Uint64']['output'];
  unitPrice: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type ClaimDetailInput = {
  additionalPayment?: InputMaybe<Scalars['Uint64']['input']>;
  amount: Scalars['Uint64']['input'];
  claimCategoryID: Scalars['Uint64']['input'];
  courseID?: InputMaybe<Scalars['Uint64']['input']>;
  date: Scalars['Time']['input'];
  lessonID?: InputMaybe<Scalars['Uint64']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  spotLessonID?: InputMaybe<Scalars['Uint64']['input']>;
  unitPrice: Scalars['Uint64']['input'];
};

export type ClaimDetailSearchResponse = {
  __typename?: 'ClaimDetailSearchResponse';
  items: Array<ClaimDetail>;
  total: Scalars['Uint64']['output'];
};

export type ClaimInput = {
  remark?: InputMaybe<Scalars['String']['input']>;
};

export type ClaimSearchResponse = {
  __typename?: 'ClaimSearchResponse';
  items: Array<Claim>;
  total: Scalars['Uint64']['output'];
};

export type Coaching = {
  __typename?: 'Coaching';
  coach?: Maybe<Instructor>;
  course: Course;
  createdAt: Scalars['Time']['output'];
  finishedSessionCount: Scalars['Uint64']['output'];
  id: Scalars['ULID']['output'];
  plannedSessionCount: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  withCoaching: Bool;
};

export type CoachingAssignLog = {
  __typename?: 'CoachingAssignLog';
  coachID: Scalars['Uint64']['output'];
  coaching: Coaching;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type CoachingAssignLogSearchInput = {
  coachID?: InputMaybe<Scalars['Uint64']['input']>;
  id?: InputMaybe<Scalars['ULID']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type CoachingAssignLogSearchResponse = {
  __typename?: 'CoachingAssignLogSearchResponse';
  items: Array<CoachingAssignLog>;
  total: Scalars['Int64']['output'];
};

export type CoachingSearchResponse = {
  __typename?: 'CoachingSearchResponse';
  items: Array<Coaching>;
  total: Scalars['Int64']['output'];
};

export type CognitoUser = {
  __typename?: 'CognitoUser';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  userCreateDate?: Maybe<Scalars['Time']['output']>;
  userLastModifiedDate?: Maybe<Scalars['Time']['output']>;
  userStatus?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type ContractDetailForAnalytics = {
  __typename?: 'ContractDetailForAnalytics';
  canceledAt?: Maybe<Scalars['Time']['output']>;
  periodEnd: Scalars['Time']['output'];
  periodStart: Scalars['Time']['output'];
  productID: Scalars['Uint64']['output'];
  productName: Scalars['String']['output'];
};

/**
 * ユーザー契約情報
 * GTMデータ収集用でsubscriptionに紐づくさまざまなデータの中から必要なデータのみ出力する
 * 個人契約情報と法人契約情報をまとめて取得する
 */
export type ContractOfStripeSubscriptionForAnalytics = {
  __typename?: 'ContractOfStripeSubscriptionForAnalytics';
  contractDetailForAnalytics: ContractDetailForAnalytics;
  stripeCustomerType: StripeCustomerType;
};

export enum ContractPeriodType {
  /** 契約期間：日 */
  Day = 'DAY',
  /** 契約期間：月 */
  Month = 'MONTH'
}

export type CountDocumentInput = {
  hasDocumentTypeCounts: Scalars['Boolean']['input'];
  hasTagCounts: Scalars['Boolean']['input'];
};

export type CountResponse = {
  __typename?: 'CountResponse';
  count: Scalars['Uint64']['output'];
};

export type CountSearchInput = {
  chapter?: InputMaybe<Scalars['Uint64']['input']>;
  isMine: Scalars['Boolean']['input'];
  practice?: InputMaybe<Scalars['ULID']['input']>;
  program?: InputMaybe<Scalars['Uint64']['input']>;
  questionHasAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuestionStatus?: InputMaybe<SearchQuestionStatus>;
  tags?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<DocumentType>>;
};

export type Course = {
  __typename?: 'Course';
  absent2EndDate?: Maybe<Scalars['Time']['output']>;
  absent2StartDate?: Maybe<Scalars['Time']['output']>;
  absent3EndDate?: Maybe<Scalars['Time']['output']>;
  absent3StartDate?: Maybe<Scalars['Time']['output']>;
  absentEndDate?: Maybe<Scalars['Time']['output']>;
  absentStartDate?: Maybe<Scalars['Time']['output']>;
  breakInContact?: Maybe<Scalars['Uint64']['output']>;
  canceledLessonCount?: Maybe<Scalars['Uint64']['output']>;
  careerSupport?: Maybe<Scalars['Uint64']['output']>;
  coaching?: Maybe<Coaching>;
  consultant?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Scalars['Uint64']['output']>;
  createdAt: Scalars['Time']['output'];
  curriculum?: Maybe<Scalars['String']['output']>;
  customerAcquisition?: Maybe<Scalars['Uint64']['output']>;
  delayInPayment?: Maybe<Scalars['Uint64']['output']>;
  endDate?: Maybe<Scalars['Time']['output']>;
  finishedLessonCount?: Maybe<Scalars['Uint64']['output']>;
  id: Scalars['Uint64']['output'];
  instructor?: Maybe<Instructor>;
  instructorChange2EndDate?: Maybe<Scalars['Time']['output']>;
  instructorChange2StartDate?: Maybe<Scalars['Time']['output']>;
  instructorChange3EndDate?: Maybe<Scalars['Time']['output']>;
  instructorChange3StartDate?: Maybe<Scalars['Time']['output']>;
  instructorChangeEndDate?: Maybe<Scalars['Time']['output']>;
  instructorChangeStartDate?: Maybe<Scalars['Time']['output']>;
  instructorMemo?: Maybe<Scalars['String']['output']>;
  jobChange?: Maybe<Scalars['Uint64']['output']>;
  lessonMinutesUpperLimit?: Maybe<Scalars['Uint64']['output']>;
  lessonPlace?: Maybe<Scalars['String']['output']>;
  lessonType?: Maybe<CourseLessonType>;
  lessons: Array<Lesson>;
  objective?: Maybe<Scalars['String']['output']>;
  plan: Plan;
  plannedLessonCount?: Maybe<Scalars['Uint64']['output']>;
  startDate?: Maybe<Scalars['Time']['output']>;
  status?: Maybe<Scalars['Uint64']['output']>;
  student: Student;
  studentInformation?: Maybe<StudentInformation>;
  teachingMaterialCost?: Maybe<Scalars['Uint64']['output']>;
  type?: Maybe<Scalars['Uint64']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export enum CourseLessonType {
  /** 対面 */
  FaceToFace = 'FACE_TO_FACE',
  /** オンライン */
  Online = 'ONLINE'
}

export type CourseProgram = {
  __typename?: 'CourseProgram';
  content: Scalars['String']['output'];
  courseProgramSteps?: Maybe<Array<CourseProgramStep>>;
  courseProgramUserData?: Maybe<CourseProgramUserData>;
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ULID']['output'];
  image: Scalars['String']['output'];
  number: Scalars['Uint64']['output'];
  overview: Scalars['String']['output'];
  status: Valid;
  tags?: Maybe<Array<Tag>>;
  title: Scalars['String']['output'];
  totalChapterCount: Scalars['Uint64']['output'];
  totalCompletedChapterCount: Scalars['Uint64']['output'];
  totalCompletedTime: Scalars['Int64']['output'];
  totalRequireTime: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type CourseProgramSearchInput = {
  /** 指定のCourseProgramIDのCourseを取得する */
  courseProgramIDs?: InputMaybe<Array<Scalars['ULID']['input']>>;
  /** 学習完了のコース教材を取得する */
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** 学習中のコース教材を取得する */
  isWhileStudying?: InputMaybe<Scalars['Boolean']['input']>;
  programID?: InputMaybe<Scalars['Uint64']['input']>;
  /** 登録ページに表示するCourseProgramを取得する */
  registeredCoursePrograms?: InputMaybe<Scalars['Boolean']['input']>;
  tagID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type CourseProgramSearchResponse = {
  __typename?: 'CourseProgramSearchResponse';
  items: Array<CourseProgram>;
  total: Scalars['Uint64']['output'];
};

export type CourseProgramStep = {
  __typename?: 'CourseProgramStep';
  courseProgram?: Maybe<CourseProgram>;
  courseProgramID: Scalars['ULID']['output'];
  courseProgramStepItems?: Maybe<Array<CourseProgramStepItem>>;
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ULID']['output'];
  number: Scalars['Uint64']['output'];
  status: Valid;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type CourseProgramStepItem = {
  __typename?: 'CourseProgramStepItem';
  courseProgramStepID: Scalars['ULID']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  number: Scalars['Uint64']['output'];
  program?: Maybe<Program>;
  status: Valid;
  updatedAt: Scalars['Time']['output'];
};

export type CourseProgramStepSearchResponse = {
  __typename?: 'CourseProgramStepSearchResponse';
  items: Array<CourseProgramStep>;
  total: Scalars['Uint64']['output'];
};

export type CourseProgramUserData = {
  __typename?: 'CourseProgramUserData';
  courseProgramID: Scalars['ULID']['output'];
  createdAt: Scalars['Time']['output'];
  isCompleted: Bool;
  isStarted: Bool;
  updatedAt: Scalars['Time']['output'];
  userID: Scalars['Uint64']['output'];
};

export type CourseSearchResponse = {
  __typename?: 'CourseSearchResponse';
  items: Array<Course>;
  total: Scalars['Uint64']['output'];
};

export enum CourseSearchType {
  /** すべてCourse */
  All = 'ALL',
  /** コーチング */
  Coaching = 'COACHING',
  /** コース */
  Course = 'COURSE',
  /** 過去アサインされたもの含む */
  Historical = 'HISTORICAL'
}

export enum DeviceType {
  All = 'ALL',
  Pc = 'PC',
  Sp = 'SP'
}

export type Document = {
  __typename?: 'Document';
  chapter?: Maybe<Chapter>;
  documentID: Scalars['String']['output'];
  practice?: Maybe<Practice>;
  qa?: Maybe<Question>;
  studyReport?: Maybe<StudyReport>;
  tweet?: Maybe<Tweet>;
  type: DocumentType;
};

export type DocumentResponse = {
  __typename?: 'DocumentResponse';
  items: Array<Document>;
  total: Scalars['Int64']['output'];
};

export type DocumentSearchInput = {
  chapter?: InputMaybe<Scalars['Uint64']['input']>;
  isMine: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  practice?: InputMaybe<Scalars['ULID']['input']>;
  program?: InputMaybe<Scalars['Uint64']['input']>;
  questionHasAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuestionStatus?: InputMaybe<SearchQuestionStatus>;
  sortKey: DocumentSortKey;
  tags?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<DocumentType>>;
};

export enum DocumentSortKey {
  Latest = 'LATEST'
}

export enum DocumentType {
  Practice = 'PRACTICE',
  Program = 'PROGRAM',
  Qa = 'QA',
  StudyReport = 'STUDY_REPORT',
  Tweet = 'TWEET'
}

export type DocumentTypeCount = {
  __typename?: 'DocumentTypeCount';
  count: Scalars['Int64']['output'];
  documentType: DocumentType;
};

export enum ErrorCode {
  /** デバイスタイプが重複している */
  AbTestDuplicatedDeviceType = 'ABTestDuplicatedDeviceType',
  /** OriginURLが重複している */
  AbTestDuplicatedOriginUrl = 'ABTestDuplicatedOriginURL',
  /** 開始日より終了日が前の日付 */
  AbTestStartDateIsAfterEndDate = 'ABTestStartDateIsAfterEndDate',
  /** BannerIDとTypeの組み合わせは既に存在する */
  BannerIdAndTypeCombinationAlreadyExists = 'BannerIDAndTypeCombinationAlreadyExists',
  /** チャットメッセージが既に削除されている */
  ChatMessageAlreadyDeletedError = 'ChatMessageAlreadyDeletedError',
  /** 既に請求申請が行われている */
  ClaimAlreadyExists = 'ClaimAlreadyExists',
  /** カリキュラム作成に対する請求申請詳細が既に存在する */
  ClaimDetailAlreadyExistsCurriculum = 'ClaimDetailAlreadyExistsCurriculum',
  /** 専属レッスンに対する請求申請詳細が既に存在する */
  ClaimDetailAlreadyExistsLesson = 'ClaimDetailAlreadyExistsLesson',
  /** スポットレッスンに対する請求申請詳細が既に存在する */
  ClaimDetailAlreadyExistsSpotLesson = 'ClaimDetailAlreadyExistsSpotLesson',
  /** オーダーメイドのカリキュラム対応でない場合で工数計上する */
  ClaimDetailNotAllowedFlexibleCurriculum = 'ClaimDetailNotAllowedFlexibleCurriculum',
  /** 専属レッスン前後準備ができないコースで工数計上する */
  ClaimDetailNotAllowedLessonPreparation = 'ClaimDetailNotAllowedLessonPreparation',
  /** 質問対応ができないコースで工数計上する */
  ClaimDetailNotAllowedQuestion = 'ClaimDetailNotAllowedQuestion',
  /** 許可されていないスポットレッスンで申請している */
  ClaimDetailNotAllowedSpotLesson = 'ClaimDetailNotAllowedSpotLesson',
  /** Domain全体で共通のエラー */
  CommonDatabaseErr = 'CommonDatabaseErr',
  CommonInvalidImage = 'CommonInvalidImage',
  CommonInvalidItem = 'CommonInvalidItem',
  CommonInvalidUser = 'CommonInvalidUser',
  CommonNoPermission = 'CommonNoPermission',
  CommonNotAuthorization = 'CommonNotAuthorization',
  CommonPublicUserIsDenied = 'CommonPublicUserIsDenied',
  CommonRecordCountExceeded = 'CommonRecordCountExceeded',
  CommonRecordNotFound = 'CommonRecordNotFound',
  CommonStoreWorkerErr = 'CommonStoreWorkerErr',
  CommonUnknownErr = 'CommonUnknownErr',
  CommonUserIsDenied = 'CommonUserIsDenied',
  /** コースにインストラクターがアサインされていない */
  CourseInstructorIsNotAssigned = 'CourseInstructorIsNotAssigned',
  /** 課題が既に提出済み */
  DuplicatePracticeSubmission = 'DuplicatePracticeSubmission',
  /** InstructorScheduleエラー */
  InstructorScheduleAcrossDays = 'InstructorScheduleAcrossDays',
  InstructorScheduleDuplicated = 'InstructorScheduleDuplicated',
  InstructorScheduleIsDuringNewYearHolidayPeriod = 'InstructorScheduleIsDuringNewYearHolidayPeriod',
  InstructorScheduleOutsideBusinessHours = 'InstructorScheduleOutsideBusinessHours',
  /** 無効なタグが指定されている */
  InvalidTag = 'InvalidTag',
  /** 契約人数下限に満たない */
  LessThanMinimumNumberOfTeamMembers = 'LessThanMinimumNumberOfTeamMembers',
  /** 専属レッスンの先約あり */
  LessonAlreadyReserved = 'LessonAlreadyReserved',
  /** 年末年始休業期間中 */
  LessonIsDuringNewYearHolidayPeriod = 'LessonIsDuringNewYearHolidayPeriod',
  /** コースに設定されている計画レッスン数の超過エラー */
  LessonIsOverCount = 'LessonIsOverCount',
  /** コース終了日時以降の専属レッスン日時を指定 */
  LessonIsOverDate = 'LessonIsOverDate',
  /** 利用可能なチケットがない */
  NoAvailableTickets = 'NoAvailableTickets',
  /** 銀行振込の場合にTeamMemberを減らそうとしている */
  NotPermittedDownNumberOfTeamMembers = 'NotPermittedDownNumberOfTeamMembers',
  /** 課題が提出不可 */
  PracticeIsNotSubmittable = 'PracticeIsNotSubmittable',
  /** 課題提出物のレビューステータスが更新されている */
  PracticeSubmitDetailReviewStatusIsInvalid = 'PracticeSubmitDetailReviewStatusIsInvalid',
  /** 教材の評価が重複投稿された */
  ProgramSatisfactionAlreadyExistsErr = 'ProgramSatisfactionAlreadyExistsErr',
  /** 全章終了していない */
  ProgramSatisfactionNotAllCompletedYetErr = 'ProgramSatisfactionNotAllCompletedYetErr',
  /** PromotionCode固有のエラー */
  PromotionCodeIsInvalid = 'PromotionCodeIsInvalid',
  PromotionCodeIsUsed = 'PromotionCodeIsUsed',
  /** 質問ができない */
  QuestionCommentIsNotPermitted = 'QuestionCommentIsNotPermitted',
  /** AI回答待ち */
  QuestionCommentIsPendingAnswer = 'QuestionCommentIsPendingAnswer',
  /** セッションの先約あり */
  SessionAlreadyReserved = 'SessionAlreadyReserved',
  /** セッションの年末年始休業期間中 */
  SessionIsDuringNewYearHolidayPeriod = 'SessionIsDuringNewYearHolidayPeriod',
  /** セッション回数の超過 */
  SessionIsOverCount = 'SessionIsOverCount',
  /** スポットレッスンが既に実施済みまたはキャンセル済み */
  SpotLessonAlreadyDoneOrCanceled = 'SpotLessonAlreadyDoneOrCanceled',
  /** 既にスポットレッスンが予約されている */
  SpotLessonAlreadyReserved = 'SpotLessonAlreadyReserved',
  /** スポットレッスンの予約が重複している */
  SpotLessonIsDuplicated = 'SpotLessonIsDuplicated',
  /** 予約可能なインストラクターがいない */
  SpotLessonIsFullOfReservations = 'SpotLessonIsFullOfReservations',
  /** スケジュールを変更する際に予約済みの時間帯を外そうとしている */
  SpotLessonIsNotCovered = 'SpotLessonIsNotCovered',
  /** スポットレッスンの開始時間を過ぎている */
  SpotLessonIsStarted = 'SpotLessonIsStarted',
  /** 現在時刻がスポットレッスンの開始時刻まで近すぎる */
  SpotLessonTooCloseToStartTime = 'SpotLessonTooCloseToStartTime',
  /** 不正なカードを利用しています */
  StripeCardDeclined = 'StripeCardDeclined',
  /** 有効期限切れのカードを利用しています */
  StripeCardExpired = 'StripeCardExpired',
  /** 不正なCVCのカードを利用しています */
  StripeCardIncorrectCvc = 'StripeCardIncorrectCVC',
  /** 原因不明で支払いができないクレジットカードの際に発生する */
  StripeDoNotHonorErr = 'StripeDoNotHonorErr',
  /** Stripe決済時の予期せぬ（Stripe側）エラー */
  StripeProcessingError = 'StripeProcessingError',
  /** 初回契約のみ利用可能なクーポン */
  StripePromotionCodeAlreadyUsedErr = 'StripePromotionCodeAlreadyUsedErr',
  /** Stripe固有エラー */
  StripeRequestErr = 'StripeRequestErr',
  /** 学習ログ登録時間24時間超えている */
  StudyReportMaxTimeError = 'StudyReportMaxTimeError',
  /** Subscription固有エラー */
  SubscriptionIsExisted = 'SubscriptionIsExisted',
  /** サブスク登録禁止時間に登録しようとしている */
  SubscriptionIsMaintained = 'SubscriptionIsMaintained',
  /** 支払い方法が設定されていない */
  SubscriptionPaymentMethodIsEmpty = 'SubscriptionPaymentMethodIsEmpty',
  /** 権限エラー(受講生・講師はNG) */
  TeamInvitationAuthError = 'TeamInvitationAuthError',
  /** 招待したEmailと異なる */
  TeamInvitationEmailNotMatch = 'TeamInvitationEmailNotMatch',
  /** 招待URLのidが無効 */
  TeamInvitationInvalidId = 'TeamInvitationInvalidID',
  /** 招待メール送信できるEmailなし */
  TeamInvitationNoValidEmail = 'TeamInvitationNoValidEmail',
  /** 契約人数上限に到達 */
  TeamInvitationReachedMaximumLimit = 'TeamInvitationReachedMaximumLimit',
  /** 既に法人に参加済み */
  TeamInvitationUserAlreadyJoined = 'TeamInvitationUserAlreadyJoined',
  /** 個人で既に契約済み */
  TeamInvitationUserAlreadySubscribed = 'TeamInvitationUserAlreadySubscribed',
  /** チーム内最後の管理者 */
  TeamMemberIsLastAdmin = 'TeamMemberIsLastAdmin',
  /** ユーザーが過去に削除された */
  UserAlreadyDeleted = 'UserAlreadyDeleted',
  /** ユーザーが既に存在する */
  UserAlreadyExists = 'UserAlreadyExists',
  /** Emailが不正 */
  UserEmailInvalid = 'UserEmailInvalid',
  /** GoogleMeetURLが登録されていない */
  UserNotSetGoogleMeetUrl = 'UserNotSetGoogleMeetURL'
}

export type ExamAnswer = {
  __typename?: 'ExamAnswer';
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  examQuestionID: Scalars['ULID']['output'];
  id: Scalars['ULID']['output'];
  isCorrect: Scalars['Boolean']['output'];
};

export enum ExamMedalType {
  Bronze = 'BRONZE',
  Gold = 'GOLD',
  Silver = 'SILVER'
}

export type ExamQuestion = {
  __typename?: 'ExamQuestion';
  chapterID: Scalars['Uint64']['output'];
  commentary: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  examAnswers?: Maybe<Array<ExamAnswer>>;
  id: Scalars['ULID']['output'];
};

export type ExamResponse = {
  __typename?: 'ExamResponse';
  ExamScore: ExamScore;
  answerResponses?: Maybe<Array<AnswerResponse>>;
};

export type ExamScore = {
  __typename?: 'ExamScore';
  chapterID: Scalars['Uint64']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  medalType: ExamMedalType;
  score: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  userID: Scalars['Uint64']['output'];
};

export type ExistResult = {
  __typename?: 'ExistResult';
  is: Scalars['Boolean']['output'];
};

export enum ExitFeeStatus {
  Issued = 'ISSUED',
  NotCalculated = 'NOT_CALCULATED',
  NoNeed = 'NO_NEED'
}

export type FeedbackCategoriesInput = {
  after?: InputMaybe<Scalars['Uint64']['input']>;
  first: Scalars['Int']['input'];
  type?: InputMaybe<FeedbackCategoryType>;
};

export type FeedbackCategory = {
  __typename?: 'FeedbackCategory';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type FeedbackCategoryResponse = {
  __typename?: 'FeedbackCategoryResponse';
  items: Array<FeedbackCategory>;
  pageInfo: PageInfo;
};

export enum FeedbackCategoryType {
  Program = 'PROGRAM',
  Service = 'SERVICE'
}

export enum FunctionType {
  StudyReport = 'STUDY_REPORT'
}

export type GraduationDateNotificationSendLog = {
  __typename?: 'GraduationDateNotificationSendLog';
  course: Course;
  courseEndDate: Scalars['Time']['output'];
  courseID: Scalars['Uint64']['output'];
  createdAt: Scalars['Time']['output'];
};

export type GraduationDateNotificationSendLogResponse = {
  __typename?: 'GraduationDateNotificationSendLogResponse';
  items: Array<GraduationDateNotificationSendLog>;
  total: Scalars['Int64']['output'];
};

export type GraduationDateNotificationSendLogSearchInput = {
  courseID?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  studentID?: InputMaybe<Scalars['Uint64']['input']>;
};

/** 運営への連携 */
export enum HasAnnouncementsType {
  /** いいえ */
  No = 'NO',
  /** はい */
  Yes = 'YES'
}

export type Instructor = {
  __typename?: 'Instructor';
  confirmChannelID: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  googleMeetURL: Scalars['String']['output'];
  id: Scalars['Uint64']['output'];
  isCoach?: Maybe<Scalars['Boolean']['output']>;
  /** 管理者のみ参照可、それ以外の権限の場合はnull */
  personalInfo?: Maybe<InstructorPersonalInfo>;
  scInstructorID: Scalars['String']['output'];
  slackUserID: Scalars['String']['output'];
  status: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['Uint64']['output'];
  zoomUserID: Scalars['String']['output'];
};

export type InstructorCalendar = {
  __typename?: 'InstructorCalendar';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type InstructorClaimDetailSearchInput = {
  claimCategoryID?: InputMaybe<Scalars['Uint64']['input']>;
  studentID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type InstructorCourseInput = {
  /** 受講生のメモ */
  instructorMemo: Scalars['String']['input'];
};

export type InstructorCourseSearchInput = {
  /** CourseStatus */
  status?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  /** 受講生名でLike検索 */
  studentName?: InputMaybe<Scalars['String']['input']>;
  /** Course検索タイプ */
  type: CourseSearchType;
};

export type InstructorCourseSearchWithStudentNameInput = {
  /** 受講生名でLike検索 */
  studentName?: InputMaybe<Scalars['String']['input']>;
  /** Course検索タイプ */
  type: CourseSearchType;
};

export type InstructorLessonSearchInput = {
  courseID?: InputMaybe<Scalars['Uint64']['input']>;
  courseStatus?: InputMaybe<Scalars['Uint64']['input']>;
};

/** インストラクター個人情報 */
export type InstructorPersonalInfo = {
  __typename?: 'InstructorPersonalInfo';
  firstKanaName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastKanaName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type InstructorPracticeSubmit = {
  __typename?: 'InstructorPracticeSubmit';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  practice: Practice;
  practiceID: Scalars['ULID']['output'];
  status: Valid;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['Uint64']['output'];
  withoutDraftPracticeSubmitDetails?: Maybe<Array<PracticeSubmitDetail>>;
};

export type InstructorPracticeSubmitSearchInput = {
  limit: Scalars['Int64']['input'];
  page: Scalars['Int64']['input'];
  practiceID?: InputMaybe<Scalars['ULID']['input']>;
  programID?: InputMaybe<Scalars['Uint64']['input']>;
  reviewStatus?: InputMaybe<PracticeSubmitDetailReviewStatus>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey: PracticeSubmitSortKey;
  type: InstructorPracticeSubmitSearchType;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export enum InstructorPracticeSubmitSearchType {
  /** すべての提出物 */
  All = 'ALL',
  /** 担当受講生の提出物 */
  MyStudents = 'MY_STUDENTS',
  /** レビューした提出物 */
  Reviewed = 'REVIEWED'
}

export type InstructorSchedule = {
  __typename?: 'InstructorSchedule';
  createdAt: Scalars['Time']['output'];
  endAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  instructor?: Maybe<Instructor>;
  spotLessons: Array<SpotLesson>;
  startAt: Scalars['Time']['output'];
  status: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  user?: Maybe<User>;
  userID: Scalars['Uint64']['output'];
};

export type InstructorScheduleInput = {
  endAt: Scalars['Time']['input'];
  startAt: Scalars['Time']['input'];
};

export type InstructorScheduleSearchResponse = {
  __typename?: 'InstructorScheduleSearchResponse';
  items: Array<InstructorSchedule>;
  total: Scalars['Int64']['output'];
};

export type InstructorSearchResponse = {
  __typename?: 'InstructorSearchResponse';
  items: Array<Instructor>;
  total: Scalars['Int64']['output'];
};

export type InstructorSpotLessonSearchInput = {
  from?: InputMaybe<Scalars['Time']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  phases: Array<SpotLessonPhase>;
  to?: InputMaybe<Scalars['Time']['input']>;
  withLastMinuteCanceled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  amountDue: Scalars['Uint64']['output'];
  amountPaid: Scalars['Uint64']['output'];
  amountRemaining: Scalars['Uint64']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  invoiceItems: Array<InvoiceItem>;
  providerInvoiceID: Scalars['String']['output'];
  status: InvoiceStatus;
  subscription: SubscriptionInfo;
  subtotal: Scalars['Uint64']['output'];
  tax: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  url?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  amount: Scalars['Uint64']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  invoiceID: Scalars['Uint64']['output'];
  price: Price;
  quantity: Scalars['Uint64']['output'];
  status: Valid;
  updatedAt: Scalars['Time']['output'];
};

export type InvoiceItemSearchResponse = {
  __typename?: 'InvoiceItemSearchResponse';
  items: Array<InvoiceItem>;
  total: Scalars['Uint64']['output'];
};

/** Invoice-請求一覧検索パラメーター */
export type InvoiceSearchInput = {
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
};

export type InvoiceSearchResponse = {
  __typename?: 'InvoiceSearchResponse';
  items: Array<Invoice>;
  total: Scalars['Uint64']['output'];
};

export enum InvoiceStatus {
  Draft = 'DRAFT',
  Open = 'OPEN',
  Paid = 'PAID',
  Uncollectible = 'UNCOLLECTIBLE',
  Void = 'VOID'
}

export type InvoicesSearchInput = {
  isCurrentSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int64']['input'];
  nextCursor?: InputMaybe<Scalars['String']['input']>;
  previousCursor?: InputMaybe<Scalars['String']['input']>;
};

/** 学習スケジュールの進捗 */
export enum IsOnScheduleType {
  /** やや進んでいる */
  BitForward = 'BIT_FORWARD',
  /** やや遅れている */
  BitLate = 'BIT_LATE',
  /** 進捗通り */
  OnSchedule = 'ON_SCHEDULE',
  /** 進んでいる */
  TooForward = 'TOO_FORWARD',
  /** 遅れている */
  TooLate = 'TOO_LATE'
}

export type Lesson = {
  __typename?: 'Lesson';
  assistanceDetail?: Maybe<Scalars['String']['output']>;
  canceled: Scalars['Uint64']['output'];
  completed: Scalars['Uint64']['output'];
  course?: Maybe<Course>;
  createdAt: Scalars['Time']['output'];
  delayReason?: Maybe<Scalars['String']['output']>;
  endAt: Scalars['Time']['output'];
  homework?: Maybe<Scalars['String']['output']>;
  id: Scalars['Uint64']['output'];
  instructor?: Maybe<Instructor>;
  instructorAssistance: Array<Scalars['Uint64']['output']>;
  lessonsAssistances: Array<LessonsAssistance>;
  phase: Scalars['Uint64']['output'];
  prepare?: Maybe<Scalars['String']['output']>;
  progress: Scalars['Uint64']['output'];
  startAt: Scalars['Time']['output'];
  status: Valid;
  studentAssistance: Array<Scalars['Uint64']['output']>;
  taughtSkill?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type LessonInput = {
  canceled?: InputMaybe<Scalars['Uint64']['input']>;
  completed?: InputMaybe<Scalars['Uint64']['input']>;
  delayReason?: InputMaybe<Scalars['String']['input']>;
  endAt: Scalars['Time']['input'];
  homework?: InputMaybe<Scalars['String']['input']>;
  instructorAssistance?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  phase?: InputMaybe<Scalars['Uint64']['input']>;
  prepare?: InputMaybe<Scalars['String']['input']>;
  startAt: Scalars['Time']['input'];
  studentAssistance?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  taughtSkill?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<Scalars['Uint64']['input']>;
};

export type LessonQuestionnaireSendLog = {
  __typename?: 'LessonQuestionnaireSendLog';
  course: Course;
  courseID: Scalars['Uint64']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  instructor: Instructor;
  instructorID: Scalars['Uint64']['output'];
  lesson: Lesson;
  lessonID: Scalars['Uint64']['output'];
  student: Student;
  studentID: Scalars['Uint64']['output'];
};

export type LessonQuestionnaireSendLogResponse = {
  __typename?: 'LessonQuestionnaireSendLogResponse';
  items: Array<LessonQuestionnaireSendLog>;
  total: Scalars['Int64']['output'];
};

export type LessonQuestionnaireSendLogSearchInput = {
  courseID?: InputMaybe<Scalars['Uint64']['input']>;
  id?: InputMaybe<Scalars['ULID']['input']>;
  instructorID?: InputMaybe<Scalars['Uint64']['input']>;
  lessonID?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  studentID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type LessonReportInput = {
  assistanceDetail: Scalars['String']['input'];
  assistances: Array<Scalars['Uint64']['input']>;
  canceled: Scalars['Uint64']['input'];
  delayReason: Scalars['String']['input'];
  homework: Scalars['String']['input'];
  prepare: Scalars['String']['input'];
  progress: Scalars['Uint64']['input'];
  taughtSkill: Scalars['String']['input'];
};

export type LessonSearchResponse = {
  __typename?: 'LessonSearchResponse';
  items: Array<Lesson>;
  total: Scalars['Uint64']['output'];
};

export type LessonsAssistance = {
  __typename?: 'LessonsAssistance';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type MailSetting = {
  __typename?: 'MailSetting';
  attendanceStatusChanged: Valid;
  backSchool: Valid;
  claimApplied: Valid;
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  lessonLogUnregistered: Valid;
  lessonRegistered: Valid;
  lessonRemind: Valid;
  lessonScheduleUpdated: Valid;
  lessonUnregistered: Valid;
  messageReceived: Valid;
  notice: Valid;
  practiceSubmitDetailReviewCommentRegistered: Valid;
  practiceSubmitReRegistered: Valid;
  practiceSubmitRegistered: Valid;
  questionAnswerRegistered: Valid;
  questionCommentRegistered: Valid;
  questionRegistered: Valid;
  sessionRemind: Valid;
  spotLessonCancel: Valid;
  spotLessonLogUnregistered: Valid;
  spotLessonRegistered: Valid;
  spotLessonRemind: Valid;
  studyReportAchieved: Valid;
  studyReportCommentRegistered: Valid;
  ticketRemind: Valid;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['Uint64']['output'];
};

export type MailSettingInput = {
  attendanceStatusChanged: Valid;
  backSchool: Valid;
  claimApplied: Valid;
  lessonLogUnregistered: Valid;
  lessonRegistered: Valid;
  lessonRemind: Valid;
  lessonScheduleUpdated: Valid;
  lessonUnregistered: Valid;
  messageReceived: Valid;
  notice: Valid;
  practiceSubmitDetailReviewCommentRegistered: Valid;
  practiceSubmitReRegistered: Valid;
  practiceSubmitRegistered: Valid;
  questionAnswerRegistered: Valid;
  questionCommentRegistered: Valid;
  questionRegistered: Valid;
  sessionRemind: Valid;
  spotLessonCancel: Valid;
  spotLessonLogUnregistered: Valid;
  spotLessonRegistered: Valid;
  spotLessonRemind: Valid;
  studyReportAchieved: Valid;
  studyReportCommentRegistered: Valid;
  ticketRemind: Valid;
};

/** メール設定検索結果 */
export type MailSettingSearchResponse = {
  __typename?: 'MailSettingSearchResponse';
  items: Array<MailSetting>;
  total: Scalars['Uint64']['output'];
};

export type Modal = {
  __typename?: 'Modal';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  isRead: Scalars['Int64']['output'];
  type: ModalType;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['Uint64']['output'];
};

export enum ModalType {
  SpotLessonTicketModal = 'SPOT_LESSON_TICKET_MODAL'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** 新規登録時アンケート登録 */
  NewRegisteredQuestionnaire: Scalars['Boolean']['output'];
  /** 再課金時アンケート登録 */
  RechargeRegisteredQuestionnaire: Scalars['Boolean']['output'];
  /** QA-質問追加 */
  addQuestion: Question;
  /** QA-回答追加 */
  addQuestionAnswer: QuestionAnswer;
  /** QA-回答評価を追加 */
  addQuestionAnswerEvaluation: QuestionEvaluation;
  /** QA-コメント追加 */
  addQuestionComment: QuestionComment;
  /** タグ-Admin-登録 */
  addTagForAdmin: Scalars['Boolean']['output'];
  addTweet: Tweet;
  addTweetComment: TweetComment;
  addTweetFavorite: TweetFavorite;
  answerExam?: Maybe<ExamResponse>;
  /** 請求申請-インストラクター向け申請 */
  applyClaimForInstructor: Claim;
  banTweetCommentForAdmin: TweetComment;
  banTweetForAdmin: Tweet;
  cancelSpotLesson: Scalars['Boolean']['output'];
  /** 解約 */
  cancelSubscription: SubscriptionInfo;
  /** QA-解答いいね変更 */
  changeQuestionAnswerFavoriteStatus: QuestionAnswerFavorite;
  /** QA-質問いいね変更 */
  changeQuestionFavoriteStatus: QuestionFavorite;
  /** 権限変更 */
  changeTeamMemberRole: Scalars['Boolean']['output'];
  completeSpotLessonForInstructor: Scalars['Boolean']['output'];
  createAbTestSettingForAdmin: Scalars['Boolean']['output'];
  createAdmin: Admin;
  /** バナーCID登録 - admin用 */
  createBannerCidForAdmin: BannerCid;
  /** バナー登録 - admin用 */
  createBannerForAdmin: Banner;
  /** キャンペーンを登録する-Admin */
  createCampaignForAdmin: Campaign;
  /** Chapter-Admin-作成 */
  createChapterForAdmin: Chapter;
  /** チャットメッセージ登録 */
  createChatMessage: ChatMessage;
  /** 管理者 チャットルーム作成 */
  createChatRoomForAdmin?: Maybe<ChatRoom>;
  /** 請求申請詳細-管理者向け作成 */
  createClaimDetailForAdmin: ClaimDetail;
  /** 請求申請詳細-インストラクター向け作成 */
  createClaimDetailForInstructor: ClaimDetail;
  /** 請求申請-管理者向け作成 */
  createClaimForAdmin: Claim;
  /** コース教材作成（管理者用） */
  createCourseProgramForAdmin: CourseProgram;
  /** コース教材ステップ作成（管理者用） */
  createCourseProgramStepForAdmin: CourseProgramStep;
  /** インストラクター向け更新系 */
  createInstructorSchedule: Scalars['Boolean']['output'];
  /** 管理者向け更新系 */
  createInstructorScheduleForAdmin: Scalars['Boolean']['output'];
  /** レッスン-作成 */
  createLessonForAdmin: Lesson;
  /** レッスン-作成 */
  createLessonForInstructor: Lesson;
  /** アナウンス-Admin-作成 */
  createNoticeForAdmin: Notice;
  createPlanForAdmin: Plan;
  /** 課題-管理者向け作成 */
  createPracticeForAdmin?: Maybe<Practice>;
  /** 登録 */
  createPracticeSubmitDetailReviewComment: PracticeSubmitDetailReviewComment;
  createProgramFeedback: ProgramFeedback;
  /** Program-Admin-作成 */
  createProgramForAdmin: Scalars['Boolean']['output'];
  /** ProgramSample-Admin-作成 */
  createProgramSampleForAdmin: ProgramSample;
  /** 教材満足度登録 */
  createProgramSatisfaction: ProgramSatisfaction;
  createServiceFeedback: ServiceFeedback;
  /** セッション-作成 */
  createSession: Session;
  /** セッション-管理者向け作成 */
  createSessionForAdmin: Session;
  /** セッション受講履歴-作成 */
  createSessionReport: SessionReport;
  /** セッション受講履歴-管理者向け作成 */
  createSessionReportForAdmin: SessionReport;
  /** 管理者向けスポットレッスン-作成 */
  createSpotLessonForAdmin: SpotLesson;
  /** StudyReport-作成 */
  createStudyReport: StudyReport;
  /** StudyReportComment-作成 */
  createStudyReportComment: StudyReportComment;
  /** StudyReportComment-Admin-作成 */
  createStudyReportCommentForAdmin: StudyReportComment;
  /** StudyReportDetail-Admin-作成 */
  createStudyReportDetailForAdmin: StudyReportDetail;
  /** StudyReportFavorite-作成 */
  createStudyReportFavorite: StudyReportFavorite;
  /** StudyReport-Admin-作成 */
  createStudyReportForAdmin: StudyReport;
  /** チーム作成 */
  createTeam: Team;
  /** チーム招待作成 */
  createTeamInvitation: Scalars['Boolean']['output'];
  /** チケット作成 - Admin用 */
  createTicketForAdmin: Ticket;
  /** チャットメッセージ削除 */
  deleteChatMessage: ChatMessage;
  deleteChatMessageDraft: Scalars['Boolean']['output'];
  /** 請求申請詳細-インストラクター向け削除 */
  deleteClaimDetailForInstructor: Scalars['Boolean']['output'];
  deleteInstructorSchedule: Scalars['Boolean']['output'];
  deleteInstructorScheduleForAdmin: Scalars['Boolean']['output'];
  /** レッスン-削除 */
  deleteLessonForAdmin: Scalars['Boolean']['output'];
  /** レッスン-削除 */
  deleteLessonForInstructor: Scalars['Boolean']['output'];
  deletePaymentMethod: Scalars['Boolean']['output'];
  deleteProgramFeedbackForAdmin: ProgramFeedback;
  /** StudyReport-削除 */
  deleteStudyReport: StudyReport;
  /** StudyReportComment-削除 */
  deleteStudyReportComment: StudyReportComment;
  /** StudyReportFavorite-削除 */
  deleteStudyReportFavorite: StudyReportFavorite;
  deleteTeam: Scalars['Boolean']['output'];
  deleteTeamForAdmin: Scalars['Boolean']['output'];
  deleteTeamMemberForAdmin: Scalars['Boolean']['output'];
  deleteTweet: Tweet;
  deleteTweetComment: TweetComment;
  deleteTweetCommentForAdmin: TweetComment;
  deleteTweetFavorite: TweetFavorite;
  deleteTweetForAdmin: Tweet;
  /** 法人に参加する */
  joinTeamMember: TeamMember;
  /** 提出 */
  newPracticeSubmit: PracticeSubmit;
  nonAttendanceSpotLessonForInstructor: Scalars['Boolean']['output'];
  /** OAuth登録 */
  oAuthRegister: User;
  /** 再提出 */
  rePracticeSubmit: PracticeSubmit;
  /** チャットメッセージ既読 */
  readAllChatMessage: ReadAllChatMessageResponse;
  /** アナウンス-一括既読にする */
  readAllNotices: Scalars['Boolean']['output'];
  readAllNotifications: ResultResponse;
  readModal: Scalars['Boolean']['output'];
  /** アナウンス-既読にする */
  readNotice: Scalars['Boolean']['output'];
  readNotifications: ResultResponse;
  /** 登録 */
  register: User;
  releaseSubscriptionSchedule: Scalars['Boolean']['output'];
  /** メンバーを外す */
  removeTeamMember: Scalars['Boolean']['output'];
  /** 管理者向け-パスワードリセット処理 */
  resendTemporaryPasswordForAdmin: Scalars['Boolean']['output'];
  reserveSpotLesson: Scalars['Boolean']['output'];
  /** QA-質問を解決済みにする */
  resolveQuestion: Question;
  /** 解約のキャンセル */
  restoreSubscription: SubscriptionInfo;
  /** 学習履歴-保存 */
  saveStudyLog: StudyLog;
  selectPaymentMethod: Scalars['Boolean']['output'];
  sendWithdrawalQuestionnaireInput: Scalars['Boolean']['output'];
  setupIntent: Scalars['String']['output'];
  /** コース教材開始 */
  startCourseProgram: CourseProgramUserData;
  subscribe: Scalars['Boolean']['output'];
  switchCancelAtPeriodEndSubscription: Scalars['Boolean']['output'];
  teamDeletePaymentMethod: Scalars['Boolean']['output'];
  teamSelectPaymentMethod: Scalars['Boolean']['output'];
  teamSubscribe: Scalars['Boolean']['output'];
  teamSwitchCancelAtPeriodEndSubscription: Scalars['Boolean']['output'];
  teamUpdatePaymentMethodType: Scalars['Boolean']['output'];
  teamUpdateSubscription: Scalars['Boolean']['output'];
  updateAbTestSettingForAdmin: Scalars['Boolean']['output'];
  updateAdmin: Admin;
  /** バナーCID更新 - admin用 */
  updateBannerCidForAdmin: BannerCid;
  /** バナー更新 - admin用 */
  updateBannerForAdmin: Banner;
  /** キャンペーンを更新する-Admin */
  updateCampaignForAdmin: Campaign;
  /** Chapter-Admin-更新 */
  updateChapterForAdmin: Chapter;
  /** チャットメッセージ更新 */
  updateChatMessage: ChatMessage;
  /** 管理者向けチャットメッセージ更新 */
  updateChatMessageForAdmin?: Maybe<ChatMessage>;
  /** 管理者 チャットルーム更新 */
  updateChatRoomForAdmin?: Maybe<ChatRoom>;
  /** 請求申請詳細-管理者向け更新 */
  updateClaimDetailForAdmin: ClaimDetail;
  /** 請求申請詳細-インストラクター向け更新 */
  updateClaimDetailForInstructor: ClaimDetail;
  /** 請求申請-管理者向け更新 */
  updateClaimForAdmin: Claim;
  /** 請求申請-管理者向け複数承認 */
  updateClaimsToApproveForAdmin: Scalars['Boolean']['output'];
  /** 管理者用コース更新 */
  updateCourseForAdmin: Course;
  /** インストラクター向けコースのメモ更新 */
  updateCourseForInstructor: Course;
  /** コース教材更新（管理者用） */
  updateCourseProgramForAdmin: CourseProgram;
  /** コース教材ステップ更新（管理者用） */
  updateCourseProgramStepForAdmin: CourseProgramStep;
  /** 管理者向け-ログインユーザーのプロフィール画像更新 */
  updateCurrentUserImageForAdmin: User;
  updateInstructorForAdmin: Instructor;
  updateInstructorSchedule: Scalars['Boolean']['output'];
  updateInstructorScheduleForAdmin: Scalars['Boolean']['output'];
  /** 最終アクセス更新 */
  updateLastAccess: Scalars['Boolean']['output'];
  /** レッスン-更新 */
  updateLessonForAdmin: Lesson;
  /** レッスン-更新 */
  updateLessonForInstructor: Lesson;
  updateMailSetting: MailSetting;
  /** メール設定-Admin-更新 */
  updateMailSettingForAdmin: MailSetting;
  /** アナウンス-Admin-編集 */
  updateNoticeForAdmin: Notice;
  updatePlanForAdmin: Plan;
  /** 課題-管理者向け更新 */
  updatePracticeForAdmin: Practice;
  /** 課題提出詳細-管理者向け更新 */
  updatePracticeSubmitDetailForAdmin: PracticeSubmitDetail;
  /** 編集 */
  updatePracticeSubmitDetailReviewComment: PracticeSubmitDetailReviewComment;
  /** 課題提出-管理者向け更新 */
  updatePracticeSubmitForAdmin: PracticeSubmit;
  /** Program-Admin-更新 */
  updateProgramForAdmin: Scalars['Boolean']['output'];
  /** ProgramSample-Admin-更新 */
  updateProgramSampleForAdmin: ProgramSample;
  /** QA-質問更新 */
  updateQuestion: Question;
  /** QA-回答更新 */
  updateQuestionAnswer: QuestionAnswer;
  /** QA-Admin-回答更新 */
  updateQuestionAnswerForAdmin: QuestionAnswer;
  /** QA-コメント更新 */
  updateQuestionComment: QuestionComment;
  /** QA-Admin-コメント更新 */
  updateQuestionCommentForAdmin: QuestionComment;
  /** QA-Admin-質問更新 */
  updateQuestionForAdmin: Question;
  /** セッション-更新 */
  updateSession: Session;
  /** セッション-管理者向け更新 */
  updateSessionForAdmin: Session;
  /** セッション受講履歴-更新 */
  updateSessionReport: SessionReport;
  /** セッション受講履歴-管理者向け更新 */
  updateSessionReportForAdmin: SessionReport;
  updateSpotLesson: Scalars['Boolean']['output'];
  /** 管理者向けスポットレッスン更新系 */
  updateSpotLessonForAdmin: Scalars['Boolean']['output'];
  updateStudentForAdmin: Student;
  /** StudyReport-更新 */
  updateStudyReport: StudyReport;
  /** StudyReportComment-更新 */
  updateStudyReportComment: StudyReportComment;
  /** StudyReportComment-Admin-更新 */
  updateStudyReportCommentForAdmin: StudyReportComment;
  /** StudyReportDetail-Admin-更新 */
  updateStudyReportDetailForAdmin: StudyReportDetail;
  /** StudyReport-Admin-更新 */
  updateStudyReportForAdmin: StudyReport;
  updateSubscription: Scalars['Boolean']['output'];
  /** 管理者向け解約ステータス更新 */
  updateSubscriptionCancellationStatus: SubscriptionInfo;
  /** タグ-Admin-更新 */
  updateTagForAdmin: Scalars['Boolean']['output'];
  updateTeam: Team;
  updateTeamForAdmin: Team;
  updateTeamMemberForAdmin: TeamMember;
  /** チケット更新 - Admin用 */
  updateTicketForAdmin?: Maybe<Ticket>;
  /** 現在ログインしているユーザーを更新する */
  updateUser: User;
  /** 管理者向け-更新処理 */
  updateUserForAdmin: User;
  uploadFiles?: Maybe<Array<UploadFilesResponse>>;
  upsertChatMessageDraft: Scalars['Boolean']['output'];
  /** レッスン受講履歴-登録更新 */
  upsertLessonReportForInstructor: Lesson;
  /** 退会 */
  withdraw: Scalars['Boolean']['output'];
  /** 管理者向け-退会処理 */
  withdrawForAdmin: Scalars['Boolean']['output'];
};


export type MutationNewRegisteredQuestionnaireArgs = {
  questionnaireInput: NewRegisteredQuestionnaireInput;
};


export type MutationRechargeRegisteredQuestionnaireArgs = {
  questionnaireInput: RechargeRegisteredQuestionnaireInput;
};


export type MutationAddQuestionArgs = {
  input: QuestionInput;
};


export type MutationAddQuestionAnswerArgs = {
  input: QuestionAnswerInput;
  isEscalation: Scalars['Boolean']['input'];
  questionID: Scalars['Uint64']['input'];
};


export type MutationAddQuestionAnswerEvaluationArgs = {
  input: QuestionAnswerEvaluationInput;
};


export type MutationAddQuestionCommentArgs = {
  input: QuestionCommentInput;
  questionAnswerID: Scalars['Uint64']['input'];
};


export type MutationAddTagForAdminArgs = {
  input: AdminTagInput;
};


export type MutationAddTweetArgs = {
  input?: InputMaybe<TweetInput>;
};


export type MutationAddTweetCommentArgs = {
  input: TweetCommentInput;
};


export type MutationAddTweetFavoriteArgs = {
  tweetID: Scalars['ULID']['input'];
};


export type MutationAnswerExamArgs = {
  input: AnswerExamInput;
};


export type MutationApplyClaimForInstructorArgs = {
  input: ClaimInput;
  yearMonth: Scalars['Time']['input'];
};


export type MutationBanTweetCommentForAdminArgs = {
  tweetCommentID: Scalars['ULID']['input'];
};


export type MutationBanTweetForAdminArgs = {
  tweetID: Scalars['ULID']['input'];
};


export type MutationCancelSpotLessonArgs = {
  id: Scalars['Uint64']['input'];
};


export type MutationCancelSubscriptionArgs = {
  id: Scalars['Uint64']['input'];
  questionnaireInput: WithdrawalQuestionnaireInput;
};


export type MutationChangeQuestionAnswerFavoriteStatusArgs = {
  questionAnswerID: Scalars['Uint64']['input'];
};


export type MutationChangeQuestionFavoriteStatusArgs = {
  questionID: Scalars['Uint64']['input'];
};


export type MutationChangeTeamMemberRoleArgs = {
  role: TeamMemberRole;
  teamMemberID: Scalars['ULID']['input'];
};


export type MutationCompleteSpotLessonForInstructorArgs = {
  id: Scalars['Uint64']['input'];
};


export type MutationCreateAbTestSettingForAdminArgs = {
  input: AdminAbTestSettingInput;
};


export type MutationCreateAdminArgs = {
  input: AdminCreateInput;
};


export type MutationCreateBannerCidForAdminArgs = {
  input: AdminBannerCidInput;
};


export type MutationCreateBannerForAdminArgs = {
  input: AdminBannerInput;
};


export type MutationCreateCampaignForAdminArgs = {
  input?: InputMaybe<CampaignInput>;
};


export type MutationCreateChapterForAdminArgs = {
  input: AdminChapterInput;
};


export type MutationCreateChatMessageArgs = {
  input: ChatMessageCreateInput;
};


export type MutationCreateChatRoomForAdminArgs = {
  input: AdminChatRoomCreateInput;
};


export type MutationCreateClaimDetailForAdminArgs = {
  input: AdminClaimDetailInput;
};


export type MutationCreateClaimDetailForInstructorArgs = {
  input: ClaimDetailInput;
  yearMonth: Scalars['Time']['input'];
};


export type MutationCreateClaimForAdminArgs = {
  input: AdminClaimCreateInput;
};


export type MutationCreateCourseProgramForAdminArgs = {
  input: AdminCourseProgramInput;
};


export type MutationCreateCourseProgramStepForAdminArgs = {
  input: AdminCourseProgramStepInput;
};


export type MutationCreateInstructorScheduleArgs = {
  input: InstructorScheduleInput;
};


export type MutationCreateInstructorScheduleForAdminArgs = {
  input: AdminInstructorScheduleInput;
};


export type MutationCreateLessonForAdminArgs = {
  courseID: Scalars['Uint64']['input'];
  input: AdminLessonInput;
};


export type MutationCreateLessonForInstructorArgs = {
  courseID: Scalars['Uint64']['input'];
  input: LessonInput;
};


export type MutationCreateNoticeForAdminArgs = {
  input: AdminNoticeInput;
};


export type MutationCreatePlanForAdminArgs = {
  input: AdminPlanInput;
};


export type MutationCreatePracticeForAdminArgs = {
  input: AdminPracticeInput;
};


export type MutationCreatePracticeSubmitDetailReviewCommentArgs = {
  input: PracticeSubmitDetailReviewCommentInput;
};


export type MutationCreateProgramFeedbackArgs = {
  input?: InputMaybe<ProgramFeedbackInput>;
};


export type MutationCreateProgramForAdminArgs = {
  input: AdminProgramInput;
};


export type MutationCreateProgramSampleForAdminArgs = {
  input: AdminProgramSampleInput;
};


export type MutationCreateProgramSatisfactionArgs = {
  input: ProgramSatisfactionInput;
};


export type MutationCreateServiceFeedbackArgs = {
  input?: InputMaybe<ServiceFeedbackInput>;
};


export type MutationCreateSessionArgs = {
  coachingID: Scalars['ULID']['input'];
  input: SessionInput;
};


export type MutationCreateSessionForAdminArgs = {
  input: AdminSessionInput;
};


export type MutationCreateSessionReportArgs = {
  id: Scalars['ULID']['input'];
  input: SessionReportInput;
};


export type MutationCreateSessionReportForAdminArgs = {
  input: AdminSessionReportInput;
};


export type MutationCreateSpotLessonForAdminArgs = {
  input: AdminSpotLessonInput;
};


export type MutationCreateStudyReportArgs = {
  input: StudyReportInput;
};


export type MutationCreateStudyReportCommentArgs = {
  input: StudyReportCommentInput;
  studyReportID: Scalars['Uint64']['input'];
};


export type MutationCreateStudyReportCommentForAdminArgs = {
  input: AdminStudyReportCommentInput;
};


export type MutationCreateStudyReportDetailForAdminArgs = {
  input: AdminStudyReportDetailInput;
};


export type MutationCreateStudyReportFavoriteArgs = {
  studyReportID: Scalars['Uint64']['input'];
};


export type MutationCreateStudyReportForAdminArgs = {
  input: AdminStudyReportInput;
};


export type MutationCreateTeamArgs = {
  input: TeamInput;
};


export type MutationCreateTeamInvitationArgs = {
  input: TeamInvitationInput;
};


export type MutationCreateTicketForAdminArgs = {
  input: AdminTicketCreateInput;
};


export type MutationDeleteChatMessageArgs = {
  id: Scalars['Uint64']['input'];
};


export type MutationDeleteChatMessageDraftArgs = {
  chatRoomID: Scalars['Uint64']['input'];
};


export type MutationDeleteClaimDetailForInstructorArgs = {
  id: Scalars['Uint64']['input'];
};


export type MutationDeleteInstructorScheduleArgs = {
  id: Scalars['Uint64']['input'];
};


export type MutationDeleteInstructorScheduleForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type MutationDeleteLessonForAdminArgs = {
  lessonID: Scalars['Uint64']['input'];
};


export type MutationDeleteLessonForInstructorArgs = {
  lessonID: Scalars['Uint64']['input'];
};


export type MutationDeletePaymentMethodArgs = {
  providerID: Scalars['String']['input'];
};


export type MutationDeleteProgramFeedbackForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type MutationDeleteStudyReportArgs = {
  id: Scalars['Uint64']['input'];
};


export type MutationDeleteStudyReportCommentArgs = {
  id: Scalars['Uint64']['input'];
};


export type MutationDeleteStudyReportFavoriteArgs = {
  studyReportID: Scalars['Uint64']['input'];
};


export type MutationDeleteTeamArgs = {
  teamID: Scalars['ULID']['input'];
};


export type MutationDeleteTeamForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type MutationDeleteTeamMemberForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type MutationDeleteTweetArgs = {
  tweetID: Scalars['ULID']['input'];
};


export type MutationDeleteTweetCommentArgs = {
  tweetCommentID: Scalars['ULID']['input'];
};


export type MutationDeleteTweetCommentForAdminArgs = {
  tweetCommentID: Scalars['ULID']['input'];
};


export type MutationDeleteTweetFavoriteArgs = {
  tweetID: Scalars['ULID']['input'];
};


export type MutationDeleteTweetForAdminArgs = {
  tweetID: Scalars['ULID']['input'];
};


export type MutationJoinTeamMemberArgs = {
  teamInvitationID: Scalars['ULID']['input'];
};


export type MutationNewPracticeSubmitArgs = {
  input: PracticeSubmitInput;
};


export type MutationNonAttendanceSpotLessonForInstructorArgs = {
  id: Scalars['Uint64']['input'];
};


export type MutationOAuthRegisterArgs = {
  input: OAuthUserRegisterInput;
};


export type MutationRePracticeSubmitArgs = {
  input: RePracticeSubmitInput;
};


export type MutationReadAllChatMessageArgs = {
  chatRoomID: Scalars['Uint64']['input'];
};


export type MutationReadModalArgs = {
  id: Scalars['Uint64']['input'];
};


export type MutationReadNoticeArgs = {
  id: Scalars['Uint64']['input'];
};


export type MutationReadNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type MutationRegisterArgs = {
  input: UserRegisterInput;
};


export type MutationRemoveTeamMemberArgs = {
  id: Scalars['ULID']['input'];
};


export type MutationResendTemporaryPasswordForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type MutationReserveSpotLessonArgs = {
  input: SpotLessonInput;
};


export type MutationResolveQuestionArgs = {
  id: Scalars['Uint64']['input'];
};


export type MutationRestoreSubscriptionArgs = {
  id: Scalars['Uint64']['input'];
};


export type MutationSaveStudyLogArgs = {
  chapterID: Scalars['Uint64']['input'];
  understandingLevel: StudyLogUnderstandingLevel;
};


export type MutationSelectPaymentMethodArgs = {
  providerID: Scalars['String']['input'];
};


export type MutationSendWithdrawalQuestionnaireInputArgs = {
  input: WithdrawalQuestionnaireInput;
};


export type MutationStartCourseProgramArgs = {
  id: Scalars['ULID']['input'];
};


export type MutationSubscribeArgs = {
  input: SubscribeFormInput;
};


export type MutationTeamDeletePaymentMethodArgs = {
  providerID: Scalars['String']['input'];
  teamID: Scalars['ULID']['input'];
};


export type MutationTeamSelectPaymentMethodArgs = {
  providerID: Scalars['String']['input'];
  teamID: Scalars['ULID']['input'];
};


export type MutationTeamSubscribeArgs = {
  input: TeamSubscribeFormInput;
};


export type MutationTeamSwitchCancelAtPeriodEndSubscriptionArgs = {
  teamID: Scalars['ULID']['input'];
};


export type MutationTeamUpdatePaymentMethodTypeArgs = {
  paymentMethodType: PaymentMethodType;
  teamID: Scalars['ULID']['input'];
};


export type MutationTeamUpdateSubscriptionArgs = {
  input: TeamUpdateSubscriptionFormInput;
  teamID: Scalars['ULID']['input'];
};


export type MutationUpdateAbTestSettingForAdminArgs = {
  id: Scalars['ULID']['input'];
  input: AdminAbTestSettingInput;
};


export type MutationUpdateAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminUpdateInput;
};


export type MutationUpdateBannerCidForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminBannerCidInput;
};


export type MutationUpdateBannerForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminBannerInput;
};


export type MutationUpdateCampaignForAdminArgs = {
  id: Scalars['ULID']['input'];
  input?: InputMaybe<CampaignInput>;
};


export type MutationUpdateChapterForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminChapterInput;
};


export type MutationUpdateChatMessageArgs = {
  id: Scalars['Uint64']['input'];
  input: ChatMessageUpdateInput;
};


export type MutationUpdateChatMessageForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminChatMessageInput;
};


export type MutationUpdateChatRoomForAdminArgs = {
  input: AdminChatRoomInput;
};


export type MutationUpdateClaimDetailForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminClaimDetailInput;
};


export type MutationUpdateClaimDetailForInstructorArgs = {
  id: Scalars['Uint64']['input'];
  input: ClaimDetailInput;
};


export type MutationUpdateClaimForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminClaimInput;
};


export type MutationUpdateClaimsToApproveForAdminArgs = {
  ids: Array<Scalars['Uint64']['input']>;
};


export type MutationUpdateCourseForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminCourseInput;
};


export type MutationUpdateCourseForInstructorArgs = {
  id: Scalars['Uint64']['input'];
  input: InstructorCourseInput;
};


export type MutationUpdateCourseProgramForAdminArgs = {
  id: Scalars['ULID']['input'];
  input: AdminCourseProgramInput;
};


export type MutationUpdateCourseProgramStepForAdminArgs = {
  id: Scalars['ULID']['input'];
  input: AdminCourseProgramStepInput;
};


export type MutationUpdateCurrentUserImageForAdminArgs = {
  image: Scalars['Upload']['input'];
};


export type MutationUpdateInstructorForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminInstructorInput;
};


export type MutationUpdateInstructorScheduleArgs = {
  id: Scalars['Uint64']['input'];
  input: InstructorScheduleInput;
};


export type MutationUpdateInstructorScheduleForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminUpdateInstructorScheduleInput;
};


export type MutationUpdateLastAccessArgs = {
  smrc?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLessonForAdminArgs = {
  input: AdminLessonInput;
  lessonID: Scalars['Uint64']['input'];
};


export type MutationUpdateLessonForInstructorArgs = {
  input: LessonInput;
  lessonID: Scalars['Uint64']['input'];
};


export type MutationUpdateMailSettingArgs = {
  input: MailSettingInput;
};


export type MutationUpdateMailSettingForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminMailSettingInput;
};


export type MutationUpdateNoticeForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminNoticeInput;
};


export type MutationUpdatePlanForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminPlanInput;
};


export type MutationUpdatePracticeForAdminArgs = {
  id: Scalars['ULID']['input'];
  input: AdminPracticeInput;
};


export type MutationUpdatePracticeSubmitDetailForAdminArgs = {
  id: Scalars['ULID']['input'];
  input: PracticeSubmitDetailInput;
};


export type MutationUpdatePracticeSubmitDetailReviewCommentArgs = {
  input: UpdatePracticeSubmitDetailReviewCommentInput;
};


export type MutationUpdatePracticeSubmitForAdminArgs = {
  id: Scalars['ULID']['input'];
  input: AdminPracticeSubmitInput;
};


export type MutationUpdateProgramForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminProgramInput;
};


export type MutationUpdateProgramSampleForAdminArgs = {
  id: Scalars['ULID']['input'];
  input: AdminProgramSampleInput;
};


export type MutationUpdateQuestionArgs = {
  id: Scalars['Uint64']['input'];
  input: QuestionInput;
};


export type MutationUpdateQuestionAnswerArgs = {
  id: Scalars['Uint64']['input'];
  input: QuestionAnswerInput;
};


export type MutationUpdateQuestionAnswerForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminQuestionAnswerInput;
};


export type MutationUpdateQuestionCommentArgs = {
  id: Scalars['Uint64']['input'];
  input: QuestionCommentInput;
};


export type MutationUpdateQuestionCommentForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminQuestionCommentInput;
};


export type MutationUpdateQuestionForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminQuestionInput;
};


export type MutationUpdateSessionArgs = {
  id: Scalars['ULID']['input'];
  input?: InputMaybe<SessionInput>;
};


export type MutationUpdateSessionForAdminArgs = {
  id: Scalars['ULID']['input'];
  input?: InputMaybe<AdminSessionInput>;
};


export type MutationUpdateSessionReportArgs = {
  id: Scalars['ULID']['input'];
  input: SessionReportInput;
};


export type MutationUpdateSessionReportForAdminArgs = {
  id: Scalars['ULID']['input'];
  input: AdminSessionReportInput;
};


export type MutationUpdateSpotLessonArgs = {
  id: Scalars['Uint64']['input'];
  input: SpotLessonUpdateInput;
};


export type MutationUpdateSpotLessonForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminSpotLessonUpdateInput;
};


export type MutationUpdateStudentForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminStudentInput;
};


export type MutationUpdateStudyReportArgs = {
  id: Scalars['Uint64']['input'];
  input: StudyReportInput;
};


export type MutationUpdateStudyReportCommentArgs = {
  id: Scalars['Uint64']['input'];
  input: StudyReportCommentInput;
};


export type MutationUpdateStudyReportCommentForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminStudyReportCommentInput;
};


export type MutationUpdateStudyReportDetailForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminStudyReportDetailInput;
};


export type MutationUpdateStudyReportForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminStudyReportInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionFormInput;
};


export type MutationUpdateSubscriptionCancellationStatusArgs = {
  id: Scalars['Uint64']['input'];
};


export type MutationUpdateTagForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminTagInput;
};


export type MutationUpdateTeamArgs = {
  id: Scalars['ULID']['input'];
  input: UpdateTeamInput;
};


export type MutationUpdateTeamForAdminArgs = {
  id: Scalars['ULID']['input'];
  input: UpdateTeamInput;
};


export type MutationUpdateTeamMemberForAdminArgs = {
  id: Scalars['ULID']['input'];
  input: UpdateTeamMemberInput;
};


export type MutationUpdateTicketForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminTicketInput;
};


export type MutationUpdateUserArgs = {
  input: UserInput;
};


export type MutationUpdateUserForAdminArgs = {
  id: Scalars['Uint64']['input'];
  input: AdminUserInput;
};


export type MutationUploadFilesArgs = {
  input: UploadFilesInput;
};


export type MutationUpsertChatMessageDraftArgs = {
  chatRoomID: Scalars['Uint64']['input'];
  content: Scalars['String']['input'];
};


export type MutationUpsertLessonReportForInstructorArgs = {
  input: LessonReportInput;
  lessonID: Scalars['Uint64']['input'];
};


export type MutationWithdrawArgs = {
  questionnaireInput: WithdrawalQuestionnaireInput;
};


export type MutationWithdrawForAdminArgs = {
  id: Scalars['Uint64']['input'];
};

export type MySubscriptionContractInput = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

/** 新規登録時アンケート入力項目 */
export type NewRegisteredQuestionnaireInput = {
  /** 魅力 - その他 */
  attractiveTypeOthers?: InputMaybe<Scalars['String']['input']>;
  /** 魅力 */
  attractiveTypes: Array<RegisteredQuestionnaireAttractiveType>;
  /** 生年月日 */
  birthday: Scalars['Time']['input'];
  /** 目的 */
  purpose: RegisteredQuestionnairePurpose;
  /** 目的 - その他 */
  purposeOthers?: InputMaybe<Scalars['String']['input']>;
  /** 学習予定の言語・技術 - その他 */
  scheduledStudyTypeOthers?: InputMaybe<Scalars['String']['input']>;
  /** 学習予定の言語・技術 */
  scheduledStudyTypes: Array<Scalars['Uint64']['input']>;
};

export type Notice = {
  __typename?: 'Notice';
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  noticePermissions: Array<NoticePermission>;
  noticeRead?: Maybe<NoticeRead>;
  notified: NoticeNotified;
  status: Valid;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export enum NoticeNotified {
  /** 通知済み */
  Finished = 'FINISHED',
  /** 未通知 */
  NotYet = 'NOT_YET',
  /** 処理中 */
  Processing = 'PROCESSING'
}

export type NoticePermission = {
  __typename?: 'NoticePermission';
  createdAt: Scalars['Time']['output'];
  noticeID: Scalars['Uint64']['output'];
  userRole: UserRole;
};

export type NoticeRead = {
  __typename?: 'NoticeRead';
  noticeID: Scalars['Uint64']['output'];
  userID: Scalars['Uint64']['output'];
};

export type NoticeSearchResponse = {
  __typename?: 'NoticeSearchResponse';
  items: Array<Notice>;
  total: Scalars['Uint64']['output'];
};

export type NoticesResponse = {
  __typename?: 'NoticesResponse';
  items: Array<Notice>;
  pageInfo: PageInfo;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  notificationDetail?: Maybe<NotificationDetail>;
  notificationReadStatus?: Maybe<NotificationReadStatus>;
  notificationStatus?: Maybe<NotificationStatus>;
  type: NotificationType;
  updatedAt: Scalars['Time']['output'];
  user?: Maybe<User>;
  userID: Scalars['Uint64']['output'];
};

export type NotificationDetail = {
  __typename?: 'NotificationDetail';
  actor?: Maybe<User>;
  course?: Maybe<Course>;
  createdAt: Scalars['Time']['output'];
  lesson?: Maybe<Lesson>;
  notificationID: Scalars['Uint64']['output'];
  practiceSubmit?: Maybe<PracticeSubmit>;
  practiceSubmitDetail?: Maybe<PracticeSubmitDetail>;
  practiceSubmitDetailReviewComment?: Maybe<PracticeSubmitDetailReviewComment>;
  question?: Maybe<Question>;
  session?: Maybe<Session>;
  spotLesson?: Maybe<SpotLesson>;
  studyReport?: Maybe<StudyReport>;
  title: Scalars['String']['output'];
};

export enum NotificationReadStatus {
  Read = 'READ',
  Unread = 'UNREAD'
}

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  items: Array<Notification>;
  pageInfo: PageInfo;
};

export enum NotificationStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export enum NotificationType {
  AttendanceStatusChangedNotifications = 'ATTENDANCE_STATUS_CHANGED_NOTIFICATIONS',
  BackSchoolNotifications = 'BACK_SCHOOL_NOTIFICATIONS',
  ClaimAppliedNotifications = 'CLAIM_APPLIED_NOTIFICATIONS',
  GivenFreeSpotLessonTicketNotifications = 'GIVEN_FREE_SPOT_LESSON_TICKET_NOTIFICATIONS',
  LessonCreatedNotifications = 'LESSON_CREATED_NOTIFICATIONS',
  LessonScheduleNotifications = 'LESSON_SCHEDULE_NOTIFICATIONS',
  LessonScheduleUncreatedNotifications = 'LESSON_SCHEDULE_UNCREATED_NOTIFICATIONS',
  LessonScheduleUpdatedNotifications = 'LESSON_SCHEDULE_UPDATED_NOTIFICATIONS',
  MessageNotifications = 'MESSAGE_NOTIFICATIONS',
  PracticeSubmitCreatedNotifications = 'PRACTICE_SUBMIT_CREATED_NOTIFICATIONS',
  PracticeSubmitDetailReviewCommentCreatedNotifications = 'PRACTICE_SUBMIT_DETAIL_REVIEW_COMMENT_CREATED_NOTIFICATIONS',
  PracticeSubmitReCreatedNotifications = 'PRACTICE_SUBMIT_RE_CREATED_NOTIFICATIONS',
  QuestionAnswerCreatedNotifications = 'QUESTION_ANSWER_CREATED_NOTIFICATIONS',
  QuestionCommentCreatedNotifications = 'QUESTION_COMMENT_CREATED_NOTIFICATIONS',
  QuestionCreatedNotifications = 'QUESTION_CREATED_NOTIFICATIONS',
  SessionRemindNotifications = 'SESSION_REMIND_NOTIFICATIONS',
  SpotLessonCancelNotifications = 'SPOT_LESSON_CANCEL_NOTIFICATIONS',
  SpotLessonLogUnregisteredNotifications = 'SPOT_LESSON_LOG_UNREGISTERED_NOTIFICATIONS',
  SpotLessonRegisteredNotifications = 'SPOT_LESSON_REGISTERED_NOTIFICATIONS',
  SpotLessonRemindNotifications = 'SPOT_LESSON_REMIND_NOTIFICATIONS',
  StudyReportCommentCreatedNotifications = 'STUDY_REPORT_COMMENT_CREATED_NOTIFICATIONS'
}

/** OAuth用アカウント作成の入力 */
export type OAuthUserRegisterInput = {
  smrc?: InputMaybe<Scalars['String']['input']>;
  userName: Scalars['String']['input'];
};

export type Onboarding = {
  __typename?: 'Onboarding';
  isCompletedProfile: Scalars['Boolean']['output'];
  isCompletedProgram: Scalars['Boolean']['output'];
  isCompletedQuestion: Scalars['Boolean']['output'];
  isCompletedSpotLesson: Scalars['Boolean']['output'];
  isCompletedStudyReport: Scalars['Boolean']['output'];
  isShowOnboarding: Scalars['Boolean']['output'];
  isShowProfile: Scalars['Boolean']['output'];
  isShowProgram: Scalars['Boolean']['output'];
  isShowQuestion: Scalars['Boolean']['output'];
  isShowSpotLesson: Scalars['Boolean']['output'];
  isShowStudyReport: Scalars['Boolean']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  amountPaid: Scalars['Uint64']['output'];
  charges: Array<Charge>;
  createdAt: Scalars['Time']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['Uint64']['output'];
  paymentIntentPurchaseItems: Array<PaymentIntentPurchaseItem>;
  phase: PaymentIntentPhase;
  providerPaymentIntentID: Scalars['String']['output'];
  status: Valid;
  tax: Scalars['Uint64']['output'];
  taxPercentage: Scalars['Float64']['output'];
  totalAmount: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

export enum PaymentIntentPhase {
  Canceled = 'CANCELED',
  Processing = 'PROCESSING',
  RequiresAction = 'REQUIRES_ACTION',
  RequiresCapture = 'REQUIRES_CAPTURE',
  RequiresConfirmation = 'REQUIRES_CONFIRMATION',
  RequiresPaymentmethod = 'REQUIRES_PAYMENTMETHOD',
  RequiresSucceeded = 'REQUIRES_SUCCEEDED',
  UnknOwN = 'UNKNOwN'
}

export type PaymentIntentPurchaseItem = {
  __typename?: 'PaymentIntentPurchaseItem';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  paymentIntent: PaymentIntent;
  purchaseItem: PurchaseItem;
  quantity: Scalars['Uint64']['output'];
  subTotal: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** PaymentIntent-課金履歴一覧検索パラメーター */
export type PaymentIntentSearchInput = {
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
};

export type PaymentIntentSearchResponse = {
  __typename?: 'PaymentIntentSearchResponse';
  items: Array<PaymentIntent>;
  total: Scalars['Uint64']['output'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  cardBrand: Scalars['String']['output'];
  cardNumber: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  expireMonth: Scalars['Uint64']['output'];
  expireYear: Scalars['Uint64']['output'];
  id: Scalars['Uint64']['output'];
  isAvailable: Bool;
  paymentMethodDefault?: Maybe<PaymentMethodDefault>;
  paymentType: Scalars['String']['output'];
  providerPaymentMethodID: Scalars['String']['output'];
  status: Valid;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

export type PaymentMethodDefault = {
  __typename?: 'PaymentMethodDefault';
  createdAt: Scalars['Time']['output'];
  paymentMethodID: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  userID: Scalars['Uint64']['output'];
};

export type PaymentMethodSearchResponse = {
  __typename?: 'PaymentMethodSearchResponse';
  items: Array<PaymentMethod>;
  total: Scalars['Uint64']['output'];
};

export enum PaymentMethodType {
  Bank = 'BANK',
  CreditCard = 'CREDIT_CARD'
}

export type PermissionList = {
  __typename?: 'PermissionList';
  roles: Array<UserRole>;
  teamIDs: Array<Scalars['ULID']['output']>;
  teamIDsForTeamAdmin: Array<Scalars['ULID']['output']>;
};

export enum PermissionType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Read = 'READ',
  Update = 'UPDATE'
}

export type Plan = {
  __typename?: 'Plan';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  isExtension: Bool;
  isFlexibleCurriculum: Bool;
  isLessonPreparationAllowed: Bool;
  isQuestionAllowed: Bool;
  lessonMinutes?: Maybe<Scalars['Uint64']['output']>;
  name: Scalars['String']['output'];
  status: Valid;
  updatedAt: Scalars['Time']['output'];
};

export type PlanSearchResponse = {
  __typename?: 'PlanSearchResponse';
  items: Array<Plan>;
  total: Scalars['Uint64']['output'];
};

export type Practice = {
  __typename?: 'Practice';
  answer?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  difficulty: PracticeDifficulty;
  id: Scalars['ULID']['output'];
  isAiReviewEnabled: Scalars['Boolean']['output'];
  isSubmittable: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  mySubmit?: Maybe<PracticeSubmit>;
  program: Program;
  programID: Scalars['Uint64']['output'];
  requireTime: Scalars['Int64']['output'];
  status: Valid;
  submitPassedCount: Scalars['Int64']['output'];
  title: Scalars['String']['output'];
  type: AuthorizationType;
  updatedAt: Scalars['Time']['output'];
};

export enum PracticeDifficulty {
  Easier = 'EASIER',
  Harder = 'HARDER',
  Normal = 'NORMAL',
  VeryEasy = 'VERY_EASY',
  VeryHard = 'VERY_HARD'
}

export type PracticeListItem = {
  __typename?: 'PracticeListItem';
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  difficulty: PracticeDifficulty;
  id: Scalars['ULID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  mySubmit?: Maybe<PracticeSubmit>;
  program: Program;
  programID: Scalars['Uint64']['output'];
  requireTime: Scalars['Int64']['output'];
  status: Valid;
  submitPassedCount: Scalars['Int64']['output'];
  title: Scalars['String']['output'];
  type: AuthorizationType;
  updatedAt: Scalars['Time']['output'];
};

export type PracticeSearchInput = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  tagID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type PracticeSearchResponse = {
  __typename?: 'PracticeSearchResponse';
  items: Array<PracticeListItem>;
  total: Scalars['Int64']['output'];
};

export type PracticeSubmit = {
  __typename?: 'PracticeSubmit';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  isInstructorReviewRequested: Scalars['Boolean']['output'];
  practice: Practice;
  practiceID: Scalars['ULID']['output'];
  practiceSubmitDetails?: Maybe<Array<PracticeSubmitDetail>>;
  status: Valid;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['Uint64']['output'];
};

export type PracticeSubmitDetail = {
  __typename?: 'PracticeSubmitDetail';
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  editedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ULID']['output'];
  practiceSubmitDetailReviewComment?: Maybe<PracticeSubmitDetailReviewComment>;
  practiceSubmitID: Scalars['ULID']['output'];
  reviewStatus: PracticeSubmitDetailReviewStatus;
  status: Valid;
  updatedAt: Scalars['Time']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type PracticeSubmitDetailInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  practiceSubmitID: Scalars['ULID']['input'];
  reviewStatus: PracticeSubmitDetailReviewStatus;
  status: Valid;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PracticeSubmitDetailReviewComment = {
  __typename?: 'PracticeSubmitDetailReviewComment';
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  practiceSubmitDetailID: Scalars['ULID']['output'];
  status: Valid;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['Uint64']['output'];
};

export type PracticeSubmitDetailReviewCommentInput = {
  content: Scalars['String']['input'];
  passed: Scalars['Boolean']['input'];
  practiceSubmitDetailID: Scalars['ULID']['input'];
  practiceSubmitID: Scalars['ULID']['input'];
};

export enum PracticeSubmitDetailReviewStatus {
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Passed = 'PASSED',
  WaitingForAiReview = 'WAITING_FOR_AI_REVIEW',
  WaitingForInstructorReview = 'WAITING_FOR_INSTRUCTOR_REVIEW'
}

export type PracticeSubmitDetailSearchResponse = {
  __typename?: 'PracticeSubmitDetailSearchResponse';
  items: Array<PracticeSubmitDetail>;
  total: Scalars['Int64']['output'];
};

export type PracticeSubmitInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  isDraft: Scalars['Boolean']['input'];
  /** 新規課題：必須、下書き課題：不要 */
  practiceID?: InputMaybe<Scalars['ULID']['input']>;
  /** 新規課題：不要、下書き課題：必須 */
  practiceSubmitDetailID?: InputMaybe<Scalars['ULID']['input']>;
  /** 新規課題：不要、下書き課題：必須 */
  practiceSubmitID?: InputMaybe<Scalars['ULID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** PracticeSubmitDetailを返却しない */
export type PracticeSubmitSearch = {
  __typename?: 'PracticeSubmitSearch';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  /** 詳細表示可否 */
  isViewable: Scalars['Boolean']['output'];
  /** 画面表示用 */
  latestPracticeSubmitDetailEditedAt?: Maybe<Scalars['Time']['output']>;
  /** 画面表示用 */
  latestPracticeSubmitDetailID: Scalars['ULID']['output'];
  practice: Practice;
  practiceID: Scalars['ULID']['output'];
  /** 画面表示用 */
  reviewStatus: PracticeSubmitDetailReviewStatus;
  /** 画面表示用 */
  reviewedCount: Scalars['Int64']['output'];
  status: Valid;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['Uint64']['output'];
};

export type PracticeSubmitSearchInput = {
  limit: Scalars['Int64']['input'];
  page: Scalars['Int64']['input'];
  practiceID?: InputMaybe<Scalars['ULID']['input']>;
  programID?: InputMaybe<Scalars['Uint64']['input']>;
  reviewStatus?: InputMaybe<PracticeSubmitDetailReviewStatus>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey: PracticeSubmitSortKey;
  type: PracticeSubmitSearchType;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

export type PracticeSubmitSearchResponse = {
  __typename?: 'PracticeSubmitSearchResponse';
  items: Array<PracticeSubmitSearch>;
  total: Scalars['Int64']['output'];
};

export enum PracticeSubmitSearchType {
  /** すべての提出物 */
  All = 'ALL',
  /** みんなの提出物 */
  Everyone = 'EVERYONE',
  /** あなたの提出物 */
  Mine = 'MINE',
  /** 下書き */
  MyDraft = 'MY_DRAFT'
}

export enum PracticeSubmitSortKey {
  /** 提出物が新しい順 */
  CreatedAt = 'CREATED_AT',
  /** 更新日時が新しい順 */
  UpdatedAt = 'UPDATED_AT'
}

export type Prefecture = {
  __typename?: 'Prefecture';
  createdAt: Scalars['Time']['output'];
  /** 都道府県ID */
  id: Scalars['Uint64']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type Price = {
  __typename?: 'Price';
  contractRecurringInterval: RecurringInterval;
  contractRecurringIntervalCount: Scalars['Int64']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  isMultiMonthContract: Scalars['Boolean']['output'];
  isSingleMonthContract: Scalars['Boolean']['output'];
  numberOfTickets: Scalars['Int']['output'];
  pricePermission?: Maybe<PricePermission>;
  product: Product;
  /** Stripe側のID、管理者のみ閲覧可能 */
  providerPriceID: Scalars['String']['output'];
  recurringInterval: RecurringInterval;
  recurringIntervalCount: Scalars['Int64']['output'];
  status: Valid;
  subscriptionType: SubscriptionType;
  type: PriceType;
  unitAmount: Scalars['Uint64']['output'];
  unitAmountDecimal: Scalars['String']['output'];
  unitAmountIncludingTax: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type PricePermission = {
  __typename?: 'PricePermission';
  practice?: Maybe<Scalars['Boolean']['output']>;
  program?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['Boolean']['output']>;
  studyLog?: Maybe<Scalars['Boolean']['output']>;
  submitPractice?: Maybe<Scalars['Boolean']['output']>;
  subscriptionType: SubscriptionType;
};

export type PriceSearchResponse = {
  __typename?: 'PriceSearchResponse';
  items: Array<Price>;
  total: Scalars['Int64']['output'];
};

export enum PriceType {
  PriceTypeOnetime = 'PRICE_TYPE_ONETIME',
  PriceTypeRecurring = 'PRICE_TYPE_RECURRING'
}

export type Product = {
  __typename?: 'Product';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  name: Scalars['String']['output'];
  price: Array<Price>;
  /** ProductExtensionが存在しない場合はDefault値を設定したものを返却 */
  productExtension: ProductExtension;
  /** Stripe側のID、管理者のみ閲覧可能 */
  providerProductID: Scalars['String']['output'];
  status: Valid;
  updatedAt: Scalars['Time']['output'];
};

export type ProductExtension = {
  __typename?: 'ProductExtension';
  contractPeriod: Scalars['Uint64']['output'];
  /** 1:月 or 2:日 */
  contractPeriodType: ContractPeriodType;
  /** 月 or 日で返却 */
  contractPeriodTypeLabel: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  isMultiMonthContract: Scalars['Boolean']['output'];
  productID: Scalars['Uint64']['output'];
  ticketCount: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** Product-Product検索パラメーター */
export type ProductSearchInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  priceType?: InputMaybe<PriceType>;
};

/** Product-Product検索結果 */
export type ProductSearchResponse = {
  __typename?: 'ProductSearchResponse';
  items: Array<Product>;
  total: Scalars['Int64']['output'];
};

export type Program = {
  __typename?: 'Program';
  answerCount: Scalars['Uint64']['output'];
  category: ProgramCategory;
  chapterCount: Scalars['Uint64']['output'];
  completedTime: Scalars['Int64']['output'];
  createdAt: Scalars['Time']['output'];
  currentProgramElement?: Maybe<ProgramElement>;
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['Uint64']['output'];
  number: Scalars['Uint64']['output'];
  programElements?: Maybe<Array<ProgramElement>>;
  programPermissions: Array<ProgramPermission>;
  programSample?: Maybe<ProgramSample>;
  questionCount: Scalars['Uint64']['output'];
  questions?: Maybe<Array<Question>>;
  repository: Scalars['String']['output'];
  requireTime: Scalars['Uint64']['output'];
  skill1: Scalars['String']['output'];
  skill2: Scalars['String']['output'];
  skill3: Scalars['String']['output'];
  status: Valid;
  studyLogCount: Scalars['Uint64']['output'];
  summary: Scalars['String']['output'];
  summaryImage1: Scalars['String']['output'];
  summaryImage2: Scalars['String']['output'];
  summaryImage3: Scalars['String']['output'];
  summaryImage4: Scalars['String']['output'];
  summaryImage5: Scalars['String']['output'];
  tags?: Maybe<Array<Tag>>;
  thumbnail: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: ProgramType;
  updatedAt: Scalars['Time']['output'];
};


export type ProgramCompletedTimeArgs = {
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};


export type ProgramCurrentProgramElementArgs = {
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};


export type ProgramStudyLogCountArgs = {
  userID?: InputMaybe<Scalars['Uint64']['input']>;
};

/** Programカテゴリー */
export enum ProgramCategory {
  /** 技術Q&A */
  Tech = 'TECH',
  /** お悩みQ&A */
  Trouble = 'TROUBLE'
}

export type ProgramElement = {
  __typename?: 'ProgramElement';
  chapter?: Maybe<Chapter>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  number?: Maybe<Scalars['Uint64']['output']>;
  practice?: Maybe<Practice>;
  program: Program;
  programID: Scalars['Uint64']['output'];
  status: Valid;
  updatedAt: Scalars['Time']['output'];
};

export type ProgramElementSearchResponse = {
  __typename?: 'ProgramElementSearchResponse';
  items: Array<ProgramElement>;
  total: Scalars['Int64']['output'];
};

export type ProgramFeedback = {
  __typename?: 'ProgramFeedback';
  chapter?: Maybe<Chapter>;
  chapterID?: Maybe<Scalars['Uint64']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  feedbackCategory: FeedbackCategory;
  feedbackCategoryID: Scalars['Uint64']['output'];
  id: Scalars['ULID']['output'];
  practice?: Maybe<Practice>;
  practiceID?: Maybe<Scalars['ULID']['output']>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['Uint64']['output'];
};

export type ProgramFeedbackInput = {
  chapterID?: InputMaybe<Scalars['Uint64']['input']>;
  content: Scalars['String']['input'];
  feedbackCategoryID: Scalars['Uint64']['input'];
  practiceID?: InputMaybe<Scalars['ULID']['input']>;
};

export type ProgramFeedbackResponse = {
  __typename?: 'ProgramFeedbackResponse';
  items: Array<ProgramFeedback>;
  pageInfo: PageInfo;
};

export type ProgramPermission = {
  __typename?: 'ProgramPermission';
  programID: Scalars['Uint64']['output'];
  userRole?: Maybe<UserRole>;
};

export type ProgramSample = {
  __typename?: 'ProgramSample';
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ULID']['output'];
  number: Scalars['Uint64']['output'];
  program: Program;
  status: Valid;
  thumbnail: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  url: Scalars['String']['output'];
};

/** ProgramSample-教材サンプル検索パラメーター */
export type ProgramSampleSearchInput = {
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
};

export type ProgramSampleSearchResponse = {
  __typename?: 'ProgramSampleSearchResponse';
  items: Array<ProgramSample>;
  total: Scalars['Uint64']['output'];
};

export type ProgramSatisfaction = {
  __typename?: 'ProgramSatisfaction';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  level: ProgramSatisfactionLevel;
  programID: Scalars['Uint64']['output'];
  userID: Scalars['Uint64']['output'];
};

export type ProgramSatisfactionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  level: ProgramSatisfactionLevel;
  programID: Scalars['Uint64']['input'];
};

export enum ProgramSatisfactionLevel {
  /** 普通 */
  Average = 'AVERAGE',
  /** とても不満 */
  Bad = 'BAD',
  /** とても満足 */
  Excellent = 'EXCELLENT',
  /** やや満足 */
  Good = 'GOOD',
  /** やや不満 */
  Poor = 'POOR'
}

export type ProgramSearchInput = {
  altMode?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<ProgramCategory>;
  limit?: InputMaybe<Scalars['Int64']['input']>;
  page?: InputMaybe<Scalars['Int64']['input']>;
  /** 検索タイプ　学習中or学習完了した教材を取得する場合はここで指定する */
  programSearchType: ProgramSearchType;
  tagID?: InputMaybe<Scalars['Uint64']['input']>;
  targetUserID?: InputMaybe<Scalars['Uint64']['input']>;
  /** Programタイプ　1:一般、2:インストラクター向け */
  type?: InputMaybe<ProgramType>;
  word?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramSearchResponse = {
  __typename?: 'ProgramSearchResponse';
  items: Array<Program>;
  total: Scalars['Int64']['output'];
};

/** 教材検索種別 */
export enum ProgramSearchType {
  /** すべての教材 */
  All = 'ALL',
  /** 学習完了した教材 */
  CompletedStudy = 'COMPLETED_STUDY',
  /** 学習中の教材 */
  WhileStudying = 'WHILE_STUDYING'
}

/** Programタイプ */
export enum ProgramType {
  /** インストラクター */
  Instructor = 'INSTRUCTOR',
  /** 一般 */
  Normal = 'NORMAL'
}

export type PromotionCodeApplyResult = {
  __typename?: 'PromotionCodeApplyResult';
  amountOff?: Maybe<Scalars['Uint64']['output']>;
  appliedPrice: Scalars['Uint64']['output'];
  appliedPriceIncludingTax: Scalars['Uint64']['output'];
  isValid: Bool;
  percentOff?: Maybe<Scalars['String']['output']>;
  price: Scalars['Uint64']['output'];
  priceIncludingTax: Scalars['Uint64']['output'];
  pvdDuration: SpCouponDuration;
  pvdDurationInMonths?: Maybe<Scalars['Int64']['output']>;
};

export type PromotionCodeTransaction = {
  __typename?: 'PromotionCodeTransaction';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  spPromotionCode: SpPromotionCode;
  spPromotionCodeID: Scalars['ULID']['output'];
  subscription: SubscriptionInfo;
  subscriptionID: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  usedUserID: Scalars['Uint64']['output'];
  user: User;
};

export type PromotionCodeTransactionResponse = {
  __typename?: 'PromotionCodeTransactionResponse';
  items: Array<PromotionCodeTransaction>;
  total: Scalars['Int64']['output'];
};

export enum ProviderInvoiceStatus {
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Open = 'OPEN',
  Paid = 'PAID',
  Uncollectible = 'UNCOLLECTIBLE',
  Void = 'VOID'
}

export enum ProviderSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID'
}

export type PurchaseItem = {
  __typename?: 'PurchaseItem';
  amount: Scalars['Uint64']['output'];
  createdAt: Scalars['Time']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['Uint64']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type Query = {
  __typename?: 'Query';
  abTestDeliveries: Array<AbTestDelivery>;
  abTestSettingForAdmin?: Maybe<AbTestSetting>;
  abTestSettingsForAdmin: AdminAbTestSettingSearchResponse;
  /** インストラクター用アクティブなコース検索 */
  activeCoursesForInstructor?: Maybe<Array<Course>>;
  admin?: Maybe<Admin>;
  adminTweetCommentDetailV1?: Maybe<TweetComment>;
  adminTweetDetailV1?: Maybe<Tweet>;
  adminTweetsV1: TweetResponse;
  admins: AdminSearchResponse;
  aiUser?: Maybe<User>;
  /** PromotionCode適用チェック */
  applyPromotionCode: PromotionCodeApplyResult;
  assignLogs: AssignLogSearchResponse;
  /** バナーCID主キー検索 - admin用 */
  bannerCidForAdmin?: Maybe<BannerCid>;
  /** バナーCID取得 */
  bannerCids: Array<BannerCid>;
  /** バナーCID検索 - admin用 */
  bannerCidsForAdmin: AdminBannerCidSearchResponse;
  /** バナー主キー検索 - admin用 */
  bannerForAdmin?: Maybe<Banner>;
  /** バナー検索 - admin用 */
  bannersForAdmin: AdminBannerSearchResponse;
  /** インストラクター＆コーチ向けカレンダーデータ取得 */
  calendarForInstructor: InstructorCalendar;
  categories: Array<Category>;
  /** Chapter単体取得 */
  chapter?: Maybe<Chapter>;
  /** 管理者用Chapter単体取得 */
  chapterForAdmin?: Maybe<AdminChapter>;
  /** 管理者用Chapter一覧取得 */
  chaptersForAdmin?: Maybe<AdminChapterSearchResponse>;
  chatMessageDraft?: Maybe<ChatMessageDraft>;
  /** 管理者向けチャットメッセージ取得 */
  chatMessageForAdmin: ChatMessage;
  /** チャットメッセージ未読件数 */
  chatMessageUnreadCount: Scalars['Int64']['output'];
  /** チャットメッセージ一覧 */
  chatMessages?: Maybe<ChatMessageConnection>;
  /** 管理者向けチャットメッセージ一覧取得 */
  chatMessagesForAdmin: AdminChatMessageResponse;
  /** チャットルーム一覧 */
  chatRooms: ChatRoomsResponse;
  /** 管理者 チャットルーム検索 */
  chatRoomsForAdmin: AdminChatRoomsResponse;
  checkUpgrade?: Maybe<CheckUpgradePlanResult>;
  checkUpgradeTypes: Array<SubscriptionUpgradeTypeItem>;
  /** 請求申請カテゴリー-インストラクター向け一覧 */
  claimCategoriesForInstructor: Array<ClaimCategory>;
  /** 請求申請詳細-管理者向け詳細 */
  claimDetailForAdmin?: Maybe<ClaimDetail>;
  /** 請求申請詳細-管理者向け一覧 */
  claimDetailsForAdmin: ClaimDetailSearchResponse;
  /** 請求申請詳細-インストラクター向け一覧 */
  claimDetailsForInstructor: Array<ClaimDetail>;
  /** 請求申請-管理者向け詳細 */
  claimForAdmin?: Maybe<Claim>;
  /** 請求申請-インストラクター向け詳細 */
  claimForInstructor?: Maybe<Claim>;
  /** 請求申請-管理者向け一覧 */
  claimsForAdmin: ClaimSearchResponse;
  coachingAssignLog: CoachingAssignLog;
  coachingAssignLogs: CoachingAssignLogSearchResponse;
  /** コーチング-管理者向け参照 */
  coachingForAdmin?: Maybe<Coaching>;
  /** コーチング-管理者向け一覧 */
  coachingsForAdmin: CoachingSearchResponse;
  /** 管理者向け-Cognitoユーザー取得処理 */
  cognitoUserForAdmin?: Maybe<CognitoUser>;
  commonStudyReportsV1: Array<StudyReport>;
  countByDocumentType: Array<DocumentTypeCount>;
  countByTags: Array<TagCount>;
  /** 管理者用コース取得 */
  courseForAdmin: Course;
  /** インストラクター用コース取得 */
  courseForInstructor: Course;
  /** コース教材単体取得 */
  courseProgram?: Maybe<CourseProgram>;
  /** コース教材単体取得（管理者用） */
  courseProgramForAdmin?: Maybe<CourseProgram>;
  /** コース教材ステップ単体取得（管理者用） */
  courseProgramStepForAdmin?: Maybe<CourseProgramStep>;
  /** コース教材ステップ一覧取得（管理者用） */
  courseProgramStepsForAdmin: CourseProgramStepSearchResponse;
  /** コース教材一覧取得 */
  coursePrograms?: Maybe<Array<CourseProgram>>;
  /** コース教材一覧取得（管理者用） */
  courseProgramsForAdmin: CourseProgramSearchResponse;
  /** 管理者用コース検索 */
  coursesForAdmin: CourseSearchResponse;
  /** インストラクター用コース検索 */
  coursesForInstructor?: Maybe<Array<Course>>;
  /** 受講生向けコース取得（自分のものを取得） */
  coursesForStudent?: Maybe<Array<Course>>;
  /** 請求申請詳細-管理者向けCSV一覧 */
  csvClaimDetailsForAdmin: Array<ClaimDetail>;
  currentStudent: Student;
  /** 現在ログインしているユーザーを返す */
  currentUserWithPermissions?: Maybe<UserWithPermissionList>;
  existSubscription: Scalars['Boolean']['output'];
  feedbackCategories: FeedbackCategoryResponse;
  feedbackCategory: FeedbackCategory;
  getAdminProgramFeedbackV1: ProgramFeedback;
  getAdminProgramFeedbacksV1: ProgramFeedbackResponse;
  getAdminTweetCommentsV1: TweetCommentResponse;
  /** キャンペーンを取得する */
  getCampaign?: Maybe<Campaign>;
  /** キャンペーンを取得する-Admin */
  getCampaignForAdmin: Campaign;
  /** キャンペーンを複数取得する-Admin */
  getCampaignsForAdmin: CampaignsResponse;
  getInvoiceForAdmin: Invoice;
  /** Invoice-Admin-詳細 */
  getInvoiceItemForAdmin: InvoiceItem;
  /** Invoice-Admin-一覧検索 */
  getInvoiceItemsForAdmin: InvoiceItemSearchResponse;
  /** Invoice-請求一覧 */
  getInvoices: InvoiceSearchResponse;
  /** Invoice-Admin請求検索 */
  getInvoicesForAdmin: InvoiceSearchResponse;
  getMailSetting: MailSetting;
  /** メール設定-Admin-取得 */
  getMailSettingForAdmin: MailSetting;
  /** メール設定-Admin-検索 */
  getMailSettingsForAdmin: MailSettingSearchResponse;
  getNotificationUnreadCount: CountResponse;
  getNotifications: NotificationResponse;
  getPaymentIntentForAdmin: PaymentIntent;
  /** PaymentIntent-課金履歴一覧 */
  getPaymentIntents: PaymentIntentSearchResponse;
  /** PaymentIntent-Admin-課金履歴検索 */
  getPaymentIntentsForAdmin: PaymentIntentSearchResponse;
  /** 支払方法-Admin-単体取得 */
  getPaymentMethodForAdmin?: Maybe<PaymentMethod>;
  /** 支払方法-Admin-一覧取得 */
  getPaymentMethodsForAdmin?: Maybe<PaymentMethodSearchResponse>;
  /** 取得 */
  getPracticeSubmit?: Maybe<PracticeSubmit>;
  /** インストラクター用取得 */
  getPracticeSubmitForInstructor?: Maybe<InstructorPracticeSubmit>;
  /** 一覧検索 */
  getPracticeSubmits: PracticeSubmitSearchResponse;
  /** インストラクター用一覧検索 */
  getPracticeSubmitsForInstructor: PracticeSubmitSearchResponse;
  /** 都道府県 検索 */
  getPrefecture: Prefecture;
  /** 都道府県 取得 */
  getPrefectures: Array<Prefecture>;
  /** Price-取得 */
  getPrice?: Maybe<Price>;
  /** Product-取得 */
  getProduct?: Maybe<Product>;
  /** Product-検索 */
  getProducts: ProductSearchResponse;
  getProgramSampleForAdmin?: Maybe<ProgramSample>;
  getProgramSamples: ProgramSampleSearchResponse;
  getProgramSamplesForAdmin: ProgramSampleSearchResponse;
  /** QA-質問取得 */
  getQuestion?: Maybe<Question>;
  /** QA-Admin-回答取得 */
  getQuestionAnswerForAdmin?: Maybe<QuestionAnswer>;
  /** QA-Admin-回答検索 */
  getQuestionAnswersForAdmin: QuestionAnswerSearchResponse;
  /** QA-Admin-コメント取得 */
  getQuestionCommentForAdmin?: Maybe<QuestionComment>;
  /** QA-Admin-コメント検索 */
  getQuestionCommentsForAdmin: QuestionCommentSearchResponse;
  /** QA-Admin-質問取得 */
  getQuestionForAdmin?: Maybe<Question>;
  /** QA-質問検索 */
  getQuestions: QuestionSearchResponse;
  /** QA-Admin-質問検索 */
  getQuestionsForAdmin: QuestionSearchResponse;
  /** StudyReport-Instructor-担当受講生の学習ログ取得 */
  getRelatedStudyReports: StudyReportSearchResponse;
  getStudyCalendar: Array<StudyCalendar>;
  /** StudyFavoriteSummary-学習ログいいねサマリ(合計、週間、月間の学習時間上位5つ) */
  getStudyFavoriteSummaryList: StudyFavoriteSummaryListResponse;
  /** 学習履歴-章ID検索 */
  getStudyLog?: Maybe<StudyLog>;
  /** StudyReport-学習ログ取得 */
  getStudyReport?: Maybe<StudyReport>;
  /** StudyReportComment-Admin-学習ログコメント取得 */
  getStudyReportCommentForAdmin: StudyReportComment;
  /** StudyReportComment-Admin-学習ログコメント検索 */
  getStudyReportCommentsForAdmin: StudyReportCommentSearchResponse;
  /** StudyReportDetail-Admin-学習ログ詳細取得 */
  getStudyReportDetailForAdmin: StudyReportDetail;
  /** StudyReportDetail-Admin-学習ログ詳細検索 */
  getStudyReportDetailsForAdmin: StudyReportDetailSearchResponse;
  /** StudyReport-Admin-学習ログ取得 */
  getStudyReportForAdmin?: Maybe<StudyReport>;
  /** StudyReport-学習ログ検索 */
  getStudyReports: StudyReportSearchResponse;
  /** StudyReport-Admin-学習ログ検索 */
  getStudyReportsForAdmin: StudyReportSearchResponse;
  /** StudySummary-学習ログサマリ取得 */
  getStudySummary: StudySummary;
  /** StudySummary-学習ログサマリ(合計、週間、月間の学習時間上位5つ) */
  getStudySummaryList: StudySummaryListResponse;
  /** StudyTagSummary-学習ログタグサマリ取得 */
  getStudyTagSummaries: Array<StudyTagSummary>;
  /** StudyTagSummary-学習ログタグサマリ(合計、週間、月間の学習時間上位5つ) */
  getStudyTagSummaryList: StudyTagSummaryListResponse;
  /** タグ-取得 */
  getTag?: Maybe<Tag>;
  /** タグ-Admin-取得 */
  getTagForAdmin?: Maybe<Tag>;
  /** タグ-検索 */
  getTags: TagSearchResponse;
  /** タグ-Admin-検索 */
  getTagsForAdmin: TagSearchResponse;
  getTeamMembersByTeamID: TeamMembersResponse;
  getTimelinesByUserID: TimelineResponse;
  getTimelinesV1: TimelineResponse;
  getTweetV1: Tweet;
  graduationDateNotificationSendLogForAdmin?: Maybe<GraduationDateNotificationSendLog>;
  graduationDateNotificationSendLogsForAdmin: GraduationDateNotificationSendLogResponse;
  /** インストラクター用コース取得（過去アサインされたものも全部含む） */
  historicalCoursesForInstructor?: Maybe<Array<Course>>;
  instructorForAdmin?: Maybe<Instructor>;
  /** インストラクター向け取得系 */
  instructorSchedule?: Maybe<InstructorSchedule>;
  /** 管理者向け取得系 */
  instructorScheduleForAdmin?: Maybe<InstructorSchedule>;
  instructorSchedules: Array<InstructorSchedule>;
  instructorSchedulesForAdmin: InstructorScheduleSearchResponse;
  instructorsForAdmin: InstructorSearchResponse;
  invoices: StripeInvoiceResponse;
  isUpgradable: Scalars['Boolean']['output'];
  /** 最後に学習したProgram取得 */
  lastStudiedWhileStudyingProgram?: Maybe<Program>;
  latest?: Maybe<Modal>;
  /** LessonsAssistance一覧取得 */
  lessonAssistances: Array<LessonsAssistance>;
  /** 管理者向けレッスン取得 */
  lessonForAdmin: Lesson;
  /** インストラクター向けレッスン取得 */
  lessonForInstructor?: Maybe<Lesson>;
  lessonQuestionnaireSendLogForAdmin?: Maybe<LessonQuestionnaireSendLog>;
  lessonQuestionnaireSendLogsForAdmin: LessonQuestionnaireSendLogResponse;
  /** 管理者向けレッスン取得 */
  lessonsForAdmin: LessonSearchResponse;
  /** インストラクター向け自分のレッスン全取得 */
  lessonsForInstructor: Array<Lesson>;
  /** 受講生向け自分のレッスン全取得 */
  lessonsForStudent: Array<Lesson>;
  /** 自分のサブスクリプション取得 */
  mySubscription?: Maybe<SubscriptionSummary>;
  /** 自分の契約済みサブスクリプション一覧取得 */
  mySubscriptionContractPeriodHistories: SubscriptionHistoriesSearchResponse;
  mySubscriptionContracts?: Maybe<SubscriptionContractsResponse>;
  /** 自身が所属するチーム一覧と権限を取得 */
  myTeamMembers: Array<TeamMember>;
  myTweetsV1: TweetResponse;
  /** インストラクター向け次回レッスン取得 */
  nextLessonForInstructor?: Maybe<Lesson>;
  /** 受講生向け次回レッスン取得 */
  nextLessonForStudent?: Maybe<Lesson>;
  /** セッション-インストラクター向け次回セッション */
  nextSessionForInstructor?: Maybe<Session>;
  /** セッション-受講生向け次回セッション */
  nextSessionForStudent?: Maybe<Session>;
  nextSpotLesson?: Maybe<SpotLesson>;
  /** アナウンス-詳細 */
  notice?: Maybe<Notice>;
  /** アナウンス-Admin-詳細 */
  noticeForAdmin?: Maybe<Notice>;
  /** アナウンス-未読件数 */
  noticeUnreadCount: Scalars['Int64']['output'];
  /** アナウンス-一覧 */
  notices: NoticesResponse;
  /** アナウンス-Admin-一覧検索 */
  noticesForAdmin: NoticeSearchResponse;
  onboarding: Onboarding;
  paymentMethods: StripePaymentMethodResponse;
  planForAdmin?: Maybe<Plan>;
  plansForAdmin: PlanSearchResponse;
  practice?: Maybe<Practice>;
  /** 課題-管理者向け詳細 */
  practiceForAdmin?: Maybe<AdminPractice>;
  /** 課題提出詳細-管理者向け詳細 */
  practiceSubmitDetailForAdmin?: Maybe<PracticeSubmitDetail>;
  /** 課題提出詳細-管理者向け一覧 */
  practiceSubmitDetailsForAdmin: PracticeSubmitDetailSearchResponse;
  /** 課題提出-管理者向け詳細 */
  practiceSubmitForAdmin?: Maybe<PracticeSubmit>;
  /** 課題提出-管理者向け一覧 */
  practiceSubmitsForAdmin: AdminPracticeSubmitSearchResponse;
  practices: PracticeSearchResponse;
  /** 課題-管理者向け一覧 */
  practicesForAdmin: AdminPracticeSearchResponse;
  priceForAdmin?: Maybe<Price>;
  pricesForAdmin: PriceSearchResponse;
  productForAdmin?: Maybe<Product>;
  productsForAdmin: ProductSearchResponse;
  /** Program単体取得 */
  program?: Maybe<Program>;
  programExam?: Maybe<Array<ExamQuestion>>;
  /** Program-Admin-単体取得 */
  programForAdmin?: Maybe<Program>;
  /** 教材満足度取得 */
  programSatisfaction?: Maybe<ProgramSatisfaction>;
  /** Program一覧取得 */
  programs: ProgramSearchResponse;
  /** Program-Admin一覧取得 */
  programsForAdmin: ProgramSearchResponse;
  promotionCodeTransactionForAdmin?: Maybe<PromotionCodeTransaction>;
  promotionCodeTransactionsForAdmin: PromotionCodeTransactionResponse;
  reservableInstructorsForAdmin: Array<InstructorSchedule>;
  scheduledSubscriptionContract?: Maybe<ScheduledSubscriptionContract>;
  searchDocuments: DocumentResponse;
  /** セッション-参照 */
  session?: Maybe<Session>;
  /** セッション-参照 */
  sessionForAdmin?: Maybe<Session>;
  /** セッション受講履歴-管理者向け参照 */
  sessionReportBySessionIDForAdmin?: Maybe<SessionReport>;
  /** セッション受講履歴-インストラクター向け参照 */
  sessionReportBySessionIDForInstructor?: Maybe<SessionReport>;
  /** セッション受講履歴-管理者向け参照 */
  sessionReportForAdmin?: Maybe<SessionReport>;
  /** セッション受講履歴-管理者向け一覧 */
  sessionReportsForAdmin: SessionReportSearchResponse;
  /** セッション-管理者向け一覧 */
  sessionsForAdmin: SessionSearchResponse;
  /** セッション-インストラクター向け一覧(これまで・今後の予定をすべて含む) */
  sessionsForInstructor: Array<Session>;
  /** セッション-受講生向け一覧(これまで・今後の予定をすべて含む) */
  sessionsForStudent: Array<Session>;
  spCouponForAdmin?: Maybe<SpCoupon>;
  spCouponsForAdmin: SpCouponSearchResponse;
  spDiscountCouponForAdmin?: Maybe<SpDiscountCoupon>;
  spDiscountCouponsForAdmin: SpDiscountCouponResponse;
  spDiscountForAdmin?: Maybe<SpDiscount>;
  spDiscountsForAdmin: SpDiscountResponse;
  spPromotionCodeForAdmin?: Maybe<SpPromotionCode>;
  spPromotionCodesForAdmin: SpPromotionCodeSearchResponse;
  /** サブスクユーザー向けスポットレッスン取得系 */
  spotLesson?: Maybe<SpotLesson>;
  spotLessonCalendars: Array<SpotLessonCalendar>;
  /** 管理者向けカテゴリー一覧 */
  spotLessonCategoriesForAdmin: Array<Category>;
  spotLessonCount: Scalars['Int64']['output'];
  /** 管理者向けスポットレッスン取得系 */
  spotLessonForAdmin?: Maybe<SpotLesson>;
  /** インストラクター向けスポットレッスン取得系 */
  spotLessonForInstructor?: Maybe<SpotLesson>;
  /** 管理者向けインストラクター一覧 */
  spotLessonInstructorsByTimeForAdmin: Array<Instructor>;
  spotLessons: SpotLessonSearchResponse;
  spotLessonsForAdmin: SpotLessonSearchResponse;
  spotLessonsForInstructor: SpotLessonSearchResponse;
  stripeCustomerForAdmin?: Maybe<StripeCustomer>;
  stripeCustomersForAdmin: StripeCustomerResponse;
  stripeSubscriptionForAdmin?: Maybe<StripeSubscription>;
  stripeSubscriptionLogsForAdmin: StripeSubscriptionLogResponse;
  stripeSubscriptionsForAdmin: StripeSubscriptionResponse;
  studentForAdmin?: Maybe<Student>;
  studentsForAdmin: StudentSearchResponse;
  studyFavoriteSummariesForAdmin: StudyFavoriteSummariesResponse;
  studyFavoriteSummaryForAdmin?: Maybe<StudyFavoriteSummary>;
  studySummariesForAdmin: StudySummariesResponse;
  studySummaryForAdmin?: Maybe<StudySummary>;
  studyTagSummariesForAdmin: StudyTagSummariesResponse;
  studyTagSummaryForAdmin?: Maybe<StudyTagSummary>;
  subscription?: Maybe<StripeSubscription>;
  subscriptionCancellationPeriod?: Maybe<SubscriptionCancellationPeriod>;
  subscriptionChangeHistoriesForAdmin: SubscriptionChangeHistoryResponse;
  subscriptionChangeHistoryForAdmin?: Maybe<SubscriptionChangeHistory>;
  subscriptionContractForAdmin?: Maybe<SubscriptionContract>;
  subscriptionContractLogsForAdmin: SubscriptionContractLogsResponse;
  subscriptionContractsForAdmin: SubscriptionContractsResponse;
  /** サブスクリプション管理者向け詳細 */
  subscriptionForAdmin?: Maybe<SubscriptionInfo>;
  /** サブスクリプション履歴管理者向け一覧 */
  subscriptionHistoriesForAdmin: SubscriptionHistorySearchResponse;
  /** サブスクリプション履歴管理者向け詳細 */
  subscriptionHistoryForAdmin?: Maybe<SubscriptionHistory>;
  /** サブスクリプション管理者向けユーザーID検索 */
  subscriptionsByUserIDForAdmin: Array<SubscriptionInfo>;
  /** サブスクリプション管理者向け一覧 */
  subscriptionsForAdmin: SubscriptionSearchResponse;
  team: Team;
  teamExistMySubscription: Scalars['Boolean']['output'];
  teamExistSubscription: Scalars['Boolean']['output'];
  teamForAdmin?: Maybe<Team>;
  /** 法人招待情報の取得 */
  teamInvitation: TeamInvitation;
  teamInvoices: StripeInvoiceResponse;
  teamMemberForAdmin?: Maybe<TeamMember>;
  teamMembersForAdmin: TeamMembersResponse;
  teamPaymentMethods: StripePaymentMethodResponse;
  teamPrices: Array<Price>;
  teamScheduledSubscriptionContract?: Maybe<ScheduledSubscriptionContract>;
  teamSubscription?: Maybe<StripeSubscription>;
  teamSubscriptionContracts: SubscriptionContractsResponse;
  teamUpcomingInvoice?: Maybe<TeamUpcomingResponse>;
  teamsForAdmin: TeamsResponse;
  termChangeLogs: TermChangeLogSearchResponse;
  /** チケット詳細取得 - Admin用 */
  ticketForAdmin: Ticket;
  tickets: Array<Ticket>;
  ticketsForAdmin?: Maybe<TicketSearchResponse>;
  totalMedalCount: TotalMedalCountResponse;
  totalMedalCounts?: Maybe<Array<TotalMedalCountResponse>>;
  unixTimestampV1: UnixTimestamp;
  upcomingInvoice?: Maybe<UpcomingResponse>;
  user?: Maybe<User>;
  /** 管理者向け-ユーザー取得処理 */
  userForAdmin?: Maybe<User>;
  /** 管理者向け-ユーザー取得処理 */
  usersForAdmin: UserSearchResponse;
};


export type QueryAbTestSettingForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryAbTestSettingsForAdminArgs = {
  input: AdminAbTestSettingSearchInput;
};


export type QueryActiveCoursesForInstructorArgs = {
  input: InstructorCourseSearchWithStudentNameInput;
};


export type QueryAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryAdminTweetCommentDetailV1Args = {
  tweetCommentID: Scalars['ULID']['input'];
};


export type QueryAdminTweetDetailV1Args = {
  id: Scalars['ULID']['input'];
};


export type QueryAdminTweetsV1Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  searchWord?: InputMaybe<Scalars['String']['input']>;
  tweetDestination?: InputMaybe<TweetPostDestination>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminsArgs = {
  input: AdminSearchInput;
};


export type QueryApplyPromotionCodeArgs = {
  priceID: Scalars['Uint64']['input'];
  promotionCode: Scalars['String']['input'];
};


export type QueryAssignLogsArgs = {
  input: AdminAssignLogSearchInput;
};


export type QueryBannerCidForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryBannerCidsArgs = {
  input: BannerCidSearchInput;
};


export type QueryBannerCidsForAdminArgs = {
  input: AdminBannerCidSearchInput;
};


export type QueryBannerForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryBannersForAdminArgs = {
  input: AdminBannerSearchInput;
};


export type QueryChapterArgs = {
  chapterID: Scalars['Uint64']['input'];
};


export type QueryChapterForAdminArgs = {
  chapterID: Scalars['Uint64']['input'];
};


export type QueryChaptersForAdminArgs = {
  input?: InputMaybe<AdminChapterSearchInput>;
};


export type QueryChatMessageDraftArgs = {
  chatRoomID: Scalars['Uint64']['input'];
};


export type QueryChatMessageForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryChatMessageUnreadCountArgs = {
  chatRoomID?: InputMaybe<Scalars['Uint64']['input']>;
};


export type QueryChatMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  chatRoomID: Scalars['Uint64']['input'];
  first: Scalars['Int']['input'];
};


export type QueryChatMessagesForAdminArgs = {
  input?: InputMaybe<AdminChatMessageSearchInput>;
};


export type QueryChatRoomsArgs = {
  after?: InputMaybe<Scalars['Time']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryChatRoomsForAdminArgs = {
  input?: InputMaybe<AdminChatRoomSearchInput>;
};


export type QueryCheckUpgradeArgs = {
  priceID: Scalars['Uint64']['input'];
};


export type QueryClaimDetailForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryClaimDetailsForAdminArgs = {
  input?: InputMaybe<AdminClaimDetailSearchInput>;
};


export type QueryClaimDetailsForInstructorArgs = {
  input?: InputMaybe<InstructorClaimDetailSearchInput>;
  yearMonth: Scalars['Time']['input'];
};


export type QueryClaimForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryClaimForInstructorArgs = {
  yearMonth: Scalars['Time']['input'];
};


export type QueryClaimsForAdminArgs = {
  input?: InputMaybe<AdminClaimSearchInput>;
};


export type QueryCoachingAssignLogArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryCoachingAssignLogsArgs = {
  input: CoachingAssignLogSearchInput;
};


export type QueryCoachingForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryCoachingsForAdminArgs = {
  input: AdminCoachingSearchInput;
};


export type QueryCognitoUserForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryCommonStudyReportsV1Args = {
  after?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryCountByDocumentTypeArgs = {
  input?: InputMaybe<CountSearchInput>;
};


export type QueryCountByTagsArgs = {
  input?: InputMaybe<CountSearchInput>;
  tagIDs?: InputMaybe<Array<Scalars['Uint64']['input']>>;
};


export type QueryCourseForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryCourseForInstructorArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryCourseProgramArgs = {
  courseProgramID: Scalars['ULID']['input'];
};


export type QueryCourseProgramForAdminArgs = {
  courseProgramID: Scalars['ULID']['input'];
};


export type QueryCourseProgramStepForAdminArgs = {
  courseProgramStepID: Scalars['ULID']['input'];
};


export type QueryCourseProgramStepsForAdminArgs = {
  input: AdminCourseProgramStepSearchInput;
};


export type QueryCourseProgramsArgs = {
  input?: InputMaybe<CourseProgramSearchInput>;
};


export type QueryCourseProgramsForAdminArgs = {
  input: AdminCourseProgramSearchInput;
};


export type QueryCoursesForAdminArgs = {
  input: AdminCourseSearchInput;
};


export type QueryCoursesForInstructorArgs = {
  input: InstructorCourseSearchInput;
};


export type QueryCoursesForStudentArgs = {
  input: StudentCourseSearchInput;
};


export type QueryCsvClaimDetailsForAdminArgs = {
  input?: InputMaybe<AdminClaimDetailSearchInput>;
};


export type QueryExistSubscriptionArgs = {
  teamID: Scalars['ULID']['input'];
};


export type QueryFeedbackCategoriesArgs = {
  input: FeedbackCategoriesInput;
};


export type QueryFeedbackCategoryArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetAdminProgramFeedbackV1Args = {
  id: Scalars['ULID']['input'];
};


export type QueryGetAdminProgramFeedbacksV1Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryGetAdminTweetCommentsV1Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  searchWord?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCampaignForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryGetCampaignsForAdminArgs = {
  input: AdminCampaignSearchInput;
};


export type QueryGetInvoiceForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetInvoiceItemForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetInvoiceItemsForAdminArgs = {
  input: AdminInvoiceItemSearchInput;
};


export type QueryGetInvoicesArgs = {
  input: InvoiceSearchInput;
};


export type QueryGetInvoicesForAdminArgs = {
  input: AdminInvoiceSearchInput;
};


export type QueryGetMailSettingForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetMailSettingsForAdminArgs = {
  input: AdminMailSettingSearchInput;
};


export type QueryGetNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryGetPaymentIntentForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetPaymentIntentsArgs = {
  input: PaymentIntentSearchInput;
};


export type QueryGetPaymentIntentsForAdminArgs = {
  input: AdminPaymentIntentSearchInput;
};


export type QueryGetPaymentMethodForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetPaymentMethodsForAdminArgs = {
  input?: InputMaybe<AdminPaymentMethodSearchInput>;
};


export type QueryGetPracticeSubmitArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryGetPracticeSubmitForInstructorArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryGetPracticeSubmitsArgs = {
  input: PracticeSubmitSearchInput;
};


export type QueryGetPracticeSubmitsForInstructorArgs = {
  input: InstructorPracticeSubmitSearchInput;
};


export type QueryGetPrefectureArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetPriceArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetProductArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetProductsArgs = {
  input: ProductSearchInput;
};


export type QueryGetProgramSampleForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryGetProgramSamplesArgs = {
  input: ProgramSampleSearchInput;
};


export type QueryGetProgramSamplesForAdminArgs = {
  input: AdminProgramSampleSearchInput;
};


export type QueryGetQuestionArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetQuestionAnswerForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetQuestionAnswersForAdminArgs = {
  input: AdminQuestionAnswerSearchInput;
};


export type QueryGetQuestionCommentForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetQuestionCommentsForAdminArgs = {
  input: AdminQuestionCommentSearchInput;
};


export type QueryGetQuestionForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetQuestionsArgs = {
  input: QuestionSearchInput;
};


export type QueryGetQuestionsForAdminArgs = {
  input: AdminQuestionSearchInput;
};


export type QueryGetRelatedStudyReportsArgs = {
  input: RelatedStudyReportSearchInput;
};


export type QueryGetStudyCalendarArgs = {
  input: StudyCalendarSearchInput;
};


export type QueryGetStudyLogArgs = {
  chapterID: Scalars['Uint64']['input'];
};


export type QueryGetStudyReportArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetStudyReportCommentForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetStudyReportCommentsForAdminArgs = {
  input: AdminStudyReportCommentSearchInput;
};


export type QueryGetStudyReportDetailForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetStudyReportDetailsForAdminArgs = {
  input: AdminStudyReportDetailSearchInput;
};


export type QueryGetStudyReportForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetStudyReportsArgs = {
  input: StudyReportSearchInput;
};


export type QueryGetStudyReportsForAdminArgs = {
  input: AdminStudyReportSearchInput;
};


export type QueryGetTagArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetTagForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryGetTagsArgs = {
  input: TagSearchInput;
};


export type QueryGetTagsForAdminArgs = {
  input: AdminTagSearchInput;
};


export type QueryGetTeamMembersByTeamIdArgs = {
  input: TeamMemberSearchInput;
};


export type QueryGetTimelinesByUserIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  userID: Scalars['Int']['input'];
};


export type QueryGetTimelinesV1Args = {
  adminAfter?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryGetTweetV1Args = {
  id: Scalars['ULID']['input'];
};


export type QueryGraduationDateNotificationSendLogForAdminArgs = {
  courseEndDate: Scalars['Time']['input'];
  courseID: Scalars['Uint64']['input'];
};


export type QueryGraduationDateNotificationSendLogsForAdminArgs = {
  input: GraduationDateNotificationSendLogSearchInput;
};


export type QueryHistoricalCoursesForInstructorArgs = {
  userName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInstructorForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryInstructorScheduleArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryInstructorScheduleForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryInstructorSchedulesArgs = {
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
};


export type QueryInstructorSchedulesForAdminArgs = {
  input: AdminInstructorScheduleSearchInput;
};


export type QueryInstructorsForAdminArgs = {
  input: AdminInstructorSearchInput;
};


export type QueryInvoicesArgs = {
  input: InvoicesSearchInput;
};


export type QueryLatestArgs = {
  modalType: ModalType;
};


export type QueryLessonForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryLessonForInstructorArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryLessonQuestionnaireSendLogForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryLessonQuestionnaireSendLogsForAdminArgs = {
  input: LessonQuestionnaireSendLogSearchInput;
};


export type QueryLessonsForAdminArgs = {
  input?: InputMaybe<AdminLessonSearchInput>;
};


export type QueryLessonsForInstructorArgs = {
  input?: InputMaybe<InstructorLessonSearchInput>;
};


export type QueryMySubscriptionContractPeriodHistoriesArgs = {
  input: SubscriptionContractPeriodHistorySearchInput;
};


export type QueryMySubscriptionContractsArgs = {
  input: MySubscriptionContractInput;
};


export type QueryMyTweetsV1Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryNoticeArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryNoticeForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryNoticesArgs = {
  after?: InputMaybe<Scalars['Uint64']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryNoticesForAdminArgs = {
  input: AdminNoticeSearchInput;
};


export type QueryPaymentMethodsArgs = {
  input: StripePaymentMethodsSearchInput;
};


export type QueryPlanForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryPlansForAdminArgs = {
  input?: InputMaybe<AdminPlanSearchInput>;
};


export type QueryPracticeArgs = {
  practiceID: Scalars['ULID']['input'];
};


export type QueryPracticeForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryPracticeSubmitDetailForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryPracticeSubmitDetailsForAdminArgs = {
  input: AdminPracticeSubmitDetailSearchInput;
};


export type QueryPracticeSubmitForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryPracticeSubmitsForAdminArgs = {
  input: AdminPracticeSubmitSearchInput;
};


export type QueryPracticesArgs = {
  input: PracticeSearchInput;
};


export type QueryPracticesForAdminArgs = {
  input: AdminPracticeSearchInput;
};


export type QueryPriceForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryPricesForAdminArgs = {
  input?: InputMaybe<AdminPriceSearchInput>;
};


export type QueryProductForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryProductsForAdminArgs = {
  input?: InputMaybe<AdminProductSearchInput>;
};


export type QueryProgramArgs = {
  programID: Scalars['Uint64']['input'];
};


export type QueryProgramExamArgs = {
  chapterID: Scalars['Uint64']['input'];
};


export type QueryProgramForAdminArgs = {
  programID: Scalars['Uint64']['input'];
};


export type QueryProgramSatisfactionArgs = {
  programID: Scalars['Uint64']['input'];
};


export type QueryProgramsArgs = {
  input: ProgramSearchInput;
};


export type QueryProgramsForAdminArgs = {
  input: AdminProgramSearchInput;
};


export type QueryPromotionCodeTransactionForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryPromotionCodeTransactionsForAdminArgs = {
  input: AdminPromotionCodeTransactionSearchInput;
};


export type QueryReservableInstructorsForAdminArgs = {
  spotLessonID: Scalars['Uint64']['input'];
};


export type QuerySearchDocumentsArgs = {
  input: DocumentSearchInput;
};


export type QuerySessionArgs = {
  id: Scalars['ULID']['input'];
};


export type QuerySessionForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QuerySessionReportBySessionIdForAdminArgs = {
  sessionID: Scalars['ULID']['input'];
};


export type QuerySessionReportBySessionIdForInstructorArgs = {
  sessionID: Scalars['ULID']['input'];
};


export type QuerySessionReportForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QuerySessionReportsForAdminArgs = {
  input: AdminSessionReportSearchInput;
};


export type QuerySessionsForAdminArgs = {
  input?: InputMaybe<AdminSessionSearchInput>;
};


export type QuerySessionsForInstructorArgs = {
  input: SessionSearchInput;
};


export type QuerySpCouponForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QuerySpCouponsForAdminArgs = {
  input: AdminSpCouponInput;
};


export type QuerySpDiscountCouponForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QuerySpDiscountCouponsForAdminArgs = {
  input: AdminSpDiscountCouponSearchInput;
};


export type QuerySpDiscountForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QuerySpDiscountsForAdminArgs = {
  input: AdminSpDiscountSearchInput;
};


export type QuerySpPromotionCodeForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QuerySpPromotionCodesForAdminArgs = {
  input: AdminPromotionCodeInput;
};


export type QuerySpotLessonArgs = {
  id: Scalars['Uint64']['input'];
};


export type QuerySpotLessonCalendarsArgs = {
  from: Scalars['Time']['input'];
  tagIDs: Array<Scalars['Uint64']['input']>;
  to: Scalars['Time']['input'];
};


export type QuerySpotLessonForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QuerySpotLessonForInstructorArgs = {
  id: Scalars['Uint64']['input'];
};


export type QuerySpotLessonInstructorsByTimeForAdminArgs = {
  startAt: Scalars['Time']['input'];
};


export type QuerySpotLessonsArgs = {
  input: SpotLessonSearchInput;
};


export type QuerySpotLessonsForAdminArgs = {
  input: AdminSpotLessonSearchInput;
};


export type QuerySpotLessonsForInstructorArgs = {
  input: InstructorSpotLessonSearchInput;
};


export type QueryStripeCustomerForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryStripeCustomersForAdminArgs = {
  input: AdminStripeCustomerSearchInput;
};


export type QueryStripeSubscriptionForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryStripeSubscriptionLogsForAdminArgs = {
  input: AdminStripeSubscriptionLogSearchInput;
};


export type QueryStripeSubscriptionsForAdminArgs = {
  input: AdminStripeSubscriptionSearchInput;
};


export type QueryStudentForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryStudentsForAdminArgs = {
  input: AdminStudentSearchInput;
};


export type QueryStudyFavoriteSummariesForAdminArgs = {
  input: AdminStudyFavoriteSummarySearchInput;
};


export type QueryStudyFavoriteSummaryForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryStudySummariesForAdminArgs = {
  input: AdminStudySummarySearchInput;
};


export type QueryStudySummaryForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryStudyTagSummariesForAdminArgs = {
  input: AdminStudyTagSummarySearchInput;
};


export type QueryStudyTagSummaryForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QuerySubscriptionChangeHistoriesForAdminArgs = {
  input: AdminSubscriptionChangeHistorySearchInput;
};


export type QuerySubscriptionChangeHistoryForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QuerySubscriptionContractForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QuerySubscriptionContractLogsForAdminArgs = {
  input: AdminSubscriptionContractLogSearchInput;
};


export type QuerySubscriptionContractsForAdminArgs = {
  input: AdminSubscriptionContractSearchInput;
};


export type QuerySubscriptionForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QuerySubscriptionHistoriesForAdminArgs = {
  input: AdminSubscriptionHistorySearchInput;
};


export type QuerySubscriptionHistoryForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QuerySubscriptionsByUserIdForAdminArgs = {
  userID: Scalars['Uint64']['input'];
};


export type QuerySubscriptionsForAdminArgs = {
  input: AdminSubscriptionSearchInput;
};


export type QueryTeamArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryTeamExistSubscriptionArgs = {
  teamID: Scalars['ULID']['input'];
};


export type QueryTeamForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryTeamInvitationArgs = {
  id: Scalars['String']['input'];
};


export type QueryTeamInvoicesArgs = {
  input: TeamInvoicesSearchInput;
};


export type QueryTeamMemberForAdminArgs = {
  id: Scalars['ULID']['input'];
};


export type QueryTeamMembersForAdminArgs = {
  input: AdminTeamMemberSearchInput;
};


export type QueryTeamPaymentMethodsArgs = {
  input: TeamStripePaymentMethodsSearchInput;
};


export type QueryTeamPricesArgs = {
  paymentMethodType: PaymentMethodType;
};


export type QueryTeamScheduledSubscriptionContractArgs = {
  teamID: Scalars['ULID']['input'];
};


export type QueryTeamSubscriptionArgs = {
  teamID: Scalars['ULID']['input'];
};


export type QueryTeamSubscriptionContractsArgs = {
  input: TeamSubscriptionContractInput;
};


export type QueryTeamUpcomingInvoiceArgs = {
  input: TeamUpdateSubscriptionFormInput;
  teamID: Scalars['ULID']['input'];
};


export type QueryTeamsForAdminArgs = {
  input: AdminTeamSearchInput;
};


export type QueryTermChangeLogsArgs = {
  input: AdminTermChangeLogSearchInput;
};


export type QueryTicketForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryTicketsForAdminArgs = {
  input?: InputMaybe<AdminTicketSearchInput>;
};


export type QueryTotalMedalCountArgs = {
  programID: Scalars['Uint64']['input'];
};


export type QueryUnixTimestampV1Args = {
  _?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUpcomingInvoiceArgs = {
  input: UpdateSubscriptionFormInput;
};


export type QueryUserArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryUserForAdminArgs = {
  id: Scalars['Uint64']['input'];
};


export type QueryUsersForAdminArgs = {
  input: AdminUserSearchInput;
};

export type Question = {
  __typename?: 'Question';
  answerCount: Scalars['Uint64']['output'];
  answerRequestType: AnswerRequestType;
  chapter?: Maybe<Chapter>;
  content: Scalars['QuestionContent']['output'];
  createdAt: Scalars['Time']['output'];
  editedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Uint64']['output'];
  practice?: Maybe<Practice>;
  program?: Maybe<Program>;
  questionAnswers?: Maybe<Array<QuestionAnswer>>;
  questionEvaluation?: Maybe<QuestionEvaluation>;
  questionFavorites: Array<QuestionFavorite>;
  solved: Scalars['Boolean']['output'];
  solvedAt?: Maybe<Scalars['Time']['output']>;
  status: QuestionStatus;
  tags?: Maybe<Array<Tag>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

export type QuestionAnswer = {
  __typename?: 'QuestionAnswer';
  answerType: AnswerType;
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  question: Question;
  questionAnswerFavorites: Array<QuestionAnswerFavorite>;
  questionComments?: Maybe<Array<QuestionComment>>;
  status: QuestionAnswerStatus;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** QA-回答評価更新パラメーター */
export type QuestionAnswerEvaluationInput = {
  evaluationComment?: InputMaybe<Scalars['String']['input']>;
  evaluationType: QuestionAnswerEvaluationType;
  questionID: Scalars['Uint64']['input'];
};

/** QA-回答評価 */
export enum QuestionAnswerEvaluationType {
  /** 悪い */
  Bad = 'BAD',
  /** 良い */
  Good = 'GOOD'
}

export type QuestionAnswerFavorite = {
  __typename?: 'QuestionAnswerFavorite';
  createdAt: Scalars['Time']['output'];
  questionAnswerID: Scalars['Uint64']['output'];
  status: Valid;
  updatedAt: Scalars['Time']['output'];
  userID: Scalars['Uint64']['output'];
};

/** QA-回答登録/更新パラメーター */
export type QuestionAnswerInput = {
  content: Scalars['String']['input'];
};

/** QA-回答検索結果 */
export type QuestionAnswerSearchResponse = {
  __typename?: 'QuestionAnswerSearchResponse';
  items: Array<QuestionAnswer>;
  total: Scalars['Uint64']['output'];
};

/** QA-回答ステータス */
export enum QuestionAnswerStatus {
  /** 非表示 */
  Hide = 'HIDE',
  /** 無効 */
  Invalid = 'INVALID',
  /** 有効 */
  Valid = 'VALID'
}

/** QA-質問カテゴリー */
export enum QuestionCategory {
  /** 技術Q&A */
  Tech = 'TECH',
  /** お悩みQ&A */
  Trouble = 'TROUBLE'
}

export type QuestionComment = {
  __typename?: 'QuestionComment';
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  questionAnswer: QuestionAnswer;
  status: QuestionCommentStatus;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** QA-コメント登録/更新パラメーター */
export type QuestionCommentInput = {
  content: Scalars['String']['input'];
};

/** QA-コメント検索結果 */
export type QuestionCommentSearchResponse = {
  __typename?: 'QuestionCommentSearchResponse';
  items: Array<QuestionComment>;
  total: Scalars['Uint64']['output'];
};

/** QA-コメントステータス */
export enum QuestionCommentStatus {
  /** 非表示 */
  Hide = 'HIDE',
  /** 無効 */
  Invalid = 'INVALID',
  /** 有効 */
  Valid = 'VALID'
}

/** QA 回答評価 */
export type QuestionEvaluation = {
  __typename?: 'QuestionEvaluation';
  createdAt: Scalars['Time']['output'];
  evaluationComment?: Maybe<Scalars['String']['output']>;
  evaluationType: QuestionAnswerEvaluationType;
  id: Scalars['ULID']['output'];
  questionID: Scalars['Uint64']['output'];
  status: Valid;
  updatedAt: Scalars['Time']['output'];
};

export type QuestionFavorite = {
  __typename?: 'QuestionFavorite';
  createdAt: Scalars['Time']['output'];
  questionID: Scalars['Uint64']['output'];
  status: Valid;
  updatedAt: Scalars['Time']['output'];
  userID: Scalars['Uint64']['output'];
};

/** QA-質問登録/更新パラメーター */
export type QuestionInput = {
  chapterID?: InputMaybe<Scalars['Uint64']['input']>;
  content: Scalars['String']['input'];
  practiceID?: InputMaybe<Scalars['ULID']['input']>;
  programID?: InputMaybe<Scalars['Uint64']['input']>;
  status: QuestionStatus;
  tagIDs?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  title: Scalars['String']['input'];
};

/** QA-質問検索パラメーター */
export type QuestionSearchInput = {
  /** 回答あり true:回答あり/false:回答なし */
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  chapterID?: InputMaybe<Scalars['Uint64']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  practiceID?: InputMaybe<Scalars['ULID']['input']>;
  programID?: InputMaybe<Scalars['Uint64']['input']>;
  /** 検索用質問ステータス */
  searchQuestionStatus?: InputMaybe<SearchQuestionStatus>;
  /** 解決済み true:解決済み/false:未解決 */
  solved?: InputMaybe<Scalars['Boolean']['input']>;
  /** 並び順 */
  sortKey: QuestionSortKey;
  tagID?: InputMaybe<Scalars['Uint64']['input']>;
  /** ユーザーIDを指定すると、AuthUserで認証したユーザー以外のユーザーに紐づく質問を取得する */
  targetUserID?: InputMaybe<Scalars['Uint64']['input']>;
  type: QuestionSearchType;
  word?: InputMaybe<Scalars['String']['input']>;
};

/** QA-質問検索結果 */
export type QuestionSearchResponse = {
  __typename?: 'QuestionSearchResponse';
  items: Array<Question>;
  total: Scalars['Uint64']['output'];
};

/** 質問検索種別 */
export enum QuestionSearchType {
  /** すべての質問 */
  All = 'ALL',
  /** あなたの質問 */
  Mine = 'MINE',
  /** 回答した質問 */
  MyAnswered = 'MY_ANSWERED',
  /** 下書き */
  MyDraft = 'MY_DRAFT',
  /** 担当した受講生の質問 */
  MyStudents = 'MY_STUDENTS'
}

/** QAソートキー */
export enum QuestionSortKey {
  /** アクションが新しい順 */
  ActionedAt = 'ACTIONED_AT',
  /** 回答数が多い順 */
  AnswerCount = 'ANSWER_COUNT',
  /** 参考になったが多い順 */
  AnswerFavoriteCount = 'ANSWER_FAVORITE_COUNT',
  /** 質問が新しい順 */
  CreatedAt = 'CREATED_AT',
  /** 同じくが多い順 */
  QuestionFavoriteCount = 'QUESTION_FAVORITE_COUNT'
}

/** QA-質問ステータス */
export enum QuestionStatus {
  /** 下書き */
  Draft = 'DRAFT',
  /** 非表示 */
  Hide = 'HIDE',
  /** 無効 */
  Invalid = 'INVALID',
  /** 有効 */
  Valid = 'VALID'
}

export type RePracticeSubmitInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  isDraft: Scalars['Boolean']['input'];
  /** 新規課題：不要、下書き課題：必須 */
  practiceSubmitDetailID?: InputMaybe<Scalars['ULID']['input']>;
  practiceSubmitID: Scalars['ULID']['input'];
  requestsInstructorReview?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ReadAllChatMessageResponse = {
  __typename?: 'ReadAllChatMessageResponse';
  chatRoomID: Scalars['Uint64']['output'];
  result: Scalars['Boolean']['output'];
};

/** 再課金時アンケート入力項目 */
export type RechargeRegisteredQuestionnaireInput = {
  /** 魅力 - その他 */
  attractiveTypeOthers?: InputMaybe<Scalars['String']['input']>;
  /** 魅力 */
  attractiveTypes: Array<RegisteredQuestionnaireAttractiveType>;
  /** 生年月日 */
  birthday: Scalars['Time']['input'];
  /** 目的 */
  purpose: RegisteredQuestionnairePurpose;
  /** 目的 - その他 */
  purposeOthers?: InputMaybe<Scalars['String']['input']>;
  /** 学習予定の言語・技術 - その他 */
  scheduledStudyTypeOthers?: InputMaybe<Scalars['String']['input']>;
  /** 学習予定の言語・技術 */
  scheduledStudyTypes: Array<Scalars['Uint64']['input']>;
  /** きっかけ */
  trigger: RegisteredQuestionnaireTrigger;
  /** きっかけ - その他 */
  triggerOthers?: InputMaybe<Scalars['String']['input']>;
};

export enum RecurringInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** 新規登録・再課金時アンケート - 魅力 */
export enum RegisteredQuestionnaireAttractiveType {
  /** AWS教材 */
  AwsProgram = 'AWS_PROGRAM',
  /** 一緒に学べる仲間がいる環境 */
  Environment = 'ENVIRONMENT',
  /** HTML/CSS教材 */
  HtmlCssProgram = 'HTML_CSS_PROGRAM',
  /** JavaScript教材 */
  JavaScriptProgram = 'JAVA_SCRIPT_PROGRAM',
  /** 現役エンジニアに直接相談できるレッスン */
  Lesson = 'LESSON',
  /** それ以外の機能 */
  Others = 'OTHERS',
  /** その他の教材 */
  OthersProgram = 'OTHERS_PROGRAM',
  /** PHP/Ruby教材 */
  PhpRubyProgram = 'PHP_RUBY_PROGRAM',
  /** Python教材 */
  PythonProgram = 'PYTHON_PROGRAM',
  /** いつでも質問できるQ&A掲示板 */
  Qa = 'QA'
}

/** 新規登録・再課金時アンケート - 目的 */
export enum RegisteredQuestionnairePurpose {
  /** サービス開発 */
  Development = 'DEVELOPMENT',
  /** 教養 */
  Education = 'EDUCATION',
  /** 仕事の業務効率化 */
  Efficiency = 'EFFICIENCY',
  /** エンジニア転職 */
  JobChange = 'JOB_CHANGE',
  /** その他 */
  Others = 'OTHERS',
  /** フリーランス・副業 */
  SideBusiness = 'SIDE_BUSINESS'
}

/** 新規登録・再課金時アンケート - きっかけ */
export enum RegisteredQuestionnaireTrigger {
  /** 新しい機能が追加されたから */
  AddNewFunction = 'ADD_NEW_FUNCTION',
  /** 新しい教材が追加されたから */
  AddNewProgram = 'ADD_NEW_PROGRAM',
  /** 質問したいことが出来たから */
  AskAQuestion = 'ASK_A_QUESTION',
  /** 他サービスを試したが侍テラコヤのほうが良かったから */
  BetterThanOther = 'BETTER_THAN_OTHER',
  /** キャンペーンで見かけたから */
  Campaign = 'CAMPAIGN',
  /** 時間がなくてやめたが勉強する時間が取れるようになったから */
  GotMoreTime = 'GOT_MORE_TIME',
  /** その他 */
  Others = 'OTHERS'
}

/** StudyReport-Instructor-担当受講生の学習ログ検索パラメーター */
export type RelatedStudyReportSearchInput = {
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  tagID?: InputMaybe<Scalars['Uint64']['input']>;
  targetUserID?: InputMaybe<Scalars['Uint64']['input']>;
};

export enum ResponseCode {
  Created = 'CREATED',
  DbConnectionFail = 'DB_CONNECTION_FAIL',
  Duplicated = 'DUPLICATED',
  Fail = 'FAIL',
  InvalidExtension = 'INVALID_EXTENSION',
  InvalidMimetype = 'INVALID_MIMETYPE',
  NotFound = 'NOT_FOUND',
  ServiceError = 'SERVICE_ERROR',
  SessionFail = 'SESSION_FAIL',
  Success = 'SUCCESS',
  Unauthorized = 'UNAUTHORIZED',
  Unknown = 'UNKNOWN',
  ValidationFail = 'VALIDATION_FAIL',
  WrongInput = 'WRONG_INPUT'
}

/** 運営への連携項目の対応期限 */
export enum ResponseDeadlineType {
  /** 急ぎ対応希望 */
  Asap = 'ASAP',
  /** 1~3営業日以内の対応希望 */
  FewDays = 'FEW_DAYS',
  /** 7営業日以内の対応希望 */
  SevenDays = 'SEVEN_DAYS'
}

export type ResultResponse = {
  __typename?: 'ResultResponse';
  result: Scalars['Boolean']['output'];
};

export type ScheduledSubscriptionContract = {
  __typename?: 'ScheduledSubscriptionContract';
  endDate: Scalars['Time']['output'];
  price?: Maybe<Price>;
  priceID: Scalars['Uint64']['output'];
  product?: Maybe<Product>;
  productID: Scalars['Uint64']['output'];
  quantity: Scalars['Int64']['output'];
  startDate: Scalars['Time']['output'];
};

export enum SearchQuestionStatus {
  Ai = 'AI',
  All = 'ALL',
  Escalation = 'ESCALATION',
  Solved = 'SOLVED'
}

export type ServiceFeedback = {
  __typename?: 'ServiceFeedback';
  content: Scalars['String']['output'];
  feedbackCategory: FeedbackCategory;
  user: User;
};

export type ServiceFeedbackInput = {
  content: Scalars['String']['input'];
  feedbackCategoryID: Scalars['Uint64']['input'];
};

export type Session = {
  __typename?: 'Session';
  assignedCoach?: Maybe<Instructor>;
  coaching: Coaching;
  createdAt: Scalars['Time']['output'];
  endAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  phase: SessionPhase;
  startAt: Scalars['Time']['output'];
  status: Valid;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type SessionInput = {
  endAt: Scalars['Time']['input'];
  startAt: Scalars['Time']['input'];
  title: Scalars['String']['input'];
};

/** セッションのフェーズ */
export enum SessionPhase {
  /** コーチ事由などによるキャンセル */
  Canceled = 'CANCELED',
  /** 受講生によるキャンセル */
  CanceledByStudent = 'CANCELED_BY_STUDENT',
  /** 完了 */
  Completed = 'COMPLETED',
  /** 未完了 */
  NotCompleted = 'NOT_COMPLETED'
}

export type SessionReport = {
  __typename?: 'SessionReport';
  announcements: Array<SessionReportAnnouncement>;
  coachingMemo: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  delayReason: Scalars['String']['output'];
  hasAnnouncements: HasAnnouncementsType;
  hasAnnouncementsDetail: Scalars['String']['output'];
  hasPreparations: Bool;
  id: Scalars['ULID']['output'];
  isOnSchedule: IsOnScheduleType;
  preparationOthers: Scalars['String']['output'];
  preparations: Array<SessionReportPreparation>;
  responseDeadline: ResponseDeadlineType;
  session: Session;
  sessionID: Scalars['ULID']['output'];
  status: Valid;
  updatedAt: Scalars['Time']['output'];
};

export type SessionReportAnnouncement = {
  __typename?: 'SessionReportAnnouncement';
  id: Scalars['ULID']['output'];
  sessionReportID: Scalars['ULID']['output'];
  type: SessionReportAnnouncementType;
};

export type SessionReportAnnouncementInput = {
  type: SessionReportAnnouncementType;
};

/** 運営への連携項目 */
export enum SessionReportAnnouncementType {
  /** インストラクター交代について相談したい */
  ChangeToInstructor = 'CHANGE_TO_INSTRUCTOR',
  /** インストラクターの指導を改善してほしい */
  InstructToInstructor = 'INSTRUCT_TO_INSTRUCTOR',
  /** その他 */
  Other = 'OTHER',
  /** 目標・カリキュラム内容の見直し相談について */
  ReconsiderCurricurum = 'RECONSIDER_CURRICURUM',
  /** インストラクターに情報共有してほしい */
  ShareInfoToInstructor = 'SHARE_INFO_TO_INSTRUCTOR',
  /** 受講生のメンタル面などについて共有したい */
  StudentMental = 'STUDENT_MENTAL',
  /** 解約について相談したい */
  TalkToCancel = 'TALK_TO_CANCEL',
  /** コース変更について相談したい */
  TalkToChangeCourse = 'TALK_TO_CHANGE_COURSE',
  /** 延長コースについて相談したい */
  TalkToExtensionCourse = 'TALK_TO_EXTENSION_COURSE',
  /** 転職サポートに連携したい */
  TalkToJobchamgeSupport = 'TALK_TO_JOBCHAMGE_SUPPORT',
  /** 支払いについて相談したい */
  TalkToPayment = 'TALK_TO_PAYMENT',
  /** サービスの不満について */
  TalkToServiceDiscontent = 'TALK_TO_SERVICE_DISCONTENT'
}

export type SessionReportInput = {
  announcements: Array<SessionReportAnnouncementInput>;
  coachingMemo?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  delayReason?: InputMaybe<Scalars['String']['input']>;
  hasAnnouncementsDetail?: InputMaybe<Scalars['String']['input']>;
  isOnSchedule: IsOnScheduleType;
  phase: SessionPhase;
  preparationOthers?: InputMaybe<Scalars['String']['input']>;
  preparations: Array<SessionReportPreparationInput>;
  responseDeadline?: InputMaybe<ResponseDeadlineType>;
  sessionID: Scalars['ULID']['input'];
};

export type SessionReportPreparation = {
  __typename?: 'SessionReportPreparation';
  id: Scalars['ULID']['output'];
  sessionReportID: Scalars['ULID']['output'];
  type: SessionReportPreparationType;
};

export type SessionReportPreparationInput = {
  type: SessionReportPreparationType;
};

/** セッション前準備項目 */
export enum SessionReportPreparationType {
  /** 運営からの依頼対応 */
  AdminRequestTask = 'ADMIN_REQUEST_TASK',
  /** 受講生情報確認(QAやセッション履歴、カリキュラムなど) */
  CheckStudentInfoTask = 'CHECK_STUDENT_INFO_TASK',
  /** 受講生のメッセージ対応 */
  MessageTask = 'MESSAGE_TASK',
  /** その他 */
  OtherTask = 'OTHER_TASK'
}

export type SessionReportSearchResponse = {
  __typename?: 'SessionReportSearchResponse';
  items: Array<SessionReport>;
  total: Scalars['Int64']['output'];
};

export type SessionSearchInput = {
  coachingID?: InputMaybe<Scalars['ULID']['input']>;
  courseStatus?: InputMaybe<Scalars['Uint64']['input']>;
};

export type SessionSearchResponse = {
  __typename?: 'SessionSearchResponse';
  items: Array<Session>;
  total: Scalars['Uint64']['output'];
};

export type SpCoupon = {
  __typename?: 'SpCoupon';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  pvdAmountOff?: Maybe<Scalars['Uint64']['output']>;
  pvdCreated: Scalars['Time']['output'];
  pvdCurrency?: Maybe<Scalars['String']['output']>;
  pvdDuration: Scalars['String']['output'];
  pvdDurationInMonths?: Maybe<Scalars['Uint64']['output']>;
  pvdID: Scalars['String']['output'];
  pvdMaxRedemptions?: Maybe<Scalars['Uint64']['output']>;
  pvdName: Scalars['String']['output'];
  pvdPercentOff?: Maybe<Scalars['String']['output']>;
  pvdRedeemBy?: Maybe<Scalars['Time']['output']>;
  pvdTimesRedeemed?: Maybe<Scalars['Uint64']['output']>;
  pvdValid: Valid;
  spPromotionCodes: Array<SpPromotionCode>;
  updatedAt: Scalars['Time']['output'];
};

export enum SpCouponDuration {
  Forever = 'FOREVER',
  Once = 'ONCE',
  Repeating = 'REPEATING'
}

export type SpCouponSearchResponse = {
  __typename?: 'SpCouponSearchResponse';
  items: Array<SpCoupon>;
  total: Scalars['Uint64']['output'];
};

export type SpDiscount = {
  __typename?: 'SpDiscount';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  pvdCheckoutSession?: Maybe<Scalars['String']['output']>;
  pvdCustomer: Scalars['String']['output'];
  pvdEnd?: Maybe<Scalars['Time']['output']>;
  pvdID: Scalars['String']['output'];
  pvdInvoice?: Maybe<Scalars['String']['output']>;
  pvdInvoiceItem?: Maybe<Scalars['String']['output']>;
  pvdPromotionCode?: Maybe<Scalars['String']['output']>;
  pvdStart: Scalars['Time']['output'];
  pvdSubscription?: Maybe<Scalars['String']['output']>;
  subscription: SubscriptionInfo;
  subscriptionID: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type SpDiscountCoupon = {
  __typename?: 'SpDiscountCoupon';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  pvdAmountOff?: Maybe<Scalars['Int64']['output']>;
  pvdCreated: Scalars['Time']['output'];
  pvdCurrency?: Maybe<Scalars['String']['output']>;
  pvdDuration: Scalars['String']['output'];
  pvdDurationInMonths?: Maybe<Scalars['Int64']['output']>;
  pvdID: Scalars['String']['output'];
  pvdMaxRedemptions?: Maybe<Scalars['Int64']['output']>;
  pvdName: Scalars['String']['output'];
  pvdPercentOff?: Maybe<Scalars['String']['output']>;
  pvdRedeemBy?: Maybe<Scalars['Time']['output']>;
  pvdTimesRedeemed?: Maybe<Scalars['Int64']['output']>;
  pvdValid?: Maybe<Valid>;
  spDiscount: SpDiscount;
  spDiscountID: Scalars['ULID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type SpDiscountCouponResponse = {
  __typename?: 'SpDiscountCouponResponse';
  items: Array<SpDiscountCoupon>;
  total: Scalars['Int64']['output'];
};

export type SpDiscountResponse = {
  __typename?: 'SpDiscountResponse';
  items: Array<SpDiscount>;
  total: Scalars['Int64']['output'];
};

export type SpPromotionCode = {
  __typename?: 'SpPromotionCode';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  pvdActive: Bool;
  pvdCode: Scalars['String']['output'];
  pvdCreated: Scalars['Time']['output'];
  pvdCustomer?: Maybe<Scalars['String']['output']>;
  pvdExpiresAt?: Maybe<Scalars['Time']['output']>;
  pvdID: Scalars['String']['output'];
  pvdMaxRedemptions?: Maybe<Scalars['Uint64']['output']>;
  pvdRestrictionsCurrencyMinimumAmountCurrency?: Maybe<Scalars['String']['output']>;
  pvdRestrictionsFirstTimeTransaction?: Maybe<Bool>;
  pvdRestrictionsMinimumAmount?: Maybe<Scalars['Uint64']['output']>;
  pvdTimesRedeemed?: Maybe<Scalars['Uint64']['output']>;
  spCoupon?: Maybe<SpCoupon>;
  spCouponID: Scalars['ULID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type SpPromotionCodeSearchResponse = {
  __typename?: 'SpPromotionCodeSearchResponse';
  items: Array<SpPromotionCode>;
  total: Scalars['Uint64']['output'];
};

export type SpotLesson = {
  __typename?: 'SpotLesson';
  cancelType?: Maybe<SpotLessonCancelType>;
  canceledAt?: Maybe<Scalars['Time']['output']>;
  categories?: Maybe<Array<Category>>;
  createdAt: Scalars['Time']['output'];
  endAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  instructorSchedule?: Maybe<InstructorSchedule>;
  instructorScheduleID?: Maybe<Scalars['Uint64']['output']>;
  instructorUser?: Maybe<User>;
  instructorUserID: Scalars['Uint64']['output'];
  phase?: Maybe<SpotLessonPhase>;
  researchContent?: Maybe<Scalars['String']['output']>;
  startAt: Scalars['Time']['output'];
  status?: Maybe<Scalars['Uint64']['output']>;
  tags?: Maybe<Array<Tag>>;
  ticket?: Maybe<Ticket>;
  ticketID: Scalars['Uint64']['output'];
  troubleContent?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  user?: Maybe<User>;
  userID: Scalars['Uint64']['output'];
  zoomMtgID?: Maybe<Scalars['String']['output']>;
  zoomURL?: Maybe<Scalars['String']['output']>;
};

export type SpotLessonCalendar = {
  __typename?: 'SpotLessonCalendar';
  date: Scalars['Time']['output'];
  timeBlocks: Array<SpotLessonTimeBlock>;
};

export enum SpotLessonCancelType {
  Instructor = 'INSTRUCTOR',
  Student = 'STUDENT'
}

export type SpotLessonInput = {
  categories: Array<Scalars['Uint64']['input']>;
  endAt: Scalars['Time']['input'];
  researchContent: Scalars['String']['input'];
  startAt: Scalars['Time']['input'];
  tags: Array<Scalars['Uint64']['input']>;
  troubleContent: Scalars['String']['input'];
};

export enum SpotLessonPhase {
  Cancel = 'CANCEL',
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  NonAttendance = 'NON_ATTENDANCE'
}

export type SpotLessonSearchInput = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type SpotLessonSearchResponse = {
  __typename?: 'SpotLessonSearchResponse';
  items: Array<SpotLesson>;
  total: Scalars['Int64']['output'];
};

export type SpotLessonTimeBlock = {
  __typename?: 'SpotLessonTimeBlock';
  disable: Scalars['Boolean']['output'];
  duration: Scalars['Int64']['output'];
  reservationCount: Scalars['Int64']['output'];
  slotCount: Scalars['Int64']['output'];
  startAt: Scalars['Time']['output'];
};

export type SpotLessonUpdateInput = {
  researchContent: Scalars['String']['input'];
  troubleContent: Scalars['String']['input'];
};

export enum StripeCollectionMethod {
  ChargeAutomatically = 'CHARGE_AUTOMATICALLY',
  SendInvoice = 'SEND_INVOICE'
}

export type StripeCustomer = {
  __typename?: 'StripeCustomer';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  providerID: Scalars['String']['output'];
  stripeCustomerType: StripeCustomerType;
  subscriptionCurrent?: Maybe<SubscriptionCurrent>;
  team?: Maybe<Team>;
  updatedAt: Scalars['Time']['output'];
  user?: Maybe<User>;
};

export type StripeCustomerResponse = {
  __typename?: 'StripeCustomerResponse';
  items: Array<StripeCustomer>;
  total: Scalars['Int64']['output'];
};

export enum StripeCustomerType {
  Personal = 'PERSONAL',
  Team = 'TEAM',
  Unknown = 'UNKNOWN'
}

export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  created: Scalars['Time']['output'];
  hostedInvoiceURL: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoicePDF: Scalars['String']['output'];
  periodEnd: Scalars['Time']['output'];
  periodStart: Scalars['Time']['output'];
  status: ProviderInvoiceStatus;
  stripeInvoiceLines: Array<StripeInvoiceLine>;
  subscription: Scalars['String']['output'];
  subtotal: Scalars['Int64']['output'];
  total: Scalars['Int64']['output'];
};

export type StripeInvoiceLine = {
  __typename?: 'StripeInvoiceLine';
  amount: Scalars['Int64']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  periodEnd: Scalars['Time']['output'];
  periodStart: Scalars['Time']['output'];
  price: StripePrice;
  quantity: Scalars['Int64']['output'];
};

export type StripeInvoiceResponse = {
  __typename?: 'StripeInvoiceResponse';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  items: Array<StripeInvoice>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  previousCursor?: Maybe<Scalars['String']['output']>;
};

export type StripePaymentMethod = {
  __typename?: 'StripePaymentMethod';
  cardBrand: Scalars['String']['output'];
  cardNumber: Scalars['String']['output'];
  expireMonth: Scalars['Int64']['output'];
  expireYear: Scalars['Int64']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
};

export type StripePaymentMethodResponse = {
  __typename?: 'StripePaymentMethodResponse';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  items: Array<StripePaymentMethod>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  previousCursor?: Maybe<Scalars['String']['output']>;
};

export type StripePaymentMethodsSearchInput = {
  limit: Scalars['Int64']['input'];
  nextCursor?: InputMaybe<Scalars['String']['input']>;
  previousCursor?: InputMaybe<Scalars['String']['input']>;
};

export type StripePrice = {
  __typename?: 'StripePrice';
  id: Scalars['String']['output'];
  productDetail?: Maybe<Product>;
  productID: Scalars['String']['output'];
  unitAmount: Scalars['Int64']['output'];
  unitAmountDecimal: Scalars['Float64']['output'];
};

export type StripeStoredSubscription = {
  __typename?: 'StripeStoredSubscription';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  collectionMethod: StripeCollectionMethod;
  currentPeriodEnd: Scalars['Time']['output'];
  currentPeriodStart: Scalars['Time']['output'];
  id: Scalars['String']['output'];
  latestInvoice: Scalars['String']['output'];
  status: ProviderSubscriptionStatus;
  stripeSubscriptionItems: Array<StripeSubscriptionItem>;
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  price?: Maybe<Price>;
  priceID?: Maybe<Scalars['Uint64']['output']>;
  providerID: Scalars['String']['output'];
  providerQuantity: Scalars['Int64']['output'];
  providerStatus: ProviderSubscriptionStatus;
  stripeCustomer?: Maybe<StripeCustomer>;
  stripeCustomerID: Scalars['ULID']['output'];
  stripeSubscriptionResponse?: Maybe<StripeStoredSubscription>;
  subscriptionContracts: Array<SubscriptionContract>;
  subscriptionCurrent?: Maybe<SubscriptionCurrent>;
  updatedAt: Scalars['Time']['output'];
};

export type StripeSubscriptionItem = {
  __typename?: 'StripeSubscriptionItem';
  price: StripePrice;
  quantity: Scalars['Int64']['output'];
};

export type StripeSubscriptionLog = {
  __typename?: 'StripeSubscriptionLog';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  price?: Maybe<Price>;
  priceID?: Maybe<Scalars['Uint64']['output']>;
  providerID: Scalars['String']['output'];
  providerQuantity: Scalars['Int64']['output'];
  providerStatus: ProviderSubscriptionStatus;
  stripeCustomer?: Maybe<StripeCustomer>;
  stripeCustomerID: Scalars['ULID']['output'];
  stripeSubscriptionID: Scalars['ULID']['output'];
  stripeSubscriptionResponse?: Maybe<StripeStoredSubscription>;
  subscriptionChangeHistory?: Maybe<SubscriptionChangeHistory>;
  subscriptionContracts: Array<SubscriptionContract>;
  updatedAt: Scalars['Time']['output'];
};

export type StripeSubscriptionLogResponse = {
  __typename?: 'StripeSubscriptionLogResponse';
  items: Array<StripeSubscriptionLog>;
  total: Scalars['Int64']['output'];
};

export type StripeSubscriptionResponse = {
  __typename?: 'StripeSubscriptionResponse';
  items: Array<StripeSubscription>;
  total: Scalars['Int64']['output'];
};

export type Student = {
  __typename?: 'Student';
  careerSupport?: Maybe<Scalars['Uint64']['output']>;
  courses: Array<Course>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  /** 管理者のみ参照可、それ以外の権限の場合はnull */
  personalInfo?: Maybe<StudentPersonalInfo>;
  scClientID: Scalars['String']['output'];
  scStudentID: Scalars['String']['output'];
  status?: Maybe<Scalars['Uint64']['output']>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['Uint64']['output'];
};

export type StudentCourseSearchInput = {
  /** Course検索タイプ */
  type: CourseSearchType;
};

export type StudentInformation = {
  __typename?: 'StudentInformation';
  createdAt: Scalars['Time']['output'];
  customerInformation: Scalars['String']['output'];
  id: Scalars['ULID']['output'];
  transferInformation: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** 受講生個人情報 */
export type StudentPersonalInfo = {
  __typename?: 'StudentPersonalInfo';
  firstName?: Maybe<Scalars['String']['output']>;
  kanaName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
};

export type StudentSearchResponse = {
  __typename?: 'StudentSearchResponse';
  items: Array<Student>;
  total: Scalars['Int64']['output'];
};

export type StudyCalendar = {
  __typename?: 'StudyCalendar';
  createdAt: Scalars['Time']['output'];
  date: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  studyReportTime: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  userID: Scalars['Uint64']['output'];
};

export type StudyCalendarSearchInput = {
  from?: InputMaybe<Scalars['Time']['input']>;
  to?: InputMaybe<Scalars['Time']['input']>;
};

export type StudyFavoriteSummariesResponse = {
  __typename?: 'StudyFavoriteSummariesResponse';
  items: Array<StudyFavoriteSummary>;
  total: Scalars['Int64']['output'];
};

export type StudyFavoriteSummary = {
  __typename?: 'StudyFavoriteSummary';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  studyFavoriteCount: Scalars['Uint64']['output'];
  studyFavoriteCountMonth: Scalars['Uint64']['output'];
  studyFavoriteCountWeek: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  user?: Maybe<User>;
  userID: Scalars['Uint64']['output'];
};

export type StudyFavoriteSummaryListResponse = {
  __typename?: 'StudyFavoriteSummaryListResponse';
  studyFavoriteCount: Array<StudyFavoriteSummary>;
  studyFavoriteCountMonth: Array<StudyFavoriteSummary>;
  studyFavoriteCountWeek: Array<StudyFavoriteSummary>;
};

export type StudyLog = {
  __typename?: 'StudyLog';
  chapterID: Scalars['Uint64']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  understandingLevel: StudyLogUnderstandingLevel;
  updatedAt: Scalars['Time']['output'];
  userID: Scalars['Uint64']['output'];
};

/** 学習履歴-理解度 */
export enum StudyLogUnderstandingLevel {
  /** 80〜 */
  High = 'HIGH',
  /** 〜50 */
  Low = 'LOW',
  /** 50〜80 */
  Middle = 'MIDDLE'
}

export type StudyReport = Timeline & {
  __typename?: 'StudyReport';
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdAtKey?: Maybe<Scalars['ULID']['output']>;
  date: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  status: Valid;
  studyReportComments: Array<StudyReportComment>;
  studyReportDetails: Array<StudyReportDetail>;
  studyReportFavorites: Array<StudyReportFavorite>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['Uint64']['output'];
};

export type StudyReportComment = {
  __typename?: 'StudyReportComment';
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  status: Valid;
  studyReport?: Maybe<StudyReport>;
  studyReportID: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['Uint64']['output'];
};

/** StudyReportComment-学習ログコメント登録/更新パラメーター */
export type StudyReportCommentInput = {
  content: Scalars['String']['input'];
};

/** StudyReportComment-学習ログコメント検索結果 */
export type StudyReportCommentSearchResponse = {
  __typename?: 'StudyReportCommentSearchResponse';
  items: Array<StudyReportComment>;
  total: Scalars['Uint64']['output'];
};

export type StudyReportDetail = {
  __typename?: 'StudyReportDetail';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  program?: Maybe<Program>;
  programID?: Maybe<Scalars['Uint64']['output']>;
  studyReportID: Scalars['Uint64']['output'];
  tag?: Maybe<Tag>;
  tagID: Scalars['Uint64']['output'];
  time?: Maybe<Scalars['Uint64']['output']>;
  updatedAt: Scalars['Time']['output'];
};

/** StudyReportDetail-学習ログ詳細登録/更新パラメーター */
export type StudyReportDetailInput = {
  programID?: InputMaybe<Scalars['Uint64']['input']>;
  tagID: Scalars['Uint64']['input'];
  time: Scalars['Uint64']['input'];
};

/** StudyReportDetail-学習ログ詳細検索結果 */
export type StudyReportDetailSearchResponse = {
  __typename?: 'StudyReportDetailSearchResponse';
  items: Array<StudyReportDetail>;
  total: Scalars['Uint64']['output'];
};

export type StudyReportFavorite = {
  __typename?: 'StudyReportFavorite';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  status: Valid;
  studyReportID: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  userID: Scalars['Uint64']['output'];
};

/** StudyReport-学習ログ登録/更新パラメーター */
export type StudyReportInput = {
  content: Scalars['String']['input'];
  date: Scalars['Time']['input'];
  studyReportDetails?: InputMaybe<Array<InputMaybe<StudyReportDetailInput>>>;
};

/** StudyReport-学習ログ検索パラメーター */
export type StudyReportSearchInput = {
  date?: InputMaybe<Scalars['Time']['input']>;
  /** 受講生の学習ログのみ */
  isStudent?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  tagID?: InputMaybe<Scalars['Uint64']['input']>;
  /** ユーザーIDを指定すると、AuthUserで認証したユーザー以外のユーザーに紐づく学習ログを取得する */
  targetUserID?: InputMaybe<Scalars['Uint64']['input']>;
  word?: InputMaybe<Scalars['String']['input']>;
};

/** StudyReport-学習ログ検索結果 */
export type StudyReportSearchResponse = {
  __typename?: 'StudyReportSearchResponse';
  items: Array<StudyReport>;
  total: Scalars['Uint64']['output'];
};

export type StudySummariesResponse = {
  __typename?: 'StudySummariesResponse';
  items: Array<StudySummary>;
  total: Scalars['Int64']['output'];
};

export type StudySummary = {
  __typename?: 'StudySummary';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  studyReportCount?: Maybe<Scalars['Uint64']['output']>;
  studyReportCurrentRunningLayDays: Scalars['Uint64']['output'];
  studyReportRunningLayDays: Scalars['Uint64']['output'];
  studyReportTime?: Maybe<Scalars['Uint64']['output']>;
  studyReportTimeMonth: Scalars['Uint64']['output'];
  studyReportTimeWeek: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  user?: Maybe<User>;
  userID: Scalars['Uint64']['output'];
};

export type StudySummaryListResponse = {
  __typename?: 'StudySummaryListResponse';
  studyReportTime: Array<StudySummary>;
  studyReportTimeMonth: Array<StudySummary>;
  studyReportTimeWeek: Array<StudySummary>;
};

export type StudyTagSummariesResponse = {
  __typename?: 'StudyTagSummariesResponse';
  items: Array<StudyTagSummary>;
  total: Scalars['Int64']['output'];
};

export type StudyTagSummary = {
  __typename?: 'StudyTagSummary';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  studyReportTime: Scalars['Uint64']['output'];
  studyReportTimeMonth: Scalars['Uint64']['output'];
  studyReportTimeWeek: Scalars['Uint64']['output'];
  tag: Tag;
  tagID: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  user?: Maybe<User>;
  userID: Scalars['Uint64']['output'];
};

export type StudyTagSummaryListResponse = {
  __typename?: 'StudyTagSummaryListResponse';
  studyReportTime: Array<StudyTagSummary>;
  studyReportTimeMonth: Array<StudyTagSummary>;
  studyReportTimeWeek: Array<StudyTagSummary>;
};

export type SubscribeFormInput = {
  isTrial?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodType: PaymentMethodType;
  priceID: Scalars['Uint64']['input'];
  promotionCode?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodID?: InputMaybe<Scalars['String']['input']>;
  timezoneOffset: Scalars['Int64']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** チャットメッセージ-メッセージ投稿/削除を監視 */
  chatMessagePosted: ChatMessage;
  /** チャットルーム 表示内容変更を監視 */
  chatRoomContentChanged: ChatRoom;
};


export type SubscriptionChatMessagePostedArgs = {
  chatRoomID: Scalars['Uint64']['input'];
};

export enum SubscriptionActionType {
  AdminCancel = 'ADMIN_CANCEL',
  ExitFeeJob = 'EXIT_FEE_JOB',
  MigrationJob = 'MIGRATION_JOB',
  TeamChangeCanceledAt = 'TEAM_CHANGE_CANCELED_AT',
  TeamCreate = 'TEAM_CREATE',
  TeamUpdate = 'TEAM_UPDATE',
  UserCancelAll = 'USER_CANCEL_ALL',
  UserChangeCanceledAt = 'USER_CHANGE_CANCELED_AT',
  UserCreate = 'USER_CREATE',
  UserRelease = 'USER_RELEASE',
  UserUpdate = 'USER_UPDATE',
  WebhookCreate = 'WEBHOOK_CREATE',
  WebhookUpdate = 'WEBHOOK_UPDATE'
}

export type SubscriptionCancellationPeriod = {
  __typename?: 'SubscriptionCancellationPeriod';
  endDate: Scalars['Time']['output'];
  startDate: Scalars['Time']['output'];
};

export type SubscriptionChangeHistory = {
  __typename?: 'SubscriptionChangeHistory';
  action?: Maybe<SubscriptionActionType>;
  changedBy?: Maybe<Scalars['Int64']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ULID']['output'];
  recordType: SubscriptionChangeHistoryRecordType;
  stripeCustomerID: Scalars['ULID']['output'];
  stripeSubscriptionLog?: Maybe<StripeSubscriptionLog>;
  stripeSubscriptionLogID?: Maybe<Scalars['ULID']['output']>;
  subscriptionContractLog?: Maybe<SubscriptionContractLog>;
  subscriptionContractLogID?: Maybe<Scalars['ULID']['output']>;
  subscriptionCurrentLog?: Maybe<SubscriptionCurrentLog>;
  subscriptionCurrentLogID?: Maybe<Scalars['ULID']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  webhookEventID?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionChangeHistoryRecordType {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Update = 'UPDATE',
  Upsert = 'UPSERT'
}

export type SubscriptionChangeHistoryResponse = {
  __typename?: 'SubscriptionChangeHistoryResponse';
  items: Array<SubscriptionChangeHistory>;
  total: Scalars['Int64']['output'];
};

export type SubscriptionContract = {
  __typename?: 'SubscriptionContract';
  canceledAt?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  endDate?: Maybe<Scalars['Time']['output']>;
  exitFeePaymentIntentID?: Maybe<Scalars['String']['output']>;
  exitFeeStatus: ExitFeeStatus;
  id: Scalars['ULID']['output'];
  periodEnd: Scalars['Time']['output'];
  periodStart: Scalars['Time']['output'];
  phase: SubscriptionContractPhase;
  price?: Maybe<Price>;
  priceID?: Maybe<Scalars['Uint64']['output']>;
  stripeSubscription?: Maybe<StripeSubscription>;
  stripeSubscriptionID?: Maybe<Scalars['ULID']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type SubscriptionContractLog = {
  __typename?: 'SubscriptionContractLog';
  canceledAt?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  endDate?: Maybe<Scalars['Time']['output']>;
  exitFeePaymentIntentID?: Maybe<Scalars['String']['output']>;
  exitFeeStatus: ExitFeeStatus;
  id: Scalars['ULID']['output'];
  periodEnd: Scalars['Time']['output'];
  periodStart: Scalars['Time']['output'];
  phase: SubscriptionContractPhase;
  price?: Maybe<Price>;
  priceID?: Maybe<Scalars['Uint64']['output']>;
  stripeSubscription?: Maybe<StripeSubscription>;
  stripeSubscriptionID?: Maybe<Scalars['ULID']['output']>;
  subscriptionChangeHistory?: Maybe<SubscriptionChangeHistory>;
  subscriptionContractID: Scalars['ULID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type SubscriptionContractLogsResponse = {
  __typename?: 'SubscriptionContractLogsResponse';
  items: Array<SubscriptionContractLog>;
  total: Scalars['Int64']['output'];
};

export type SubscriptionContractPeriod = {
  __typename?: 'SubscriptionContractPeriod';
  createdAt: Scalars['Time']['output'];
  endDate: Scalars['Time']['output'];
  startDate: Scalars['Time']['output'];
  status: SubscriptionContractPeriodStatus;
  subscriptionID: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type SubscriptionContractPeriodHistory = {
  __typename?: 'SubscriptionContractPeriodHistory';
  createdAt: Scalars['Time']['output'];
  endDate: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  phase: SubscriptionPhase;
  startDate: Scalars['Time']['output'];
  subscription: SubscriptionInfo;
  subscriptionID: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  userID: Scalars['Uint64']['output'];
};

export type SubscriptionContractPeriodHistorySearchInput = {
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
};

export enum SubscriptionContractPeriodStatus {
  Active = 'ACTIVE',
  AutoCancel = 'AUTO_CANCEL',
  SelcCancel = 'SELC_CANCEL',
  Unknown = 'UNKNOWN'
}

export enum SubscriptionContractPhase {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  ChangeContractPeriod = 'CHANGE_CONTRACT_PERIOD',
  Completed = 'COMPLETED'
}

export type SubscriptionContractsResponse = {
  __typename?: 'SubscriptionContractsResponse';
  items: Array<SubscriptionContract>;
  total: Scalars['Int64']['output'];
};

export type SubscriptionCurrent = {
  __typename?: 'SubscriptionCurrent';
  createdAt: Scalars['Time']['output'];
  stripeCustomerID: Scalars['ULID']['output'];
  stripeSubscriptionID?: Maybe<Scalars['ULID']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type SubscriptionCurrentLog = {
  __typename?: 'SubscriptionCurrentLog';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  stripeCustomerID: Scalars['ULID']['output'];
  stripeSubscriptionID?: Maybe<Scalars['ULID']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type SubscriptionHistoriesSearchResponse = {
  __typename?: 'SubscriptionHistoriesSearchResponse';
  items: Array<SubscriptionContractPeriodHistory>;
  total: Scalars['Uint64']['output'];
};

export type SubscriptionHistory = {
  __typename?: 'SubscriptionHistory';
  createdAt: Scalars['Time']['output'];
  endDate: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  phase: SubscriptionPhase;
  startDate: Scalars['Time']['output'];
  status: Valid;
  subscriptionID: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

export type SubscriptionHistorySearchResponse = {
  __typename?: 'SubscriptionHistorySearchResponse';
  items: Array<SubscriptionHistory>;
  total: Scalars['Uint64']['output'];
};

/** サブスク情報 */
export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo';
  cancelAtPeriodEnd: Bool;
  canceledAt?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  endDate: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  invoices: Array<Invoice>;
  paymentIntents: Array<PaymentIntent>;
  phase: SubscriptionPhase;
  providerSubscriptionID: Scalars['String']['output'];
  startDate: Scalars['Time']['output'];
  status: Valid;
  stripeCanceledAt?: Maybe<Scalars['Time']['output']>;
  subscriptionContractPeriod?: Maybe<SubscriptionContractPeriod>;
  subscriptionContractPeriodHistories: Array<SubscriptionContractPeriodHistory>;
  subscriptionHistories: Array<SubscriptionHistory>;
  subscriptionItems: Array<SubscriptionItem>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

export type SubscriptionItem = {
  __typename?: 'SubscriptionItem';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  price: Price;
  providerSubscriptionItemID: Scalars['String']['output'];
  status: Valid;
  subscriptionID: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
};

export enum SubscriptionPhase {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Trialing = 'TRIALING',
  Unknown = 'UNKNOWN',
  Unpaid = 'UNPAID'
}

export type SubscriptionSearchResponse = {
  __typename?: 'SubscriptionSearchResponse';
  items: Array<SubscriptionInfo>;
  total: Scalars['Uint64']['output'];
};

/** サブスクリプションサマリ情報 */
export type SubscriptionSummary = {
  __typename?: 'SubscriptionSummary';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  /** 解約時手数料が発生しない期間(TO) */
  cancellationEndDate?: Maybe<Scalars['Time']['output']>;
  /** 解約時手数料が発生しない期間(FROM) */
  cancellationStartDate?: Maybe<Scalars['Time']['output']>;
  /** 契約上の終了日 */
  contractEndDate: Scalars['Time']['output'];
  /** 契約上の開始日 */
  contractStartDate: Scalars['Time']['output'];
  /** 終了日 */
  endDate: Scalars['Time']['output'];
  /** 現在のサブスクリプションが契約期間最終月か */
  isLastContractMonth: Scalars['Boolean']['output'];
  /** 複数月契約か */
  isMultiMonthContract: Scalars['Boolean']['output'];
  phase: SubscriptionPhase;
  price: Scalars['Uint64']['output'];
  productName: Scalars['String']['output'];
  /** 開始日 */
  startDate: Scalars['Time']['output'];
  subscriptionID: Scalars['Uint64']['output'];
};

export enum SubscriptionType {
  Basic = 'BASIC',
  Light = 'LIGHT',
  Premium = 'PREMIUM'
}

export enum SubscriptionUpgradeType {
  DowngradeSchedule = 'DOWNGRADE_SCHEDULE',
  Immediate = 'IMMEDIATE',
  NotAvailable = 'NOT_AVAILABLE',
  Operation = 'OPERATION',
  Schedule = 'SCHEDULE',
  Self = 'SELF'
}

export type SubscriptionUpgradeTypeItem = {
  __typename?: 'SubscriptionUpgradeTypeItem';
  priceID: Scalars['Uint64']['output'];
  subscriptionType: SubscriptionType;
  subscriptionUpgradeType: SubscriptionUpgradeType;
};

export type Tag = {
  __typename?: 'Tag';
  createdAt: Scalars['Time']['output'];
  iconImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Uint64']['output'];
  name: Scalars['String']['output'];
  overview?: Maybe<Scalars['String']['output']>;
  questionCount: Scalars['Uint64']['output'];
  status: Valid;
  studyReportCount: Scalars['Uint64']['output'];
  tagPermissions: Array<TagPermission>;
  updatedAt: Scalars['Time']['output'];
};

/** タグ-カテゴリー */
export enum TagCategory {
  /** 技術Q&A */
  Tech = 'TECH',
  /** お悩みQ&A */
  Trouble = 'TROUBLE'
}

export type TagCount = {
  __typename?: 'TagCount';
  count: Scalars['Int64']['output'];
  tag?: Maybe<Tag>;
  tagID: Scalars['Uint64']['output'];
};

/** 検索順 */
export enum TagOrder {
  /** 質問数 */
  QuestionCount = 'QUESTION_COUNT'
}

export type TagPermission = {
  __typename?: 'TagPermission';
  tagID: Scalars['Uint64']['output'];
  userRole?: Maybe<UserRole>;
};

/** タグ-検索パラメーター */
export type TagSearchInput = {
  category?: InputMaybe<TagCategory>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** タグ名(部分一致) */
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TagOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TagType>;
};

/** タグ-検索結果 */
export type TagSearchResponse = {
  __typename?: 'TagSearchResponse';
  items: Array<Tag>;
  total: Scalars['Int64']['output'];
};

/** タグ-タイプ */
export enum TagType {
  /** 教材 */
  Program = 'PROGRAM',
  /** 課金後のアンケート */
  RegisteredQuestionnaire = 'REGISTERED_QUESTIONNAIRE',
  /** スポットレッスン */
  SpotLesson = 'SPOT_LESSON'
}

export enum TargetDeviceType {
  All = 'ALL',
  ByDevice = 'BY_DEVICE',
  Pc = 'PC',
  Sp = 'SP'
}

export type Team = {
  __typename?: 'Team';
  adminEmail?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  paymentMethodType?: Maybe<PaymentMethodType>;
  status: Valid;
  teamMembers?: Maybe<Array<TeamMember>>;
  updatedAt: Scalars['Time']['output'];
};

export type TeamInput = {
  adminEmail: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
};

export type TeamInvitation = {
  __typename?: 'TeamInvitation';
  createdAt: Scalars['Time']['output'];
  email: Scalars['String']['output'];
  expireAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  status: Valid;
  team: Team;
  teamID: Scalars['ULID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type TeamInvitationInput = {
  emails: Array<Scalars['String']['input']>;
  teamID: Scalars['ULID']['input'];
};

export type TeamInvoicesSearchInput = {
  isCurrentSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int64']['input'];
  nextCursor?: InputMaybe<Scalars['String']['input']>;
  previousCursor?: InputMaybe<Scalars['String']['input']>;
  teamID: Scalars['ULID']['input'];
};

export type TeamMember = {
  __typename?: 'TeamMember';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  role: TeamMemberRole;
  status: Valid;
  team: Team;
  teamID: Scalars['ULID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['Uint64']['output'];
};

export enum TeamMemberRole {
  Admin = 'ADMIN',
  General = 'GENERAL'
}

/** TeamMember-チームメンバー一覧取得Input */
export type TeamMemberSearchInput = {
  limit: Scalars['Uint64']['input'];
  page: Scalars['Uint64']['input'];
  teamID: Scalars['ULID']['input'];
};

/** TeamMember-チームメンバー一覧レスポンス */
export type TeamMembersResponse = {
  __typename?: 'TeamMembersResponse';
  items: Array<TeamMember>;
  total: Scalars['Uint64']['output'];
};

export type TeamStripePaymentMethodsSearchInput = {
  limit: Scalars['Int64']['input'];
  nextCursor?: InputMaybe<Scalars['String']['input']>;
  previousCursor?: InputMaybe<Scalars['String']['input']>;
  teamID: Scalars['ULID']['input'];
};

export type TeamSubscribeFormInput = {
  billingCycleAnchor?: InputMaybe<Scalars['Time']['input']>;
  paymentMethodType: PaymentMethodType;
  priceID: Scalars['Uint64']['input'];
  providerPaymentMethodID?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int64']['input'];
  teamID: Scalars['ULID']['input'];
  timezoneOffset: Scalars['Int64']['input'];
};

export type TeamSubscriptionContractInput = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  teamID: Scalars['ULID']['input'];
};

export type TeamUpcomingResponse = {
  __typename?: 'TeamUpcomingResponse';
  defaultPrice?: Maybe<Scalars['Int64']['output']>;
  isIncrementalUpdate: Scalars['Boolean']['output'];
  nextInvoice?: Maybe<StripeInvoice>;
};

export type TeamUpdateSubscriptionFormInput = {
  priceID?: InputMaybe<Scalars['Uint64']['input']>;
  quantity: Scalars['Int64']['input'];
};

export type TeamsResponse = {
  __typename?: 'TeamsResponse';
  items: Array<Team>;
  total: Scalars['Int64']['output'];
};

export type TermChangeLog = {
  __typename?: 'TermChangeLog';
  afterEndDate: Scalars['Time']['output'];
  afterStartDate: Scalars['Time']['output'];
  course: Course;
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  termChangeReason: TermChangeReason;
  updatedAt: Scalars['Time']['output'];
};

export type TermChangeLogSearchResponse = {
  __typename?: 'TermChangeLogSearchResponse';
  items: Array<TermChangeLog>;
  total: Scalars['Uint64']['output'];
};

export type TermChangeReason = {
  __typename?: 'TermChangeReason';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  reason: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type Ticket = {
  __typename?: 'Ticket';
  createdAt: Scalars['Time']['output'];
  expireAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  isUsed: Scalars['Uint64']['output'];
  type: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  user?: Maybe<User>;
  userID: Scalars['Uint64']['output'];
};

/** チケット 一覧取得用モデル */
export type TicketSearchResponse = {
  __typename?: 'TicketSearchResponse';
  items: Array<Ticket>;
  total: Scalars['Int64']['output'];
};

export type Timeline = {
  createdAt: Scalars['Time']['output'];
};

export type TimelineResponse = {
  __typename?: 'TimelineResponse';
  adminPageInfo: PageInfo;
  items: Array<TimelineResult>;
  pageInfo: PageInfo;
};

export type TimelineResult = StudyReport | Tweet;

export type TotalMedalCountResponse = {
  __typename?: 'TotalMedalCountResponse';
  medalCounts: Scalars['Map']['output'];
  programID?: Maybe<Scalars['Uint64']['output']>;
  userID: Scalars['Uint64']['output'];
};

export type Tweet = Timeline & {
  __typename?: 'Tweet';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  tweetDetail: TweetDetail;
  tweetPostDestination: TweetPostDestination;
  tweetStatus?: Maybe<TweetStatus>;
};

export type TweetComment = {
  __typename?: 'TweetComment';
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  tweetCommentID: Scalars['ULID']['output'];
  tweetCommentStatus: TweetCommentStatus;
  tweetID: Scalars['ULID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

export type TweetCommentInput = {
  content: Scalars['String']['input'];
  tweetID: Scalars['ULID']['input'];
};

export type TweetCommentResponse = {
  __typename?: 'TweetCommentResponse';
  items: Array<TweetComment>;
  pageInfo: PageInfo;
};

export enum TweetCommentStatus {
  Active = 'ACTIVE',
  Ban = 'BAN',
  Deleted = 'DELETED'
}

export type TweetDetail = {
  __typename?: 'TweetDetail';
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  detailType?: Maybe<TweetDetailType>;
  tweetComments?: Maybe<Array<TweetComment>>;
  tweetFavorites?: Maybe<Array<TweetFavorite>>;
  tweetID: Scalars['ULID']['output'];
  tweetImages?: Maybe<Array<TweetImage>>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['Uint64']['output'];
};


export type TweetDetailTweetCommentsArgs = {
  isAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TweetDetailType {
  Admin = 'ADMIN',
  Common = 'COMMON',
  Instructor = 'INSTRUCTOR'
}

export type TweetFavorite = {
  __typename?: 'TweetFavorite';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  status: Scalars['Uint64']['output'];
  tweetID: Scalars['ULID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['Uint64']['output'];
};

export type TweetImage = {
  __typename?: 'TweetImage';
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ULID']['output'];
  tweetID: Scalars['ULID']['output'];
};

export type TweetImageInput = {
  content: Scalars['String']['input'];
};

export type TweetInput = {
  content: Scalars['String']['input'];
  tweetImageInputs?: InputMaybe<Array<TweetImageInput>>;
  tweetPostDestination: TweetPostDestination;
};

export enum TweetPostDestination {
  All = 'ALL',
  Plus = 'PLUS',
  Pro = 'PRO'
}

export type TweetResponse = {
  __typename?: 'TweetResponse';
  items: Array<Tweet>;
  pageInfo: PageInfo;
};

export enum TweetStatus {
  Active = 'ACTIVE',
  Ban = 'BAN',
  Deleted = 'DELETED'
}

export type UnixTimestamp = {
  __typename?: 'UnixTimestamp';
  value: Scalars['String']['output'];
};

export type UpcomingResponse = {
  __typename?: 'UpcomingResponse';
  oldPriceInvoice?: Maybe<StripeInvoice>;
};

export type UpdatePracticeSubmitDetailReviewCommentInput = {
  content: Scalars['String']['input'];
  practiceSubmitDetailID: Scalars['ULID']['input'];
  practiceSubmitDetailReviewCommentID: Scalars['ULID']['input'];
  practiceSubmitID: Scalars['ULID']['input'];
};

export type UpdatePracticeSubmitInput = {
  content: Scalars['String']['input'];
  practiceSubmitDetailID: Scalars['ULID']['input'];
  practiceSubmitID: Scalars['ULID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionFormInput = {
  priceID: Scalars['Uint64']['input'];
};

/** Team-チーム情報更新更新パラメーター */
export type UpdateTeamInput = {
  adminEmail: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
};

export type UpdateTeamMemberInput = {
  role: TeamMemberRole;
};

export type UploadFilesResponse = {
  __typename?: 'UploadFilesResponse';
  code: ResponseCode;
  fileName: Scalars['String']['output'];
  s3FilePath: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  activeTeamMembers?: Maybe<Array<TeamMember>>;
  available?: Maybe<Scalars['Boolean']['output']>;
  completedPrograms?: Maybe<Array<Program>>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  image: Scalars['String']['output'];
  instructor?: Maybe<Instructor>;
  isAI: Scalars['Boolean']['output'];
  isAdmin: Scalars['Uint64']['output'];
  isInstructor: Scalars['Uint64']['output'];
  isStudent: Scalars['Uint64']['output'];
  isWithdrawable?: Maybe<Scalars['Boolean']['output']>;
  lastAccessedAt?: Maybe<Scalars['Time']['output']>;
  lastStudyReportAt?: Maybe<Scalars['Time']['output']>;
  mailSetting?: Maybe<MailSetting>;
  maskedPersonalInfo?: Maybe<UserMaskedPersonalInfo>;
  monthlyStudyCalendars?: Maybe<Array<StudyCalendar>>;
  nickName: Scalars['String']['output'];
  objective?: Maybe<Scalars['String']['output']>;
  personalInfo?: Maybe<UserPersonalInfo>;
  profile?: Maybe<Scalars['String']['output']>;
  questionAnswers?: Maybe<Array<QuestionAnswer>>;
  questions?: Maybe<Array<Question>>;
  snsType: Scalars['Uint64']['output'];
  status: Scalars['Uint64']['output'];
  stripeCustomerID?: Maybe<Scalars['ULID']['output']>;
  student?: Maybe<Student>;
  studySummary?: Maybe<StudySummary>;
  studyTagSummaries?: Maybe<Array<StudyTagSummary>>;
  tags?: Maybe<Array<Tag>>;
  totalLessonCount?: Maybe<Array<SpotLesson>>;
  updatedAt: Scalars['Time']['output'];
  userTags?: Maybe<Array<UserTag>>;
  whileStudyingPrograms?: Maybe<Array<Program>>;
  withdrewAt?: Maybe<Scalars['Time']['output']>;
};

export type UserChatMessage = {
  __typename?: 'UserChatMessage';
  chatRoomID: Scalars['Uint64']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  isRead: Bool;
  updatedAt: Scalars['Time']['output'];
  userID: Scalars['Uint64']['output'];
};

/** アカウント情報更新の入力 */
export type UserInput = {
  /** プロフィール画像画像 指定しなかった場合は更新しない */
  image?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  nickName: Scalars['String']['input'];
  objective?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['String']['input']>;
  tags: Array<Scalars['Uint64']['input']>;
  userTags: Array<UserTagInput>;
};

/** ユーザー個人情報(最小限) */
export type UserMaskedPersonalInfo = {
  __typename?: 'UserMaskedPersonalInfo';
  kanaName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** ユーザー個人情報 */
export type UserPersonalInfo = {
  __typename?: 'UserPersonalInfo';
  email: Scalars['String']['output'];
  kanaName: Scalars['String']['output'];
  mobilePhone?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  oauthUserName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  providerCustomerID: Scalars['String']['output'];
  scLeadID: Scalars['String']['output'];
  sex?: Maybe<Scalars['Uint64']['output']>;
  skypeID?: Maybe<Scalars['String']['output']>;
  sub: Scalars['String']['output'];
};

/** アカウント作成の入力 */
export type UserRegisterInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nickName: Scalars['String']['input'];
  objective?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  profile?: InputMaybe<Scalars['String']['input']>;
  smrc?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Uint64']['input']>>>;
  userTags?: InputMaybe<Array<InputMaybe<UserTagInput>>>;
};

export enum UserRole {
  Admin = 'ADMIN',
  Coach = 'COACH',
  Instructor = 'INSTRUCTOR',
  NotLogin = 'NOT_LOGIN',
  Student = 'STUDENT',
  StudentFree = 'STUDENT_FREE',
  StudentGraduated = 'STUDENT_GRADUATED',
  StudentSubscription = 'STUDENT_SUBSCRIPTION',
  StudentSubscriptionBasic = 'STUDENT_SUBSCRIPTION_BASIC',
  StudentSubscriptionLight = 'STUDENT_SUBSCRIPTION_LIGHT',
  StudentSubscriptionPremium = 'STUDENT_SUBSCRIPTION_PREMIUM',
  Subscription = 'SUBSCRIPTION',
  SubscriptionBasic = 'SUBSCRIPTION_BASIC',
  SubscriptionFree = 'SUBSCRIPTION_FREE',
  SubscriptionLight = 'SUBSCRIPTION_LIGHT',
  SubscriptionPremium = 'SUBSCRIPTION_PREMIUM',
  TeamAdmin = 'TEAM_ADMIN',
  TeamAdminFree = 'TEAM_ADMIN_FREE',
  TeamMember = 'TEAM_MEMBER',
  TeamMemberFree = 'TEAM_MEMBER_FREE'
}

export type UserSearchResponse = {
  __typename?: 'UserSearchResponse';
  items: Array<User>;
  total: Scalars['Int64']['output'];
};

export type UserTag = {
  __typename?: 'UserTag';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Uint64']['output'];
  tag?: Maybe<Tag>;
  tagID: Scalars['Uint64']['output'];
  term?: Maybe<Scalars['Uint64']['output']>;
  updatedAt: Scalars['Time']['output'];
  user?: Maybe<User>;
  userID: Scalars['Uint64']['output'];
};

export type UserTagInput = {
  tagID: Scalars['Uint64']['input'];
  term: Scalars['Uint64']['input'];
};

export type UserWithPermissionList = {
  __typename?: 'UserWithPermissionList';
  contractsOfStripeSubscriptionForAnalytics: Array<ContractOfStripeSubscriptionForAnalytics>;
  permissionList?: Maybe<PermissionList>;
  user?: Maybe<User>;
};

export enum Valid {
  Invalid = 'INVALID',
  Valid = 'VALID'
}

/** 解約・退会時アンケート - 難易度 */
export enum WithdrawalQuestionnaireDifficultyLevel {
  /** ちょうどよかった */
  JustRight = 'JUST_RIGHT',
  /** そもそも使っていない */
  NotUsed = 'NOT_USED',
  /** 自分には難易度が高すぎた */
  TooDifficult = 'TOO_DIFFICULT',
  /** 自分には難易度が低すぎた */
  TooEasy = 'TOO_EASY'
}

/** 解約・退会時アンケート入力項目 */
export type WithdrawalQuestionnaireInput = {
  /** 難易度 */
  difficultyLevel: WithdrawalQuestionnaireDifficultyLevel;
  /** その他要望 */
  otherRequests?: InputMaybe<Scalars['String']['input']>;
  /** 解約・退会理由 */
  reasonTypes: Array<WithdrawalQuestionnaireReasonType>;
};

/** 解約・退会時アンケート - 理由 */
export enum WithdrawalQuestionnaireReasonType {
  /** 目標を達成したから */
  Achieved = 'ACHIEVED',
  /** 忙しくて勉強する時間が取れないから */
  Busy = 'BUSY',
  /** プランを変更したいから */
  ChangePlan = 'CHANGE_PLAN',
  /** レッスンに不満を感じた */
  DissatisfiedWithLesson = 'DISSATISFIED_WITH_LESSON',
  /** 教材に不満を感じた */
  DissatisfiedWithPrograms = 'DISSATISFIED_WITH_PROGRAMS',
  /** Q&A掲示板に不満を感じた */
  DissatisfiedWithQa = 'DISSATISFIED_WITH_QA',
  /** 金額が高い */
  Expensive = 'EXPENSIVE',
  /** 他に良いサービスが見つかった */
  FoundOtherServices = 'FOUND_OTHER_SERVICES',
  /** スキルが身につかなかった */
  NotAcquiredSkills = 'NOT_ACQUIRED_SKILLS',
  /** 上記以外 */
  Others = 'OTHERS',
  /** プログラミング学習自体をやめる */
  StopLearning = 'STOP_LEARNING',
  /** 必要性を感じなかった */
  Unnecessary = 'UNNECESSARY',
  /** 習いたい言語が対応不可だったから */
  UnsupportedSkill = 'UNSUPPORTED_SKILL'
}

export type UploadFilesInput = {
  files: Array<Scalars['Upload']['input']>;
  /** 画像アップロード用 */
  isImage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetAbTestDeliveriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAbTestDeliveriesQuery = { __typename?: 'Query', abTestDeliveries: Array<{ __typename?: 'AbTestDelivery', originURL: any, deviceType: DeviceType, totalRate: number, startDate: string, endDate: string, abTestDeliveryDetails: Array<{ __typename?: 'AbTestDeliveryDetail', deliveryURL: any, deliveryRate: number }> }> };

export type AbTestDeliveryFragment = { __typename?: 'AbTestDelivery', originURL: any, deviceType: DeviceType, totalRate: number, startDate: string, endDate: string, abTestDeliveryDetails: Array<{ __typename?: 'AbTestDeliveryDetail', deliveryURL: any, deliveryRate: number }> };

export type GetBannerCidsQueryVariables = Exact<{
  targetType: BannerTargetType;
  cidTypes: Array<BannerCidType> | BannerCidType;
  limit: Scalars['Uint64']['input'];
}>;


export type GetBannerCidsQuery = { __typename?: 'Query', bannerCids: Array<{ __typename?: 'BannerCid', id: number, type: BannerCidType, deviceType: BannerCidDeviceType, cid: string, banner: { __typename?: 'Banner', link: string, imageURL: string, title: string } }> };

export type BannerCidFragment = { __typename?: 'BannerCid', id: number, type: BannerCidType, deviceType: BannerCidDeviceType, cid: string, banner: { __typename?: 'Banner', link: string, imageURL: string, title: string } };

export type GetCampaignQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCampaignQuery = { __typename?: 'Query', getCampaign?: { __typename?: 'Campaign', title: string, imageURL: string } | null };

export type CampaignFragment = { __typename?: 'Campaign', title: string, imageURL: string };

export type GetCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name?: string | null, status?: number | null, createdAt: string, updatedAt: string }> };

export type CategoryFragment = { __typename?: 'Category', id: number, name?: string | null, status?: number | null, createdAt: string, updatedAt: string };

export type GetChapterQueryVariables = Exact<{
  chapterID: Scalars['Uint64']['input'];
  includeExam: Scalars['Boolean']['input'];
}>;


export type GetChapterQuery = { __typename?: 'Query', chapter?: { __typename?: 'Chapter', content: string, createdAt: string, description: string, id: number, key: string, number: number, requireTime: number, status: Valid, title: string, type: AuthorizationType, updatedAt: string, programElement: { __typename?: 'ProgramElement', programID: number, program: { __typename?: 'Program', title: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } }, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id: string, content: string, commentary: string, examAnswers?: Array<{ __typename?: 'ExamAnswer', id: string, content: string, isCorrect: boolean }> | null }> | null } | null, programExam?: Array<{ __typename?: 'ExamQuestion', id: string, content: string, commentary: string, examAnswers?: Array<{ __typename?: 'ExamAnswer', id: string, content: string, isCorrect: boolean }> | null }> | null };

export type ChapterFragment = { __typename?: 'Chapter', content: string, createdAt: string, description: string, id: number, key: string, number: number, requireTime: number, status: Valid, title: string, type: AuthorizationType, updatedAt: string, programElement: { __typename?: 'ProgramElement', programID: number, program: { __typename?: 'Program', title: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } }, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id: string, content: string, commentary: string, examAnswers?: Array<{ __typename?: 'ExamAnswer', id: string, content: string, isCorrect: boolean }> | null }> | null };

export type ChapterSearchFragment = { __typename?: 'Chapter', id: number, title: string, description: string, number: number, type: AuthorizationType, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null };

export type ChapterDetailSearchFragment = { __typename?: 'Chapter', id: number, title: string, description: string, number: number, type: AuthorizationType, programElement: { __typename?: 'ProgramElement', program: { __typename?: 'Program', id: number, title: string, description: string, icon: string } } };

export type ChatMemberListFragment = { __typename?: 'ChatMember', id: number, status: Valid, user: { __typename?: 'User', id: number, nickName: string, image: string, isInstructor: number, isStudent: number, isAdmin: number, updatedAt: string, snsType: number, instructor?: { __typename?: 'Instructor', isCoach?: boolean | null } | null, student?: { __typename?: 'Student', status?: number | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null } };

export type ChatMemberUserFragment = { __typename?: 'User', id: number, nickName: string, image: string, isInstructor: number, isStudent: number, isAdmin: number, updatedAt: string, snsType: number, instructor?: { __typename?: 'Instructor', isCoach?: boolean | null } | null, student?: { __typename?: 'Student', status?: number | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null };

export type GetChatMessagesQueryVariables = Exact<{
  chatRoomID: Scalars['Uint64']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChatMessagesQuery = { __typename?: 'Query', chatMessages?: { __typename?: 'ChatMessageConnection', edges: Array<{ __typename?: 'ChatMessageEdge', cursor: string, node: { __typename?: 'ChatMessage', id: number, content: string, status: Valid, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isInstructor: number, isStudent: number, isAdmin: number, updatedAt: string, snsType: number, instructor?: { __typename?: 'Instructor', isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null }, userChatMessage?: { __typename?: 'UserChatMessage', id: number, userID: number, chatRoomID: number, isRead: Bool, createdAt: string, updatedAt: string } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetChatMessageUnreadCountQueryVariables = Exact<{
  chatRoomID?: InputMaybe<Scalars['Uint64']['input']>;
}>;


export type GetChatMessageUnreadCountQuery = { __typename?: 'Query', chatMessageUnreadCount: any };

export type ReadAllChatMessageMutationVariables = Exact<{
  chatRoomID: Scalars['Uint64']['input'];
}>;


export type ReadAllChatMessageMutation = { __typename?: 'Mutation', readAllChatMessage: { __typename?: 'ReadAllChatMessageResponse', chatRoomID: number, result: boolean } };

export type CreateChatMessageMutationVariables = Exact<{
  input: ChatMessageCreateInput;
}>;


export type CreateChatMessageMutation = { __typename?: 'Mutation', createChatMessage: { __typename?: 'ChatMessage', id: number, content: string, status: Valid, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isInstructor: number, isStudent: number, isAdmin: number, updatedAt: string, snsType: number, instructor?: { __typename?: 'Instructor', isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null }, userChatMessage?: { __typename?: 'UserChatMessage', id: number, userID: number, chatRoomID: number, isRead: Bool, createdAt: string, updatedAt: string } | null } };

export type UpdateChatMessageMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
  input: ChatMessageUpdateInput;
}>;


export type UpdateChatMessageMutation = { __typename?: 'Mutation', updateChatMessage: { __typename?: 'ChatMessage', id: number, content: string, status: Valid, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isInstructor: number, isStudent: number, isAdmin: number, updatedAt: string, snsType: number, instructor?: { __typename?: 'Instructor', isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null }, userChatMessage?: { __typename?: 'UserChatMessage', id: number, userID: number, chatRoomID: number, isRead: Bool, createdAt: string, updatedAt: string } | null } };

export type DeleteChatMessageMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type DeleteChatMessageMutation = { __typename?: 'Mutation', deleteChatMessage: { __typename?: 'ChatMessage', id: number, content: string, status: Valid, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isInstructor: number, isStudent: number, isAdmin: number, updatedAt: string, snsType: number, instructor?: { __typename?: 'Instructor', isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null }, userChatMessage?: { __typename?: 'UserChatMessage', id: number, userID: number, chatRoomID: number, isRead: Bool, createdAt: string, updatedAt: string } | null } };

export type ChatMessagePostedSubscriptionVariables = Exact<{
  chatRoomID: Scalars['Uint64']['input'];
}>;


export type ChatMessagePostedSubscription = { __typename?: 'Subscription', chatMessagePosted: { __typename?: 'ChatMessage', id: number, content: string, status: Valid, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isInstructor: number, isStudent: number, isAdmin: number, updatedAt: string, snsType: number, instructor?: { __typename?: 'Instructor', isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null }, userChatMessage?: { __typename?: 'UserChatMessage', id: number, userID: number, chatRoomID: number, isRead: Bool, createdAt: string, updatedAt: string } | null } };

export type ChatMessageListFragment = { __typename?: 'ChatMessage', id: number, content: string, status: Valid, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isInstructor: number, isStudent: number, isAdmin: number, updatedAt: string, snsType: number, instructor?: { __typename?: 'Instructor', isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null }, userChatMessage?: { __typename?: 'UserChatMessage', id: number, userID: number, chatRoomID: number, isRead: Bool, createdAt: string, updatedAt: string } | null };

export type ChatMessageChatRoomFragment = { __typename?: 'ChatRoom', id: number, unreadCount: number, lastMessage?: { __typename?: 'ChatMessage', id: number, content: string, status: Valid, createdAt: string, updatedAt: string } | null };

export type ChatMessageUserFragment = { __typename?: 'User', id: number, nickName: string, image: string, isInstructor: number, isStudent: number, isAdmin: number, updatedAt: string, snsType: number, instructor?: { __typename?: 'Instructor', isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null };

export type ChatMessageEdgeFragment = { __typename?: 'ChatMessageEdge', cursor: string, node: { __typename?: 'ChatMessage', id: number, content: string, status: Valid, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isInstructor: number, isStudent: number, isAdmin: number, updatedAt: string, snsType: number, instructor?: { __typename?: 'Instructor', isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null }, userChatMessage?: { __typename?: 'UserChatMessage', id: number, userID: number, chatRoomID: number, isRead: Bool, createdAt: string, updatedAt: string } | null } };

export type GetChatMessageDraftQueryVariables = Exact<{
  chatRoomID: Scalars['Uint64']['input'];
}>;


export type GetChatMessageDraftQuery = { __typename?: 'Query', chatMessageDraft?: { __typename?: 'ChatMessageDraft', chatRoomID: number, userID: number, content: string } | null };

export type UpsertChatMessageDraftMutationVariables = Exact<{
  chatRoomID: Scalars['Uint64']['input'];
  content: Scalars['String']['input'];
}>;


export type UpsertChatMessageDraftMutation = { __typename?: 'Mutation', upsertChatMessageDraft: boolean };

export type DeleteChatMessageDraftMutationVariables = Exact<{
  chatRoomID: Scalars['Uint64']['input'];
}>;


export type DeleteChatMessageDraftMutation = { __typename?: 'Mutation', deleteChatMessageDraft: boolean };

export type ChatMessageDraftFragment = { __typename?: 'ChatMessageDraft', chatRoomID: number, userID: number, content: string };

export type GetChatRoomsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['Time']['input']>;
}>;


export type GetChatRoomsQuery = { __typename?: 'Query', chatRooms: { __typename?: 'ChatRoomsResponse', items: Array<{ __typename?: 'ChatRoom', id: number, title: string, status: Valid, createdAt: string, updatedAt: string, unreadCount: number, chatMembers: Array<{ __typename?: 'ChatMember', id: number, status: Valid, user: { __typename?: 'User', id: number, nickName: string, image: string, isInstructor: number, isStudent: number, isAdmin: number, updatedAt: string, snsType: number, instructor?: { __typename?: 'Instructor', isCoach?: boolean | null } | null, student?: { __typename?: 'Student', status?: number | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null } }>, lastMessage?: { __typename?: 'ChatMessage', id: number, content: string, status: Valid, createdAt: string, updatedAt: string } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type ChatRoomContentChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ChatRoomContentChangedSubscription = { __typename?: 'Subscription', chatRoomContentChanged: { __typename?: 'ChatRoom', id: number, title: string, status: Valid, createdAt: string, updatedAt: string, unreadCount: number, chatMembers: Array<{ __typename?: 'ChatMember', id: number, status: Valid, user: { __typename?: 'User', id: number, nickName: string, image: string, isInstructor: number, isStudent: number, isAdmin: number, updatedAt: string, snsType: number, instructor?: { __typename?: 'Instructor', isCoach?: boolean | null } | null, student?: { __typename?: 'Student', status?: number | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null } }>, lastMessage?: { __typename?: 'ChatMessage', id: number, content: string, status: Valid, createdAt: string, updatedAt: string } | null } };

export type ChatRoomListFragment = { __typename?: 'ChatRoom', id: number, title: string, status: Valid, createdAt: string, updatedAt: string, unreadCount: number, chatMembers: Array<{ __typename?: 'ChatMember', id: number, status: Valid, user: { __typename?: 'User', id: number, nickName: string, image: string, isInstructor: number, isStudent: number, isAdmin: number, updatedAt: string, snsType: number, instructor?: { __typename?: 'Instructor', isCoach?: boolean | null } | null, student?: { __typename?: 'Student', status?: number | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null } }>, lastMessage?: { __typename?: 'ChatMessage', id: number, content: string, status: Valid, createdAt: string, updatedAt: string } | null };

export type GetClaimAndDetailsForInstructorQueryVariables = Exact<{
  yearMonth: Scalars['Time']['input'];
  input?: InputMaybe<InstructorClaimDetailSearchInput>;
}>;


export type GetClaimAndDetailsForInstructorQuery = { __typename?: 'Query', claimForInstructor?: { __typename?: 'Claim', id: number, applyStatus: ClaimApplyStatus, month: string } | null, claimDetailsForInstructor: Array<{ __typename?: 'ClaimDetail', id: number, subTotal: number, amount?: number | null, date: string, additionalPayment?: number | null, remark?: string | null, unitPrice: number, course?: { __typename?: 'Course', id: number, student: { __typename?: 'Student', id: number, status?: number | null, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }, plan: { __typename?: 'Plan', name: string } } | null, lesson?: { __typename?: 'Lesson', id: number, title: string, type: number } | null, spotLesson?: { __typename?: 'SpotLesson', id: number, startAt: string } | null, claimCategory: { __typename?: 'ClaimCategory', id: number, name: string } }> };

export type GetClaimCategoriesForInstructorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClaimCategoriesForInstructorQuery = { __typename?: 'Query', claimCategoriesForInstructor: Array<{ __typename?: 'ClaimCategory', id: number, name: string }> };

export type AddClaimDetailForInstructorMutationVariables = Exact<{
  yearMonth: Scalars['Time']['input'];
  input: ClaimDetailInput;
}>;


export type AddClaimDetailForInstructorMutation = { __typename?: 'Mutation', createClaimDetailForInstructor: { __typename?: 'ClaimDetail', id: number } };

export type UpdateClaimDetailForInstructorMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
  input: ClaimDetailInput;
}>;


export type UpdateClaimDetailForInstructorMutation = { __typename?: 'Mutation', updateClaimDetailForInstructor: { __typename?: 'ClaimDetail', id: number } };

export type DeleteClaimDetailForInstructorMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type DeleteClaimDetailForInstructorMutation = { __typename?: 'Mutation', deleteClaimDetailForInstructor: boolean };

export type ApplyClaimForInstructorMutationVariables = Exact<{
  yearMonth: Scalars['Time']['input'];
  input: ClaimInput;
}>;


export type ApplyClaimForInstructorMutation = { __typename?: 'Mutation', applyClaimForInstructor: { __typename?: 'Claim', id: number } };

export type ClaimFragment = { __typename?: 'Claim', id: number, applyStatus: ClaimApplyStatus, month: string };

export type ClaimDetailFragment = { __typename?: 'ClaimDetail', id: number, subTotal: number, amount?: number | null, date: string, additionalPayment?: number | null, remark?: string | null, unitPrice: number, course?: { __typename?: 'Course', id: number, student: { __typename?: 'Student', id: number, status?: number | null, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }, plan: { __typename?: 'Plan', name: string } } | null, lesson?: { __typename?: 'Lesson', id: number, title: string, type: number } | null, spotLesson?: { __typename?: 'SpotLesson', id: number, startAt: string } | null, claimCategory: { __typename?: 'ClaimCategory', id: number, name: string } };

export type ClaimCategoryFragment = { __typename?: 'ClaimCategory', id: number, name: string };

export type PageInfoFragment = { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean };

export type GetCoursesForInstructorQueryVariables = Exact<{
  input: InstructorCourseSearchInput;
}>;


export type GetCoursesForInstructorQuery = { __typename?: 'Query', coursesForInstructor?: Array<{ __typename?: 'Course', id: number, absentStartDate?: string | null, absentEndDate?: string | null, absent2StartDate?: string | null, absent2EndDate?: string | null, absent3StartDate?: string | null, absent3EndDate?: string | null, instructorChangeStartDate?: string | null, instructorChangeEndDate?: string | null, instructorChange2StartDate?: string | null, instructorChange2EndDate?: string | null, instructorChange3StartDate?: string | null, instructorChange3EndDate?: string | null, consultant?: string | null, status?: number | null, lessonType?: CourseLessonType | null, lessonPlace?: string | null, startDate?: string | null, endDate?: string | null, contractType?: number | null, curriculum?: string | null, jobChange?: number | null, careerSupport?: number | null, customerAcquisition?: number | null, delayInPayment?: number | null, breakInContact?: number | null, teachingMaterialCost?: number | null, lessonMinutesUpperLimit?: number | null, plannedLessonCount?: number | null, finishedLessonCount?: number | null, instructorMemo?: string | null, student: { __typename?: 'Student', id: number, user: { __typename?: 'User', id: number, image: string, nickName: string, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null } }, plan: { __typename?: 'Plan', name: string }, coaching?: { __typename?: 'Coaching', finishedSessionCount: number, plannedSessionCount: number } | null, studentInformation?: { __typename?: 'StudentInformation', customerInformation: string, transferInformation: string } | null }> | null };

export type GetCoursesForInstructorCreateLessonListQueryVariables = Exact<{
  input: InstructorCourseSearchInput;
}>;


export type GetCoursesForInstructorCreateLessonListQuery = { __typename?: 'Query', coursesForInstructor?: Array<{ __typename?: 'Course', id: number, plannedLessonCount?: number | null, endDate?: string | null, student: { __typename?: 'Student', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }, lessons: Array<{ __typename?: 'Lesson', id: number }>, plan: { __typename?: 'Plan', name: string, lessonMinutes?: number | null } }> | null };

export type GetCoursesForInstructorCourseListQueryVariables = Exact<{
  input: InstructorCourseSearchInput;
}>;


export type GetCoursesForInstructorCourseListQuery = { __typename?: 'Query', coursesForInstructor?: Array<{ __typename?: 'Course', id: number, endDate?: string | null, student: { __typename?: 'Student', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }, plan: { __typename?: 'Plan', name: string }, coaching?: { __typename?: 'Coaching', id: string, plannedSessionCount: number, finishedSessionCount: number } | null }> | null };

export type GetActiveCoursesForInstructorQueryVariables = Exact<{
  input: InstructorCourseSearchWithStudentNameInput;
}>;


export type GetActiveCoursesForInstructorQuery = { __typename?: 'Query', activeCoursesForInstructor?: Array<{ __typename?: 'Course', id: number, endDate?: string | null, student: { __typename?: 'Student', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }, plan: { __typename?: 'Plan', name: string }, coaching?: { __typename?: 'Coaching', id: string, plannedSessionCount: number, finishedSessionCount: number } | null }> | null };

export type GetCourseForInstructorQueryVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type GetCourseForInstructorQuery = { __typename?: 'Query', courseForInstructor: { __typename?: 'Course', id: number, absentStartDate?: string | null, absentEndDate?: string | null, absent2StartDate?: string | null, absent2EndDate?: string | null, absent3StartDate?: string | null, absent3EndDate?: string | null, instructorChangeStartDate?: string | null, instructorChangeEndDate?: string | null, instructorChange2StartDate?: string | null, instructorChange2EndDate?: string | null, instructorChange3StartDate?: string | null, instructorChange3EndDate?: string | null, consultant?: string | null, status?: number | null, lessonType?: CourseLessonType | null, lessonPlace?: string | null, startDate?: string | null, endDate?: string | null, contractType?: number | null, curriculum?: string | null, jobChange?: number | null, careerSupport?: number | null, customerAcquisition?: number | null, delayInPayment?: number | null, breakInContact?: number | null, teachingMaterialCost?: number | null, lessonMinutesUpperLimit?: number | null, plannedLessonCount?: number | null, finishedLessonCount?: number | null, instructorMemo?: string | null, student: { __typename?: 'Student', id: number, user: { __typename?: 'User', id: number, image: string, nickName: string, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null } }, plan: { __typename?: 'Plan', name: string }, coaching?: { __typename?: 'Coaching', finishedSessionCount: number, plannedSessionCount: number } | null, studentInformation?: { __typename?: 'StudentInformation', customerInformation: string, transferInformation: string } | null } };

export type GetHistoricalCoursesForInstructorQueryVariables = Exact<{
  userName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHistoricalCoursesForInstructorQuery = { __typename?: 'Query', historicalCoursesForInstructor?: Array<{ __typename?: 'Course', id: number, lessons: Array<{ __typename?: 'Lesson', id: number, startAt: string, endAt: string, completed: number, canceled: number, title: string }>, plan: { __typename?: 'Plan', isLessonPreparationAllowed: Bool, isQuestionAllowed: Bool, isFlexibleCurriculum: Bool, name: string }, student: { __typename?: 'Student', id: number, user: { __typename?: 'User', id: number, image: string, nickName: string, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null } } }> | null };

export type GetCoursesForStudentHomeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCoursesForStudentHomeQuery = { __typename?: 'Query', coursesForStudent?: Array<{ __typename?: 'Course', startDate?: string | null, endDate?: string | null, curriculum?: string | null, finishedLessonCount?: number | null, plannedLessonCount?: number | null, status?: number | null, plan: { __typename?: 'Plan', name: string }, coaching?: { __typename?: 'Coaching', plannedSessionCount: number, finishedSessionCount: number } | null }> | null };

export type UpdateCourseMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
  input: InstructorCourseInput;
}>;


export type UpdateCourseMutation = { __typename?: 'Mutation', updateCourseForInstructor: { __typename?: 'Course', id: number } };

export type CourseFragment = { __typename?: 'Course', id: number, absentStartDate?: string | null, absentEndDate?: string | null, absent2StartDate?: string | null, absent2EndDate?: string | null, absent3StartDate?: string | null, absent3EndDate?: string | null, instructorChangeStartDate?: string | null, instructorChangeEndDate?: string | null, instructorChange2StartDate?: string | null, instructorChange2EndDate?: string | null, instructorChange3StartDate?: string | null, instructorChange3EndDate?: string | null, consultant?: string | null, status?: number | null, lessonType?: CourseLessonType | null, lessonPlace?: string | null, startDate?: string | null, endDate?: string | null, contractType?: number | null, curriculum?: string | null, jobChange?: number | null, careerSupport?: number | null, customerAcquisition?: number | null, delayInPayment?: number | null, breakInContact?: number | null, teachingMaterialCost?: number | null, lessonMinutesUpperLimit?: number | null, plannedLessonCount?: number | null, finishedLessonCount?: number | null, instructorMemo?: string | null, student: { __typename?: 'Student', id: number, user: { __typename?: 'User', id: number, image: string, nickName: string, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null } }, plan: { __typename?: 'Plan', name: string }, coaching?: { __typename?: 'Coaching', finishedSessionCount: number, plannedSessionCount: number } | null, studentInformation?: { __typename?: 'StudentInformation', customerInformation: string, transferInformation: string } | null };

export type CourseStudentFragment = { __typename?: 'Student', id: number, user: { __typename?: 'User', id: number, image: string, nickName: string, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null } };

export type CourseListFragment = { __typename?: 'Course', id: number, endDate?: string | null, student: { __typename?: 'Student', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }, plan: { __typename?: 'Plan', name: string }, coaching?: { __typename?: 'Coaching', id: string, plannedSessionCount: number, finishedSessionCount: number } | null };

export type StudentCourseFragment = { __typename?: 'Course', startDate?: string | null, endDate?: string | null, curriculum?: string | null, finishedLessonCount?: number | null, plannedLessonCount?: number | null, status?: number | null, plan: { __typename?: 'Plan', name: string }, coaching?: { __typename?: 'Coaching', plannedSessionCount: number, finishedSessionCount: number } | null };

export type HistoricalCourseFragment = { __typename?: 'Course', id: number, lessons: Array<{ __typename?: 'Lesson', id: number, startAt: string, endAt: string, completed: number, canceled: number, title: string }>, plan: { __typename?: 'Plan', isLessonPreparationAllowed: Bool, isQuestionAllowed: Bool, isFlexibleCurriculum: Bool, name: string }, student: { __typename?: 'Student', id: number, user: { __typename?: 'User', id: number, image: string, nickName: string, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null } } };

export type CourseNewLessonFragment = { __typename?: 'Course', id: number, plannedLessonCount?: number | null, endDate?: string | null, student: { __typename?: 'Student', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }, lessons: Array<{ __typename?: 'Lesson', id: number }>, plan: { __typename?: 'Plan', name: string, lessonMinutes?: number | null } };

export type GetCourseProgramsQueryVariables = Exact<{
  input?: InputMaybe<CourseProgramSearchInput>;
}>;


export type GetCourseProgramsQuery = { __typename?: 'Query', coursePrograms?: Array<{ __typename?: 'CourseProgram', id: string, title: string, image: string, content: string, description: string, overview: string, totalChapterCount: number, totalCompletedChapterCount: number, totalRequireTime: number, totalCompletedTime: any, courseProgramUserData?: { __typename?: 'CourseProgramUserData', createdAt: string, isStarted: Bool } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }> | null };

export type GetCourseProgramQueryVariables = Exact<{
  id: Scalars['ULID']['input'];
  userID?: InputMaybe<Scalars['Uint64']['input']>;
}>;


export type GetCourseProgramQuery = { __typename?: 'Query', courseProgram?: { __typename?: 'CourseProgram', id: string, title: string, image: string, content: string, description: string, overview: string, totalChapterCount: number, totalCompletedChapterCount: number, totalRequireTime: number, totalCompletedTime: any, courseProgramUserData?: { __typename?: 'CourseProgramUserData', createdAt: string, isStarted: Bool } | null, courseProgramSteps?: Array<{ __typename?: 'CourseProgramStep', id: string, title: string, description: string, number: number, courseProgramStepItems?: Array<{ __typename?: 'CourseProgramStepItem', id: string, program?: { __typename?: 'Program', id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, completedTime: any, programElements?: Array<{ __typename?: 'ProgramElement', id: string, number?: number | null, programID: number, chapter?: { __typename?: 'Chapter', id: number, type: AuthorizationType, studyLog?: { __typename?: 'StudyLog', id: number } | null } | null, practice?: { __typename?: 'Practice', id: string, type: AuthorizationType, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null }> | null, currentProgramElement?: { __typename?: 'ProgramElement', id: string, number?: number | null, programID: number, chapter?: { __typename?: 'Chapter', id: number, type: AuthorizationType, studyLog?: { __typename?: 'StudyLog', id: number } | null } | null, practice?: { __typename?: 'Practice', id: string, type: AuthorizationType, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null } | null } | null }> | null }> | null } | null };

export type StartCourseProgramMutationVariables = Exact<{
  id: Scalars['ULID']['input'];
}>;


export type StartCourseProgramMutation = { __typename?: 'Mutation', startCourseProgram: { __typename?: 'CourseProgramUserData', createdAt: string } };

export type CourseProgramDetailFragment = { __typename?: 'CourseProgram', id: string, title: string, image: string, content: string, description: string, overview: string, totalChapterCount: number, totalCompletedChapterCount: number, totalRequireTime: number, totalCompletedTime: any, courseProgramUserData?: { __typename?: 'CourseProgramUserData', createdAt: string, isStarted: Bool } | null, courseProgramSteps?: Array<{ __typename?: 'CourseProgramStep', id: string, title: string, description: string, number: number, courseProgramStepItems?: Array<{ __typename?: 'CourseProgramStepItem', id: string, program?: { __typename?: 'Program', id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, completedTime: any, programElements?: Array<{ __typename?: 'ProgramElement', id: string, number?: number | null, programID: number, chapter?: { __typename?: 'Chapter', id: number, type: AuthorizationType, studyLog?: { __typename?: 'StudyLog', id: number } | null } | null, practice?: { __typename?: 'Practice', id: string, type: AuthorizationType, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null }> | null, currentProgramElement?: { __typename?: 'ProgramElement', id: string, number?: number | null, programID: number, chapter?: { __typename?: 'Chapter', id: number, type: AuthorizationType, studyLog?: { __typename?: 'StudyLog', id: number } | null } | null, practice?: { __typename?: 'Practice', id: string, type: AuthorizationType, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null } | null } | null }> | null }> | null };

export type CourseProgramStepItemFragment = { __typename?: 'CourseProgramStepItem', id: string, program?: { __typename?: 'Program', id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, completedTime: any, programElements?: Array<{ __typename?: 'ProgramElement', id: string, number?: number | null, programID: number, chapter?: { __typename?: 'Chapter', id: number, type: AuthorizationType, studyLog?: { __typename?: 'StudyLog', id: number } | null } | null, practice?: { __typename?: 'Practice', id: string, type: AuthorizationType, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null }> | null, currentProgramElement?: { __typename?: 'ProgramElement', id: string, number?: number | null, programID: number, chapter?: { __typename?: 'Chapter', id: number, type: AuthorizationType, studyLog?: { __typename?: 'StudyLog', id: number } | null } | null, practice?: { __typename?: 'Practice', id: string, type: AuthorizationType, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null } | null } | null };

export type CourseProgramFragment = { __typename?: 'CourseProgram', id: string, title: string, image: string, content: string, description: string, overview: string, totalChapterCount: number, totalCompletedChapterCount: number, totalRequireTime: number, totalCompletedTime: any, courseProgramUserData?: { __typename?: 'CourseProgramUserData', createdAt: string, isStarted: Bool } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null };

export type CourseProgramTagFragment = { __typename?: 'Tag', id: number, name: string };

export type ProgramElementForCourseProgramStepItemFragment = { __typename?: 'ProgramElement', id: string, number?: number | null, programID: number, chapter?: { __typename?: 'Chapter', id: number, type: AuthorizationType, studyLog?: { __typename?: 'StudyLog', id: number } | null } | null, practice?: { __typename?: 'Practice', id: string, type: AuthorizationType, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null };

export type ChapterForCourseProgramStepItemFragment = { __typename?: 'Chapter', id: number, type: AuthorizationType, studyLog?: { __typename?: 'StudyLog', id: number } | null };

export type PracticeForCourseProgramStepItemFragment = { __typename?: 'Practice', id: string, type: AuthorizationType, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null };

export type SearchDocumentsQueryVariables = Exact<{
  input: DocumentSearchInput;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
}>;


export type SearchDocumentsQuery = { __typename?: 'Query', searchDocuments: { __typename?: 'DocumentResponse', total: any, items: Array<{ __typename?: 'Document', documentID: string, type: DocumentType, practice?: { __typename?: 'Practice', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null, chapter?: { __typename?: 'Chapter', content: string, createdAt: string, description: string, id: number, key: string, number: number, requireTime: number, status: Valid, title: string, type: AuthorizationType, updatedAt: string, programElement: { __typename?: 'ProgramElement', programID: number, program: { __typename?: 'Program', title: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } }, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id: string, content: string, commentary: string, examAnswers?: Array<{ __typename?: 'ExamAnswer', id: string, content: string, isCorrect: boolean }> | null }> | null } | null, qa?: { __typename?: 'Question', id: number, title: string, content: any, solved: boolean, editedAt?: string | null, answerCount: number, answerRequestType: AnswerRequestType, status: QuestionStatus, createdAt: string, updatedAt: string, questionAnswers?: Array<{ __typename?: 'QuestionAnswer', id: number, content: string, answerType: AnswerType, status: QuestionAnswerStatus, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean }, questionComments?: Array<{ __typename?: 'QuestionComment', id: number, content: string, status: QuestionCommentStatus, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean } }> | null, questionAnswerFavorites: Array<{ __typename?: 'QuestionAnswerFavorite', userID: number }> }> | null, questionFavorites: Array<{ __typename?: 'QuestionFavorite', userID: number }>, user: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean }, program?: { __typename?: 'Program', id: number, title: string } | null, chapter?: { __typename?: 'Chapter', id: number, title: string } | null, practice?: { __typename?: 'Practice', id: string, title: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } | null, studyReport?: { __typename?: 'StudyReport', id: number, date: string, content: string, status: Valid, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, studyReportDetails: Array<{ __typename?: 'StudyReportDetail', id: number, time?: number | null, createdAt: string, updatedAt: string, tag?: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null, studyReportCount: number } | null, program?: { __typename?: 'Program', id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, repository: string, completedTime: any, programSample?: { __typename?: 'ProgramSample', id: string, title: string, url: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', id: number, title: string, description: string, number: number, type: AuthorizationType, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null } | null, practice?: { __typename?: 'Practice', id: string, title: string, description: string, type: AuthorizationType } | null }> | null } | null }>, studyReportComments: Array<{ __typename?: 'StudyReportComment', id: number, content: string, studyReportID: number, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }>, studyReportFavorites: Array<{ __typename?: 'StudyReportFavorite', id: number, studyReportID: number, userID: number }> } | null, tweet?: { __typename?: 'Tweet', createdAt: string, tweetPostDestination: TweetPostDestination, tweetID: string, tweetDetail: { __typename?: 'TweetDetail', content: string, detailType?: TweetDetailType | null, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, tweetImages?: Array<{ __typename?: 'TweetImage', id: string, content: string }> | null, tweetComments?: Array<{ __typename?: 'TweetComment', tweetCommentID: string, content: string, createdAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }> | null, tweetFavorites?: Array<{ __typename?: 'TweetFavorite', id: string, userID: number }> | null } } | null }> } };

export type GetCountByDocumentTypeQueryVariables = Exact<{
  input?: InputMaybe<CountSearchInput>;
}>;


export type GetCountByDocumentTypeQuery = { __typename?: 'Query', countByDocumentType: Array<{ __typename?: 'DocumentTypeCount', documentType: DocumentType, count: any }> };

export type GetCountByTagsQueryVariables = Exact<{
  input?: InputMaybe<CountSearchInput>;
  tagIDs?: InputMaybe<Array<Scalars['Uint64']['input']> | Scalars['Uint64']['input']>;
}>;


export type GetCountByTagsQuery = { __typename?: 'Query', countByTags: Array<{ __typename?: 'TagCount', tagID: number, count: any, tag?: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null, questionCount: number, studyReportCount: number, overview?: string | null } | null }> };

export type DocumentListFragment = { __typename?: 'Document', documentID: string, type: DocumentType, practice?: { __typename?: 'Practice', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null, chapter?: { __typename?: 'Chapter', content: string, createdAt: string, description: string, id: number, key: string, number: number, requireTime: number, status: Valid, title: string, type: AuthorizationType, updatedAt: string, programElement: { __typename?: 'ProgramElement', programID: number, program: { __typename?: 'Program', title: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } }, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id: string, content: string, commentary: string, examAnswers?: Array<{ __typename?: 'ExamAnswer', id: string, content: string, isCorrect: boolean }> | null }> | null } | null, qa?: { __typename?: 'Question', id: number, title: string, content: any, solved: boolean, editedAt?: string | null, answerCount: number, answerRequestType: AnswerRequestType, status: QuestionStatus, createdAt: string, updatedAt: string, questionAnswers?: Array<{ __typename?: 'QuestionAnswer', id: number, content: string, answerType: AnswerType, status: QuestionAnswerStatus, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean }, questionComments?: Array<{ __typename?: 'QuestionComment', id: number, content: string, status: QuestionCommentStatus, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean } }> | null, questionAnswerFavorites: Array<{ __typename?: 'QuestionAnswerFavorite', userID: number }> }> | null, questionFavorites: Array<{ __typename?: 'QuestionFavorite', userID: number }>, user: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean }, program?: { __typename?: 'Program', id: number, title: string } | null, chapter?: { __typename?: 'Chapter', id: number, title: string } | null, practice?: { __typename?: 'Practice', id: string, title: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } | null, studyReport?: { __typename?: 'StudyReport', id: number, date: string, content: string, status: Valid, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, studyReportDetails: Array<{ __typename?: 'StudyReportDetail', id: number, time?: number | null, createdAt: string, updatedAt: string, tag?: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null, studyReportCount: number } | null, program?: { __typename?: 'Program', id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, repository: string, completedTime: any, programSample?: { __typename?: 'ProgramSample', id: string, title: string, url: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', id: number, title: string, description: string, number: number, type: AuthorizationType, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null } | null, practice?: { __typename?: 'Practice', id: string, title: string, description: string, type: AuthorizationType } | null }> | null } | null }>, studyReportComments: Array<{ __typename?: 'StudyReportComment', id: number, content: string, studyReportID: number, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }>, studyReportFavorites: Array<{ __typename?: 'StudyReportFavorite', id: number, studyReportID: number, userID: number }> } | null, tweet?: { __typename?: 'Tweet', createdAt: string, tweetPostDestination: TweetPostDestination, tweetID: string, tweetDetail: { __typename?: 'TweetDetail', content: string, detailType?: TweetDetailType | null, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, tweetImages?: Array<{ __typename?: 'TweetImage', id: string, content: string }> | null, tweetComments?: Array<{ __typename?: 'TweetComment', tweetCommentID: string, content: string, createdAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }> | null, tweetFavorites?: Array<{ __typename?: 'TweetFavorite', id: string, userID: number }> | null } } | null };

export type GetProgramExamQueryVariables = Exact<{
  chapterID: Scalars['Uint64']['input'];
}>;


export type GetProgramExamQuery = { __typename?: 'Query', programExam?: Array<{ __typename?: 'ExamQuestion', id: string, content: string, commentary: string, examAnswers?: Array<{ __typename?: 'ExamAnswer', id: string, content: string, isCorrect: boolean }> | null }> | null, chapter?: { __typename?: 'Chapter', content: string, createdAt: string, description: string, id: number, key: string, number: number, requireTime: number, status: Valid, title: string, type: AuthorizationType, updatedAt: string, programElement: { __typename?: 'ProgramElement', programID: number, program: { __typename?: 'Program', title: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } }, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id: string, content: string, commentary: string, examAnswers?: Array<{ __typename?: 'ExamAnswer', id: string, content: string, isCorrect: boolean }> | null }> | null } | null };

export type GetTotalMedalCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotalMedalCountsQuery = { __typename?: 'Query', totalMedalCounts?: Array<{ __typename?: 'TotalMedalCountResponse', programID?: number | null, medalCounts: any }> | null };

export type AnswerExamMutationVariables = Exact<{
  input: AnswerExamInput;
}>;


export type AnswerExamMutation = { __typename?: 'Mutation', answerExam?: { __typename?: 'ExamResponse', ExamScore: { __typename?: 'ExamScore', score: number, medalType: ExamMedalType }, answerResponses?: Array<{ __typename?: 'AnswerResponse', questionID: string, answerID: string, result: boolean }> | null } | null };

export type ExamScoreFragment = { __typename?: 'ExamScore', score: number, medalType: ExamMedalType };

export type AnswerResponseFragment = { __typename?: 'AnswerResponse', questionID: string, answerID: string, result: boolean };

export type ExamQuestionFragment = { __typename?: 'ExamQuestion', id: string, content: string, commentary: string, examAnswers?: Array<{ __typename?: 'ExamAnswer', id: string, content: string, isCorrect: boolean }> | null };

export type GetFeedbackCategoriesQueryVariables = Exact<{
  input: FeedbackCategoriesInput;
}>;


export type GetFeedbackCategoriesQuery = { __typename?: 'Query', feedbackCategories: { __typename?: 'FeedbackCategoryResponse', items: Array<{ __typename?: 'FeedbackCategory', id: number, name: string }> } };

export type UploadFilesMutationVariables = Exact<{
  files: Array<Scalars['Upload']['input']> | Scalars['Upload']['input'];
}>;


export type UploadFilesMutation = { __typename?: 'Mutation', uploadFiles?: Array<{ __typename?: 'UploadFilesResponse', code: ResponseCode, fileName: string, s3FilePath: string }> | null };

export type UploadImagesMutationVariables = Exact<{
  files: Array<Scalars['Upload']['input']> | Scalars['Upload']['input'];
}>;


export type UploadImagesMutation = { __typename?: 'Mutation', uploadFiles?: Array<{ __typename?: 'UploadFilesResponse', code: ResponseCode, fileName: string, s3FilePath: string }> | null };

export type UploadFileFragment = { __typename?: 'UploadFilesResponse', code: ResponseCode, fileName: string, s3FilePath: string };

export type GetCalendarForInstructorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCalendarForInstructorQuery = { __typename?: 'Query', calendarForInstructor: { __typename?: 'InstructorCalendar', id: string } };

export type GetInstructorScheduleQueryVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type GetInstructorScheduleQuery = { __typename?: 'Query', instructorSchedule?: { __typename?: 'InstructorSchedule', id: number, startAt: string, endAt: string } | null };

export type GetInstructorSchedulesQueryVariables = Exact<{
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
}>;


export type GetInstructorSchedulesQuery = { __typename?: 'Query', instructorSchedules: Array<{ __typename?: 'InstructorSchedule', id: number, startAt: string, endAt: string }> };

export type CreateInstructorScheduleMutationVariables = Exact<{
  input: InstructorScheduleInput;
}>;


export type CreateInstructorScheduleMutation = { __typename?: 'Mutation', createInstructorSchedule: boolean };

export type DeleteInstructorScheduleMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type DeleteInstructorScheduleMutation = { __typename?: 'Mutation', deleteInstructorSchedule: boolean };

export type UpdateInstructorScheduleMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
  input: InstructorScheduleInput;
}>;


export type UpdateInstructorScheduleMutation = { __typename?: 'Mutation', updateInstructorSchedule: boolean };

export type InstructorScheduleFragment = { __typename?: 'InstructorSchedule', id: number, startAt: string, endAt: string };

export type GetNextLessonForStudentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNextLessonForStudentQuery = { __typename?: 'Query', nextLessonForStudent?: { __typename?: 'Lesson', id: number, startAt: string, endAt: string, taughtSkill?: string | null, title: string, type: number, homework?: string | null, prepare?: string | null, progress: number, delayReason?: string | null, assistanceDetail?: string | null, canceled: number, completed: number, lessonsAssistances: Array<{ __typename?: 'LessonsAssistance', id: number }>, course?: { __typename?: 'Course', id: number, plannedLessonCount?: number | null, plan: { __typename?: 'Plan', id: number, lessonMinutes?: number | null, name: string }, instructor?: { __typename?: 'Instructor', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } | null } | null } | null };

export type GetLessonsForStudentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLessonsForStudentQuery = { __typename?: 'Query', lessonsForStudent: Array<{ __typename?: 'Lesson', id: number, startAt: string, endAt: string, taughtSkill?: string | null, title: string, type: number, homework?: string | null, prepare?: string | null, progress: number, delayReason?: string | null, assistanceDetail?: string | null, canceled: number, completed: number, lessonsAssistances: Array<{ __typename?: 'LessonsAssistance', id: number }>, course?: { __typename?: 'Course', id: number, plannedLessonCount?: number | null, plan: { __typename?: 'Plan', id: number, lessonMinutes?: number | null, name: string }, instructor?: { __typename?: 'Instructor', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } | null } | null }> };

export type GetNextLessonForInstructorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNextLessonForInstructorQuery = { __typename?: 'Query', nextLessonForInstructor?: { __typename?: 'Lesson', id: number, startAt: string, endAt: string, taughtSkill?: string | null, title: string, type: number, homework?: string | null, prepare?: string | null, progress: number, delayReason?: string | null, assistanceDetail?: string | null, canceled: number, completed: number, lessonsAssistances: Array<{ __typename?: 'LessonsAssistance', id: number }>, course?: { __typename?: 'Course', id: number, plannedLessonCount?: number | null, student: { __typename?: 'Student', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }, plan: { __typename?: 'Plan', id: number, lessonMinutes?: number | null } } | null } | null };

export type GetLessonsForInstructorQueryVariables = Exact<{
  input?: InputMaybe<InstructorLessonSearchInput>;
}>;


export type GetLessonsForInstructorQuery = { __typename?: 'Query', lessonsForInstructor: Array<{ __typename?: 'Lesson', id: number, startAt: string, endAt: string, taughtSkill?: string | null, title: string, type: number, homework?: string | null, prepare?: string | null, progress: number, delayReason?: string | null, assistanceDetail?: string | null, canceled: number, completed: number, lessonsAssistances: Array<{ __typename?: 'LessonsAssistance', id: number }>, course?: { __typename?: 'Course', id: number, plannedLessonCount?: number | null, student: { __typename?: 'Student', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }, plan: { __typename?: 'Plan', id: number, lessonMinutes?: number | null } } | null }> };

export type GetLessonForInstructorQueryVariables = Exact<{
  lessonID: Scalars['Uint64']['input'];
}>;


export type GetLessonForInstructorQuery = { __typename?: 'Query', lessonForInstructor?: { __typename?: 'Lesson', id: number, startAt: string, endAt: string, taughtSkill?: string | null, title: string, type: number, homework?: string | null, prepare?: string | null, progress: number, delayReason?: string | null, assistanceDetail?: string | null, canceled: number, completed: number, lessonsAssistances: Array<{ __typename?: 'LessonsAssistance', id: number }>, course?: { __typename?: 'Course', id: number, plannedLessonCount?: number | null, student: { __typename?: 'Student', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }, plan: { __typename?: 'Plan', id: number, lessonMinutes?: number | null } } | null } | null };

export type GetLessonAssistancesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLessonAssistancesQuery = { __typename?: 'Query', lessonAssistances: Array<{ __typename?: 'LessonsAssistance', id: number, name: string }> };

export type CreateLessonForInstructorMutationVariables = Exact<{
  courseID: Scalars['Uint64']['input'];
  input: LessonInput;
}>;


export type CreateLessonForInstructorMutation = { __typename?: 'Mutation', createLessonForInstructor: { __typename?: 'Lesson', id: number } };

export type UpdateLessonForInstructorMutationVariables = Exact<{
  lessonID: Scalars['Uint64']['input'];
  input: LessonInput;
}>;


export type UpdateLessonForInstructorMutation = { __typename?: 'Mutation', updateLessonForInstructor: { __typename?: 'Lesson', id: number } };

export type UpsertLessonReportForInstructorMutationVariables = Exact<{
  lessonID: Scalars['Uint64']['input'];
  input: LessonReportInput;
}>;


export type UpsertLessonReportForInstructorMutation = { __typename?: 'Mutation', upsertLessonReportForInstructor: { __typename?: 'Lesson', id: number } };

export type DeleteLessonForInstructorMutationVariables = Exact<{
  lessonID: Scalars['Uint64']['input'];
}>;


export type DeleteLessonForInstructorMutation = { __typename?: 'Mutation', deleteLessonForInstructor: boolean };

export type LessonsAssistanceFragment = { __typename?: 'LessonsAssistance', id: number, name: string };

export type InstructorLessonFragment = { __typename?: 'Lesson', id: number, startAt: string, endAt: string, taughtSkill?: string | null, title: string, type: number, homework?: string | null, prepare?: string | null, progress: number, delayReason?: string | null, assistanceDetail?: string | null, canceled: number, completed: number, lessonsAssistances: Array<{ __typename?: 'LessonsAssistance', id: number }>, course?: { __typename?: 'Course', id: number, plannedLessonCount?: number | null, student: { __typename?: 'Student', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }, plan: { __typename?: 'Plan', id: number, lessonMinutes?: number | null } } | null };

export type StudentLessonFragment = { __typename?: 'Lesson', id: number, startAt: string, endAt: string, taughtSkill?: string | null, title: string, type: number, homework?: string | null, prepare?: string | null, progress: number, delayReason?: string | null, assistanceDetail?: string | null, canceled: number, completed: number, lessonsAssistances: Array<{ __typename?: 'LessonsAssistance', id: number }>, course?: { __typename?: 'Course', id: number, plannedLessonCount?: number | null, plan: { __typename?: 'Plan', id: number, lessonMinutes?: number | null, name: string }, instructor?: { __typename?: 'Instructor', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } | null } | null };

export type GetMailSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMailSettingQuery = { __typename?: 'Query', getMailSetting: { __typename?: 'MailSetting', messageReceived: Valid, lessonRegistered: Valid, lessonRemind: Valid, lessonUnregistered: Valid, lessonScheduleUpdated: Valid, practiceSubmitRegistered: Valid, practiceSubmitReRegistered: Valid, practiceSubmitDetailReviewCommentRegistered: Valid, questionRegistered: Valid, questionAnswerRegistered: Valid, questionCommentRegistered: Valid, claimApplied: Valid, backSchool: Valid, attendanceStatusChanged: Valid, notice: Valid, lessonLogUnregistered: Valid, studyReportCommentRegistered: Valid, studyReportAchieved: Valid, spotLessonRegistered: Valid, spotLessonRemind: Valid, spotLessonCancel: Valid, spotLessonLogUnregistered: Valid, ticketRemind: Valid, sessionRemind: Valid } };

export type UpdateMailSettingMutationVariables = Exact<{
  input: MailSettingInput;
}>;


export type UpdateMailSettingMutation = { __typename?: 'Mutation', updateMailSetting: { __typename?: 'MailSetting', id: number } };

export type MailSettingFragment = { __typename?: 'MailSetting', messageReceived: Valid, lessonRegistered: Valid, lessonRemind: Valid, lessonUnregistered: Valid, lessonScheduleUpdated: Valid, practiceSubmitRegistered: Valid, practiceSubmitReRegistered: Valid, practiceSubmitDetailReviewCommentRegistered: Valid, questionRegistered: Valid, questionAnswerRegistered: Valid, questionCommentRegistered: Valid, claimApplied: Valid, backSchool: Valid, attendanceStatusChanged: Valid, notice: Valid, lessonLogUnregistered: Valid, studyReportCommentRegistered: Valid, studyReportAchieved: Valid, spotLessonRegistered: Valid, spotLessonRemind: Valid, spotLessonCancel: Valid, spotLessonLogUnregistered: Valid, ticketRemind: Valid, sessionRemind: Valid };

export type GetLatestModalQueryVariables = Exact<{
  modalType: ModalType;
}>;


export type GetLatestModalQuery = { __typename?: 'Query', latest?: { __typename?: 'Modal', id: number, isRead: any } | null };

export type ReadModalMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type ReadModalMutation = { __typename?: 'Mutation', readModal: boolean };

export type ModalFragment = { __typename?: 'Modal', id: number, isRead: any };

export type GetNoticesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['Uint64']['input']>;
}>;


export type GetNoticesQuery = { __typename?: 'Query', notices: { __typename?: 'NoticesResponse', items: Array<{ __typename?: 'Notice', id: number, title: string, content: string, createdAt: string, noticeRead?: { __typename?: 'NoticeRead', noticeID: number } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetNoticeQueryVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type GetNoticeQuery = { __typename?: 'Query', notice?: { __typename?: 'Notice', id: number, title: string, content: string, createdAt: string, noticeRead?: { __typename?: 'NoticeRead', noticeID: number } | null } | null };

export type ReadNoticeMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type ReadNoticeMutation = { __typename?: 'Mutation', readNotice: boolean };

export type ReadAllNoticesMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadAllNoticesMutation = { __typename?: 'Mutation', readAllNotices: boolean };

export type NoticeFragment = { __typename?: 'Notice', id: number, title: string, content: string, createdAt: string, noticeRead?: { __typename?: 'NoticeRead', noticeID: number } | null };

export type GetNotificationsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', getNotifications: { __typename?: 'NotificationResponse', items: Array<{ __typename?: 'Notification', id: number, type: NotificationType, notificationReadStatus?: NotificationReadStatus | null, notificationStatus?: NotificationStatus | null, createdAt: string, user?: { __typename?: 'User', id: number, nickName: string } | null, notificationDetail?: { __typename?: 'NotificationDetail', title: string, actor?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null, question?: { __typename?: 'Question', id: number, title: string } | null, lesson?: { __typename?: 'Lesson', id: number, title: string, startAt: string, endAt: string } | null, course?: { __typename?: 'Course', id: number, plan: { __typename?: 'Plan', name: string }, student: { __typename?: 'Student', user: { __typename?: 'User', nickName: string } }, instructor?: { __typename?: 'Instructor', user: { __typename?: 'User', nickName: string } } | null } | null, studyReport?: { __typename?: 'StudyReport', id: number } | null, spotLesson?: { __typename?: 'SpotLesson', id: number, startAt: string, endAt: string, categories?: Array<{ __typename?: 'Category', name?: string | null }> | null } | null, session?: { __typename?: 'Session', id: string, title: string, startAt: string, endAt: string } | null, practiceSubmit?: { __typename?: 'PracticeSubmit', id: string, practice: { __typename?: 'Practice', title: string } } | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type ReadNotificationsMutationVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReadNotificationsMutation = { __typename?: 'Mutation', readNotifications: { __typename?: 'ResultResponse', result: boolean } };

export type ReadAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadAllNotificationsMutation = { __typename?: 'Mutation', readAllNotifications: { __typename?: 'ResultResponse', result: boolean } };

export type GetNotificationUnreadCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationUnreadCountQuery = { __typename?: 'Query', noticeUnreadCount: any, getNotificationUnreadCount: { __typename?: 'CountResponse', count: number } };

export type NotificationFragment = { __typename?: 'Notification', id: number, type: NotificationType, notificationReadStatus?: NotificationReadStatus | null, notificationStatus?: NotificationStatus | null, createdAt: string, user?: { __typename?: 'User', id: number, nickName: string } | null, notificationDetail?: { __typename?: 'NotificationDetail', title: string, actor?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null, question?: { __typename?: 'Question', id: number, title: string } | null, lesson?: { __typename?: 'Lesson', id: number, title: string, startAt: string, endAt: string } | null, course?: { __typename?: 'Course', id: number, plan: { __typename?: 'Plan', name: string }, student: { __typename?: 'Student', user: { __typename?: 'User', nickName: string } }, instructor?: { __typename?: 'Instructor', user: { __typename?: 'User', nickName: string } } | null } | null, studyReport?: { __typename?: 'StudyReport', id: number } | null, spotLesson?: { __typename?: 'SpotLesson', id: number, startAt: string, endAt: string, categories?: Array<{ __typename?: 'Category', name?: string | null }> | null } | null, session?: { __typename?: 'Session', id: string, title: string, startAt: string, endAt: string } | null, practiceSubmit?: { __typename?: 'PracticeSubmit', id: string, practice: { __typename?: 'Practice', title: string } } | null } | null };

export type NotificationQuestionFragment = { __typename?: 'Question', id: number, title: string };

export type NotificationLessonFragment = { __typename?: 'Lesson', id: number, title: string, startAt: string, endAt: string };

export type NotificationCourseFragment = { __typename?: 'Course', id: number, plan: { __typename?: 'Plan', name: string }, student: { __typename?: 'Student', user: { __typename?: 'User', nickName: string } }, instructor?: { __typename?: 'Instructor', user: { __typename?: 'User', nickName: string } } | null };

export type NotificationSpotLessonFragment = { __typename?: 'SpotLesson', id: number, startAt: string, endAt: string, categories?: Array<{ __typename?: 'Category', name?: string | null }> | null };

export type NotificationSessionFragment = { __typename?: 'Session', id: string, title: string, startAt: string, endAt: string };

export type NotificationPracticeSubmitFragment = { __typename?: 'PracticeSubmit', id: string, practice: { __typename?: 'Practice', title: string } };

export type OnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingQuery = { __typename?: 'Query', onboarding: { __typename?: 'Onboarding', isShowOnboarding: boolean, isShowProfile: boolean, isCompletedProfile: boolean, isShowProgram: boolean, isCompletedProgram: boolean, isShowStudyReport: boolean, isCompletedStudyReport: boolean, isShowQuestion: boolean, isCompletedQuestion: boolean, isShowSpotLesson: boolean, isCompletedSpotLesson: boolean } };

export type GetPaymentIntentsQueryVariables = Exact<{
  input: PaymentIntentSearchInput;
}>;


export type GetPaymentIntentsQuery = { __typename?: 'Query', getPaymentIntents: { __typename?: 'PaymentIntentSearchResponse', total: number, items: Array<{ __typename?: 'PaymentIntent', id: number, amountPaid: number, createdAt: string, charges: Array<{ __typename?: 'Charge', receiptURL?: string | null }>, paymentIntentPurchaseItems: Array<{ __typename?: 'PaymentIntentPurchaseItem', quantity: number, purchaseItem: { __typename?: 'PurchaseItem', name: string } }> }> } };

export type PaymentIntentFragment = { __typename?: 'PaymentIntent', id: number, amountPaid: number, createdAt: string, charges: Array<{ __typename?: 'Charge', receiptURL?: string | null }>, paymentIntentPurchaseItems: Array<{ __typename?: 'PaymentIntentPurchaseItem', quantity: number, purchaseItem: { __typename?: 'PurchaseItem', name: string } }> };

export type GetPracticeQueryVariables = Exact<{
  practiceID: Scalars['ULID']['input'];
  userID?: InputMaybe<Scalars['Uint64']['input']>;
}>;


export type GetPracticeQuery = { __typename?: 'Query', practice?: { __typename?: 'Practice', id: string, programID: number, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', summary: string, summaryImage1: string, summaryImage2: string, summaryImage3: string, summaryImage4: string, summaryImage5: string, category: ProgramCategory, id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, repository: string, completedTime: any, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', content: string, createdAt: string, description: string, id: number, key: string, number: number, requireTime: number, status: Valid, title: string, type: AuthorizationType, updatedAt: string, programElement: { __typename?: 'ProgramElement', programID: number, program: { __typename?: 'Program', title: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } }, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id: string, content: string, commentary: string, examAnswers?: Array<{ __typename?: 'ExamAnswer', id: string, content: string, isCorrect: boolean }> | null }> | null } | null, practice?: { __typename?: 'Practice', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null }> | null, programSample?: { __typename?: 'ProgramSample', id: string, title: string, url: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null };

export type GetPracticesQueryVariables = Exact<{
  input: PracticeSearchInput;
}>;


export type GetPracticesQuery = { __typename?: 'Query', practices: { __typename?: 'PracticeSearchResponse', total: any, items: Array<{ __typename?: 'PracticeListItem', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, type: AuthorizationType, submitPassedCount: any, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null }> } };

export type PracticeFragment = { __typename?: 'Practice', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null };

export type PracticeListItemFragment = { __typename?: 'PracticeListItem', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, type: AuthorizationType, submitPassedCount: any, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null };

export type PracticeDetailFragment = { __typename?: 'Practice', id: string, programID: number, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', summary: string, summaryImage1: string, summaryImage2: string, summaryImage3: string, summaryImage4: string, summaryImage5: string, category: ProgramCategory, id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, repository: string, completedTime: any, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', content: string, createdAt: string, description: string, id: number, key: string, number: number, requireTime: number, status: Valid, title: string, type: AuthorizationType, updatedAt: string, programElement: { __typename?: 'ProgramElement', programID: number, program: { __typename?: 'Program', title: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } }, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id: string, content: string, commentary: string, examAnswers?: Array<{ __typename?: 'ExamAnswer', id: string, content: string, isCorrect: boolean }> | null }> | null } | null, practice?: { __typename?: 'Practice', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null }> | null, programSample?: { __typename?: 'ProgramSample', id: string, title: string, url: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null };

export type PracticeSearchFragment = { __typename?: 'Practice', id: string, title: string, description: string, type: AuthorizationType };

export type GetPracticeSubmitsQueryVariables = Exact<{
  input: PracticeSubmitSearchInput;
}>;


export type GetPracticeSubmitsQuery = { __typename?: 'Query', getPracticeSubmits: { __typename?: 'PracticeSubmitSearchResponse', total: any, items: Array<{ __typename?: 'PracticeSubmitSearch', id: string, latestPracticeSubmitDetailID: string, latestPracticeSubmitDetailEditedAt?: string | null, reviewStatus: PracticeSubmitDetailReviewStatus, reviewedCount: any, isViewable: boolean, createdAt: string, updatedAt: string, practice: { __typename?: 'Practice', id: string, title: string, type: AuthorizationType, program: { __typename?: 'Program', id: number, title: string } }, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }> } };

export type GetPracticeSubmitsForInstructorQueryVariables = Exact<{
  input: InstructorPracticeSubmitSearchInput;
}>;


export type GetPracticeSubmitsForInstructorQuery = { __typename?: 'Query', getPracticeSubmitsForInstructor: { __typename?: 'PracticeSubmitSearchResponse', total: any, items: Array<{ __typename?: 'PracticeSubmitSearch', id: string, latestPracticeSubmitDetailID: string, latestPracticeSubmitDetailEditedAt?: string | null, reviewStatus: PracticeSubmitDetailReviewStatus, reviewedCount: any, isViewable: boolean, createdAt: string, updatedAt: string, practice: { __typename?: 'Practice', id: string, title: string, type: AuthorizationType, program: { __typename?: 'Program', id: number, title: string } }, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }> } };

export type GetPracticeSubmitQueryVariables = Exact<{
  id: Scalars['ULID']['input'];
}>;


export type GetPracticeSubmitQuery = { __typename?: 'Query', getPracticeSubmit?: { __typename?: 'PracticeSubmit', id: string, isInstructorReviewRequested: boolean, createdAt: string, updatedAt: string, practice: { __typename?: 'Practice', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null }, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, practiceSubmitID: string, url?: string | null, content?: string | null, reviewStatus: PracticeSubmitDetailReviewStatus, editedAt?: string | null, createdAt: string, updatedAt: string, practiceSubmitDetailReviewComment?: { __typename?: 'PracticeSubmitDetailReviewComment', id: string, practiceSubmitDetailID: string, userID: number, content?: string | null, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } | null }> | null } | null };

export type GetPracticeSubmitForInstructorQueryVariables = Exact<{
  id: Scalars['ULID']['input'];
}>;


export type GetPracticeSubmitForInstructorQuery = { __typename?: 'Query', getPracticeSubmitForInstructor?: { __typename?: 'InstructorPracticeSubmit', id: string, createdAt: string, updatedAt: string, practice: { __typename?: 'Practice', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null }, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, withoutDraftPracticeSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, practiceSubmitID: string, url?: string | null, content?: string | null, reviewStatus: PracticeSubmitDetailReviewStatus, editedAt?: string | null, createdAt: string, updatedAt: string, practiceSubmitDetailReviewComment?: { __typename?: 'PracticeSubmitDetailReviewComment', id: string, practiceSubmitDetailID: string, userID: number, content?: string | null, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } | null }> | null } | null };

export type NewPracticeSubmitMutationVariables = Exact<{
  input: PracticeSubmitInput;
}>;


export type NewPracticeSubmitMutation = { __typename?: 'Mutation', newPracticeSubmit: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string }> | null } };

export type RePracticeSubmitMutationVariables = Exact<{
  input: RePracticeSubmitInput;
}>;


export type RePracticeSubmitMutation = { __typename?: 'Mutation', rePracticeSubmit: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string }> | null } };

export type PracticeSubmitListFragment = { __typename?: 'PracticeSubmitSearch', id: string, latestPracticeSubmitDetailID: string, latestPracticeSubmitDetailEditedAt?: string | null, reviewStatus: PracticeSubmitDetailReviewStatus, reviewedCount: any, isViewable: boolean, createdAt: string, updatedAt: string, practice: { __typename?: 'Practice', id: string, title: string, type: AuthorizationType, program: { __typename?: 'Program', id: number, title: string } }, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } };

export type PracticeSubmitFragment = { __typename?: 'PracticeSubmit', id: string, isInstructorReviewRequested: boolean, createdAt: string, updatedAt: string, practice: { __typename?: 'Practice', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null }, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, practiceSubmitID: string, url?: string | null, content?: string | null, reviewStatus: PracticeSubmitDetailReviewStatus, editedAt?: string | null, createdAt: string, updatedAt: string, practiceSubmitDetailReviewComment?: { __typename?: 'PracticeSubmitDetailReviewComment', id: string, practiceSubmitDetailID: string, userID: number, content?: string | null, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } | null }> | null };

export type InstructorPracticeSubmitFragment = { __typename?: 'InstructorPracticeSubmit', id: string, createdAt: string, updatedAt: string, practice: { __typename?: 'Practice', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null }, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, withoutDraftPracticeSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, practiceSubmitID: string, url?: string | null, content?: string | null, reviewStatus: PracticeSubmitDetailReviewStatus, editedAt?: string | null, createdAt: string, updatedAt: string, practiceSubmitDetailReviewComment?: { __typename?: 'PracticeSubmitDetailReviewComment', id: string, practiceSubmitDetailID: string, userID: number, content?: string | null, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } | null }> | null };

export type PracticeSubmitDetailFragment = { __typename?: 'PracticeSubmitDetail', id: string, practiceSubmitID: string, url?: string | null, content?: string | null, reviewStatus: PracticeSubmitDetailReviewStatus, editedAt?: string | null, createdAt: string, updatedAt: string, practiceSubmitDetailReviewComment?: { __typename?: 'PracticeSubmitDetailReviewComment', id: string, practiceSubmitDetailID: string, userID: number, content?: string | null, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } | null };

export type CreatePracticeSubmitDetailReviewCommentMutationVariables = Exact<{
  input: PracticeSubmitDetailReviewCommentInput;
}>;


export type CreatePracticeSubmitDetailReviewCommentMutation = { __typename?: 'Mutation', createPracticeSubmitDetailReviewComment: { __typename?: 'PracticeSubmitDetailReviewComment', id: string } };

export type UpdatePracticeSubmitDetailReviewCommentMutationVariables = Exact<{
  input: UpdatePracticeSubmitDetailReviewCommentInput;
}>;


export type UpdatePracticeSubmitDetailReviewCommentMutation = { __typename?: 'Mutation', updatePracticeSubmitDetailReviewComment: { __typename?: 'PracticeSubmitDetailReviewComment', id: string } };

export type PracticeSubmitDetailReviewCommentFragment = { __typename?: 'PracticeSubmitDetailReviewComment', id: string, practiceSubmitDetailID: string, userID: number, content?: string | null, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } };

export type GetTeamPricesQueryVariables = Exact<{
  paymentMethodType: PaymentMethodType;
}>;


export type GetTeamPricesQuery = { __typename?: 'Query', teamPrices: Array<{ __typename?: 'Price', id: number, recurringIntervalCount: any, unitAmount: number }> };

export type TeamPriceFragment = { __typename?: 'Price', id: number, recurringIntervalCount: any, unitAmount: number };

export type PricePermissionFragment = { __typename?: 'PricePermission', program?: boolean | null, studyLog?: boolean | null, question?: boolean | null, practice?: boolean | null, submitPractice?: boolean | null };

export type GetPriceQueryVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type GetPriceQuery = { __typename?: 'Query', getPrice?: { __typename?: 'Price', id: number, unitAmountIncludingTax: number, product: { __typename?: 'Product', id: number, name: string, productExtension: { __typename?: 'ProductExtension', contractPeriod: number, contractPeriodTypeLabel: string, isMultiMonthContract: boolean } } } | null };

export type GetProductQueryVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type GetProductQuery = { __typename?: 'Query', getProduct?: { __typename?: 'Product', id: number, name: string, price: Array<{ __typename?: 'Price', unitAmountIncludingTax: number }>, productExtension: { __typename?: 'ProductExtension', contractPeriod: number, contractPeriodTypeLabel: string, isMultiMonthContract: boolean } } | null };

export type GetProgramsQueryVariables = Exact<{
  input: ProgramSearchInput;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
}>;


export type GetProgramsQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramSearchResponse', items: Array<{ __typename?: 'Program', id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, repository: string, completedTime: any, programSample?: { __typename?: 'ProgramSample', id: string, title: string, url: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', id: number, title: string, description: string, number: number, type: AuthorizationType, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null } | null, practice?: { __typename?: 'Practice', id: string, title: string, description: string, type: AuthorizationType } | null }> | null }> } };

export type SearchProgramsQueryVariables = Exact<{
  input: ProgramSearchInput;
}>;


export type SearchProgramsQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramSearchResponse', items: Array<{ __typename?: 'Program', id: number, title: string, description: string, icon: string, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', id: number, title: string, description: string, number: number, type: AuthorizationType, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null } | null, practice?: { __typename?: 'Practice', id: string, title: string, description: string, type: AuthorizationType } | null }> | null }> } };

export type GetProgramQueryVariables = Exact<{
  programID: Scalars['Uint64']['input'];
  userID?: InputMaybe<Scalars['Uint64']['input']>;
}>;


export type GetProgramQuery = { __typename?: 'Query', program?: { __typename?: 'Program', summary: string, summaryImage1: string, summaryImage2: string, summaryImage3: string, summaryImage4: string, summaryImage5: string, category: ProgramCategory, id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, repository: string, completedTime: any, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', content: string, createdAt: string, description: string, id: number, key: string, number: number, requireTime: number, status: Valid, title: string, type: AuthorizationType, updatedAt: string, programElement: { __typename?: 'ProgramElement', programID: number, program: { __typename?: 'Program', title: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } }, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id: string, content: string, commentary: string, examAnswers?: Array<{ __typename?: 'ExamAnswer', id: string, content: string, isCorrect: boolean }> | null }> | null } | null, practice?: { __typename?: 'Practice', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null }> | null, programSample?: { __typename?: 'ProgramSample', id: string, title: string, url: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } | null };

export type GetLastStudiedWhileStudyingProgramQueryVariables = Exact<{
  userID?: InputMaybe<Scalars['Uint64']['input']>;
}>;


export type GetLastStudiedWhileStudyingProgramQuery = { __typename?: 'Query', lastStudiedWhileStudyingProgram?: { __typename?: 'Program', summary: string, summaryImage1: string, summaryImage2: string, summaryImage3: string, summaryImage4: string, summaryImage5: string, category: ProgramCategory, id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, repository: string, completedTime: any, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', content: string, createdAt: string, description: string, id: number, key: string, number: number, requireTime: number, status: Valid, title: string, type: AuthorizationType, updatedAt: string, programElement: { __typename?: 'ProgramElement', programID: number, program: { __typename?: 'Program', title: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } }, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id: string, content: string, commentary: string, examAnswers?: Array<{ __typename?: 'ExamAnswer', id: string, content: string, isCorrect: boolean }> | null }> | null } | null, practice?: { __typename?: 'Practice', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null }> | null, programSample?: { __typename?: 'ProgramSample', id: string, title: string, url: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } | null };

export type ProgramTagFragment = { __typename?: 'Tag', id: number, name: string };

export type ProgramFragment = { __typename?: 'Program', id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, repository: string, completedTime: any, programSample?: { __typename?: 'ProgramSample', id: string, title: string, url: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', id: number, title: string, description: string, number: number, type: AuthorizationType, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null } | null, practice?: { __typename?: 'Practice', id: string, title: string, description: string, type: AuthorizationType } | null }> | null };

export type ProgramDetailFragment = { __typename?: 'Program', summary: string, summaryImage1: string, summaryImage2: string, summaryImage3: string, summaryImage4: string, summaryImage5: string, category: ProgramCategory, id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, repository: string, completedTime: any, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', content: string, createdAt: string, description: string, id: number, key: string, number: number, requireTime: number, status: Valid, title: string, type: AuthorizationType, updatedAt: string, programElement: { __typename?: 'ProgramElement', programID: number, program: { __typename?: 'Program', title: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } }, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id: string, content: string, commentary: string, examAnswers?: Array<{ __typename?: 'ExamAnswer', id: string, content: string, isCorrect: boolean }> | null }> | null } | null, practice?: { __typename?: 'Practice', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null }> | null, programSample?: { __typename?: 'ProgramSample', id: string, title: string, url: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null };

export type ProgramSearchFragment = { __typename?: 'Program', id: number, title: string, description: string, icon: string, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', id: number, title: string, description: string, number: number, type: AuthorizationType, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null } | null, practice?: { __typename?: 'Practice', id: string, title: string, description: string, type: AuthorizationType } | null }> | null };

export type ProgramSearchSimpleFragment = { __typename?: 'Program', id: number, title: string, description: string, icon: string };

export type CreateProgramFeedbackMutationVariables = Exact<{
  input: ProgramFeedbackInput;
}>;


export type CreateProgramFeedbackMutation = { __typename?: 'Mutation', createProgramFeedback: { __typename?: 'ProgramFeedback', id: string } };

export type GetProgramSamplesQueryVariables = Exact<{
  input: ProgramSampleSearchInput;
}>;


export type GetProgramSamplesQuery = { __typename?: 'Query', getProgramSamples: { __typename?: 'ProgramSampleSearchResponse', items: Array<{ __typename?: 'ProgramSample', id: string, title: string, description: string, thumbnail: string, url: string, program: { __typename?: 'Program', id: number, title: string, description: string, icon: string } }> } };

export type ProgramSampleFragment = { __typename?: 'ProgramSample', id: string, title: string, description: string, thumbnail: string, url: string, program: { __typename?: 'Program', id: number, title: string, description: string, icon: string } };

export type ProgramSampleSimpleFragment = { __typename?: 'ProgramSample', id: string, title: string, url: string };

export type GetProgramSatisfactionQueryVariables = Exact<{
  programID: Scalars['Uint64']['input'];
}>;


export type GetProgramSatisfactionQuery = { __typename?: 'Query', programSatisfaction?: { __typename?: 'ProgramSatisfaction', userID: number, programID: number, level: ProgramSatisfactionLevel, comment?: string | null, createdAt: string } | null, program?: { __typename?: 'Program', id: number, title: string, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', content: string, createdAt: string, description: string, id: number, key: string, number: number, requireTime: number, status: Valid, title: string, type: AuthorizationType, updatedAt: string, programElement: { __typename?: 'ProgramElement', programID: number, program: { __typename?: 'Program', title: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } }, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id: string, content: string, commentary: string, examAnswers?: Array<{ __typename?: 'ExamAnswer', id: string, content: string, isCorrect: boolean }> | null }> | null } | null, practice?: { __typename?: 'Practice', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null }> | null } | null };

export type CreateProgramSatisfactionMutationVariables = Exact<{
  input: ProgramSatisfactionInput;
}>;


export type CreateProgramSatisfactionMutation = { __typename?: 'Mutation', createProgramSatisfaction: { __typename?: 'ProgramSatisfaction', userID: number, programID: number, level: ProgramSatisfactionLevel, comment?: string | null, createdAt: string } };

export type ProgramSatisfactionFragment = { __typename?: 'ProgramSatisfaction', userID: number, programID: number, level: ProgramSatisfactionLevel, comment?: string | null, createdAt: string };

export type ProgramForProgramSatisfactionFragment = { __typename?: 'Program', id: number, title: string, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', content: string, createdAt: string, description: string, id: number, key: string, number: number, requireTime: number, status: Valid, title: string, type: AuthorizationType, updatedAt: string, programElement: { __typename?: 'ProgramElement', programID: number, program: { __typename?: 'Program', title: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } }, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id: string, content: string, commentary: string, examAnswers?: Array<{ __typename?: 'ExamAnswer', id: string, content: string, isCorrect: boolean }> | null }> | null } | null, practice?: { __typename?: 'Practice', id: string, programID: number, key?: string | null, title: string, description: string, requireTime: any, content?: string | null, answer?: string | null, type: AuthorizationType, submitPassedCount: any, isAiReviewEnabled: boolean, isSubmittable: boolean, difficulty: PracticeDifficulty, status: Valid, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: number, icon: string, title: string, category: ProgramCategory, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }, mySubmit?: { __typename?: 'PracticeSubmit', id: string, practiceSubmitDetails?: Array<{ __typename?: 'PracticeSubmitDetail', id: string, reviewStatus: PracticeSubmitDetailReviewStatus }> | null } | null } | null }> | null };

export type ApplyPromotionCodeQueryVariables = Exact<{
  promotionCode: Scalars['String']['input'];
  priceID: Scalars['Uint64']['input'];
}>;


export type ApplyPromotionCodeQuery = { __typename?: 'Query', applyPromotionCode: { __typename?: 'PromotionCodeApplyResult', isValid: Bool, amountOff?: number | null, percentOff?: string | null, price: number, appliedPrice: number, pvdDuration: SpCouponDuration, pvdDurationInMonths?: any | null } };

export type PromotionCodeApplyResultFragment = { __typename?: 'PromotionCodeApplyResult', isValid: Bool, amountOff?: number | null, percentOff?: string | null, price: number, appliedPrice: number, pvdDuration: SpCouponDuration, pvdDurationInMonths?: any | null };

export type GetQuestionsQueryVariables = Exact<{
  input: QuestionSearchInput;
}>;


export type GetQuestionsQuery = { __typename?: 'Query', getQuestions: { __typename?: 'QuestionSearchResponse', total: number, items: Array<{ __typename?: 'Question', id: number, title: string, content: any, solved: boolean, editedAt?: string | null, answerCount: number, answerRequestType: AnswerRequestType, status: QuestionStatus, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, program?: { __typename?: 'Program', id: number, title: string } | null, chapter?: { __typename?: 'Chapter', id: number, title: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }> } };

export type GetQuestionQueryVariables = Exact<{
  questionID: Scalars['Uint64']['input'];
}>;


export type GetQuestionQuery = { __typename?: 'Query', getQuestion?: { __typename?: 'Question', id: number, title: string, content: any, solved: boolean, editedAt?: string | null, answerCount: number, answerRequestType: AnswerRequestType, status: QuestionStatus, createdAt: string, updatedAt: string, questionAnswers?: Array<{ __typename?: 'QuestionAnswer', id: number, content: string, answerType: AnswerType, status: QuestionAnswerStatus, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean }, questionComments?: Array<{ __typename?: 'QuestionComment', id: number, content: string, status: QuestionCommentStatus, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean } }> | null, questionAnswerFavorites: Array<{ __typename?: 'QuestionAnswerFavorite', userID: number }> }> | null, questionFavorites: Array<{ __typename?: 'QuestionFavorite', userID: number }>, user: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean }, program?: { __typename?: 'Program', id: number, title: string } | null, chapter?: { __typename?: 'Chapter', id: number, title: string } | null, practice?: { __typename?: 'Practice', id: string, title: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null } | null };

export type ResolveQuestionMutationVariables = Exact<{
  questionID: Scalars['Uint64']['input'];
}>;


export type ResolveQuestionMutation = { __typename?: 'Mutation', resolveQuestion: { __typename?: 'Question', id: number } };

export type AddQuestionMutationVariables = Exact<{
  input: QuestionInput;
}>;


export type AddQuestionMutation = { __typename?: 'Mutation', addQuestion: { __typename?: 'Question', id: number } };

export type UpdateQuestionMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
  input: QuestionInput;
}>;


export type UpdateQuestionMutation = { __typename?: 'Mutation', updateQuestion: { __typename?: 'Question', id: number } };

export type AddQuestionAnswerMutationVariables = Exact<{
  questionID: Scalars['Uint64']['input'];
  input: QuestionAnswerInput;
  isEscalation: Scalars['Boolean']['input'];
}>;


export type AddQuestionAnswerMutation = { __typename?: 'Mutation', addQuestionAnswer: { __typename?: 'QuestionAnswer', id: number } };

export type UpdateQuestionAnswerMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
  input: QuestionAnswerInput;
}>;


export type UpdateQuestionAnswerMutation = { __typename?: 'Mutation', updateQuestionAnswer: { __typename?: 'QuestionAnswer', id: number } };

export type AddQuestionCommentMutationVariables = Exact<{
  questionAnswerID: Scalars['Uint64']['input'];
  input: QuestionCommentInput;
}>;


export type AddQuestionCommentMutation = { __typename?: 'Mutation', addQuestionComment: { __typename?: 'QuestionComment', id: number } };

export type AddQuestionAnswerEvaluationMutationVariables = Exact<{
  input: QuestionAnswerEvaluationInput;
}>;


export type AddQuestionAnswerEvaluationMutation = { __typename?: 'Mutation', addQuestionAnswerEvaluation: { __typename?: 'QuestionEvaluation', id: string } };

export type UpdateQuestionCommentMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
  input: QuestionCommentInput;
}>;


export type UpdateQuestionCommentMutation = { __typename?: 'Mutation', updateQuestionComment: { __typename?: 'QuestionComment', id: number } };

export type ChangeQuestionFavoriteStatusMutationVariables = Exact<{
  questionID: Scalars['Uint64']['input'];
}>;


export type ChangeQuestionFavoriteStatusMutation = { __typename?: 'Mutation', changeQuestionFavoriteStatus: { __typename?: 'QuestionFavorite', userID: number } };

export type ChangeQuestionAnswerFavoriteStatusMutationVariables = Exact<{
  questionAnswerID: Scalars['Uint64']['input'];
}>;


export type ChangeQuestionAnswerFavoriteStatusMutation = { __typename?: 'Mutation', changeQuestionAnswerFavoriteStatus: { __typename?: 'QuestionAnswerFavorite', userID: number } };

export type QuestionListFragment = { __typename?: 'Question', id: number, title: string, content: any, solved: boolean, editedAt?: string | null, answerCount: number, answerRequestType: AnswerRequestType, status: QuestionStatus, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, program?: { __typename?: 'Program', id: number, title: string } | null, chapter?: { __typename?: 'Chapter', id: number, title: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null };

export type QuestionFragment = { __typename?: 'Question', id: number, title: string, content: any, solved: boolean, editedAt?: string | null, answerCount: number, answerRequestType: AnswerRequestType, status: QuestionStatus, createdAt: string, updatedAt: string, questionAnswers?: Array<{ __typename?: 'QuestionAnswer', id: number, content: string, answerType: AnswerType, status: QuestionAnswerStatus, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean }, questionComments?: Array<{ __typename?: 'QuestionComment', id: number, content: string, status: QuestionCommentStatus, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean } }> | null, questionAnswerFavorites: Array<{ __typename?: 'QuestionAnswerFavorite', userID: number }> }> | null, questionFavorites: Array<{ __typename?: 'QuestionFavorite', userID: number }>, user: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean }, program?: { __typename?: 'Program', id: number, title: string } | null, chapter?: { __typename?: 'Chapter', id: number, title: string } | null, practice?: { __typename?: 'Practice', id: string, title: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null };

export type QuestionAnswerFragment = { __typename?: 'QuestionAnswer', id: number, content: string, answerType: AnswerType, status: QuestionAnswerStatus, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean }, questionComments?: Array<{ __typename?: 'QuestionComment', id: number, content: string, status: QuestionCommentStatus, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean } }> | null, questionAnswerFavorites: Array<{ __typename?: 'QuestionAnswerFavorite', userID: number }> };

export type QuestionCommentFragment = { __typename?: 'QuestionComment', id: number, content: string, status: QuestionCommentStatus, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean } };

export type NewRegisteredQuestionnaireMutationVariables = Exact<{
  questionnaireInput: NewRegisteredQuestionnaireInput;
}>;


export type NewRegisteredQuestionnaireMutation = { __typename?: 'Mutation', NewRegisteredQuestionnaire: boolean };

export type RechargeRegisteredQuestionnaireMutationVariables = Exact<{
  questionnaireInput: RechargeRegisteredQuestionnaireInput;
}>;


export type RechargeRegisteredQuestionnaireMutation = { __typename?: 'Mutation', RechargeRegisteredQuestionnaire: boolean };

export type CreateServiceFeedbackMutationVariables = Exact<{
  input: ServiceFeedbackInput;
}>;


export type CreateServiceFeedbackMutation = { __typename?: 'Mutation', createServiceFeedback: { __typename?: 'ServiceFeedback', feedbackCategory: { __typename?: 'FeedbackCategory', name: string } } };

export type GetNextSessionForStudentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNextSessionForStudentQuery = { __typename?: 'Query', nextSessionForStudent?: { __typename?: 'Session', id: string, title: string, startAt: string, endAt: string, phase: SessionPhase, coaching: { __typename?: 'Coaching', id: string, course: { __typename?: 'Course', plan: { __typename?: 'Plan', name: string } }, coach?: { __typename?: 'Instructor', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } | null } } | null };

export type GetNextSessionForInstructorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNextSessionForInstructorQuery = { __typename?: 'Query', nextSessionForInstructor?: { __typename?: 'Session', id: string, title: string, startAt: string, endAt: string, phase: SessionPhase, status: Valid, createdAt: string, updatedAt: string, coaching: { __typename?: 'Coaching', id: string, course: { __typename?: 'Course', id: number, student: { __typename?: 'Student', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } } }, assignedCoach?: { __typename?: 'Instructor', id: number, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } | null } | null };

export type GetSessionsForInstructorQueryVariables = Exact<{
  input: SessionSearchInput;
}>;


export type GetSessionsForInstructorQuery = { __typename?: 'Query', sessionsForInstructor: Array<{ __typename?: 'Session', id: string, title: string, startAt: string, endAt: string, phase: SessionPhase, coaching: { __typename?: 'Coaching', id: string, course: { __typename?: 'Course', student: { __typename?: 'Student', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } } } }> };

export type GetSessionAndSessionReportForInstructorQueryVariables = Exact<{
  sessionID: Scalars['ULID']['input'];
}>;


export type GetSessionAndSessionReportForInstructorQuery = { __typename?: 'Query', session?: { __typename?: 'Session', id: string, title: string, startAt: string, endAt: string, phase: SessionPhase, status: Valid, createdAt: string, updatedAt: string, coaching: { __typename?: 'Coaching', id: string, course: { __typename?: 'Course', id: number, student: { __typename?: 'Student', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } } }, assignedCoach?: { __typename?: 'Instructor', id: number, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } | null } | null, sessionReportBySessionIDForInstructor?: { __typename?: 'SessionReport', id: string, sessionID: string, content: string, hasPreparations: Bool, preparationOthers: string, isOnSchedule: IsOnScheduleType, delayReason: string, hasAnnouncements: HasAnnouncementsType, hasAnnouncementsDetail: string, responseDeadline: ResponseDeadlineType, coachingMemo: string, preparations: Array<{ __typename?: 'SessionReportPreparation', id: string, sessionReportID: string, type: SessionReportPreparationType }>, announcements: Array<{ __typename?: 'SessionReportAnnouncement', id: string, sessionReportID: string, type: SessionReportAnnouncementType }> } | null };

export type GetSessionsForStudentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSessionsForStudentQuery = { __typename?: 'Query', sessionsForStudent: Array<{ __typename?: 'Session', id: string, title: string, startAt: string, endAt: string, phase: SessionPhase, coaching: { __typename?: 'Coaching', id: string, course: { __typename?: 'Course', plan: { __typename?: 'Plan', name: string } }, coach?: { __typename?: 'Instructor', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } | null } }> };

export type CreateSessionMutationVariables = Exact<{
  coachingID: Scalars['ULID']['input'];
  input: SessionInput;
}>;


export type CreateSessionMutation = { __typename?: 'Mutation', createSession: { __typename?: 'Session', id: string } };

export type UpdateSessionMutationVariables = Exact<{
  id: Scalars['ULID']['input'];
  input: SessionInput;
}>;


export type UpdateSessionMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'Session', id: string } };

export type CreateSessionReportMutationVariables = Exact<{
  id: Scalars['ULID']['input'];
  input: SessionReportInput;
}>;


export type CreateSessionReportMutation = { __typename?: 'Mutation', createSessionReport: { __typename?: 'SessionReport', id: string } };

export type UpdateSessionReportMutationVariables = Exact<{
  id: Scalars['ULID']['input'];
  input: SessionReportInput;
}>;


export type UpdateSessionReportMutation = { __typename?: 'Mutation', updateSessionReport: { __typename?: 'SessionReport', id: string } };

export type SessionInstrForInstructorFragment = { __typename?: 'Session', id: string, title: string, startAt: string, endAt: string, phase: SessionPhase, status: Valid, createdAt: string, updatedAt: string, coaching: { __typename?: 'Coaching', id: string, course: { __typename?: 'Course', id: number, student: { __typename?: 'Student', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } } }, assignedCoach?: { __typename?: 'Instructor', id: number, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } | null };

export type SessionListFragment = { __typename?: 'Session', id: string, title: string, startAt: string, endAt: string, phase: SessionPhase, coaching: { __typename?: 'Coaching', id: string, course: { __typename?: 'Course', student: { __typename?: 'Student', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } } } };

export type SessionListForInstructorFragment = { __typename?: 'Session', id: string, title: string, startAt: string, endAt: string, phase: SessionPhase, coaching: { __typename?: 'Coaching', id: string, course: { __typename?: 'Course', student: { __typename?: 'Student', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } } } };

export type SessionListForStudentFragment = { __typename?: 'Session', id: string, title: string, startAt: string, endAt: string, phase: SessionPhase, coaching: { __typename?: 'Coaching', id: string, course: { __typename?: 'Course', plan: { __typename?: 'Plan', name: string } }, coach?: { __typename?: 'Instructor', user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } | null } };

export type SessionReportForInstructorFragment = { __typename?: 'SessionReport', id: string, sessionID: string, content: string, hasPreparations: Bool, preparationOthers: string, isOnSchedule: IsOnScheduleType, delayReason: string, hasAnnouncements: HasAnnouncementsType, hasAnnouncementsDetail: string, responseDeadline: ResponseDeadlineType, coachingMemo: string, preparations: Array<{ __typename?: 'SessionReportPreparation', id: string, sessionReportID: string, type: SessionReportPreparationType }>, announcements: Array<{ __typename?: 'SessionReportAnnouncement', id: string, sessionReportID: string, type: SessionReportAnnouncementType }> };

export type SessionReportPreparationFragment = { __typename?: 'SessionReportPreparation', id: string, sessionReportID: string, type: SessionReportPreparationType };

export type SessionReportAnnouncementFragment = { __typename?: 'SessionReportAnnouncement', id: string, sessionReportID: string, type: SessionReportAnnouncementType };

export type UpdateSpotLessonMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
  input: SpotLessonUpdateInput;
}>;


export type UpdateSpotLessonMutation = { __typename?: 'Mutation', updateSpotLesson: boolean };

export type ReserveSpotLessonMutationVariables = Exact<{
  input: SpotLessonInput;
}>;


export type ReserveSpotLessonMutation = { __typename?: 'Mutation', reserveSpotLesson: boolean };

export type CancelSpotLessonMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type CancelSpotLessonMutation = { __typename?: 'Mutation', cancelSpotLesson: boolean };

export type CompleteSpotLessonForInstructorMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type CompleteSpotLessonForInstructorMutation = { __typename?: 'Mutation', completeSpotLessonForInstructor: boolean };

export type NonAttendanceSpotLessonForInstructorMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type NonAttendanceSpotLessonForInstructorMutation = { __typename?: 'Mutation', nonAttendanceSpotLessonForInstructor: boolean };

export type GetSpotLessonQueryVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type GetSpotLessonQuery = { __typename?: 'Query', spotLesson?: { __typename?: 'SpotLesson', id: number, troubleContent?: string | null, researchContent?: string | null, startAt: string, endAt: string, phase?: SpotLessonPhase | null, zoomURL?: string | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, categories?: Array<{ __typename?: 'Category', id: number, name?: string | null }> | null, instructorUser?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null, user?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null } | null };

export type GetSpotLessonsQueryVariables = Exact<{
  input: SpotLessonSearchInput;
}>;


export type GetSpotLessonsQuery = { __typename?: 'Query', spotLessons: { __typename?: 'SpotLessonSearchResponse', total: any, items: Array<{ __typename?: 'SpotLesson', id: number, troubleContent?: string | null, researchContent?: string | null, startAt: string, endAt: string, phase?: SpotLessonPhase | null, zoomURL?: string | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, categories?: Array<{ __typename?: 'Category', id: number, name?: string | null }> | null, instructorUser?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null, user?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null }> } };

export type GetSpotLessonCalendarsQueryVariables = Exact<{
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
  tagIDs: Array<Scalars['Uint64']['input']> | Scalars['Uint64']['input'];
}>;


export type GetSpotLessonCalendarsQuery = { __typename?: 'Query', spotLessonCalendars: Array<{ __typename?: 'SpotLessonCalendar', date: string, timeBlocks: Array<{ __typename?: 'SpotLessonTimeBlock', duration: any, disable: boolean, slotCount: any, reservationCount: any, startAt: string }> }> };

export type GetSpotLessonCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSpotLessonCountQuery = { __typename?: 'Query', spotLessonCount: any };

export type GetNextSpotLessonQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNextSpotLessonQuery = { __typename?: 'Query', nextSpotLesson?: { __typename?: 'SpotLesson', id: number, troubleContent?: string | null, researchContent?: string | null, startAt: string, endAt: string, phase?: SpotLessonPhase | null, zoomURL?: string | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, categories?: Array<{ __typename?: 'Category', id: number, name?: string | null }> | null, instructorUser?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null, user?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null } | null };

export type GetSpotLessonsForInstructorQueryVariables = Exact<{
  input: InstructorSpotLessonSearchInput;
}>;


export type GetSpotLessonsForInstructorQuery = { __typename?: 'Query', spotLessonsForInstructor: { __typename?: 'SpotLessonSearchResponse', total: any, items: Array<{ __typename?: 'SpotLesson', id: number, troubleContent?: string | null, researchContent?: string | null, startAt: string, endAt: string, phase?: SpotLessonPhase | null, zoomURL?: string | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, categories?: Array<{ __typename?: 'Category', id: number, name?: string | null }> | null, instructorUser?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null, user?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null }> } };

export type GetSpotLessonForInstructorQueryVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type GetSpotLessonForInstructorQuery = { __typename?: 'Query', spotLessonForInstructor?: { __typename?: 'SpotLesson', id: number, troubleContent?: string | null, researchContent?: string | null, startAt: string, endAt: string, phase?: SpotLessonPhase | null, zoomURL?: string | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, categories?: Array<{ __typename?: 'Category', id: number, name?: string | null }> | null, instructorUser?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null, user?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null } | null };

export type SpotLessonFragment = { __typename?: 'SpotLesson', id: number, troubleContent?: string | null, researchContent?: string | null, startAt: string, endAt: string, phase?: SpotLessonPhase | null, zoomURL?: string | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, categories?: Array<{ __typename?: 'Category', id: number, name?: string | null }> | null, instructorUser?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null, user?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null };

export type SpotLessonCalendarFragment = { __typename?: 'SpotLessonCalendar', date: string, timeBlocks: Array<{ __typename?: 'SpotLessonTimeBlock', duration: any, disable: boolean, slotCount: any, reservationCount: any, startAt: string }> };

export type TimeBlockFragment = { __typename?: 'SpotLessonTimeBlock', duration: any, disable: boolean, slotCount: any, reservationCount: any, startAt: string };

export type SetupIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type SetupIntentMutation = { __typename?: 'Mutation', setupIntent: string };

export type SubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionQuery = { __typename?: 'Query', subscription?: { __typename?: 'StripeSubscription', id: string, providerQuantity: any, providerStatus: ProviderSubscriptionStatus, price?: { __typename?: 'Price', id: number, unitAmount: number, isSingleMonthContract: boolean, isMultiMonthContract: boolean, numberOfTickets: number, product: { __typename?: 'Product', id: number, name: string }, pricePermission?: { __typename?: 'PricePermission', program?: boolean | null, studyLog?: boolean | null, question?: boolean | null, practice?: boolean | null, submitPractice?: boolean | null } | null } | null, stripeSubscriptionResponse?: { __typename?: 'StripeStoredSubscription', id: string, currentPeriodStart: string, currentPeriodEnd: string, collectionMethod: StripeCollectionMethod, latestInvoice: string, status: ProviderSubscriptionStatus, cancelAtPeriodEnd: boolean } | null } | null, scheduledSubscriptionContract?: { __typename?: 'ScheduledSubscriptionContract', startDate: string, endDate: string, quantity: any, product?: { __typename?: 'Product', name: string } | null } | null, subscriptionCancellationPeriod?: { __typename?: 'SubscriptionCancellationPeriod', startDate: string, endDate: string } | null };

export type GetTeamSubscriptionQueryVariables = Exact<{
  teamID: Scalars['ULID']['input'];
}>;


export type GetTeamSubscriptionQuery = { __typename?: 'Query', teamSubscription?: { __typename?: 'StripeSubscription', id: string, providerQuantity: any, providerStatus: ProviderSubscriptionStatus, price?: { __typename?: 'Price', id: number, unitAmount: number, isSingleMonthContract: boolean, isMultiMonthContract: boolean, numberOfTickets: number, product: { __typename?: 'Product', id: number, name: string }, pricePermission?: { __typename?: 'PricePermission', program?: boolean | null, studyLog?: boolean | null, question?: boolean | null, practice?: boolean | null, submitPractice?: boolean | null } | null } | null, stripeSubscriptionResponse?: { __typename?: 'StripeStoredSubscription', id: string, currentPeriodStart: string, currentPeriodEnd: string, collectionMethod: StripeCollectionMethod, latestInvoice: string, status: ProviderSubscriptionStatus, cancelAtPeriodEnd: boolean } | null } | null, teamScheduledSubscriptionContract?: { __typename?: 'ScheduledSubscriptionContract', startDate: string, endDate: string, quantity: any, product?: { __typename?: 'Product', name: string } | null } | null };

export type GetTeamExistSubscriptionQueryVariables = Exact<{
  teamID: Scalars['ULID']['input'];
}>;


export type GetTeamExistSubscriptionQuery = { __typename?: 'Query', teamExistSubscription: boolean };

export type GetTeamExistMySubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeamExistMySubscriptionQuery = { __typename?: 'Query', teamExistMySubscription: boolean };

export type GetTeamUpcomingInvoiceQueryVariables = Exact<{
  id: Scalars['ULID']['input'];
  input: TeamUpdateSubscriptionFormInput;
}>;


export type GetTeamUpcomingInvoiceQuery = { __typename?: 'Query', teamUpcomingInvoice?: { __typename?: 'TeamUpcomingResponse', defaultPrice?: any | null, isIncrementalUpdate: boolean, nextInvoice?: { __typename?: 'StripeInvoice', id: string, periodEnd: string, periodStart: string, total: any, invoicePDF: string, created: string, status: ProviderInvoiceStatus, stripeInvoiceLines: Array<{ __typename?: 'StripeInvoiceLine', periodEnd: string, periodStart: string, price: { __typename?: 'StripePrice', productDetail?: { __typename?: 'Product', id: number, name: string } | null } }> } | null } | null };

export type GetUpcomingInvoiceQueryVariables = Exact<{
  input: UpdateSubscriptionFormInput;
}>;


export type GetUpcomingInvoiceQuery = { __typename?: 'Query', upcomingInvoice?: { __typename?: 'UpcomingResponse', oldPriceInvoice?: { __typename?: 'StripeInvoice', id: string, periodEnd: string, periodStart: string, total: any, invoicePDF: string, created: string, status: ProviderInvoiceStatus, stripeInvoiceLines: Array<{ __typename?: 'StripeInvoiceLine', periodEnd: string, periodStart: string, price: { __typename?: 'StripePrice', productDetail?: { __typename?: 'Product', id: number, name: string } | null } }> } | null } | null };

export type StripeSubscriptionFragment = { __typename?: 'StripeSubscription', id: string, providerQuantity: any, providerStatus: ProviderSubscriptionStatus, price?: { __typename?: 'Price', id: number, unitAmount: number, isSingleMonthContract: boolean, isMultiMonthContract: boolean, numberOfTickets: number, product: { __typename?: 'Product', id: number, name: string }, pricePermission?: { __typename?: 'PricePermission', program?: boolean | null, studyLog?: boolean | null, question?: boolean | null, practice?: boolean | null, submitPractice?: boolean | null } | null } | null, stripeSubscriptionResponse?: { __typename?: 'StripeStoredSubscription', id: string, currentPeriodStart: string, currentPeriodEnd: string, collectionMethod: StripeCollectionMethod, latestInvoice: string, status: ProviderSubscriptionStatus, cancelAtPeriodEnd: boolean } | null };

export type StripeStoredSubscriptionFragment = { __typename?: 'StripeStoredSubscription', id: string, currentPeriodStart: string, currentPeriodEnd: string, collectionMethod: StripeCollectionMethod, latestInvoice: string, status: ProviderSubscriptionStatus, cancelAtPeriodEnd: boolean };

export type TeamSubscribeMutationVariables = Exact<{
  input: TeamSubscribeFormInput;
}>;


export type TeamSubscribeMutation = { __typename?: 'Mutation', teamSubscribe: boolean };

export type TeamSwitchCancelAtPeriodEndSubscriptionMutationVariables = Exact<{
  id: Scalars['ULID']['input'];
}>;


export type TeamSwitchCancelAtPeriodEndSubscriptionMutation = { __typename?: 'Mutation', teamSwitchCancelAtPeriodEndSubscription: boolean };

export type TeamUpdateSubscriptionMutationVariables = Exact<{
  teamID: Scalars['ULID']['input'];
  input: TeamUpdateSubscriptionFormInput;
}>;


export type TeamUpdateSubscriptionMutation = { __typename?: 'Mutation', teamUpdateSubscription: boolean };

export type SubscribeMutationVariables = Exact<{
  input: SubscribeFormInput;
}>;


export type SubscribeMutation = { __typename?: 'Mutation', subscribe: boolean };

export type RestoreSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type RestoreSubscriptionMutation = { __typename?: 'Mutation', switchCancelAtPeriodEndSubscription: boolean };

export type CancelSubscriptionMutationVariables = Exact<{
  input: WithdrawalQuestionnaireInput;
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', switchCancelAtPeriodEndSubscription: boolean, sendWithdrawalQuestionnaireInput: boolean };

export type ReleaseSubscriptionScheduleMutationVariables = Exact<{ [key: string]: never; }>;


export type ReleaseSubscriptionScheduleMutation = { __typename?: 'Mutation', releaseSubscriptionSchedule: boolean };

export type UpdateSubscriptionMutationVariables = Exact<{
  input: UpdateSubscriptionFormInput;
}>;


export type UpdateSubscriptionMutation = { __typename?: 'Mutation', updateSubscription: boolean };

export type GetInvoicesQueryVariables = Exact<{
  input: InvoicesSearchInput;
}>;


export type GetInvoicesQuery = { __typename?: 'Query', invoices: { __typename?: 'StripeInvoiceResponse', previousCursor?: string | null, nextCursor?: string | null, hasPrevious: boolean, hasNext: boolean, items: Array<{ __typename?: 'StripeInvoice', id: string, periodEnd: string, periodStart: string, total: any, invoicePDF: string, created: string, status: ProviderInvoiceStatus, stripeInvoiceLines: Array<{ __typename?: 'StripeInvoiceLine', periodEnd: string, periodStart: string, price: { __typename?: 'StripePrice', productDetail?: { __typename?: 'Product', id: number, name: string } | null } }> }> } };

export type GetTeamInvoicesQueryVariables = Exact<{
  input: TeamInvoicesSearchInput;
}>;


export type GetTeamInvoicesQuery = { __typename?: 'Query', teamInvoices: { __typename?: 'StripeInvoiceResponse', previousCursor?: string | null, nextCursor?: string | null, hasPrevious: boolean, hasNext: boolean, items: Array<{ __typename?: 'StripeInvoice', id: string, periodEnd: string, periodStart: string, total: any, invoicePDF: string, created: string, status: ProviderInvoiceStatus, stripeInvoiceLines: Array<{ __typename?: 'StripeInvoiceLine', periodEnd: string, periodStart: string, price: { __typename?: 'StripePrice', productDetail?: { __typename?: 'Product', id: number, name: string } | null } }> }> } };

export type StripeInvoiceFragment = { __typename?: 'StripeInvoice', id: string, periodEnd: string, periodStart: string, total: any, invoicePDF: string, created: string, status: ProviderInvoiceStatus, stripeInvoiceLines: Array<{ __typename?: 'StripeInvoiceLine', periodEnd: string, periodStart: string, price: { __typename?: 'StripePrice', productDetail?: { __typename?: 'Product', id: number, name: string } | null } }> };

export type GetPaymentMethodsQueryVariables = Exact<{
  limit: Scalars['Int64']['input'];
}>;


export type GetPaymentMethodsQuery = { __typename?: 'Query', paymentMethods: { __typename?: 'StripePaymentMethodResponse', items: Array<{ __typename?: 'StripePaymentMethod', id: string, cardNumber: string, cardBrand: string, expireMonth: any, expireYear: any, isDefault: boolean }> } };

export type GetTeamPaymentMethodsQueryVariables = Exact<{
  teamID: Scalars['ULID']['input'];
  limit: Scalars['Int64']['input'];
}>;


export type GetTeamPaymentMethodsQuery = { __typename?: 'Query', teamPaymentMethods: { __typename?: 'StripePaymentMethodResponse', items: Array<{ __typename?: 'StripePaymentMethod', id: string, cardNumber: string, cardBrand: string, expireMonth: any, expireYear: any, isDefault: boolean }> } };

export type StripePaymentMethodFragment = { __typename?: 'StripePaymentMethod', id: string, cardNumber: string, cardBrand: string, expireMonth: any, expireYear: any, isDefault: boolean };

export type TeamSelectPaymentMethodMutationVariables = Exact<{
  teamID: Scalars['ULID']['input'];
  providerID: Scalars['String']['input'];
}>;


export type TeamSelectPaymentMethodMutation = { __typename?: 'Mutation', teamSelectPaymentMethod: boolean };

export type TeamDeletePaymentMethodMutationVariables = Exact<{
  teamID: Scalars['ULID']['input'];
  providerID: Scalars['String']['input'];
}>;


export type TeamDeletePaymentMethodMutation = { __typename?: 'Mutation', teamDeletePaymentMethod: boolean };

export type SelectPaymentMethodMutationVariables = Exact<{
  providerID: Scalars['String']['input'];
}>;


export type SelectPaymentMethodMutation = { __typename?: 'Mutation', selectPaymentMethod: boolean };

export type DeletePaymentMethodMutationVariables = Exact<{
  providerID: Scalars['String']['input'];
}>;


export type DeletePaymentMethodMutation = { __typename?: 'Mutation', deletePaymentMethod: boolean };

export type CheckUpgradeTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckUpgradeTypesQuery = { __typename?: 'Query', checkUpgradeTypes: Array<{ __typename?: 'SubscriptionUpgradeTypeItem', priceID: number, subscriptionUpgradeType: SubscriptionUpgradeType, subscriptionType: SubscriptionType }> };

export type CheckUpgradeQueryVariables = Exact<{
  priceID: Scalars['Uint64']['input'];
}>;


export type CheckUpgradeQuery = { __typename?: 'Query', checkUpgrade?: { __typename?: 'CheckUpgradePlanResult', priceID: number, subscriptionUpgradeType: SubscriptionUpgradeType, startDate: string, endDate: string, price?: { __typename?: 'Price', unitAmount: number, numberOfTickets: number, product: { __typename?: 'Product', name: string }, pricePermission?: { __typename?: 'PricePermission', program?: boolean | null, studyLog?: boolean | null, question?: boolean | null, practice?: boolean | null, submitPractice?: boolean | null } | null } | null } | null };

export type IsUpgradableQueryVariables = Exact<{ [key: string]: never; }>;


export type IsUpgradableQuery = { __typename?: 'Query', isUpgradable: boolean };

export type GetCurrentStudentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentStudentQuery = { __typename?: 'Query', currentStudent: { __typename?: 'Student', courses: Array<{ __typename?: 'Course', id: number, startDate?: string | null, endDate?: string | null, absentStartDate?: string | null, absentEndDate?: string | null, curriculum?: string | null, plan: { __typename?: 'Plan', name: string } }> } };

export type GetStudyCalendarQueryVariables = Exact<{
  input: StudyCalendarSearchInput;
}>;


export type GetStudyCalendarQuery = { __typename?: 'Query', getStudyCalendar: Array<{ __typename?: 'StudyCalendar', id: number, date: string, studyReportTime: number }> };

export type StudyCalendarFragment = { __typename?: 'StudyCalendar', id: number, date: string, studyReportTime: number };

export type GetStudyFavoriteSummaryListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStudyFavoriteSummaryListQuery = { __typename?: 'Query', getStudyFavoriteSummaryList: { __typename?: 'StudyFavoriteSummaryListResponse', studyFavoriteCount: Array<{ __typename?: 'StudyFavoriteSummary', studyFavoriteCount: number, studyFavoriteCountWeek: number, studyFavoriteCountMonth: number, user?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null }>, studyFavoriteCountWeek: Array<{ __typename?: 'StudyFavoriteSummary', studyFavoriteCount: number, studyFavoriteCountWeek: number, studyFavoriteCountMonth: number, user?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null }>, studyFavoriteCountMonth: Array<{ __typename?: 'StudyFavoriteSummary', studyFavoriteCount: number, studyFavoriteCountWeek: number, studyFavoriteCountMonth: number, user?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null }> } };

export type StudyFavoriteSummaryFragment = { __typename?: 'StudyFavoriteSummary', studyFavoriteCount: number, studyFavoriteCountWeek: number, studyFavoriteCountMonth: number, user?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null };

export type GetStudyLogQueryVariables = Exact<{
  chapterID: Scalars['Uint64']['input'];
}>;


export type GetStudyLogQuery = { __typename?: 'Query', getStudyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null };

export type SaveStudyLogMutationVariables = Exact<{
  chapterID: Scalars['Uint64']['input'];
  understandingLevel: StudyLogUnderstandingLevel;
}>;


export type SaveStudyLogMutation = { __typename?: 'Mutation', saveStudyLog: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } };

export type StudyLogFragment = { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel };

export type GetStudyReportQueryVariables = Exact<{
  id: Scalars['Uint64']['input'];
  userID?: InputMaybe<Scalars['Uint64']['input']>;
}>;


export type GetStudyReportQuery = { __typename?: 'Query', getStudyReport?: { __typename?: 'StudyReport', id: number, date: string, content: string, status: Valid, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, studyReportDetails: Array<{ __typename?: 'StudyReportDetail', id: number, time?: number | null, createdAt: string, updatedAt: string, tag?: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null, studyReportCount: number } | null, program?: { __typename?: 'Program', id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, repository: string, completedTime: any, programSample?: { __typename?: 'ProgramSample', id: string, title: string, url: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', id: number, title: string, description: string, number: number, type: AuthorizationType, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null } | null, practice?: { __typename?: 'Practice', id: string, title: string, description: string, type: AuthorizationType } | null }> | null } | null }>, studyReportComments: Array<{ __typename?: 'StudyReportComment', id: number, content: string, studyReportID: number, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }>, studyReportFavorites: Array<{ __typename?: 'StudyReportFavorite', id: number, studyReportID: number, userID: number }> } | null };

export type GetStudyReportsQueryVariables = Exact<{
  input: StudyReportSearchInput;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
}>;


export type GetStudyReportsQuery = { __typename?: 'Query', getStudyReports: { __typename?: 'StudyReportSearchResponse', total: number, items: Array<{ __typename?: 'StudyReport', id: number, date: string, content: string, status: Valid, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, studyReportDetails: Array<{ __typename?: 'StudyReportDetail', id: number, time?: number | null, createdAt: string, updatedAt: string, tag?: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null, studyReportCount: number } | null, program?: { __typename?: 'Program', id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, repository: string, completedTime: any, programSample?: { __typename?: 'ProgramSample', id: string, title: string, url: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', id: number, title: string, description: string, number: number, type: AuthorizationType, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null } | null, practice?: { __typename?: 'Practice', id: string, title: string, description: string, type: AuthorizationType } | null }> | null } | null }>, studyReportComments: Array<{ __typename?: 'StudyReportComment', id: number, content: string, studyReportID: number, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }>, studyReportFavorites: Array<{ __typename?: 'StudyReportFavorite', id: number, studyReportID: number, userID: number }> }> } };

export type GetRelatedStudyReportsQueryVariables = Exact<{
  input: RelatedStudyReportSearchInput;
  userID?: InputMaybe<Scalars['Uint64']['input']>;
}>;


export type GetRelatedStudyReportsQuery = { __typename?: 'Query', getRelatedStudyReports: { __typename?: 'StudyReportSearchResponse', total: number, items: Array<{ __typename?: 'StudyReport', id: number, date: string, content: string, status: Valid, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, studyReportDetails: Array<{ __typename?: 'StudyReportDetail', id: number, time?: number | null, createdAt: string, updatedAt: string, tag?: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null, studyReportCount: number } | null, program?: { __typename?: 'Program', id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, repository: string, completedTime: any, programSample?: { __typename?: 'ProgramSample', id: string, title: string, url: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', id: number, title: string, description: string, number: number, type: AuthorizationType, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null } | null, practice?: { __typename?: 'Practice', id: string, title: string, description: string, type: AuthorizationType } | null }> | null } | null }>, studyReportComments: Array<{ __typename?: 'StudyReportComment', id: number, content: string, studyReportID: number, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }>, studyReportFavorites: Array<{ __typename?: 'StudyReportFavorite', id: number, studyReportID: number, userID: number }> }> } };

export type CreateStudyReportMutationVariables = Exact<{
  input: StudyReportInput;
}>;


export type CreateStudyReportMutation = { __typename?: 'Mutation', createStudyReport: { __typename?: 'StudyReport', id: number } };

export type UpdateStudyReportMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
  input: StudyReportInput;
}>;


export type UpdateStudyReportMutation = { __typename?: 'Mutation', updateStudyReport: { __typename?: 'StudyReport', id: number } };

export type DeleteStudyReportMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type DeleteStudyReportMutation = { __typename?: 'Mutation', deleteStudyReport: { __typename?: 'StudyReport', id: number } };

export type CreateStudyReportCommentMutationVariables = Exact<{
  studyReportID: Scalars['Uint64']['input'];
  input: StudyReportCommentInput;
}>;


export type CreateStudyReportCommentMutation = { __typename?: 'Mutation', createStudyReportComment: { __typename?: 'StudyReportComment', id: number, content: string, createdAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } };

export type UpdateStudyReportCommentMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
  input: StudyReportCommentInput;
}>;


export type UpdateStudyReportCommentMutation = { __typename?: 'Mutation', updateStudyReportComment: { __typename?: 'StudyReportComment', id: number } };

export type DeleteStudyReportCommentMutationVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type DeleteStudyReportCommentMutation = { __typename?: 'Mutation', deleteStudyReportComment: { __typename?: 'StudyReportComment', id: number } };

export type CreateStudyReportFavoriteMutationVariables = Exact<{
  studyReportID: Scalars['Uint64']['input'];
}>;


export type CreateStudyReportFavoriteMutation = { __typename?: 'Mutation', createStudyReportFavorite: { __typename?: 'StudyReportFavorite', id: number, studyReportID: number, userID: number } };

export type DeleteStudyReportFavoriteMutationVariables = Exact<{
  studyReportID: Scalars['Uint64']['input'];
}>;


export type DeleteStudyReportFavoriteMutation = { __typename?: 'Mutation', deleteStudyReportFavorite: { __typename?: 'StudyReportFavorite', id: number } };

export type StudyReportFragment = { __typename?: 'StudyReport', id: number, date: string, content: string, status: Valid, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, studyReportDetails: Array<{ __typename?: 'StudyReportDetail', id: number, time?: number | null, createdAt: string, updatedAt: string, tag?: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null, studyReportCount: number } | null, program?: { __typename?: 'Program', id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, repository: string, completedTime: any, programSample?: { __typename?: 'ProgramSample', id: string, title: string, url: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', id: number, title: string, description: string, number: number, type: AuthorizationType, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null } | null, practice?: { __typename?: 'Practice', id: string, title: string, description: string, type: AuthorizationType } | null }> | null } | null }>, studyReportComments: Array<{ __typename?: 'StudyReportComment', id: number, content: string, studyReportID: number, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }>, studyReportFavorites: Array<{ __typename?: 'StudyReportFavorite', id: number, studyReportID: number, userID: number }> };

export type StudyReportDetailFragment = { __typename?: 'StudyReportDetail', id: number, time?: number | null, createdAt: string, updatedAt: string, tag?: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null, studyReportCount: number } | null, program?: { __typename?: 'Program', id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, repository: string, completedTime: any, programSample?: { __typename?: 'ProgramSample', id: string, title: string, url: string } | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, programElements?: Array<{ __typename?: 'ProgramElement', chapter?: { __typename?: 'Chapter', id: number, title: string, description: string, number: number, type: AuthorizationType, examScores?: Array<{ __typename?: 'ExamScore', score: number, medalType: ExamMedalType }> | null, studyLog?: { __typename?: 'StudyLog', id: number, chapterID: number, understandingLevel: StudyLogUnderstandingLevel } | null } | null, practice?: { __typename?: 'Practice', id: string, title: string, description: string, type: AuthorizationType } | null }> | null } | null };

export type StudyReportCommentFragment = { __typename?: 'StudyReportComment', id: number, content: string, studyReportID: number, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } };

export type StudyReportFavoriteFragment = { __typename?: 'StudyReportFavorite', id: number, studyReportID: number, userID: number };

export type StudyReportTagFragment = { __typename?: 'Tag', id: number, name: string, iconImage?: string | null, studyReportCount: number };

export type GetStudySummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStudySummaryQuery = { __typename?: 'Query', getStudySummary: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } };

export type GetStudySummaryListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStudySummaryListQuery = { __typename?: 'Query', getStudySummaryList: { __typename?: 'StudySummaryListResponse', studyReportTime: Array<{ __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, user?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null }>, studyReportTimeWeek: Array<{ __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, user?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null }>, studyReportTimeMonth: Array<{ __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, user?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null }> } };

export type StudySummaryFragment = { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number };

export type StudySummaryListFragment = { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, user?: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } | null };

export type GetStudyTagSummariesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStudyTagSummariesQuery = { __typename?: 'Query', getStudyTagSummaries: Array<{ __typename?: 'StudyTagSummary', id: number, studyReportTime: number, studyReportTimeMonth: number, studyReportTimeWeek: number, tag: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null, status: Valid } }> };

export type GetStudyTagSummaryListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStudyTagSummaryListQuery = { __typename?: 'Query', getStudyTagSummaryList: { __typename?: 'StudyTagSummaryListResponse', studyReportTime: Array<{ __typename?: 'StudyTagSummary', studyReportTime: number, studyReportTimeMonth: number, studyReportTimeWeek: number, tag: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null } }>, studyReportTimeWeek: Array<{ __typename?: 'StudyTagSummary', studyReportTime: number, studyReportTimeMonth: number, studyReportTimeWeek: number, tag: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null } }>, studyReportTimeMonth: Array<{ __typename?: 'StudyTagSummary', studyReportTime: number, studyReportTimeMonth: number, studyReportTimeWeek: number, tag: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null } }> } };

export type StudyTagSummaryListFragment = { __typename?: 'StudyTagSummary', studyReportTime: number, studyReportTimeMonth: number, studyReportTimeWeek: number, tag: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null } };

export type StudyTagSummaryFragment = { __typename?: 'StudyTagSummary', id: number, studyReportTime: number, studyReportTimeMonth: number, studyReportTimeWeek: number, tag: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null, status: Valid } };

export type MySubscriptionContractsQueryVariables = Exact<{
  input: MySubscriptionContractInput;
}>;


export type MySubscriptionContractsQuery = { __typename?: 'Query', mySubscriptionContracts?: { __typename?: 'SubscriptionContractsResponse', total: any, items: Array<{ __typename?: 'SubscriptionContract', id: string, canceledAt?: string | null, periodStart: string, periodEnd: string, endDate?: string | null, price?: { __typename?: 'Price', product: { __typename?: 'Product', name: string } } | null }> } | null };

export type TeamSubscriptionContractsQueryVariables = Exact<{
  input: TeamSubscriptionContractInput;
}>;


export type TeamSubscriptionContractsQuery = { __typename?: 'Query', teamSubscriptionContracts: { __typename?: 'SubscriptionContractsResponse', total: any, items: Array<{ __typename?: 'SubscriptionContract', id: string, canceledAt?: string | null, periodStart: string, periodEnd: string, endDate?: string | null, price?: { __typename?: 'Price', product: { __typename?: 'Product', name: string } } | null }> } };

export type ScheduledSubscriptionContractFragment = { __typename?: 'ScheduledSubscriptionContract', startDate: string, endDate: string, quantity: any, product?: { __typename?: 'Product', name: string } | null };

export type SubscriptionContractFragment = { __typename?: 'SubscriptionContract', id: string, canceledAt?: string | null, periodStart: string, periodEnd: string };

export type SubscriptionContractForListFragment = { __typename?: 'SubscriptionContract', id: string, canceledAt?: string | null, periodStart: string, periodEnd: string, endDate?: string | null, price?: { __typename?: 'Price', product: { __typename?: 'Product', name: string } } | null };

export type SubscriptionCancellationPeriodFragment = { __typename?: 'SubscriptionCancellationPeriod', startDate: string, endDate: string };

export type GetTagsQueryVariables = Exact<{
  input: TagSearchInput;
}>;


export type GetTagsQuery = { __typename?: 'Query', getTags: { __typename?: 'TagSearchResponse', total: any, items: Array<{ __typename?: 'Tag', id: number, name: string, iconImage?: string | null, questionCount: number, studyReportCount: number, overview?: string | null }> } };

export type GetTagQueryVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type GetTagQuery = { __typename?: 'Query', getTag?: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null, questionCount: number, studyReportCount: number, overview?: string | null } | null };

export type TagFragment = { __typename?: 'Tag', id: number, name: string, iconImage?: string | null, questionCount: number, studyReportCount: number, overview?: string | null };

export type GetTeamQueryVariables = Exact<{
  id: Scalars['ULID']['input'];
}>;


export type GetTeamQuery = { __typename?: 'Query', team: { __typename?: 'Team', image?: string | null, companyName?: string | null, adminEmail?: string | null, paymentMethodType?: PaymentMethodType | null } };

export type UpdateTeamMutationVariables = Exact<{
  id: Scalars['ULID']['input'];
  input: UpdateTeamInput;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'Team', id: string } };

export type TeamFragment = { __typename?: 'Team', image?: string | null, companyName?: string | null, adminEmail?: string | null };

export type GetTeamWithSubscriptionQueryVariables = Exact<{
  id: Scalars['ULID']['input'];
}>;


export type GetTeamWithSubscriptionQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, paymentMethodType?: PaymentMethodType | null, teamMembers?: Array<{ __typename?: 'TeamMember', id: string, teamID: string, role: TeamMemberRole, team: { __typename?: 'Team', companyName?: string | null, image?: string | null, status: Valid } }> | null }, teamSubscription?: { __typename?: 'StripeSubscription', providerStatus: ProviderSubscriptionStatus } | null };

export type CreateTeamMutationVariables = Exact<{
  input: TeamInput;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: string } };

export type DeleteTeamMutationVariables = Exact<{
  id: Scalars['ULID']['input'];
}>;


export type DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam: boolean };

export type TeamUpdatePaymentMethodTypeMutationVariables = Exact<{
  teamID: Scalars['ULID']['input'];
  paymentMethodType: PaymentMethodType;
}>;


export type TeamUpdatePaymentMethodTypeMutation = { __typename?: 'Mutation', teamUpdatePaymentMethodType: boolean };

export type GetTeamInvitationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTeamInvitationQuery = { __typename?: 'Query', teamInvitation: { __typename?: 'TeamInvitation', team: { __typename?: 'Team', companyName?: string | null } } };

export type CreateTeamInvitationMutationVariables = Exact<{
  input: TeamInvitationInput;
}>;


export type CreateTeamInvitationMutation = { __typename?: 'Mutation', createTeamInvitation: boolean };

export type GetMyTeamMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyTeamMembersQuery = { __typename?: 'Query', myTeamMembers: Array<{ __typename?: 'TeamMember', id: string, teamID: string, role: TeamMemberRole, team: { __typename?: 'Team', companyName?: string | null, image?: string | null, status: Valid } }> };

export type MyTeamMemberFragment = { __typename?: 'TeamMember', id: string, teamID: string, role: TeamMemberRole, team: { __typename?: 'Team', companyName?: string | null, image?: string | null, status: Valid } };

export type JoinTeamMemberMutationVariables = Exact<{
  teamInvitationID: Scalars['ULID']['input'];
}>;


export type JoinTeamMemberMutation = { __typename?: 'Mutation', joinTeamMember: { __typename?: 'TeamMember', id: string, teamID: string } };

export type GetTeamMembersByTeamIdQueryVariables = Exact<{
  input: TeamMemberSearchInput;
}>;


export type GetTeamMembersByTeamIdQuery = { __typename?: 'Query', getTeamMembersByTeamID: { __typename?: 'TeamMembersResponse', total: number, items: Array<{ __typename?: 'TeamMember', id: string, role: TeamMemberRole, user: { __typename?: 'User', id: number, nickName: string, image: string, completedPrograms?: Array<{ __typename?: 'Program', id: number }> | null, totalLessonCount?: Array<{ __typename?: 'SpotLesson', id: number }> | null, studySummary?: { __typename?: 'StudySummary', studyReportTime?: number | null, studyReportCount?: number | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null } }> } };

export type TeamMemberListFragment = { __typename?: 'TeamMember', id: string, role: TeamMemberRole, user: { __typename?: 'User', id: number, nickName: string, image: string, completedPrograms?: Array<{ __typename?: 'Program', id: number }> | null, totalLessonCount?: Array<{ __typename?: 'SpotLesson', id: number }> | null, studySummary?: { __typename?: 'StudySummary', studyReportTime?: number | null, studyReportCount?: number | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null } };

export type ChangeTeamMemberRoleMutationVariables = Exact<{
  teamMemberID: Scalars['ULID']['input'];
  role: TeamMemberRole;
}>;


export type ChangeTeamMemberRoleMutation = { __typename?: 'Mutation', changeTeamMemberRole: boolean };

export type RemoveTeamMemberMutationVariables = Exact<{
  id: Scalars['ULID']['input'];
}>;


export type RemoveTeamMemberMutation = { __typename?: 'Mutation', removeTeamMember: boolean };

export type GetTicketsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTicketsQuery = { __typename?: 'Query', tickets: Array<{ __typename?: 'Ticket', id: number, expireAt: string }> };

export type TicketFragment = { __typename?: 'Ticket', id: number, expireAt: string };

export type GetTimelinesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  adminAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTimelinesQuery = { __typename?: 'Query', getTimelinesV1: { __typename?: 'TimelineResponse', items: Array<{ __typename?: 'StudyReport', date: string, content: string, createdAt: string, studyReportID: number, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, studyReportDetails: Array<{ __typename?: 'StudyReportDetail', time?: number | null, tag?: { __typename?: 'Tag', id: number, iconImage?: string | null, name: string } | null, program?: { __typename?: 'Program', id: number, title: string, thumbnail: string, icon: string, repository: string } | null }>, studyReportComments: Array<{ __typename?: 'StudyReportComment', id: number, content: string, createdAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }>, studyReportFavorites: Array<{ __typename?: 'StudyReportFavorite', id: number, userID: number }> } | { __typename?: 'Tweet', createdAt: string, tweetPostDestination: TweetPostDestination, tweetID: string, tweetDetail: { __typename?: 'TweetDetail', content: string, detailType?: TweetDetailType | null, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, tweetImages?: Array<{ __typename?: 'TweetImage', id: string, content: string }> | null, tweetComments?: Array<{ __typename?: 'TweetComment', tweetCommentID: string, content: string, createdAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }> | null, tweetFavorites?: Array<{ __typename?: 'TweetFavorite', id: string, userID: number }> | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, adminPageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetTimelinesByUserIdQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  userID: Scalars['Int']['input'];
}>;


export type GetTimelinesByUserIdQuery = { __typename?: 'Query', getTimelinesByUserID: { __typename?: 'TimelineResponse', items: Array<{ __typename?: 'StudyReport', date: string, content: string, createdAt: string, studyReportID: number, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, studyReportDetails: Array<{ __typename?: 'StudyReportDetail', time?: number | null, tag?: { __typename?: 'Tag', id: number, iconImage?: string | null, name: string } | null, program?: { __typename?: 'Program', id: number, title: string, thumbnail: string, icon: string, repository: string } | null }>, studyReportComments: Array<{ __typename?: 'StudyReportComment', id: number, content: string, createdAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }>, studyReportFavorites: Array<{ __typename?: 'StudyReportFavorite', id: number, userID: number }> } | { __typename?: 'Tweet', createdAt: string, tweetPostDestination: TweetPostDestination, tweetID: string, tweetDetail: { __typename?: 'TweetDetail', content: string, detailType?: TweetDetailType | null, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, tweetImages?: Array<{ __typename?: 'TweetImage', id: string, content: string }> | null, tweetComments?: Array<{ __typename?: 'TweetComment', tweetCommentID: string, content: string, createdAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }> | null, tweetFavorites?: Array<{ __typename?: 'TweetFavorite', id: string, userID: number }> | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type TimelineStudyReportFragment = { __typename?: 'StudyReport', date: string, content: string, createdAt: string, studyReportID: number, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, studyReportDetails: Array<{ __typename?: 'StudyReportDetail', time?: number | null, tag?: { __typename?: 'Tag', id: number, iconImage?: string | null, name: string } | null, program?: { __typename?: 'Program', id: number, title: string, thumbnail: string, icon: string, repository: string } | null }>, studyReportComments: Array<{ __typename?: 'StudyReportComment', id: number, content: string, createdAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }>, studyReportFavorites: Array<{ __typename?: 'StudyReportFavorite', id: number, userID: number }> };

export type GetTweetQueryVariables = Exact<{
  id: Scalars['ULID']['input'];
}>;


export type GetTweetQuery = { __typename?: 'Query', getTweetV1: { __typename?: 'Tweet', createdAt: string, tweetPostDestination: TweetPostDestination, tweetID: string, tweetDetail: { __typename?: 'TweetDetail', content: string, detailType?: TweetDetailType | null, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, tweetImages?: Array<{ __typename?: 'TweetImage', id: string, content: string }> | null, tweetComments?: Array<{ __typename?: 'TweetComment', tweetCommentID: string, content: string, createdAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }> | null, tweetFavorites?: Array<{ __typename?: 'TweetFavorite', id: string, userID: number }> | null } } };

export type AddTweetMutationVariables = Exact<{
  input: TweetInput;
}>;


export type AddTweetMutation = { __typename?: 'Mutation', addTweet: { __typename?: 'Tweet', id: string } };

export type DeleteTweetMutationVariables = Exact<{
  tweetID: Scalars['ULID']['input'];
}>;


export type DeleteTweetMutation = { __typename?: 'Mutation', deleteTweet: { __typename?: 'Tweet', id: string } };

export type AddTweetFavoriteMutationVariables = Exact<{
  tweetID: Scalars['ULID']['input'];
}>;


export type AddTweetFavoriteMutation = { __typename?: 'Mutation', addTweetFavorite: { __typename?: 'TweetFavorite', id: string, userID: number } };

export type DeleteTweetFavoriteMutationVariables = Exact<{
  tweetID: Scalars['ULID']['input'];
}>;


export type DeleteTweetFavoriteMutation = { __typename?: 'Mutation', deleteTweetFavorite: { __typename?: 'TweetFavorite', id: string, userID: number } };

export type AddTweetCommentMutationVariables = Exact<{
  input: TweetCommentInput;
}>;


export type AddTweetCommentMutation = { __typename?: 'Mutation', addTweetComment: { __typename?: 'TweetComment', tweetCommentID: string, content: string, createdAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } };

export type DeleteTweetCommentMutationVariables = Exact<{
  tweetCommentID: Scalars['ULID']['input'];
}>;


export type DeleteTweetCommentMutation = { __typename?: 'Mutation', deleteTweetComment: { __typename?: 'TweetComment', tweetCommentID: string, content: string, createdAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } } };

export type TweetFragment = { __typename?: 'Tweet', createdAt: string, tweetPostDestination: TweetPostDestination, tweetID: string, tweetDetail: { __typename?: 'TweetDetail', content: string, detailType?: TweetDetailType | null, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null }, tweetImages?: Array<{ __typename?: 'TweetImage', id: string, content: string }> | null, tweetComments?: Array<{ __typename?: 'TweetComment', tweetCommentID: string, content: string, createdAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } }> | null, tweetFavorites?: Array<{ __typename?: 'TweetFavorite', id: string, userID: number }> | null } };

export type TweetCommentFragment = { __typename?: 'TweetComment', tweetCommentID: string, content: string, createdAt: string, user: { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null } };

export type TweetFavoriteFragment = { __typename?: 'TweetFavorite', id: string, userID: number };

export type GetUserForUserPageLayoutQueryVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type GetUserForUserPageLayoutQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, nickName: string, isInstructor: number } | null };

export type GetUserProfileQueryVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type GetUserProfileQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, nickName: string, isInstructor: number, isStudent: number, image: string, profile?: string | null, objective?: string | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, userTags?: Array<{ __typename?: 'UserTag', id: number, term?: number | null, tag?: { __typename?: 'Tag', id: number, name: string } | null }> | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null, monthlyStudyCalendars?: Array<{ __typename?: 'StudyCalendar', id: number, date: string, studyReportTime: number }> | null, studyTagSummaries?: Array<{ __typename?: 'StudyTagSummary', id: number, studyReportTime: number, studyReportTimeMonth: number, studyReportTimeWeek: number, tag: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null, status: Valid } }> | null, completedPrograms?: Array<{ __typename?: 'Program', id: number }> | null, whileStudyingPrograms?: Array<{ __typename?: 'Program', id: number }> | null, totalLessonCount?: Array<{ __typename?: 'SpotLesson', id: number }> | null, questions?: Array<{ __typename?: 'Question', id: number }> | null } | null };

export type GetUserWithProgramsQueryVariables = Exact<{
  id: Scalars['Uint64']['input'];
}>;


export type GetUserWithProgramsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, nickName: string, isInstructor: number, completedPrograms?: Array<{ __typename?: 'Program', id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, completedTime: any, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }> | null, whileStudyingPrograms?: Array<{ __typename?: 'Program', id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, completedTime: any, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null }> | null } | null };

export type GetCurrentUserWithPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserWithPermissionsQuery = { __typename?: 'Query', currentUserWithPermissions?: { __typename?: 'UserWithPermissionList', user?: { __typename?: 'User', id: number, snsType: number, status: number, isAdmin: number, isInstructor: number, profile?: string | null, objective?: string | null, nickName: string, createdAt: string, isStudent: number, image: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, userTags?: Array<{ __typename?: 'UserTag', id: number, term?: number | null, tag?: { __typename?: 'Tag', id: number, name: string } | null }> | null, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, personalInfo?: { __typename?: 'UserPersonalInfo', name: string, email: string, sex?: number | null } | null, student?: { __typename?: 'Student', id: number, status?: number | null, courses: Array<{ __typename?: 'Course', coaching?: { __typename?: 'Coaching', id: string } | null }> } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null } | null, contractsOfStripeSubscriptionForAnalytics: Array<{ __typename?: 'ContractOfStripeSubscriptionForAnalytics', stripeCustomerType: StripeCustomerType, contractDetailForAnalytics: { __typename?: 'ContractDetailForAnalytics', productID: number, productName: string, periodStart: string, periodEnd: string, canceledAt?: string | null } }>, permissionList?: { __typename?: 'PermissionList', roles: Array<UserRole>, teamIDs: Array<string>, teamIDsForTeamAdmin: Array<string> } | null } | null };

export type GetAiUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAiUserQuery = { __typename?: 'Query', aiUser?: { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean } | null };

export type WithdrawMutationVariables = Exact<{
  questionnaireInput: WithdrawalQuestionnaireInput;
}>;


export type WithdrawMutation = { __typename?: 'Mutation', withdraw: boolean };

export type UpdateLastAccessMutationVariables = Exact<{
  smrc?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateLastAccessMutation = { __typename?: 'Mutation', updateLastAccess: boolean };

export type UpdateUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: number } };

export type RegisterMutationVariables = Exact<{
  input: UserRegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'User', id: number } };

export type OAuthRegisterMutationVariables = Exact<{
  input: OAuthUserRegisterInput;
}>;


export type OAuthRegisterMutation = { __typename?: 'Mutation', oAuthRegister: { __typename?: 'User', id: number, snsType: number, status: number, isAdmin: number, isInstructor: number, profile?: string | null, objective?: string | null, nickName: string, createdAt: string, isStudent: number, image: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, userTags?: Array<{ __typename?: 'UserTag', id: number, term?: number | null, tag?: { __typename?: 'Tag', id: number, name: string } | null }> | null, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, personalInfo?: { __typename?: 'UserPersonalInfo', name: string, email: string, sex?: number | null } | null, student?: { __typename?: 'Student', id: number, status?: number | null, courses: Array<{ __typename?: 'Course', coaching?: { __typename?: 'Coaching', id: string } | null }> } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null } };

export type UserPageLayoutFragment = { __typename?: 'User', id: number, nickName: string, isInstructor: number };

export type UserProfileFragment = { __typename?: 'User', id: number, nickName: string, isInstructor: number, isStudent: number, image: string, profile?: string | null, objective?: string | null, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, userTags?: Array<{ __typename?: 'UserTag', id: number, term?: number | null, tag?: { __typename?: 'Tag', id: number, name: string } | null }> | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null, monthlyStudyCalendars?: Array<{ __typename?: 'StudyCalendar', id: number, date: string, studyReportTime: number }> | null, studyTagSummaries?: Array<{ __typename?: 'StudyTagSummary', id: number, studyReportTime: number, studyReportTimeMonth: number, studyReportTimeWeek: number, tag: { __typename?: 'Tag', id: number, name: string, iconImage?: string | null, status: Valid } }> | null, completedPrograms?: Array<{ __typename?: 'Program', id: number }> | null, whileStudyingPrograms?: Array<{ __typename?: 'Program', id: number }> | null, totalLessonCount?: Array<{ __typename?: 'SpotLesson', id: number }> | null, questions?: Array<{ __typename?: 'Question', id: number }> | null };

export type UserProgramFragment = { __typename?: 'Program', id: number, icon: string, thumbnail: string, title: string, description: string, questionCount: number, answerCount: number, chapterCount: number, requireTime: number, studyLogCount: number, completedTime: any, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null };

export type IconUserFragment = { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null };

export type CurrentUserFragment = { __typename?: 'User', id: number, snsType: number, status: number, isAdmin: number, isInstructor: number, profile?: string | null, objective?: string | null, nickName: string, createdAt: string, isStudent: number, image: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, userTags?: Array<{ __typename?: 'UserTag', id: number, term?: number | null, tag?: { __typename?: 'Tag', id: number, name: string } | null }> | null, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, personalInfo?: { __typename?: 'UserPersonalInfo', name: string, email: string, sex?: number | null } | null, student?: { __typename?: 'Student', id: number, status?: number | null, courses: Array<{ __typename?: 'Course', coaching?: { __typename?: 'Coaching', id: string } | null }> } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null };

export type UserFragment = { __typename?: 'User', id: number, image: string, isAI: boolean, isAdmin: number, isInstructor: number, isStudent: number, nickName: string, snsType: number, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null, studySummary?: { __typename?: 'StudySummary', id: number, studyReportTime?: number | null, studyReportCount?: number | null, studyReportTimeMonth: number, studyReportTimeWeek: number, studyReportRunningLayDays: number, studyReportCurrentRunningLayDays: number } | null };

export type CurrentUserWithPermissionListFragment = { __typename?: 'UserWithPermissionList', user?: { __typename?: 'User', id: number, snsType: number, status: number, isAdmin: number, isInstructor: number, profile?: string | null, objective?: string | null, nickName: string, createdAt: string, isStudent: number, image: string, tags?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, userTags?: Array<{ __typename?: 'UserTag', id: number, term?: number | null, tag?: { __typename?: 'Tag', id: number, name: string } | null }> | null, instructor?: { __typename?: 'Instructor', id: number, isCoach?: boolean | null } | null, personalInfo?: { __typename?: 'UserPersonalInfo', name: string, email: string, sex?: number | null } | null, student?: { __typename?: 'Student', id: number, status?: number | null, courses: Array<{ __typename?: 'Course', coaching?: { __typename?: 'Coaching', id: string } | null }> } | null, maskedPersonalInfo?: { __typename?: 'UserMaskedPersonalInfo', name: string } | null } | null, contractsOfStripeSubscriptionForAnalytics: Array<{ __typename?: 'ContractOfStripeSubscriptionForAnalytics', stripeCustomerType: StripeCustomerType, contractDetailForAnalytics: { __typename?: 'ContractDetailForAnalytics', productID: number, productName: string, periodStart: string, periodEnd: string, canceledAt?: string | null } }>, permissionList?: { __typename?: 'PermissionList', roles: Array<UserRole>, teamIDs: Array<string>, teamIDsForTeamAdmin: Array<string> } | null };

export type CurrentPermissionListFragment = { __typename?: 'PermissionList', roles: Array<UserRole>, teamIDs: Array<string>, teamIDsForTeamAdmin: Array<string> };

export type ContractOfStripeSubscriptionForAnalyticsFragment = { __typename?: 'ContractOfStripeSubscriptionForAnalytics', stripeCustomerType: StripeCustomerType, contractDetailForAnalytics: { __typename?: 'ContractDetailForAnalytics', productID: number, productName: string, periodStart: string, periodEnd: string, canceledAt?: string | null } };

export type QuestionUserFragment = { __typename?: 'User', id: number, nickName: string, image: string, isStudent: number, isInstructor: number, isAdmin: number, snsType: number, isAI: boolean };

export type UserChatMessageFragment = { __typename?: 'UserChatMessage', id: number, userID: number, chatRoomID: number, isRead: Bool, createdAt: string, updatedAt: string };

export const AbTestDeliveryFragmentDoc = gql`
    fragment AbTestDelivery on AbTestDelivery {
  originURL
  deviceType
  totalRate
  startDate
  endDate
  abTestDeliveryDetails {
    deliveryURL
    deliveryRate
  }
}
    `;
export const BannerCidFragmentDoc = gql`
    fragment BannerCid on BannerCid {
  id
  type
  deviceType
  cid
  banner {
    link
    imageURL
    title
  }
}
    `;
export const CampaignFragmentDoc = gql`
    fragment Campaign on Campaign {
  title
  imageURL
}
    `;
export const CategoryFragmentDoc = gql`
    fragment Category on Category {
  id
  name
  status
  createdAt
  updatedAt
}
    `;
export const ProgramSearchSimpleFragmentDoc = gql`
    fragment ProgramSearchSimple on Program {
  id
  title
  description
  icon
}
    `;
export const ChapterDetailSearchFragmentDoc = gql`
    fragment ChapterDetailSearch on Chapter {
  id
  title
  description
  number
  type
  programElement {
    program {
      ...ProgramSearchSimple
    }
  }
}
    ${ProgramSearchSimpleFragmentDoc}`;
export const ChatMessageChatRoomFragmentDoc = gql`
    fragment ChatMessageChatRoom on ChatRoom {
  id
  unreadCount
  lastMessage {
    id
    content
    status
    createdAt
    updatedAt
  }
}
    `;
export const ChatMessageUserFragmentDoc = gql`
    fragment ChatMessageUser on User {
  id
  nickName
  image
  isInstructor
  isStudent
  isAdmin
  updatedAt
  instructor {
    isCoach
  }
  maskedPersonalInfo {
    name
  }
  snsType
}
    `;
export const UserChatMessageFragmentDoc = gql`
    fragment UserChatMessage on UserChatMessage {
  id
  userID
  chatRoomID
  isRead
  createdAt
  updatedAt
}
    `;
export const ChatMessageListFragmentDoc = gql`
    fragment ChatMessageList on ChatMessage {
  id
  content
  status
  createdAt
  updatedAt
  user {
    ...ChatMessageUser
  }
  userChatMessage {
    ...UserChatMessage
  }
}
    ${ChatMessageUserFragmentDoc}
${UserChatMessageFragmentDoc}`;
export const ChatMessageEdgeFragmentDoc = gql`
    fragment ChatMessageEdge on ChatMessageEdge {
  node {
    ...ChatMessageList
  }
  cursor
}
    ${ChatMessageListFragmentDoc}`;
export const ChatMessageDraftFragmentDoc = gql`
    fragment ChatMessageDraft on ChatMessageDraft {
  chatRoomID
  userID
  content
}
    `;
export const ChatMemberUserFragmentDoc = gql`
    fragment ChatMemberUser on User {
  id
  nickName
  image
  isInstructor
  isStudent
  isAdmin
  updatedAt
  instructor {
    isCoach
  }
  student {
    status
  }
  maskedPersonalInfo {
    name
  }
  snsType
}
    `;
export const ChatMemberListFragmentDoc = gql`
    fragment ChatMemberList on ChatMember {
  id
  status
  user {
    ...ChatMemberUser
  }
}
    ${ChatMemberUserFragmentDoc}`;
export const ChatRoomListFragmentDoc = gql`
    fragment ChatRoomList on ChatRoom {
  id
  title
  status
  createdAt
  updatedAt
  unreadCount
  chatMembers {
    ...ChatMemberList
  }
  lastMessage {
    id
    content
    status
    createdAt
    updatedAt
  }
}
    ${ChatMemberListFragmentDoc}`;
export const ClaimFragmentDoc = gql`
    fragment Claim on Claim {
  id
  applyStatus
  month
}
    `;
export const StudySummaryFragmentDoc = gql`
    fragment StudySummary on StudySummary {
  id
  studyReportTime
  studyReportCount
  studyReportTimeMonth
  studyReportTimeWeek
  studyReportRunningLayDays
  studyReportCurrentRunningLayDays
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  image
  instructor {
    id
    isCoach
  }
  isAI
  isAdmin
  isInstructor
  isStudent
  maskedPersonalInfo {
    name
  }
  nickName
  snsType
  studySummary {
    ...StudySummary
  }
}
    ${StudySummaryFragmentDoc}`;
export const ClaimDetailFragmentDoc = gql`
    fragment ClaimDetail on ClaimDetail {
  id
  subTotal
  amount
  date
  additionalPayment
  remark
  unitPrice
  course {
    id
    student {
      id
      status
      user {
        ...User
      }
    }
    plan {
      name
    }
  }
  lesson {
    id
    title
    type
  }
  spotLesson {
    id
    startAt
  }
  claimCategory {
    id
    name
  }
}
    ${UserFragmentDoc}`;
export const ClaimCategoryFragmentDoc = gql`
    fragment ClaimCategory on ClaimCategory {
  id
  name
}
    `;
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on PageInfo {
  startCursor
  endCursor
  hasNextPage
  hasPreviousPage
}
    `;
export const CourseStudentFragmentDoc = gql`
    fragment CourseStudent on Student {
  id
  user {
    id
    image
    nickName
    maskedPersonalInfo {
      name
    }
  }
}
    `;
export const CourseFragmentDoc = gql`
    fragment Course on Course {
  id
  absentStartDate
  absentEndDate
  absent2StartDate
  absent2EndDate
  absent3StartDate
  absent3EndDate
  instructorChangeStartDate
  instructorChangeEndDate
  instructorChange2StartDate
  instructorChange2EndDate
  instructorChange3StartDate
  instructorChange3EndDate
  consultant
  status
  lessonType
  lessonPlace
  startDate
  endDate
  student {
    ...CourseStudent
  }
  plan {
    name
  }
  contractType
  curriculum
  jobChange
  careerSupport
  customerAcquisition
  delayInPayment
  breakInContact
  teachingMaterialCost
  lessonMinutesUpperLimit
  status
  plannedLessonCount
  finishedLessonCount
  coaching {
    finishedSessionCount
    plannedSessionCount
  }
  studentInformation {
    customerInformation
    transferInformation
  }
  instructorMemo
}
    ${CourseStudentFragmentDoc}`;
export const CourseListFragmentDoc = gql`
    fragment CourseList on Course {
  id
  endDate
  student {
    user {
      ...User
    }
  }
  plan {
    name
  }
  coaching {
    id
    plannedSessionCount
    finishedSessionCount
  }
}
    ${UserFragmentDoc}`;
export const StudentCourseFragmentDoc = gql`
    fragment StudentCourse on Course {
  startDate
  endDate
  curriculum
  finishedLessonCount
  plannedLessonCount
  plan {
    name
  }
  coaching {
    plannedSessionCount
    finishedSessionCount
  }
  status
}
    `;
export const HistoricalCourseFragmentDoc = gql`
    fragment HistoricalCourse on Course {
  id
  lessons {
    id
    startAt
    endAt
    completed
    canceled
    title
  }
  plan {
    isLessonPreparationAllowed
    isQuestionAllowed
    isFlexibleCurriculum
    name
  }
  student {
    ...CourseStudent
  }
}
    ${CourseStudentFragmentDoc}`;
export const CourseNewLessonFragmentDoc = gql`
    fragment CourseNewLesson on Course {
  id
  student {
    user {
      ...User
    }
  }
  lessons {
    id
  }
  plan {
    name
    lessonMinutes
  }
  plannedLessonCount
  endDate
}
    ${UserFragmentDoc}`;
export const ChapterForCourseProgramStepItemFragmentDoc = gql`
    fragment ChapterForCourseProgramStepItem on Chapter {
  id
  studyLog {
    id
  }
  type
}
    `;
export const PracticeForCourseProgramStepItemFragmentDoc = gql`
    fragment PracticeForCourseProgramStepItem on Practice {
  id
  type
  mySubmit {
    id
    practiceSubmitDetails {
      id
      reviewStatus
    }
  }
}
    `;
export const ProgramElementForCourseProgramStepItemFragmentDoc = gql`
    fragment ProgramElementForCourseProgramStepItem on ProgramElement {
  id
  number
  programID
  chapter {
    ...ChapterForCourseProgramStepItem
  }
  practice {
    ...PracticeForCourseProgramStepItem
  }
}
    ${ChapterForCourseProgramStepItemFragmentDoc}
${PracticeForCourseProgramStepItemFragmentDoc}`;
export const CourseProgramStepItemFragmentDoc = gql`
    fragment CourseProgramStepItem on CourseProgramStepItem {
  id
  program {
    id
    icon
    thumbnail
    title
    description
    questionCount
    answerCount
    chapterCount
    requireTime
    studyLogCount(userID: $userID)
    programElements {
      ...ProgramElementForCourseProgramStepItem
    }
    completedTime
    currentProgramElement {
      ...ProgramElementForCourseProgramStepItem
    }
  }
}
    ${ProgramElementForCourseProgramStepItemFragmentDoc}`;
export const CourseProgramDetailFragmentDoc = gql`
    fragment CourseProgramDetail on CourseProgram {
  id
  title
  image
  content
  description
  overview
  totalChapterCount
  totalCompletedChapterCount
  totalRequireTime
  totalCompletedTime
  courseProgramUserData {
    createdAt
    isStarted
  }
  courseProgramSteps {
    id
    title
    description
    number
    courseProgramStepItems {
      ...CourseProgramStepItem
    }
  }
}
    ${CourseProgramStepItemFragmentDoc}`;
export const CourseProgramTagFragmentDoc = gql`
    fragment CourseProgramTag on Tag {
  id
  name
}
    `;
export const CourseProgramFragmentDoc = gql`
    fragment CourseProgram on CourseProgram {
  id
  title
  image
  content
  description
  overview
  totalChapterCount
  totalCompletedChapterCount
  totalRequireTime
  totalCompletedTime
  courseProgramUserData {
    createdAt
    isStarted
  }
  tags {
    ...CourseProgramTag
  }
}
    ${CourseProgramTagFragmentDoc}`;
export const ProgramTagFragmentDoc = gql`
    fragment ProgramTag on Tag {
  id
  name
}
    `;
export const PracticeFragmentDoc = gql`
    fragment Practice on Practice {
  id
  programID
  key
  program {
    id
    icon
    title
    category
    tags {
      ...ProgramTag
    }
  }
  title
  description
  requireTime
  content
  answer
  type
  submitPassedCount
  mySubmit {
    id
    practiceSubmitDetails {
      id
      reviewStatus
    }
  }
  isAiReviewEnabled
  isSubmittable
  difficulty
  status
  createdAt
  updatedAt
}
    ${ProgramTagFragmentDoc}`;
export const ExamScoreFragmentDoc = gql`
    fragment ExamScore on ExamScore {
  score
  medalType
}
    `;
export const StudyLogFragmentDoc = gql`
    fragment StudyLog on StudyLog {
  id
  chapterID
  understandingLevel
}
    `;
export const ExamQuestionFragmentDoc = gql`
    fragment ExamQuestion on ExamQuestion {
  id
  content
  commentary
  examAnswers {
    id
    content
    isCorrect
  }
}
    `;
export const ChapterFragmentDoc = gql`
    fragment Chapter on Chapter {
  content
  createdAt
  description
  id
  key
  number
  requireTime
  status
  title
  type
  updatedAt
  programElement {
    programID
    program {
      title
      tags {
        ...ProgramTag
      }
    }
  }
  examScores {
    ...ExamScore
  }
  studyLog {
    ...StudyLog
  }
  examQuestions {
    ...ExamQuestion
  }
}
    ${ProgramTagFragmentDoc}
${ExamScoreFragmentDoc}
${StudyLogFragmentDoc}
${ExamQuestionFragmentDoc}`;
export const QuestionUserFragmentDoc = gql`
    fragment QuestionUser on User {
  id
  nickName
  image
  isStudent
  isInstructor
  isAdmin
  snsType
  isAI
}
    `;
export const QuestionCommentFragmentDoc = gql`
    fragment QuestionComment on QuestionComment {
  id
  user {
    ...QuestionUser
  }
  content
  status
  createdAt
  updatedAt
}
    ${QuestionUserFragmentDoc}`;
export const QuestionAnswerFragmentDoc = gql`
    fragment QuestionAnswer on QuestionAnswer {
  id
  user {
    ...QuestionUser
  }
  content
  answerType
  status
  questionComments {
    ...QuestionComment
  }
  questionAnswerFavorites {
    userID
  }
  createdAt
  updatedAt
}
    ${QuestionUserFragmentDoc}
${QuestionCommentFragmentDoc}`;
export const QuestionFragmentDoc = gql`
    fragment Question on Question {
  id
  title
  content
  solved
  editedAt
  answerCount
  answerRequestType
  status
  createdAt
  updatedAt
  questionAnswers {
    ...QuestionAnswer
  }
  questionFavorites {
    userID
  }
  user {
    ...QuestionUser
  }
  program {
    id
    title
  }
  chapter {
    id
    title
  }
  practice {
    id
    title
  }
  tags {
    id
    name
  }
}
    ${QuestionAnswerFragmentDoc}
${QuestionUserFragmentDoc}`;
export const StudyReportTagFragmentDoc = gql`
    fragment StudyReportTag on Tag {
  id
  name
  iconImage
  studyReportCount
}
    `;
export const ProgramSampleSimpleFragmentDoc = gql`
    fragment ProgramSampleSimple on ProgramSample {
  id
  title
  url
}
    `;
export const ChapterSearchFragmentDoc = gql`
    fragment ChapterSearch on Chapter {
  id
  title
  description
  number
  type
  examScores {
    ...ExamScore
  }
  studyLog {
    ...StudyLog
  }
}
    ${ExamScoreFragmentDoc}
${StudyLogFragmentDoc}`;
export const PracticeSearchFragmentDoc = gql`
    fragment PracticeSearch on Practice {
  id
  title
  description
  type
}
    `;
export const ProgramFragmentDoc = gql`
    fragment Program on Program {
  id
  icon
  thumbnail
  title
  description
  questionCount
  answerCount
  chapterCount
  requireTime
  studyLogCount(userID: $userID)
  repository
  programSample {
    ...ProgramSampleSimple
  }
  tags {
    ...ProgramTag
  }
  programElements {
    chapter {
      ...ChapterSearch
    }
    practice {
      ...PracticeSearch
    }
  }
  completedTime
}
    ${ProgramSampleSimpleFragmentDoc}
${ProgramTagFragmentDoc}
${ChapterSearchFragmentDoc}
${PracticeSearchFragmentDoc}`;
export const StudyReportDetailFragmentDoc = gql`
    fragment StudyReportDetail on StudyReportDetail {
  id
  tag {
    ...StudyReportTag
  }
  time
  program {
    ...Program
  }
  createdAt
  updatedAt
}
    ${StudyReportTagFragmentDoc}
${ProgramFragmentDoc}`;
export const StudyReportCommentFragmentDoc = gql`
    fragment StudyReportComment on StudyReportComment {
  id
  content
  studyReportID
  user {
    ...User
  }
  createdAt
  updatedAt
}
    ${UserFragmentDoc}`;
export const StudyReportFavoriteFragmentDoc = gql`
    fragment StudyReportFavorite on StudyReportFavorite {
  id
  studyReportID
  userID
}
    `;
export const StudyReportFragmentDoc = gql`
    fragment StudyReport on StudyReport {
  id
  user {
    ...User
  }
  date
  content
  studyReportDetails {
    ...StudyReportDetail
  }
  studyReportComments {
    ...StudyReportComment
  }
  studyReportFavorites {
    ...StudyReportFavorite
  }
  status
  createdAt
  updatedAt
}
    ${UserFragmentDoc}
${StudyReportDetailFragmentDoc}
${StudyReportCommentFragmentDoc}
${StudyReportFavoriteFragmentDoc}`;
export const TweetCommentFragmentDoc = gql`
    fragment TweetComment on TweetComment {
  tweetCommentID
  content
  createdAt
  user {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const TweetFavoriteFragmentDoc = gql`
    fragment TweetFavorite on TweetFavorite {
  id
  userID
}
    `;
export const TweetFragmentDoc = gql`
    fragment Tweet on Tweet {
  tweetID: id
  createdAt
  tweetDetail {
    content
    detailType
    user {
      ...User
    }
    tweetImages {
      id
      content
    }
    tweetComments {
      ...TweetComment
    }
    tweetFavorites {
      ...TweetFavorite
    }
  }
  tweetPostDestination
}
    ${UserFragmentDoc}
${TweetCommentFragmentDoc}
${TweetFavoriteFragmentDoc}`;
export const DocumentListFragmentDoc = gql`
    fragment DocumentList on Document {
  documentID
  type
  practice {
    ...Practice
  }
  chapter {
    ...Chapter
  }
  qa {
    ...Question
  }
  studyReport {
    ...StudyReport
  }
  tweet {
    ...Tweet
  }
}
    ${PracticeFragmentDoc}
${ChapterFragmentDoc}
${QuestionFragmentDoc}
${StudyReportFragmentDoc}
${TweetFragmentDoc}`;
export const AnswerResponseFragmentDoc = gql`
    fragment AnswerResponse on AnswerResponse {
  questionID
  answerID
  result
}
    `;
export const UploadFileFragmentDoc = gql`
    fragment UploadFile on UploadFilesResponse {
  code
  fileName
  s3FilePath
}
    `;
export const InstructorScheduleFragmentDoc = gql`
    fragment InstructorSchedule on InstructorSchedule {
  id
  startAt
  endAt
}
    `;
export const LessonsAssistanceFragmentDoc = gql`
    fragment LessonsAssistance on LessonsAssistance {
  id
  name
}
    `;
export const InstructorLessonFragmentDoc = gql`
    fragment InstructorLesson on Lesson {
  id
  startAt
  endAt
  taughtSkill
  title
  type
  homework
  prepare
  progress
  delayReason
  assistanceDetail
  lessonsAssistances {
    id
  }
  canceled
  completed
  course {
    id
    plannedLessonCount
    student {
      user {
        ...User
      }
    }
    plan {
      id
      lessonMinutes
    }
  }
}
    ${UserFragmentDoc}`;
export const StudentLessonFragmentDoc = gql`
    fragment StudentLesson on Lesson {
  id
  startAt
  endAt
  taughtSkill
  title
  type
  homework
  prepare
  progress
  delayReason
  assistanceDetail
  lessonsAssistances {
    id
  }
  canceled
  completed
  course {
    id
    plannedLessonCount
    plan {
      id
      lessonMinutes
      name
    }
    instructor {
      user {
        ...User
      }
    }
  }
}
    ${UserFragmentDoc}`;
export const MailSettingFragmentDoc = gql`
    fragment MailSetting on MailSetting {
  messageReceived
  lessonRegistered
  lessonRemind
  lessonUnregistered
  lessonScheduleUpdated
  practiceSubmitRegistered
  practiceSubmitReRegistered
  practiceSubmitDetailReviewCommentRegistered
  questionRegistered
  questionAnswerRegistered
  questionCommentRegistered
  claimApplied
  backSchool
  attendanceStatusChanged
  notice
  lessonLogUnregistered
  studyReportCommentRegistered
  studyReportAchieved
  spotLessonRegistered
  spotLessonRemind
  spotLessonCancel
  spotLessonLogUnregistered
  ticketRemind
  sessionRemind
}
    `;
export const ModalFragmentDoc = gql`
    fragment Modal on Modal {
  id
  isRead
}
    `;
export const NoticeFragmentDoc = gql`
    fragment Notice on Notice {
  id
  title
  content
  createdAt
  noticeRead {
    noticeID
  }
}
    `;
export const NotificationQuestionFragmentDoc = gql`
    fragment NotificationQuestion on Question {
  id
  title
}
    `;
export const NotificationLessonFragmentDoc = gql`
    fragment NotificationLesson on Lesson {
  id
  title
  startAt
  endAt
}
    `;
export const NotificationCourseFragmentDoc = gql`
    fragment NotificationCourse on Course {
  id
  plan {
    name
  }
  student {
    user {
      nickName
    }
  }
  instructor {
    user {
      nickName
    }
  }
}
    `;
export const NotificationSpotLessonFragmentDoc = gql`
    fragment NotificationSpotLesson on SpotLesson {
  id
  categories {
    name
  }
  startAt
  endAt
}
    `;
export const NotificationSessionFragmentDoc = gql`
    fragment NotificationSession on Session {
  id
  title
  startAt
  endAt
}
    `;
export const NotificationPracticeSubmitFragmentDoc = gql`
    fragment NotificationPracticeSubmit on PracticeSubmit {
  id
  practice {
    title
  }
}
    `;
export const NotificationFragmentDoc = gql`
    fragment Notification on Notification {
  id
  type
  notificationReadStatus
  notificationStatus
  createdAt
  user {
    id
    nickName
  }
  notificationDetail {
    title
    actor {
      ...User
    }
    question {
      ...NotificationQuestion
    }
    lesson {
      ...NotificationLesson
    }
    course {
      ...NotificationCourse
    }
    studyReport {
      id
    }
    spotLesson {
      ...NotificationSpotLesson
    }
    session {
      ...NotificationSession
    }
    practiceSubmit {
      ...NotificationPracticeSubmit
    }
  }
}
    ${UserFragmentDoc}
${NotificationQuestionFragmentDoc}
${NotificationLessonFragmentDoc}
${NotificationCourseFragmentDoc}
${NotificationSpotLessonFragmentDoc}
${NotificationSessionFragmentDoc}
${NotificationPracticeSubmitFragmentDoc}`;
export const PaymentIntentFragmentDoc = gql`
    fragment PaymentIntent on PaymentIntent {
  id
  amountPaid
  createdAt
  charges {
    receiptURL
  }
  paymentIntentPurchaseItems {
    quantity
    purchaseItem {
      name
    }
  }
}
    `;
export const PracticeListItemFragmentDoc = gql`
    fragment PracticeListItem on PracticeListItem {
  id
  programID
  key
  program {
    id
    icon
    title
    category
    tags {
      ...ProgramTag
    }
  }
  title
  description
  requireTime
  type
  submitPassedCount
  mySubmit {
    id
    practiceSubmitDetails {
      id
      reviewStatus
    }
  }
  difficulty
  status
  createdAt
  updatedAt
}
    ${ProgramTagFragmentDoc}`;
export const ProgramDetailFragmentDoc = gql`
    fragment ProgramDetail on Program {
  ...Program
  summary
  summaryImage1
  summaryImage2
  summaryImage3
  summaryImage4
  summaryImage5
  category
  programElements {
    chapter {
      ...Chapter
    }
    practice {
      ...Practice
    }
  }
}
    ${ProgramFragmentDoc}
${ChapterFragmentDoc}
${PracticeFragmentDoc}`;
export const PracticeDetailFragmentDoc = gql`
    fragment PracticeDetail on Practice {
  id
  programID
  program {
    ...ProgramDetail
  }
  title
  description
  requireTime
  content
  answer
  type
  submitPassedCount
  mySubmit {
    id
    practiceSubmitDetails {
      id
      reviewStatus
    }
  }
  isAiReviewEnabled
  isSubmittable
  difficulty
  status
  createdAt
  updatedAt
}
    ${ProgramDetailFragmentDoc}`;
export const PracticeSubmitListFragmentDoc = gql`
    fragment PracticeSubmitList on PracticeSubmitSearch {
  id
  practice {
    id
    title
    type
    program {
      id
      title
    }
  }
  user {
    ...User
  }
  latestPracticeSubmitDetailID
  latestPracticeSubmitDetailEditedAt
  reviewStatus
  reviewedCount
  isViewable
  createdAt
  updatedAt
}
    ${UserFragmentDoc}`;
export const PracticeSubmitDetailReviewCommentFragmentDoc = gql`
    fragment PracticeSubmitDetailReviewComment on PracticeSubmitDetailReviewComment {
  id
  practiceSubmitDetailID
  userID
  user {
    ...User
  }
  content
  createdAt
  updatedAt
}
    ${UserFragmentDoc}`;
export const PracticeSubmitDetailFragmentDoc = gql`
    fragment PracticeSubmitDetail on PracticeSubmitDetail {
  id
  practiceSubmitID
  url
  content
  reviewStatus
  editedAt
  createdAt
  updatedAt
  practiceSubmitDetailReviewComment {
    ...PracticeSubmitDetailReviewComment
  }
}
    ${PracticeSubmitDetailReviewCommentFragmentDoc}`;
export const PracticeSubmitFragmentDoc = gql`
    fragment PracticeSubmit on PracticeSubmit {
  id
  practice {
    ...Practice
  }
  user {
    ...User
  }
  isInstructorReviewRequested
  createdAt
  updatedAt
  practiceSubmitDetails {
    ...PracticeSubmitDetail
  }
}
    ${PracticeFragmentDoc}
${UserFragmentDoc}
${PracticeSubmitDetailFragmentDoc}`;
export const InstructorPracticeSubmitFragmentDoc = gql`
    fragment InstructorPracticeSubmit on InstructorPracticeSubmit {
  id
  practice {
    ...Practice
  }
  user {
    ...User
  }
  createdAt
  updatedAt
  withoutDraftPracticeSubmitDetails {
    ...PracticeSubmitDetail
  }
}
    ${PracticeFragmentDoc}
${UserFragmentDoc}
${PracticeSubmitDetailFragmentDoc}`;
export const TeamPriceFragmentDoc = gql`
    fragment TeamPrice on Price {
  id
  recurringIntervalCount
  unitAmount
}
    `;
export const ProgramSearchFragmentDoc = gql`
    fragment ProgramSearch on Program {
  id
  title
  description
  icon
  programElements {
    chapter {
      ...ChapterSearch
    }
    practice {
      ...PracticeSearch
    }
  }
}
    ${ChapterSearchFragmentDoc}
${PracticeSearchFragmentDoc}`;
export const ProgramSampleFragmentDoc = gql`
    fragment ProgramSample on ProgramSample {
  id
  title
  description
  thumbnail
  url
  program {
    ...ProgramSearchSimple
  }
}
    ${ProgramSearchSimpleFragmentDoc}`;
export const ProgramSatisfactionFragmentDoc = gql`
    fragment ProgramSatisfaction on ProgramSatisfaction {
  userID
  programID
  level
  comment
  createdAt
}
    `;
export const ProgramForProgramSatisfactionFragmentDoc = gql`
    fragment ProgramForProgramSatisfaction on Program {
  id
  title
  programElements {
    chapter {
      ...Chapter
    }
    practice {
      ...Practice
    }
  }
}
    ${ChapterFragmentDoc}
${PracticeFragmentDoc}`;
export const PromotionCodeApplyResultFragmentDoc = gql`
    fragment PromotionCodeApplyResult on PromotionCodeApplyResult {
  isValid
  amountOff
  percentOff
  price
  appliedPrice
  pvdDuration
  pvdDurationInMonths
}
    `;
export const QuestionListFragmentDoc = gql`
    fragment QuestionList on Question {
  id
  title
  content
  solved
  editedAt
  answerCount
  answerRequestType
  status
  createdAt
  updatedAt
  user {
    ...User
  }
  program {
    id
    title
  }
  chapter {
    id
    title
  }
  tags {
    id
    name
  }
}
    ${UserFragmentDoc}`;
export const SessionInstrForInstructorFragmentDoc = gql`
    fragment SessionInstrForInstructor on Session {
  id
  title
  coaching {
    id
    course {
      id
      student {
        user {
          ...User
        }
      }
    }
  }
  assignedCoach {
    id
    user {
      ...User
    }
  }
  startAt
  endAt
  phase
  status
  createdAt
  updatedAt
}
    ${UserFragmentDoc}`;
export const SessionListFragmentDoc = gql`
    fragment SessionList on Session {
  id
  title
  startAt
  endAt
  phase
  coaching {
    id
    course {
      student {
        user {
          ...User
        }
      }
    }
  }
}
    ${UserFragmentDoc}`;
export const SessionListForInstructorFragmentDoc = gql`
    fragment SessionListForInstructor on Session {
  id
  title
  startAt
  endAt
  phase
  coaching {
    id
    course {
      student {
        user {
          ...User
        }
      }
    }
  }
}
    ${UserFragmentDoc}`;
export const SessionListForStudentFragmentDoc = gql`
    fragment SessionListForStudent on Session {
  id
  title
  startAt
  endAt
  phase
  coaching {
    id
    course {
      plan {
        name
      }
    }
    coach {
      user {
        ...User
      }
    }
  }
}
    ${UserFragmentDoc}`;
export const SessionReportPreparationFragmentDoc = gql`
    fragment SessionReportPreparation on SessionReportPreparation {
  id
  sessionReportID
  type
}
    `;
export const SessionReportAnnouncementFragmentDoc = gql`
    fragment SessionReportAnnouncement on SessionReportAnnouncement {
  id
  sessionReportID
  type
}
    `;
export const SessionReportForInstructorFragmentDoc = gql`
    fragment SessionReportForInstructor on SessionReport {
  id
  sessionID
  content
  hasPreparations
  preparations {
    ...SessionReportPreparation
  }
  preparationOthers
  isOnSchedule
  delayReason
  hasAnnouncements
  announcements {
    ...SessionReportAnnouncement
  }
  hasAnnouncementsDetail
  responseDeadline
  coachingMemo
}
    ${SessionReportPreparationFragmentDoc}
${SessionReportAnnouncementFragmentDoc}`;
export const SpotLessonFragmentDoc = gql`
    fragment SpotLesson on SpotLesson {
  id
  troubleContent
  researchContent
  startAt
  endAt
  phase
  tags {
    id
    name
  }
  categories {
    id
    name
  }
  zoomURL
  instructorUser {
    ...User
  }
  user {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const TimeBlockFragmentDoc = gql`
    fragment TimeBlock on SpotLessonTimeBlock {
  duration
  disable
  slotCount
  reservationCount
  startAt
}
    `;
export const SpotLessonCalendarFragmentDoc = gql`
    fragment SpotLessonCalendar on SpotLessonCalendar {
  date
  timeBlocks {
    ...TimeBlock
  }
}
    ${TimeBlockFragmentDoc}`;
export const PricePermissionFragmentDoc = gql`
    fragment PricePermission on PricePermission {
  program
  studyLog
  question
  practice
  submitPractice
}
    `;
export const StripeStoredSubscriptionFragmentDoc = gql`
    fragment StripeStoredSubscription on StripeStoredSubscription {
  id
  currentPeriodStart
  currentPeriodEnd
  collectionMethod
  latestInvoice
  status
  cancelAtPeriodEnd
}
    `;
export const StripeSubscriptionFragmentDoc = gql`
    fragment StripeSubscription on StripeSubscription {
  id
  providerQuantity
  providerStatus
  price {
    id
    unitAmount
    isSingleMonthContract
    isMultiMonthContract
    numberOfTickets
    product {
      id
      name
    }
    pricePermission {
      ...PricePermission
    }
  }
  stripeSubscriptionResponse {
    ...StripeStoredSubscription
  }
}
    ${PricePermissionFragmentDoc}
${StripeStoredSubscriptionFragmentDoc}`;
export const StripeInvoiceFragmentDoc = gql`
    fragment StripeInvoice on StripeInvoice {
  id
  periodEnd
  periodStart
  total
  invoicePDF
  created
  status
  stripeInvoiceLines {
    price {
      productDetail {
        id
        name
      }
    }
    periodEnd
    periodStart
  }
}
    `;
export const StripePaymentMethodFragmentDoc = gql`
    fragment StripePaymentMethod on StripePaymentMethod {
  id
  cardNumber
  cardBrand
  expireMonth
  expireYear
  isDefault
}
    `;
export const StudyFavoriteSummaryFragmentDoc = gql`
    fragment StudyFavoriteSummary on StudyFavoriteSummary {
  user {
    ...User
  }
  studyFavoriteCount
  studyFavoriteCountWeek
  studyFavoriteCountMonth
}
    ${UserFragmentDoc}`;
export const StudySummaryListFragmentDoc = gql`
    fragment StudySummaryList on StudySummary {
  id
  studyReportTime
  studyReportCount
  studyReportTimeMonth
  studyReportTimeWeek
  studyReportRunningLayDays
  user {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const StudyTagSummaryListFragmentDoc = gql`
    fragment StudyTagSummaryList on StudyTagSummary {
  studyReportTime
  studyReportTimeMonth
  studyReportTimeWeek
  tag {
    id
    name
    iconImage
  }
}
    `;
export const ScheduledSubscriptionContractFragmentDoc = gql`
    fragment ScheduledSubscriptionContract on ScheduledSubscriptionContract {
  startDate
  endDate
  product {
    name
  }
  quantity
}
    `;
export const SubscriptionContractFragmentDoc = gql`
    fragment SubscriptionContract on SubscriptionContract {
  id
  canceledAt
  periodStart
  periodEnd
}
    `;
export const SubscriptionContractForListFragmentDoc = gql`
    fragment SubscriptionContractForList on SubscriptionContract {
  id
  canceledAt
  periodStart
  periodEnd
  endDate
  price {
    product {
      name
    }
  }
}
    `;
export const SubscriptionCancellationPeriodFragmentDoc = gql`
    fragment SubscriptionCancellationPeriod on SubscriptionCancellationPeriod {
  startDate
  endDate
}
    `;
export const TagFragmentDoc = gql`
    fragment Tag on Tag {
  id
  name
  iconImage
  questionCount
  studyReportCount
  overview
}
    `;
export const TeamFragmentDoc = gql`
    fragment Team on Team {
  image
  companyName
  adminEmail
}
    `;
export const MyTeamMemberFragmentDoc = gql`
    fragment MyTeamMember on TeamMember {
  id
  teamID
  role
  team {
    companyName
    image
    status
  }
}
    `;
export const TeamMemberListFragmentDoc = gql`
    fragment TeamMemberList on TeamMember {
  id
  role
  user {
    id
    nickName
    image
    completedPrograms {
      id
    }
    totalLessonCount {
      id
    }
    studySummary {
      studyReportTime
      studyReportCount
    }
    maskedPersonalInfo {
      name
    }
  }
}
    `;
export const TicketFragmentDoc = gql`
    fragment Ticket on Ticket {
  id
  expireAt
}
    `;
export const TimelineStudyReportFragmentDoc = gql`
    fragment TimelineStudyReport on StudyReport {
  studyReportID: id
  date
  content
  createdAt
  user {
    ...User
  }
  studyReportDetails {
    time
    tag {
      id
      iconImage
      name
    }
    program {
      id
      title
      thumbnail
      icon
      repository
    }
  }
  studyReportComments {
    id
    content
    createdAt
    user {
      ...User
    }
  }
  studyReportFavorites {
    id
    userID
  }
}
    ${UserFragmentDoc}`;
export const UserPageLayoutFragmentDoc = gql`
    fragment UserPageLayout on User {
  id
  nickName
  isInstructor
}
    `;
export const StudyCalendarFragmentDoc = gql`
    fragment StudyCalendar on StudyCalendar {
  id
  date
  studyReportTime
}
    `;
export const StudyTagSummaryFragmentDoc = gql`
    fragment StudyTagSummary on StudyTagSummary {
  id
  studyReportTime
  studyReportTimeMonth
  studyReportTimeWeek
  tag {
    id
    name
    iconImage
    status
  }
}
    `;
export const UserProfileFragmentDoc = gql`
    fragment UserProfile on User {
  id
  nickName
  isInstructor
  isStudent
  image
  profile
  objective
  tags {
    id
    name
  }
  userTags {
    id
    term
    tag {
      id
      name
    }
  }
  studySummary {
    ...StudySummary
  }
  monthlyStudyCalendars {
    ...StudyCalendar
  }
  studyTagSummaries {
    ...StudyTagSummary
  }
  completedPrograms {
    id
  }
  whileStudyingPrograms {
    id
  }
  totalLessonCount {
    id
  }
  questions {
    id
  }
}
    ${StudySummaryFragmentDoc}
${StudyCalendarFragmentDoc}
${StudyTagSummaryFragmentDoc}`;
export const UserProgramFragmentDoc = gql`
    fragment UserProgram on Program {
  id
  icon
  thumbnail
  title
  description
  questionCount
  answerCount
  chapterCount
  requireTime
  studyLogCount(userID: $id)
  tags {
    ...ProgramTag
  }
  completedTime(userID: $id)
}
    ${ProgramTagFragmentDoc}`;
export const IconUserFragmentDoc = gql`
    fragment IconUser on User {
  id
  image
  isAI
  isAdmin
  isInstructor
  isStudent
  instructor {
    isCoach
  }
  maskedPersonalInfo {
    name
  }
  nickName
  snsType
}
    `;
export const CurrentUserFragmentDoc = gql`
    fragment CurrentUser on User {
  id
  snsType
  status
  isAdmin
  isInstructor
  profile
  objective
  nickName
  createdAt
  tags {
    id
    name
  }
  userTags {
    id
    term
    tag {
      id
      name
    }
  }
  instructor {
    id
    isCoach
  }
  isStudent
  image
  personalInfo {
    name
    email
    sex
  }
  student {
    id
    status
    courses {
      coaching {
        id
      }
    }
  }
  maskedPersonalInfo {
    name
  }
}
    `;
export const ContractOfStripeSubscriptionForAnalyticsFragmentDoc = gql`
    fragment ContractOfStripeSubscriptionForAnalytics on ContractOfStripeSubscriptionForAnalytics {
  contractDetailForAnalytics {
    productID
    productName
    periodStart
    periodEnd
    canceledAt
  }
  stripeCustomerType
}
    `;
export const CurrentPermissionListFragmentDoc = gql`
    fragment CurrentPermissionList on PermissionList {
  roles
  teamIDs
  teamIDsForTeamAdmin
}
    `;
export const CurrentUserWithPermissionListFragmentDoc = gql`
    fragment CurrentUserWithPermissionList on UserWithPermissionList {
  user {
    ...CurrentUser
  }
  contractsOfStripeSubscriptionForAnalytics {
    ...ContractOfStripeSubscriptionForAnalytics
  }
  permissionList {
    ...CurrentPermissionList
  }
}
    ${CurrentUserFragmentDoc}
${ContractOfStripeSubscriptionForAnalyticsFragmentDoc}
${CurrentPermissionListFragmentDoc}`;
export const GetAbTestDeliveriesDocument = gql`
    query getAbTestDeliveries {
  abTestDeliveries {
    ...AbTestDelivery
  }
}
    ${AbTestDeliveryFragmentDoc}`;

/**
 * __useGetAbTestDeliveriesQuery__
 *
 * To run a query within a React component, call `useGetAbTestDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAbTestDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAbTestDeliveriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAbTestDeliveriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAbTestDeliveriesQuery, GetAbTestDeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAbTestDeliveriesQuery, GetAbTestDeliveriesQueryVariables>(GetAbTestDeliveriesDocument, options);
      }
export function useGetAbTestDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAbTestDeliveriesQuery, GetAbTestDeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAbTestDeliveriesQuery, GetAbTestDeliveriesQueryVariables>(GetAbTestDeliveriesDocument, options);
        }
export function useGetAbTestDeliveriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAbTestDeliveriesQuery, GetAbTestDeliveriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAbTestDeliveriesQuery, GetAbTestDeliveriesQueryVariables>(GetAbTestDeliveriesDocument, options);
        }
export type GetAbTestDeliveriesQueryHookResult = ReturnType<typeof useGetAbTestDeliveriesQuery>;
export type GetAbTestDeliveriesLazyQueryHookResult = ReturnType<typeof useGetAbTestDeliveriesLazyQuery>;
export type GetAbTestDeliveriesSuspenseQueryHookResult = ReturnType<typeof useGetAbTestDeliveriesSuspenseQuery>;
export type GetAbTestDeliveriesQueryResult = Apollo.QueryResult<GetAbTestDeliveriesQuery, GetAbTestDeliveriesQueryVariables>;
export const GetBannerCidsDocument = gql`
    query getBannerCids($targetType: BannerTargetType!, $cidTypes: [BannerCidType!]!, $limit: Uint64!) {
  bannerCids(input: {targetType: $targetType, cidTypes: $cidTypes, limit: $limit}) {
    ...BannerCid
  }
}
    ${BannerCidFragmentDoc}`;

/**
 * __useGetBannerCidsQuery__
 *
 * To run a query within a React component, call `useGetBannerCidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBannerCidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBannerCidsQuery({
 *   variables: {
 *      targetType: // value for 'targetType'
 *      cidTypes: // value for 'cidTypes'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBannerCidsQuery(baseOptions: Apollo.QueryHookOptions<GetBannerCidsQuery, GetBannerCidsQueryVariables> & ({ variables: GetBannerCidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBannerCidsQuery, GetBannerCidsQueryVariables>(GetBannerCidsDocument, options);
      }
export function useGetBannerCidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBannerCidsQuery, GetBannerCidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBannerCidsQuery, GetBannerCidsQueryVariables>(GetBannerCidsDocument, options);
        }
export function useGetBannerCidsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBannerCidsQuery, GetBannerCidsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBannerCidsQuery, GetBannerCidsQueryVariables>(GetBannerCidsDocument, options);
        }
export type GetBannerCidsQueryHookResult = ReturnType<typeof useGetBannerCidsQuery>;
export type GetBannerCidsLazyQueryHookResult = ReturnType<typeof useGetBannerCidsLazyQuery>;
export type GetBannerCidsSuspenseQueryHookResult = ReturnType<typeof useGetBannerCidsSuspenseQuery>;
export type GetBannerCidsQueryResult = Apollo.QueryResult<GetBannerCidsQuery, GetBannerCidsQueryVariables>;
export const GetCampaignDocument = gql`
    query getCampaign {
  getCampaign {
    ...Campaign
  }
}
    ${CampaignFragmentDoc}`;

/**
 * __useGetCampaignQuery__
 *
 * To run a query within a React component, call `useGetCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCampaignQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument, options);
      }
export function useGetCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument, options);
        }
export function useGetCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument, options);
        }
export type GetCampaignQueryHookResult = ReturnType<typeof useGetCampaignQuery>;
export type GetCampaignLazyQueryHookResult = ReturnType<typeof useGetCampaignLazyQuery>;
export type GetCampaignSuspenseQueryHookResult = ReturnType<typeof useGetCampaignSuspenseQuery>;
export type GetCampaignQueryResult = Apollo.QueryResult<GetCampaignQuery, GetCampaignQueryVariables>;
export const GetCategoriesDocument = gql`
    query getCategories {
  categories {
    ...Category
  }
}
    ${CategoryFragmentDoc}`;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetChapterDocument = gql`
    query getChapter($chapterID: Uint64!, $includeExam: Boolean!) {
  chapter(chapterID: $chapterID) {
    ...Chapter
  }
  programExam(chapterID: $chapterID) @include(if: $includeExam) {
    ...ExamQuestion
  }
}
    ${ChapterFragmentDoc}
${ExamQuestionFragmentDoc}`;

/**
 * __useGetChapterQuery__
 *
 * To run a query within a React component, call `useGetChapterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChapterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChapterQuery({
 *   variables: {
 *      chapterID: // value for 'chapterID'
 *      includeExam: // value for 'includeExam'
 *   },
 * });
 */
export function useGetChapterQuery(baseOptions: Apollo.QueryHookOptions<GetChapterQuery, GetChapterQueryVariables> & ({ variables: GetChapterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChapterQuery, GetChapterQueryVariables>(GetChapterDocument, options);
      }
export function useGetChapterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChapterQuery, GetChapterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChapterQuery, GetChapterQueryVariables>(GetChapterDocument, options);
        }
export function useGetChapterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChapterQuery, GetChapterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChapterQuery, GetChapterQueryVariables>(GetChapterDocument, options);
        }
export type GetChapterQueryHookResult = ReturnType<typeof useGetChapterQuery>;
export type GetChapterLazyQueryHookResult = ReturnType<typeof useGetChapterLazyQuery>;
export type GetChapterSuspenseQueryHookResult = ReturnType<typeof useGetChapterSuspenseQuery>;
export type GetChapterQueryResult = Apollo.QueryResult<GetChapterQuery, GetChapterQueryVariables>;
export const GetChatMessagesDocument = gql`
    query getChatMessages($chatRoomID: Uint64!, $first: Int!, $after: String) {
  chatMessages(chatRoomID: $chatRoomID, first: $first, after: $after) {
    edges {
      ...ChatMessageEdge
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${ChatMessageEdgeFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetChatMessagesQuery__
 *
 * To run a query within a React component, call `useGetChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatMessagesQuery({
 *   variables: {
 *      chatRoomID: // value for 'chatRoomID'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetChatMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables> & ({ variables: GetChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(GetChatMessagesDocument, options);
      }
export function useGetChatMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(GetChatMessagesDocument, options);
        }
export function useGetChatMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(GetChatMessagesDocument, options);
        }
export type GetChatMessagesQueryHookResult = ReturnType<typeof useGetChatMessagesQuery>;
export type GetChatMessagesLazyQueryHookResult = ReturnType<typeof useGetChatMessagesLazyQuery>;
export type GetChatMessagesSuspenseQueryHookResult = ReturnType<typeof useGetChatMessagesSuspenseQuery>;
export type GetChatMessagesQueryResult = Apollo.QueryResult<GetChatMessagesQuery, GetChatMessagesQueryVariables>;
export const GetChatMessageUnreadCountDocument = gql`
    query getChatMessageUnreadCount($chatRoomID: Uint64) {
  chatMessageUnreadCount(chatRoomID: $chatRoomID)
}
    `;

/**
 * __useGetChatMessageUnreadCountQuery__
 *
 * To run a query within a React component, call `useGetChatMessageUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatMessageUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatMessageUnreadCountQuery({
 *   variables: {
 *      chatRoomID: // value for 'chatRoomID'
 *   },
 * });
 */
export function useGetChatMessageUnreadCountQuery(baseOptions?: Apollo.QueryHookOptions<GetChatMessageUnreadCountQuery, GetChatMessageUnreadCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatMessageUnreadCountQuery, GetChatMessageUnreadCountQueryVariables>(GetChatMessageUnreadCountDocument, options);
      }
export function useGetChatMessageUnreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatMessageUnreadCountQuery, GetChatMessageUnreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatMessageUnreadCountQuery, GetChatMessageUnreadCountQueryVariables>(GetChatMessageUnreadCountDocument, options);
        }
export function useGetChatMessageUnreadCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatMessageUnreadCountQuery, GetChatMessageUnreadCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatMessageUnreadCountQuery, GetChatMessageUnreadCountQueryVariables>(GetChatMessageUnreadCountDocument, options);
        }
export type GetChatMessageUnreadCountQueryHookResult = ReturnType<typeof useGetChatMessageUnreadCountQuery>;
export type GetChatMessageUnreadCountLazyQueryHookResult = ReturnType<typeof useGetChatMessageUnreadCountLazyQuery>;
export type GetChatMessageUnreadCountSuspenseQueryHookResult = ReturnType<typeof useGetChatMessageUnreadCountSuspenseQuery>;
export type GetChatMessageUnreadCountQueryResult = Apollo.QueryResult<GetChatMessageUnreadCountQuery, GetChatMessageUnreadCountQueryVariables>;
export const ReadAllChatMessageDocument = gql`
    mutation readAllChatMessage($chatRoomID: Uint64!) {
  readAllChatMessage(chatRoomID: $chatRoomID) {
    chatRoomID
    result
  }
}
    `;
export type ReadAllChatMessageMutationFn = Apollo.MutationFunction<ReadAllChatMessageMutation, ReadAllChatMessageMutationVariables>;

/**
 * __useReadAllChatMessageMutation__
 *
 * To run a mutation, you first call `useReadAllChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllChatMessageMutation, { data, loading, error }] = useReadAllChatMessageMutation({
 *   variables: {
 *      chatRoomID: // value for 'chatRoomID'
 *   },
 * });
 */
export function useReadAllChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<ReadAllChatMessageMutation, ReadAllChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadAllChatMessageMutation, ReadAllChatMessageMutationVariables>(ReadAllChatMessageDocument, options);
      }
export type ReadAllChatMessageMutationHookResult = ReturnType<typeof useReadAllChatMessageMutation>;
export type ReadAllChatMessageMutationResult = Apollo.MutationResult<ReadAllChatMessageMutation>;
export type ReadAllChatMessageMutationOptions = Apollo.BaseMutationOptions<ReadAllChatMessageMutation, ReadAllChatMessageMutationVariables>;
export const CreateChatMessageDocument = gql`
    mutation createChatMessage($input: ChatMessageCreateInput!) {
  createChatMessage(input: $input) {
    ...ChatMessageList
  }
}
    ${ChatMessageListFragmentDoc}`;
export type CreateChatMessageMutationFn = Apollo.MutationFunction<CreateChatMessageMutation, CreateChatMessageMutationVariables>;

/**
 * __useCreateChatMessageMutation__
 *
 * To run a mutation, you first call `useCreateChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatMessageMutation, { data, loading, error }] = useCreateChatMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatMessageMutation, CreateChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatMessageMutation, CreateChatMessageMutationVariables>(CreateChatMessageDocument, options);
      }
export type CreateChatMessageMutationHookResult = ReturnType<typeof useCreateChatMessageMutation>;
export type CreateChatMessageMutationResult = Apollo.MutationResult<CreateChatMessageMutation>;
export type CreateChatMessageMutationOptions = Apollo.BaseMutationOptions<CreateChatMessageMutation, CreateChatMessageMutationVariables>;
export const UpdateChatMessageDocument = gql`
    mutation updateChatMessage($id: Uint64!, $input: ChatMessageUpdateInput!) {
  updateChatMessage(id: $id, input: $input) {
    ...ChatMessageList
  }
}
    ${ChatMessageListFragmentDoc}`;
export type UpdateChatMessageMutationFn = Apollo.MutationFunction<UpdateChatMessageMutation, UpdateChatMessageMutationVariables>;

/**
 * __useUpdateChatMessageMutation__
 *
 * To run a mutation, you first call `useUpdateChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatMessageMutation, { data, loading, error }] = useUpdateChatMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChatMessageMutation, UpdateChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChatMessageMutation, UpdateChatMessageMutationVariables>(UpdateChatMessageDocument, options);
      }
export type UpdateChatMessageMutationHookResult = ReturnType<typeof useUpdateChatMessageMutation>;
export type UpdateChatMessageMutationResult = Apollo.MutationResult<UpdateChatMessageMutation>;
export type UpdateChatMessageMutationOptions = Apollo.BaseMutationOptions<UpdateChatMessageMutation, UpdateChatMessageMutationVariables>;
export const DeleteChatMessageDocument = gql`
    mutation deleteChatMessage($id: Uint64!) {
  deleteChatMessage(id: $id) {
    ...ChatMessageList
  }
}
    ${ChatMessageListFragmentDoc}`;
export type DeleteChatMessageMutationFn = Apollo.MutationFunction<DeleteChatMessageMutation, DeleteChatMessageMutationVariables>;

/**
 * __useDeleteChatMessageMutation__
 *
 * To run a mutation, you first call `useDeleteChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatMessageMutation, { data, loading, error }] = useDeleteChatMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChatMessageMutation, DeleteChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChatMessageMutation, DeleteChatMessageMutationVariables>(DeleteChatMessageDocument, options);
      }
export type DeleteChatMessageMutationHookResult = ReturnType<typeof useDeleteChatMessageMutation>;
export type DeleteChatMessageMutationResult = Apollo.MutationResult<DeleteChatMessageMutation>;
export type DeleteChatMessageMutationOptions = Apollo.BaseMutationOptions<DeleteChatMessageMutation, DeleteChatMessageMutationVariables>;
export const ChatMessagePostedDocument = gql`
    subscription chatMessagePosted($chatRoomID: Uint64!) {
  chatMessagePosted(chatRoomID: $chatRoomID) {
    ...ChatMessageList
  }
}
    ${ChatMessageListFragmentDoc}`;

/**
 * __useChatMessagePostedSubscription__
 *
 * To run a query within a React component, call `useChatMessagePostedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatMessagePostedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatMessagePostedSubscription({
 *   variables: {
 *      chatRoomID: // value for 'chatRoomID'
 *   },
 * });
 */
export function useChatMessagePostedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ChatMessagePostedSubscription, ChatMessagePostedSubscriptionVariables> & ({ variables: ChatMessagePostedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatMessagePostedSubscription, ChatMessagePostedSubscriptionVariables>(ChatMessagePostedDocument, options);
      }
export type ChatMessagePostedSubscriptionHookResult = ReturnType<typeof useChatMessagePostedSubscription>;
export type ChatMessagePostedSubscriptionResult = Apollo.SubscriptionResult<ChatMessagePostedSubscription>;
export const GetChatMessageDraftDocument = gql`
    query getChatMessageDraft($chatRoomID: Uint64!) {
  chatMessageDraft(chatRoomID: $chatRoomID) {
    ...ChatMessageDraft
  }
}
    ${ChatMessageDraftFragmentDoc}`;

/**
 * __useGetChatMessageDraftQuery__
 *
 * To run a query within a React component, call `useGetChatMessageDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatMessageDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatMessageDraftQuery({
 *   variables: {
 *      chatRoomID: // value for 'chatRoomID'
 *   },
 * });
 */
export function useGetChatMessageDraftQuery(baseOptions: Apollo.QueryHookOptions<GetChatMessageDraftQuery, GetChatMessageDraftQueryVariables> & ({ variables: GetChatMessageDraftQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatMessageDraftQuery, GetChatMessageDraftQueryVariables>(GetChatMessageDraftDocument, options);
      }
export function useGetChatMessageDraftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatMessageDraftQuery, GetChatMessageDraftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatMessageDraftQuery, GetChatMessageDraftQueryVariables>(GetChatMessageDraftDocument, options);
        }
export function useGetChatMessageDraftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatMessageDraftQuery, GetChatMessageDraftQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatMessageDraftQuery, GetChatMessageDraftQueryVariables>(GetChatMessageDraftDocument, options);
        }
export type GetChatMessageDraftQueryHookResult = ReturnType<typeof useGetChatMessageDraftQuery>;
export type GetChatMessageDraftLazyQueryHookResult = ReturnType<typeof useGetChatMessageDraftLazyQuery>;
export type GetChatMessageDraftSuspenseQueryHookResult = ReturnType<typeof useGetChatMessageDraftSuspenseQuery>;
export type GetChatMessageDraftQueryResult = Apollo.QueryResult<GetChatMessageDraftQuery, GetChatMessageDraftQueryVariables>;
export const UpsertChatMessageDraftDocument = gql`
    mutation upsertChatMessageDraft($chatRoomID: Uint64!, $content: String!) {
  upsertChatMessageDraft(chatRoomID: $chatRoomID, content: $content)
}
    `;
export type UpsertChatMessageDraftMutationFn = Apollo.MutationFunction<UpsertChatMessageDraftMutation, UpsertChatMessageDraftMutationVariables>;

/**
 * __useUpsertChatMessageDraftMutation__
 *
 * To run a mutation, you first call `useUpsertChatMessageDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertChatMessageDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertChatMessageDraftMutation, { data, loading, error }] = useUpsertChatMessageDraftMutation({
 *   variables: {
 *      chatRoomID: // value for 'chatRoomID'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpsertChatMessageDraftMutation(baseOptions?: Apollo.MutationHookOptions<UpsertChatMessageDraftMutation, UpsertChatMessageDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertChatMessageDraftMutation, UpsertChatMessageDraftMutationVariables>(UpsertChatMessageDraftDocument, options);
      }
export type UpsertChatMessageDraftMutationHookResult = ReturnType<typeof useUpsertChatMessageDraftMutation>;
export type UpsertChatMessageDraftMutationResult = Apollo.MutationResult<UpsertChatMessageDraftMutation>;
export type UpsertChatMessageDraftMutationOptions = Apollo.BaseMutationOptions<UpsertChatMessageDraftMutation, UpsertChatMessageDraftMutationVariables>;
export const DeleteChatMessageDraftDocument = gql`
    mutation deleteChatMessageDraft($chatRoomID: Uint64!) {
  deleteChatMessageDraft(chatRoomID: $chatRoomID)
}
    `;
export type DeleteChatMessageDraftMutationFn = Apollo.MutationFunction<DeleteChatMessageDraftMutation, DeleteChatMessageDraftMutationVariables>;

/**
 * __useDeleteChatMessageDraftMutation__
 *
 * To run a mutation, you first call `useDeleteChatMessageDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatMessageDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatMessageDraftMutation, { data, loading, error }] = useDeleteChatMessageDraftMutation({
 *   variables: {
 *      chatRoomID: // value for 'chatRoomID'
 *   },
 * });
 */
export function useDeleteChatMessageDraftMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChatMessageDraftMutation, DeleteChatMessageDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChatMessageDraftMutation, DeleteChatMessageDraftMutationVariables>(DeleteChatMessageDraftDocument, options);
      }
export type DeleteChatMessageDraftMutationHookResult = ReturnType<typeof useDeleteChatMessageDraftMutation>;
export type DeleteChatMessageDraftMutationResult = Apollo.MutationResult<DeleteChatMessageDraftMutation>;
export type DeleteChatMessageDraftMutationOptions = Apollo.BaseMutationOptions<DeleteChatMessageDraftMutation, DeleteChatMessageDraftMutationVariables>;
export const GetChatRoomsDocument = gql`
    query getChatRooms($first: Int!, $after: Time) {
  chatRooms(first: $first, after: $after) {
    items {
      ...ChatRoomList
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${ChatRoomListFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetChatRoomsQuery__
 *
 * To run a query within a React component, call `useGetChatRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatRoomsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetChatRoomsQuery(baseOptions: Apollo.QueryHookOptions<GetChatRoomsQuery, GetChatRoomsQueryVariables> & ({ variables: GetChatRoomsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatRoomsQuery, GetChatRoomsQueryVariables>(GetChatRoomsDocument, options);
      }
export function useGetChatRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatRoomsQuery, GetChatRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatRoomsQuery, GetChatRoomsQueryVariables>(GetChatRoomsDocument, options);
        }
export function useGetChatRoomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatRoomsQuery, GetChatRoomsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatRoomsQuery, GetChatRoomsQueryVariables>(GetChatRoomsDocument, options);
        }
export type GetChatRoomsQueryHookResult = ReturnType<typeof useGetChatRoomsQuery>;
export type GetChatRoomsLazyQueryHookResult = ReturnType<typeof useGetChatRoomsLazyQuery>;
export type GetChatRoomsSuspenseQueryHookResult = ReturnType<typeof useGetChatRoomsSuspenseQuery>;
export type GetChatRoomsQueryResult = Apollo.QueryResult<GetChatRoomsQuery, GetChatRoomsQueryVariables>;
export const ChatRoomContentChangedDocument = gql`
    subscription chatRoomContentChanged {
  chatRoomContentChanged {
    ...ChatRoomList
  }
}
    ${ChatRoomListFragmentDoc}`;

/**
 * __useChatRoomContentChangedSubscription__
 *
 * To run a query within a React component, call `useChatRoomContentChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatRoomContentChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatRoomContentChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useChatRoomContentChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ChatRoomContentChangedSubscription, ChatRoomContentChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatRoomContentChangedSubscription, ChatRoomContentChangedSubscriptionVariables>(ChatRoomContentChangedDocument, options);
      }
export type ChatRoomContentChangedSubscriptionHookResult = ReturnType<typeof useChatRoomContentChangedSubscription>;
export type ChatRoomContentChangedSubscriptionResult = Apollo.SubscriptionResult<ChatRoomContentChangedSubscription>;
export const GetClaimAndDetailsForInstructorDocument = gql`
    query getClaimAndDetailsForInstructor($yearMonth: Time!, $input: InstructorClaimDetailSearchInput) {
  claimForInstructor(yearMonth: $yearMonth) {
    ...Claim
  }
  claimDetailsForInstructor(yearMonth: $yearMonth, input: $input) {
    ...ClaimDetail
  }
}
    ${ClaimFragmentDoc}
${ClaimDetailFragmentDoc}`;

/**
 * __useGetClaimAndDetailsForInstructorQuery__
 *
 * To run a query within a React component, call `useGetClaimAndDetailsForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClaimAndDetailsForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClaimAndDetailsForInstructorQuery({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClaimAndDetailsForInstructorQuery(baseOptions: Apollo.QueryHookOptions<GetClaimAndDetailsForInstructorQuery, GetClaimAndDetailsForInstructorQueryVariables> & ({ variables: GetClaimAndDetailsForInstructorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClaimAndDetailsForInstructorQuery, GetClaimAndDetailsForInstructorQueryVariables>(GetClaimAndDetailsForInstructorDocument, options);
      }
export function useGetClaimAndDetailsForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClaimAndDetailsForInstructorQuery, GetClaimAndDetailsForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClaimAndDetailsForInstructorQuery, GetClaimAndDetailsForInstructorQueryVariables>(GetClaimAndDetailsForInstructorDocument, options);
        }
export function useGetClaimAndDetailsForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClaimAndDetailsForInstructorQuery, GetClaimAndDetailsForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClaimAndDetailsForInstructorQuery, GetClaimAndDetailsForInstructorQueryVariables>(GetClaimAndDetailsForInstructorDocument, options);
        }
export type GetClaimAndDetailsForInstructorQueryHookResult = ReturnType<typeof useGetClaimAndDetailsForInstructorQuery>;
export type GetClaimAndDetailsForInstructorLazyQueryHookResult = ReturnType<typeof useGetClaimAndDetailsForInstructorLazyQuery>;
export type GetClaimAndDetailsForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetClaimAndDetailsForInstructorSuspenseQuery>;
export type GetClaimAndDetailsForInstructorQueryResult = Apollo.QueryResult<GetClaimAndDetailsForInstructorQuery, GetClaimAndDetailsForInstructorQueryVariables>;
export const GetClaimCategoriesForInstructorDocument = gql`
    query getClaimCategoriesForInstructor {
  claimCategoriesForInstructor {
    ...ClaimCategory
  }
}
    ${ClaimCategoryFragmentDoc}`;

/**
 * __useGetClaimCategoriesForInstructorQuery__
 *
 * To run a query within a React component, call `useGetClaimCategoriesForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClaimCategoriesForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClaimCategoriesForInstructorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClaimCategoriesForInstructorQuery(baseOptions?: Apollo.QueryHookOptions<GetClaimCategoriesForInstructorQuery, GetClaimCategoriesForInstructorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClaimCategoriesForInstructorQuery, GetClaimCategoriesForInstructorQueryVariables>(GetClaimCategoriesForInstructorDocument, options);
      }
export function useGetClaimCategoriesForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClaimCategoriesForInstructorQuery, GetClaimCategoriesForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClaimCategoriesForInstructorQuery, GetClaimCategoriesForInstructorQueryVariables>(GetClaimCategoriesForInstructorDocument, options);
        }
export function useGetClaimCategoriesForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClaimCategoriesForInstructorQuery, GetClaimCategoriesForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClaimCategoriesForInstructorQuery, GetClaimCategoriesForInstructorQueryVariables>(GetClaimCategoriesForInstructorDocument, options);
        }
export type GetClaimCategoriesForInstructorQueryHookResult = ReturnType<typeof useGetClaimCategoriesForInstructorQuery>;
export type GetClaimCategoriesForInstructorLazyQueryHookResult = ReturnType<typeof useGetClaimCategoriesForInstructorLazyQuery>;
export type GetClaimCategoriesForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetClaimCategoriesForInstructorSuspenseQuery>;
export type GetClaimCategoriesForInstructorQueryResult = Apollo.QueryResult<GetClaimCategoriesForInstructorQuery, GetClaimCategoriesForInstructorQueryVariables>;
export const AddClaimDetailForInstructorDocument = gql`
    mutation addClaimDetailForInstructor($yearMonth: Time!, $input: ClaimDetailInput!) {
  createClaimDetailForInstructor(yearMonth: $yearMonth, input: $input) {
    id
  }
}
    `;
export type AddClaimDetailForInstructorMutationFn = Apollo.MutationFunction<AddClaimDetailForInstructorMutation, AddClaimDetailForInstructorMutationVariables>;

/**
 * __useAddClaimDetailForInstructorMutation__
 *
 * To run a mutation, you first call `useAddClaimDetailForInstructorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClaimDetailForInstructorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClaimDetailForInstructorMutation, { data, loading, error }] = useAddClaimDetailForInstructorMutation({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddClaimDetailForInstructorMutation(baseOptions?: Apollo.MutationHookOptions<AddClaimDetailForInstructorMutation, AddClaimDetailForInstructorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClaimDetailForInstructorMutation, AddClaimDetailForInstructorMutationVariables>(AddClaimDetailForInstructorDocument, options);
      }
export type AddClaimDetailForInstructorMutationHookResult = ReturnType<typeof useAddClaimDetailForInstructorMutation>;
export type AddClaimDetailForInstructorMutationResult = Apollo.MutationResult<AddClaimDetailForInstructorMutation>;
export type AddClaimDetailForInstructorMutationOptions = Apollo.BaseMutationOptions<AddClaimDetailForInstructorMutation, AddClaimDetailForInstructorMutationVariables>;
export const UpdateClaimDetailForInstructorDocument = gql`
    mutation updateClaimDetailForInstructor($id: Uint64!, $input: ClaimDetailInput!) {
  updateClaimDetailForInstructor(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateClaimDetailForInstructorMutationFn = Apollo.MutationFunction<UpdateClaimDetailForInstructorMutation, UpdateClaimDetailForInstructorMutationVariables>;

/**
 * __useUpdateClaimDetailForInstructorMutation__
 *
 * To run a mutation, you first call `useUpdateClaimDetailForInstructorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClaimDetailForInstructorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClaimDetailForInstructorMutation, { data, loading, error }] = useUpdateClaimDetailForInstructorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClaimDetailForInstructorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClaimDetailForInstructorMutation, UpdateClaimDetailForInstructorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClaimDetailForInstructorMutation, UpdateClaimDetailForInstructorMutationVariables>(UpdateClaimDetailForInstructorDocument, options);
      }
export type UpdateClaimDetailForInstructorMutationHookResult = ReturnType<typeof useUpdateClaimDetailForInstructorMutation>;
export type UpdateClaimDetailForInstructorMutationResult = Apollo.MutationResult<UpdateClaimDetailForInstructorMutation>;
export type UpdateClaimDetailForInstructorMutationOptions = Apollo.BaseMutationOptions<UpdateClaimDetailForInstructorMutation, UpdateClaimDetailForInstructorMutationVariables>;
export const DeleteClaimDetailForInstructorDocument = gql`
    mutation deleteClaimDetailForInstructor($id: Uint64!) {
  deleteClaimDetailForInstructor(id: $id)
}
    `;
export type DeleteClaimDetailForInstructorMutationFn = Apollo.MutationFunction<DeleteClaimDetailForInstructorMutation, DeleteClaimDetailForInstructorMutationVariables>;

/**
 * __useDeleteClaimDetailForInstructorMutation__
 *
 * To run a mutation, you first call `useDeleteClaimDetailForInstructorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClaimDetailForInstructorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClaimDetailForInstructorMutation, { data, loading, error }] = useDeleteClaimDetailForInstructorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClaimDetailForInstructorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClaimDetailForInstructorMutation, DeleteClaimDetailForInstructorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClaimDetailForInstructorMutation, DeleteClaimDetailForInstructorMutationVariables>(DeleteClaimDetailForInstructorDocument, options);
      }
export type DeleteClaimDetailForInstructorMutationHookResult = ReturnType<typeof useDeleteClaimDetailForInstructorMutation>;
export type DeleteClaimDetailForInstructorMutationResult = Apollo.MutationResult<DeleteClaimDetailForInstructorMutation>;
export type DeleteClaimDetailForInstructorMutationOptions = Apollo.BaseMutationOptions<DeleteClaimDetailForInstructorMutation, DeleteClaimDetailForInstructorMutationVariables>;
export const ApplyClaimForInstructorDocument = gql`
    mutation applyClaimForInstructor($yearMonth: Time!, $input: ClaimInput!) {
  applyClaimForInstructor(yearMonth: $yearMonth, input: $input) {
    id
  }
}
    `;
export type ApplyClaimForInstructorMutationFn = Apollo.MutationFunction<ApplyClaimForInstructorMutation, ApplyClaimForInstructorMutationVariables>;

/**
 * __useApplyClaimForInstructorMutation__
 *
 * To run a mutation, you first call `useApplyClaimForInstructorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyClaimForInstructorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyClaimForInstructorMutation, { data, loading, error }] = useApplyClaimForInstructorMutation({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyClaimForInstructorMutation(baseOptions?: Apollo.MutationHookOptions<ApplyClaimForInstructorMutation, ApplyClaimForInstructorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyClaimForInstructorMutation, ApplyClaimForInstructorMutationVariables>(ApplyClaimForInstructorDocument, options);
      }
export type ApplyClaimForInstructorMutationHookResult = ReturnType<typeof useApplyClaimForInstructorMutation>;
export type ApplyClaimForInstructorMutationResult = Apollo.MutationResult<ApplyClaimForInstructorMutation>;
export type ApplyClaimForInstructorMutationOptions = Apollo.BaseMutationOptions<ApplyClaimForInstructorMutation, ApplyClaimForInstructorMutationVariables>;
export const GetCoursesForInstructorDocument = gql`
    query getCoursesForInstructor($input: InstructorCourseSearchInput!) {
  coursesForInstructor(input: $input) {
    ...Course
  }
}
    ${CourseFragmentDoc}`;

/**
 * __useGetCoursesForInstructorQuery__
 *
 * To run a query within a React component, call `useGetCoursesForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesForInstructorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCoursesForInstructorQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesForInstructorQuery, GetCoursesForInstructorQueryVariables> & ({ variables: GetCoursesForInstructorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesForInstructorQuery, GetCoursesForInstructorQueryVariables>(GetCoursesForInstructorDocument, options);
      }
export function useGetCoursesForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesForInstructorQuery, GetCoursesForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesForInstructorQuery, GetCoursesForInstructorQueryVariables>(GetCoursesForInstructorDocument, options);
        }
export function useGetCoursesForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesForInstructorQuery, GetCoursesForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesForInstructorQuery, GetCoursesForInstructorQueryVariables>(GetCoursesForInstructorDocument, options);
        }
export type GetCoursesForInstructorQueryHookResult = ReturnType<typeof useGetCoursesForInstructorQuery>;
export type GetCoursesForInstructorLazyQueryHookResult = ReturnType<typeof useGetCoursesForInstructorLazyQuery>;
export type GetCoursesForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetCoursesForInstructorSuspenseQuery>;
export type GetCoursesForInstructorQueryResult = Apollo.QueryResult<GetCoursesForInstructorQuery, GetCoursesForInstructorQueryVariables>;
export const GetCoursesForInstructorCreateLessonListDocument = gql`
    query getCoursesForInstructorCreateLessonList($input: InstructorCourseSearchInput!) {
  coursesForInstructor(input: $input) {
    ...CourseNewLesson
  }
}
    ${CourseNewLessonFragmentDoc}`;

/**
 * __useGetCoursesForInstructorCreateLessonListQuery__
 *
 * To run a query within a React component, call `useGetCoursesForInstructorCreateLessonListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesForInstructorCreateLessonListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesForInstructorCreateLessonListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCoursesForInstructorCreateLessonListQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesForInstructorCreateLessonListQuery, GetCoursesForInstructorCreateLessonListQueryVariables> & ({ variables: GetCoursesForInstructorCreateLessonListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesForInstructorCreateLessonListQuery, GetCoursesForInstructorCreateLessonListQueryVariables>(GetCoursesForInstructorCreateLessonListDocument, options);
      }
export function useGetCoursesForInstructorCreateLessonListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesForInstructorCreateLessonListQuery, GetCoursesForInstructorCreateLessonListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesForInstructorCreateLessonListQuery, GetCoursesForInstructorCreateLessonListQueryVariables>(GetCoursesForInstructorCreateLessonListDocument, options);
        }
export function useGetCoursesForInstructorCreateLessonListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesForInstructorCreateLessonListQuery, GetCoursesForInstructorCreateLessonListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesForInstructorCreateLessonListQuery, GetCoursesForInstructorCreateLessonListQueryVariables>(GetCoursesForInstructorCreateLessonListDocument, options);
        }
export type GetCoursesForInstructorCreateLessonListQueryHookResult = ReturnType<typeof useGetCoursesForInstructorCreateLessonListQuery>;
export type GetCoursesForInstructorCreateLessonListLazyQueryHookResult = ReturnType<typeof useGetCoursesForInstructorCreateLessonListLazyQuery>;
export type GetCoursesForInstructorCreateLessonListSuspenseQueryHookResult = ReturnType<typeof useGetCoursesForInstructorCreateLessonListSuspenseQuery>;
export type GetCoursesForInstructorCreateLessonListQueryResult = Apollo.QueryResult<GetCoursesForInstructorCreateLessonListQuery, GetCoursesForInstructorCreateLessonListQueryVariables>;
export const GetCoursesForInstructorCourseListDocument = gql`
    query getCoursesForInstructorCourseList($input: InstructorCourseSearchInput!) {
  coursesForInstructor(input: $input) {
    ...CourseList
  }
}
    ${CourseListFragmentDoc}`;

/**
 * __useGetCoursesForInstructorCourseListQuery__
 *
 * To run a query within a React component, call `useGetCoursesForInstructorCourseListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesForInstructorCourseListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesForInstructorCourseListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCoursesForInstructorCourseListQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesForInstructorCourseListQuery, GetCoursesForInstructorCourseListQueryVariables> & ({ variables: GetCoursesForInstructorCourseListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesForInstructorCourseListQuery, GetCoursesForInstructorCourseListQueryVariables>(GetCoursesForInstructorCourseListDocument, options);
      }
export function useGetCoursesForInstructorCourseListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesForInstructorCourseListQuery, GetCoursesForInstructorCourseListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesForInstructorCourseListQuery, GetCoursesForInstructorCourseListQueryVariables>(GetCoursesForInstructorCourseListDocument, options);
        }
export function useGetCoursesForInstructorCourseListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesForInstructorCourseListQuery, GetCoursesForInstructorCourseListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesForInstructorCourseListQuery, GetCoursesForInstructorCourseListQueryVariables>(GetCoursesForInstructorCourseListDocument, options);
        }
export type GetCoursesForInstructorCourseListQueryHookResult = ReturnType<typeof useGetCoursesForInstructorCourseListQuery>;
export type GetCoursesForInstructorCourseListLazyQueryHookResult = ReturnType<typeof useGetCoursesForInstructorCourseListLazyQuery>;
export type GetCoursesForInstructorCourseListSuspenseQueryHookResult = ReturnType<typeof useGetCoursesForInstructorCourseListSuspenseQuery>;
export type GetCoursesForInstructorCourseListQueryResult = Apollo.QueryResult<GetCoursesForInstructorCourseListQuery, GetCoursesForInstructorCourseListQueryVariables>;
export const GetActiveCoursesForInstructorDocument = gql`
    query getActiveCoursesForInstructor($input: InstructorCourseSearchWithStudentNameInput!) {
  activeCoursesForInstructor(input: $input) {
    ...CourseList
  }
}
    ${CourseListFragmentDoc}`;

/**
 * __useGetActiveCoursesForInstructorQuery__
 *
 * To run a query within a React component, call `useGetActiveCoursesForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCoursesForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCoursesForInstructorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetActiveCoursesForInstructorQuery(baseOptions: Apollo.QueryHookOptions<GetActiveCoursesForInstructorQuery, GetActiveCoursesForInstructorQueryVariables> & ({ variables: GetActiveCoursesForInstructorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveCoursesForInstructorQuery, GetActiveCoursesForInstructorQueryVariables>(GetActiveCoursesForInstructorDocument, options);
      }
export function useGetActiveCoursesForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveCoursesForInstructorQuery, GetActiveCoursesForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveCoursesForInstructorQuery, GetActiveCoursesForInstructorQueryVariables>(GetActiveCoursesForInstructorDocument, options);
        }
export function useGetActiveCoursesForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveCoursesForInstructorQuery, GetActiveCoursesForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveCoursesForInstructorQuery, GetActiveCoursesForInstructorQueryVariables>(GetActiveCoursesForInstructorDocument, options);
        }
export type GetActiveCoursesForInstructorQueryHookResult = ReturnType<typeof useGetActiveCoursesForInstructorQuery>;
export type GetActiveCoursesForInstructorLazyQueryHookResult = ReturnType<typeof useGetActiveCoursesForInstructorLazyQuery>;
export type GetActiveCoursesForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetActiveCoursesForInstructorSuspenseQuery>;
export type GetActiveCoursesForInstructorQueryResult = Apollo.QueryResult<GetActiveCoursesForInstructorQuery, GetActiveCoursesForInstructorQueryVariables>;
export const GetCourseForInstructorDocument = gql`
    query getCourseForInstructor($id: Uint64!) {
  courseForInstructor(id: $id) {
    ...Course
  }
}
    ${CourseFragmentDoc}`;

/**
 * __useGetCourseForInstructorQuery__
 *
 * To run a query within a React component, call `useGetCourseForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseForInstructorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseForInstructorQuery(baseOptions: Apollo.QueryHookOptions<GetCourseForInstructorQuery, GetCourseForInstructorQueryVariables> & ({ variables: GetCourseForInstructorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseForInstructorQuery, GetCourseForInstructorQueryVariables>(GetCourseForInstructorDocument, options);
      }
export function useGetCourseForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseForInstructorQuery, GetCourseForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseForInstructorQuery, GetCourseForInstructorQueryVariables>(GetCourseForInstructorDocument, options);
        }
export function useGetCourseForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseForInstructorQuery, GetCourseForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseForInstructorQuery, GetCourseForInstructorQueryVariables>(GetCourseForInstructorDocument, options);
        }
export type GetCourseForInstructorQueryHookResult = ReturnType<typeof useGetCourseForInstructorQuery>;
export type GetCourseForInstructorLazyQueryHookResult = ReturnType<typeof useGetCourseForInstructorLazyQuery>;
export type GetCourseForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetCourseForInstructorSuspenseQuery>;
export type GetCourseForInstructorQueryResult = Apollo.QueryResult<GetCourseForInstructorQuery, GetCourseForInstructorQueryVariables>;
export const GetHistoricalCoursesForInstructorDocument = gql`
    query getHistoricalCoursesForInstructor($userName: String) {
  historicalCoursesForInstructor(userName: $userName) {
    ...HistoricalCourse
  }
}
    ${HistoricalCourseFragmentDoc}`;

/**
 * __useGetHistoricalCoursesForInstructorQuery__
 *
 * To run a query within a React component, call `useGetHistoricalCoursesForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricalCoursesForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricalCoursesForInstructorQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useGetHistoricalCoursesForInstructorQuery(baseOptions?: Apollo.QueryHookOptions<GetHistoricalCoursesForInstructorQuery, GetHistoricalCoursesForInstructorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHistoricalCoursesForInstructorQuery, GetHistoricalCoursesForInstructorQueryVariables>(GetHistoricalCoursesForInstructorDocument, options);
      }
export function useGetHistoricalCoursesForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHistoricalCoursesForInstructorQuery, GetHistoricalCoursesForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHistoricalCoursesForInstructorQuery, GetHistoricalCoursesForInstructorQueryVariables>(GetHistoricalCoursesForInstructorDocument, options);
        }
export function useGetHistoricalCoursesForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHistoricalCoursesForInstructorQuery, GetHistoricalCoursesForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHistoricalCoursesForInstructorQuery, GetHistoricalCoursesForInstructorQueryVariables>(GetHistoricalCoursesForInstructorDocument, options);
        }
export type GetHistoricalCoursesForInstructorQueryHookResult = ReturnType<typeof useGetHistoricalCoursesForInstructorQuery>;
export type GetHistoricalCoursesForInstructorLazyQueryHookResult = ReturnType<typeof useGetHistoricalCoursesForInstructorLazyQuery>;
export type GetHistoricalCoursesForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetHistoricalCoursesForInstructorSuspenseQuery>;
export type GetHistoricalCoursesForInstructorQueryResult = Apollo.QueryResult<GetHistoricalCoursesForInstructorQuery, GetHistoricalCoursesForInstructorQueryVariables>;
export const GetCoursesForStudentHomeDocument = gql`
    query getCoursesForStudentHome {
  coursesForStudent(input: {type: ALL}) {
    ...StudentCourse
  }
}
    ${StudentCourseFragmentDoc}`;

/**
 * __useGetCoursesForStudentHomeQuery__
 *
 * To run a query within a React component, call `useGetCoursesForStudentHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesForStudentHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesForStudentHomeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCoursesForStudentHomeQuery(baseOptions?: Apollo.QueryHookOptions<GetCoursesForStudentHomeQuery, GetCoursesForStudentHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesForStudentHomeQuery, GetCoursesForStudentHomeQueryVariables>(GetCoursesForStudentHomeDocument, options);
      }
export function useGetCoursesForStudentHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesForStudentHomeQuery, GetCoursesForStudentHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesForStudentHomeQuery, GetCoursesForStudentHomeQueryVariables>(GetCoursesForStudentHomeDocument, options);
        }
export function useGetCoursesForStudentHomeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesForStudentHomeQuery, GetCoursesForStudentHomeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesForStudentHomeQuery, GetCoursesForStudentHomeQueryVariables>(GetCoursesForStudentHomeDocument, options);
        }
export type GetCoursesForStudentHomeQueryHookResult = ReturnType<typeof useGetCoursesForStudentHomeQuery>;
export type GetCoursesForStudentHomeLazyQueryHookResult = ReturnType<typeof useGetCoursesForStudentHomeLazyQuery>;
export type GetCoursesForStudentHomeSuspenseQueryHookResult = ReturnType<typeof useGetCoursesForStudentHomeSuspenseQuery>;
export type GetCoursesForStudentHomeQueryResult = Apollo.QueryResult<GetCoursesForStudentHomeQuery, GetCoursesForStudentHomeQueryVariables>;
export const UpdateCourseDocument = gql`
    mutation updateCourse($id: Uint64!, $input: InstructorCourseInput!) {
  updateCourseForInstructor(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateCourseMutationFn = Apollo.MutationFunction<UpdateCourseMutation, UpdateCourseMutationVariables>;

/**
 * __useUpdateCourseMutation__
 *
 * To run a mutation, you first call `useUpdateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseMutation, { data, loading, error }] = useUpdateCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCourseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourseMutation, UpdateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourseMutation, UpdateCourseMutationVariables>(UpdateCourseDocument, options);
      }
export type UpdateCourseMutationHookResult = ReturnType<typeof useUpdateCourseMutation>;
export type UpdateCourseMutationResult = Apollo.MutationResult<UpdateCourseMutation>;
export type UpdateCourseMutationOptions = Apollo.BaseMutationOptions<UpdateCourseMutation, UpdateCourseMutationVariables>;
export const GetCourseProgramsDocument = gql`
    query getCoursePrograms($input: CourseProgramSearchInput) {
  coursePrograms(input: $input) {
    ...CourseProgram
  }
}
    ${CourseProgramFragmentDoc}`;

/**
 * __useGetCourseProgramsQuery__
 *
 * To run a query within a React component, call `useGetCourseProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseProgramsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCourseProgramsQuery(baseOptions?: Apollo.QueryHookOptions<GetCourseProgramsQuery, GetCourseProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseProgramsQuery, GetCourseProgramsQueryVariables>(GetCourseProgramsDocument, options);
      }
export function useGetCourseProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseProgramsQuery, GetCourseProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseProgramsQuery, GetCourseProgramsQueryVariables>(GetCourseProgramsDocument, options);
        }
export function useGetCourseProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseProgramsQuery, GetCourseProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseProgramsQuery, GetCourseProgramsQueryVariables>(GetCourseProgramsDocument, options);
        }
export type GetCourseProgramsQueryHookResult = ReturnType<typeof useGetCourseProgramsQuery>;
export type GetCourseProgramsLazyQueryHookResult = ReturnType<typeof useGetCourseProgramsLazyQuery>;
export type GetCourseProgramsSuspenseQueryHookResult = ReturnType<typeof useGetCourseProgramsSuspenseQuery>;
export type GetCourseProgramsQueryResult = Apollo.QueryResult<GetCourseProgramsQuery, GetCourseProgramsQueryVariables>;
export const GetCourseProgramDocument = gql`
    query getCourseProgram($id: ULID!, $userID: Uint64) {
  courseProgram(courseProgramID: $id) {
    ...CourseProgramDetail
  }
}
    ${CourseProgramDetailFragmentDoc}`;

/**
 * __useGetCourseProgramQuery__
 *
 * To run a query within a React component, call `useGetCourseProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseProgramQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useGetCourseProgramQuery(baseOptions: Apollo.QueryHookOptions<GetCourseProgramQuery, GetCourseProgramQueryVariables> & ({ variables: GetCourseProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseProgramQuery, GetCourseProgramQueryVariables>(GetCourseProgramDocument, options);
      }
export function useGetCourseProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseProgramQuery, GetCourseProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseProgramQuery, GetCourseProgramQueryVariables>(GetCourseProgramDocument, options);
        }
export function useGetCourseProgramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseProgramQuery, GetCourseProgramQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseProgramQuery, GetCourseProgramQueryVariables>(GetCourseProgramDocument, options);
        }
export type GetCourseProgramQueryHookResult = ReturnType<typeof useGetCourseProgramQuery>;
export type GetCourseProgramLazyQueryHookResult = ReturnType<typeof useGetCourseProgramLazyQuery>;
export type GetCourseProgramSuspenseQueryHookResult = ReturnType<typeof useGetCourseProgramSuspenseQuery>;
export type GetCourseProgramQueryResult = Apollo.QueryResult<GetCourseProgramQuery, GetCourseProgramQueryVariables>;
export const StartCourseProgramDocument = gql`
    mutation startCourseProgram($id: ULID!) {
  startCourseProgram(id: $id) {
    createdAt
  }
}
    `;
export type StartCourseProgramMutationFn = Apollo.MutationFunction<StartCourseProgramMutation, StartCourseProgramMutationVariables>;

/**
 * __useStartCourseProgramMutation__
 *
 * To run a mutation, you first call `useStartCourseProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCourseProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCourseProgramMutation, { data, loading, error }] = useStartCourseProgramMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartCourseProgramMutation(baseOptions?: Apollo.MutationHookOptions<StartCourseProgramMutation, StartCourseProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartCourseProgramMutation, StartCourseProgramMutationVariables>(StartCourseProgramDocument, options);
      }
export type StartCourseProgramMutationHookResult = ReturnType<typeof useStartCourseProgramMutation>;
export type StartCourseProgramMutationResult = Apollo.MutationResult<StartCourseProgramMutation>;
export type StartCourseProgramMutationOptions = Apollo.BaseMutationOptions<StartCourseProgramMutation, StartCourseProgramMutationVariables>;
export const SearchDocumentsDocument = gql`
    query searchDocuments($input: DocumentSearchInput!, $userID: Uint64) {
  searchDocuments(input: $input) {
    items {
      ...DocumentList
    }
    total
  }
}
    ${DocumentListFragmentDoc}`;

/**
 * __useSearchDocumentsQuery__
 *
 * To run a query within a React component, call `useSearchDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDocumentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useSearchDocumentsQuery(baseOptions: Apollo.QueryHookOptions<SearchDocumentsQuery, SearchDocumentsQueryVariables> & ({ variables: SearchDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDocumentsQuery, SearchDocumentsQueryVariables>(SearchDocumentsDocument, options);
      }
export function useSearchDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDocumentsQuery, SearchDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDocumentsQuery, SearchDocumentsQueryVariables>(SearchDocumentsDocument, options);
        }
export function useSearchDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchDocumentsQuery, SearchDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchDocumentsQuery, SearchDocumentsQueryVariables>(SearchDocumentsDocument, options);
        }
export type SearchDocumentsQueryHookResult = ReturnType<typeof useSearchDocumentsQuery>;
export type SearchDocumentsLazyQueryHookResult = ReturnType<typeof useSearchDocumentsLazyQuery>;
export type SearchDocumentsSuspenseQueryHookResult = ReturnType<typeof useSearchDocumentsSuspenseQuery>;
export type SearchDocumentsQueryResult = Apollo.QueryResult<SearchDocumentsQuery, SearchDocumentsQueryVariables>;
export const GetCountByDocumentTypeDocument = gql`
    query getCountByDocumentType($input: CountSearchInput) {
  countByDocumentType(input: $input) {
    documentType
    count
  }
}
    `;

/**
 * __useGetCountByDocumentTypeQuery__
 *
 * To run a query within a React component, call `useGetCountByDocumentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountByDocumentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountByDocumentTypeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCountByDocumentTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetCountByDocumentTypeQuery, GetCountByDocumentTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountByDocumentTypeQuery, GetCountByDocumentTypeQueryVariables>(GetCountByDocumentTypeDocument, options);
      }
export function useGetCountByDocumentTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountByDocumentTypeQuery, GetCountByDocumentTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountByDocumentTypeQuery, GetCountByDocumentTypeQueryVariables>(GetCountByDocumentTypeDocument, options);
        }
export function useGetCountByDocumentTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountByDocumentTypeQuery, GetCountByDocumentTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountByDocumentTypeQuery, GetCountByDocumentTypeQueryVariables>(GetCountByDocumentTypeDocument, options);
        }
export type GetCountByDocumentTypeQueryHookResult = ReturnType<typeof useGetCountByDocumentTypeQuery>;
export type GetCountByDocumentTypeLazyQueryHookResult = ReturnType<typeof useGetCountByDocumentTypeLazyQuery>;
export type GetCountByDocumentTypeSuspenseQueryHookResult = ReturnType<typeof useGetCountByDocumentTypeSuspenseQuery>;
export type GetCountByDocumentTypeQueryResult = Apollo.QueryResult<GetCountByDocumentTypeQuery, GetCountByDocumentTypeQueryVariables>;
export const GetCountByTagsDocument = gql`
    query getCountByTags($input: CountSearchInput, $tagIDs: [Uint64!]) {
  countByTags(input: $input, tagIDs: $tagIDs) {
    tagID
    count
    tag {
      ...Tag
    }
  }
}
    ${TagFragmentDoc}`;

/**
 * __useGetCountByTagsQuery__
 *
 * To run a query within a React component, call `useGetCountByTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountByTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountByTagsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      tagIDs: // value for 'tagIDs'
 *   },
 * });
 */
export function useGetCountByTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetCountByTagsQuery, GetCountByTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountByTagsQuery, GetCountByTagsQueryVariables>(GetCountByTagsDocument, options);
      }
export function useGetCountByTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountByTagsQuery, GetCountByTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountByTagsQuery, GetCountByTagsQueryVariables>(GetCountByTagsDocument, options);
        }
export function useGetCountByTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountByTagsQuery, GetCountByTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountByTagsQuery, GetCountByTagsQueryVariables>(GetCountByTagsDocument, options);
        }
export type GetCountByTagsQueryHookResult = ReturnType<typeof useGetCountByTagsQuery>;
export type GetCountByTagsLazyQueryHookResult = ReturnType<typeof useGetCountByTagsLazyQuery>;
export type GetCountByTagsSuspenseQueryHookResult = ReturnType<typeof useGetCountByTagsSuspenseQuery>;
export type GetCountByTagsQueryResult = Apollo.QueryResult<GetCountByTagsQuery, GetCountByTagsQueryVariables>;
export const GetProgramExamDocument = gql`
    query getProgramExam($chapterID: Uint64!) {
  programExam(chapterID: $chapterID) {
    ...ExamQuestion
  }
  chapter(chapterID: $chapterID) {
    ...Chapter
  }
}
    ${ExamQuestionFragmentDoc}
${ChapterFragmentDoc}`;

/**
 * __useGetProgramExamQuery__
 *
 * To run a query within a React component, call `useGetProgramExamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramExamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramExamQuery({
 *   variables: {
 *      chapterID: // value for 'chapterID'
 *   },
 * });
 */
export function useGetProgramExamQuery(baseOptions: Apollo.QueryHookOptions<GetProgramExamQuery, GetProgramExamQueryVariables> & ({ variables: GetProgramExamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramExamQuery, GetProgramExamQueryVariables>(GetProgramExamDocument, options);
      }
export function useGetProgramExamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramExamQuery, GetProgramExamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramExamQuery, GetProgramExamQueryVariables>(GetProgramExamDocument, options);
        }
export function useGetProgramExamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgramExamQuery, GetProgramExamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProgramExamQuery, GetProgramExamQueryVariables>(GetProgramExamDocument, options);
        }
export type GetProgramExamQueryHookResult = ReturnType<typeof useGetProgramExamQuery>;
export type GetProgramExamLazyQueryHookResult = ReturnType<typeof useGetProgramExamLazyQuery>;
export type GetProgramExamSuspenseQueryHookResult = ReturnType<typeof useGetProgramExamSuspenseQuery>;
export type GetProgramExamQueryResult = Apollo.QueryResult<GetProgramExamQuery, GetProgramExamQueryVariables>;
export const GetTotalMedalCountsDocument = gql`
    query getTotalMedalCounts {
  totalMedalCounts {
    programID
    medalCounts
  }
}
    `;

/**
 * __useGetTotalMedalCountsQuery__
 *
 * To run a query within a React component, call `useGetTotalMedalCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalMedalCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalMedalCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotalMedalCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetTotalMedalCountsQuery, GetTotalMedalCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalMedalCountsQuery, GetTotalMedalCountsQueryVariables>(GetTotalMedalCountsDocument, options);
      }
export function useGetTotalMedalCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalMedalCountsQuery, GetTotalMedalCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalMedalCountsQuery, GetTotalMedalCountsQueryVariables>(GetTotalMedalCountsDocument, options);
        }
export function useGetTotalMedalCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotalMedalCountsQuery, GetTotalMedalCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTotalMedalCountsQuery, GetTotalMedalCountsQueryVariables>(GetTotalMedalCountsDocument, options);
        }
export type GetTotalMedalCountsQueryHookResult = ReturnType<typeof useGetTotalMedalCountsQuery>;
export type GetTotalMedalCountsLazyQueryHookResult = ReturnType<typeof useGetTotalMedalCountsLazyQuery>;
export type GetTotalMedalCountsSuspenseQueryHookResult = ReturnType<typeof useGetTotalMedalCountsSuspenseQuery>;
export type GetTotalMedalCountsQueryResult = Apollo.QueryResult<GetTotalMedalCountsQuery, GetTotalMedalCountsQueryVariables>;
export const AnswerExamDocument = gql`
    mutation answerExam($input: AnswerExamInput!) {
  answerExam(input: $input) {
    ExamScore {
      ...ExamScore
    }
    answerResponses {
      ...AnswerResponse
    }
  }
}
    ${ExamScoreFragmentDoc}
${AnswerResponseFragmentDoc}`;
export type AnswerExamMutationFn = Apollo.MutationFunction<AnswerExamMutation, AnswerExamMutationVariables>;

/**
 * __useAnswerExamMutation__
 *
 * To run a mutation, you first call `useAnswerExamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerExamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerExamMutation, { data, loading, error }] = useAnswerExamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerExamMutation(baseOptions?: Apollo.MutationHookOptions<AnswerExamMutation, AnswerExamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerExamMutation, AnswerExamMutationVariables>(AnswerExamDocument, options);
      }
export type AnswerExamMutationHookResult = ReturnType<typeof useAnswerExamMutation>;
export type AnswerExamMutationResult = Apollo.MutationResult<AnswerExamMutation>;
export type AnswerExamMutationOptions = Apollo.BaseMutationOptions<AnswerExamMutation, AnswerExamMutationVariables>;
export const GetFeedbackCategoriesDocument = gql`
    query getFeedbackCategories($input: FeedbackCategoriesInput!) {
  feedbackCategories(input: $input) {
    items {
      id
      name
    }
  }
}
    `;

/**
 * __useGetFeedbackCategoriesQuery__
 *
 * To run a query within a React component, call `useGetFeedbackCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackCategoriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFeedbackCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetFeedbackCategoriesQuery, GetFeedbackCategoriesQueryVariables> & ({ variables: GetFeedbackCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedbackCategoriesQuery, GetFeedbackCategoriesQueryVariables>(GetFeedbackCategoriesDocument, options);
      }
export function useGetFeedbackCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedbackCategoriesQuery, GetFeedbackCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedbackCategoriesQuery, GetFeedbackCategoriesQueryVariables>(GetFeedbackCategoriesDocument, options);
        }
export function useGetFeedbackCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeedbackCategoriesQuery, GetFeedbackCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeedbackCategoriesQuery, GetFeedbackCategoriesQueryVariables>(GetFeedbackCategoriesDocument, options);
        }
export type GetFeedbackCategoriesQueryHookResult = ReturnType<typeof useGetFeedbackCategoriesQuery>;
export type GetFeedbackCategoriesLazyQueryHookResult = ReturnType<typeof useGetFeedbackCategoriesLazyQuery>;
export type GetFeedbackCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackCategoriesSuspenseQuery>;
export type GetFeedbackCategoriesQueryResult = Apollo.QueryResult<GetFeedbackCategoriesQuery, GetFeedbackCategoriesQueryVariables>;
export const UploadFilesDocument = gql`
    mutation uploadFiles($files: [Upload!]!) {
  uploadFiles(input: {files: $files, isImage: false}) {
    ...UploadFile
  }
}
    ${UploadFileFragmentDoc}`;
export type UploadFilesMutationFn = Apollo.MutationFunction<UploadFilesMutation, UploadFilesMutationVariables>;

/**
 * __useUploadFilesMutation__
 *
 * To run a mutation, you first call `useUploadFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFilesMutation, { data, loading, error }] = useUploadFilesMutation({
 *   variables: {
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUploadFilesMutation(baseOptions?: Apollo.MutationHookOptions<UploadFilesMutation, UploadFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFilesMutation, UploadFilesMutationVariables>(UploadFilesDocument, options);
      }
export type UploadFilesMutationHookResult = ReturnType<typeof useUploadFilesMutation>;
export type UploadFilesMutationResult = Apollo.MutationResult<UploadFilesMutation>;
export type UploadFilesMutationOptions = Apollo.BaseMutationOptions<UploadFilesMutation, UploadFilesMutationVariables>;
export const UploadImagesDocument = gql`
    mutation uploadImages($files: [Upload!]!) {
  uploadFiles(input: {files: $files, isImage: true}) {
    ...UploadFile
  }
}
    ${UploadFileFragmentDoc}`;
export type UploadImagesMutationFn = Apollo.MutationFunction<UploadImagesMutation, UploadImagesMutationVariables>;

/**
 * __useUploadImagesMutation__
 *
 * To run a mutation, you first call `useUploadImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadImagesMutation, { data, loading, error }] = useUploadImagesMutation({
 *   variables: {
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUploadImagesMutation(baseOptions?: Apollo.MutationHookOptions<UploadImagesMutation, UploadImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadImagesMutation, UploadImagesMutationVariables>(UploadImagesDocument, options);
      }
export type UploadImagesMutationHookResult = ReturnType<typeof useUploadImagesMutation>;
export type UploadImagesMutationResult = Apollo.MutationResult<UploadImagesMutation>;
export type UploadImagesMutationOptions = Apollo.BaseMutationOptions<UploadImagesMutation, UploadImagesMutationVariables>;
export const GetCalendarForInstructorDocument = gql`
    query getCalendarForInstructor {
  calendarForInstructor {
    id
  }
}
    `;

/**
 * __useGetCalendarForInstructorQuery__
 *
 * To run a query within a React component, call `useGetCalendarForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarForInstructorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCalendarForInstructorQuery(baseOptions?: Apollo.QueryHookOptions<GetCalendarForInstructorQuery, GetCalendarForInstructorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalendarForInstructorQuery, GetCalendarForInstructorQueryVariables>(GetCalendarForInstructorDocument, options);
      }
export function useGetCalendarForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarForInstructorQuery, GetCalendarForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalendarForInstructorQuery, GetCalendarForInstructorQueryVariables>(GetCalendarForInstructorDocument, options);
        }
export function useGetCalendarForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCalendarForInstructorQuery, GetCalendarForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalendarForInstructorQuery, GetCalendarForInstructorQueryVariables>(GetCalendarForInstructorDocument, options);
        }
export type GetCalendarForInstructorQueryHookResult = ReturnType<typeof useGetCalendarForInstructorQuery>;
export type GetCalendarForInstructorLazyQueryHookResult = ReturnType<typeof useGetCalendarForInstructorLazyQuery>;
export type GetCalendarForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetCalendarForInstructorSuspenseQuery>;
export type GetCalendarForInstructorQueryResult = Apollo.QueryResult<GetCalendarForInstructorQuery, GetCalendarForInstructorQueryVariables>;
export const GetInstructorScheduleDocument = gql`
    query getInstructorSchedule($id: Uint64!) {
  instructorSchedule(id: $id) {
    ...InstructorSchedule
  }
}
    ${InstructorScheduleFragmentDoc}`;

/**
 * __useGetInstructorScheduleQuery__
 *
 * To run a query within a React component, call `useGetInstructorScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructorScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructorScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInstructorScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetInstructorScheduleQuery, GetInstructorScheduleQueryVariables> & ({ variables: GetInstructorScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstructorScheduleQuery, GetInstructorScheduleQueryVariables>(GetInstructorScheduleDocument, options);
      }
export function useGetInstructorScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstructorScheduleQuery, GetInstructorScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstructorScheduleQuery, GetInstructorScheduleQueryVariables>(GetInstructorScheduleDocument, options);
        }
export function useGetInstructorScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInstructorScheduleQuery, GetInstructorScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInstructorScheduleQuery, GetInstructorScheduleQueryVariables>(GetInstructorScheduleDocument, options);
        }
export type GetInstructorScheduleQueryHookResult = ReturnType<typeof useGetInstructorScheduleQuery>;
export type GetInstructorScheduleLazyQueryHookResult = ReturnType<typeof useGetInstructorScheduleLazyQuery>;
export type GetInstructorScheduleSuspenseQueryHookResult = ReturnType<typeof useGetInstructorScheduleSuspenseQuery>;
export type GetInstructorScheduleQueryResult = Apollo.QueryResult<GetInstructorScheduleQuery, GetInstructorScheduleQueryVariables>;
export const GetInstructorSchedulesDocument = gql`
    query getInstructorSchedules($from: Time!, $to: Time!) {
  instructorSchedules(from: $from, to: $to) {
    ...InstructorSchedule
  }
}
    ${InstructorScheduleFragmentDoc}`;

/**
 * __useGetInstructorSchedulesQuery__
 *
 * To run a query within a React component, call `useGetInstructorSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructorSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructorSchedulesQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetInstructorSchedulesQuery(baseOptions: Apollo.QueryHookOptions<GetInstructorSchedulesQuery, GetInstructorSchedulesQueryVariables> & ({ variables: GetInstructorSchedulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstructorSchedulesQuery, GetInstructorSchedulesQueryVariables>(GetInstructorSchedulesDocument, options);
      }
export function useGetInstructorSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstructorSchedulesQuery, GetInstructorSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstructorSchedulesQuery, GetInstructorSchedulesQueryVariables>(GetInstructorSchedulesDocument, options);
        }
export function useGetInstructorSchedulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInstructorSchedulesQuery, GetInstructorSchedulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInstructorSchedulesQuery, GetInstructorSchedulesQueryVariables>(GetInstructorSchedulesDocument, options);
        }
export type GetInstructorSchedulesQueryHookResult = ReturnType<typeof useGetInstructorSchedulesQuery>;
export type GetInstructorSchedulesLazyQueryHookResult = ReturnType<typeof useGetInstructorSchedulesLazyQuery>;
export type GetInstructorSchedulesSuspenseQueryHookResult = ReturnType<typeof useGetInstructorSchedulesSuspenseQuery>;
export type GetInstructorSchedulesQueryResult = Apollo.QueryResult<GetInstructorSchedulesQuery, GetInstructorSchedulesQueryVariables>;
export const CreateInstructorScheduleDocument = gql`
    mutation createInstructorSchedule($input: InstructorScheduleInput!) {
  createInstructorSchedule(input: $input)
}
    `;
export type CreateInstructorScheduleMutationFn = Apollo.MutationFunction<CreateInstructorScheduleMutation, CreateInstructorScheduleMutationVariables>;

/**
 * __useCreateInstructorScheduleMutation__
 *
 * To run a mutation, you first call `useCreateInstructorScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstructorScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstructorScheduleMutation, { data, loading, error }] = useCreateInstructorScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInstructorScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateInstructorScheduleMutation, CreateInstructorScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInstructorScheduleMutation, CreateInstructorScheduleMutationVariables>(CreateInstructorScheduleDocument, options);
      }
export type CreateInstructorScheduleMutationHookResult = ReturnType<typeof useCreateInstructorScheduleMutation>;
export type CreateInstructorScheduleMutationResult = Apollo.MutationResult<CreateInstructorScheduleMutation>;
export type CreateInstructorScheduleMutationOptions = Apollo.BaseMutationOptions<CreateInstructorScheduleMutation, CreateInstructorScheduleMutationVariables>;
export const DeleteInstructorScheduleDocument = gql`
    mutation deleteInstructorSchedule($id: Uint64!) {
  deleteInstructorSchedule(id: $id)
}
    `;
export type DeleteInstructorScheduleMutationFn = Apollo.MutationFunction<DeleteInstructorScheduleMutation, DeleteInstructorScheduleMutationVariables>;

/**
 * __useDeleteInstructorScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteInstructorScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInstructorScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInstructorScheduleMutation, { data, loading, error }] = useDeleteInstructorScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInstructorScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInstructorScheduleMutation, DeleteInstructorScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInstructorScheduleMutation, DeleteInstructorScheduleMutationVariables>(DeleteInstructorScheduleDocument, options);
      }
export type DeleteInstructorScheduleMutationHookResult = ReturnType<typeof useDeleteInstructorScheduleMutation>;
export type DeleteInstructorScheduleMutationResult = Apollo.MutationResult<DeleteInstructorScheduleMutation>;
export type DeleteInstructorScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteInstructorScheduleMutation, DeleteInstructorScheduleMutationVariables>;
export const UpdateInstructorScheduleDocument = gql`
    mutation updateInstructorSchedule($id: Uint64!, $input: InstructorScheduleInput!) {
  updateInstructorSchedule(id: $id, input: $input)
}
    `;
export type UpdateInstructorScheduleMutationFn = Apollo.MutationFunction<UpdateInstructorScheduleMutation, UpdateInstructorScheduleMutationVariables>;

/**
 * __useUpdateInstructorScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateInstructorScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstructorScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstructorScheduleMutation, { data, loading, error }] = useUpdateInstructorScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInstructorScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstructorScheduleMutation, UpdateInstructorScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInstructorScheduleMutation, UpdateInstructorScheduleMutationVariables>(UpdateInstructorScheduleDocument, options);
      }
export type UpdateInstructorScheduleMutationHookResult = ReturnType<typeof useUpdateInstructorScheduleMutation>;
export type UpdateInstructorScheduleMutationResult = Apollo.MutationResult<UpdateInstructorScheduleMutation>;
export type UpdateInstructorScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateInstructorScheduleMutation, UpdateInstructorScheduleMutationVariables>;
export const GetNextLessonForStudentDocument = gql`
    query getNextLessonForStudent {
  nextLessonForStudent {
    ...StudentLesson
  }
}
    ${StudentLessonFragmentDoc}`;

/**
 * __useGetNextLessonForStudentQuery__
 *
 * To run a query within a React component, call `useGetNextLessonForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextLessonForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextLessonForStudentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNextLessonForStudentQuery(baseOptions?: Apollo.QueryHookOptions<GetNextLessonForStudentQuery, GetNextLessonForStudentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextLessonForStudentQuery, GetNextLessonForStudentQueryVariables>(GetNextLessonForStudentDocument, options);
      }
export function useGetNextLessonForStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextLessonForStudentQuery, GetNextLessonForStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextLessonForStudentQuery, GetNextLessonForStudentQueryVariables>(GetNextLessonForStudentDocument, options);
        }
export function useGetNextLessonForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNextLessonForStudentQuery, GetNextLessonForStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNextLessonForStudentQuery, GetNextLessonForStudentQueryVariables>(GetNextLessonForStudentDocument, options);
        }
export type GetNextLessonForStudentQueryHookResult = ReturnType<typeof useGetNextLessonForStudentQuery>;
export type GetNextLessonForStudentLazyQueryHookResult = ReturnType<typeof useGetNextLessonForStudentLazyQuery>;
export type GetNextLessonForStudentSuspenseQueryHookResult = ReturnType<typeof useGetNextLessonForStudentSuspenseQuery>;
export type GetNextLessonForStudentQueryResult = Apollo.QueryResult<GetNextLessonForStudentQuery, GetNextLessonForStudentQueryVariables>;
export const GetLessonsForStudentDocument = gql`
    query getLessonsForStudent {
  lessonsForStudent {
    ...StudentLesson
  }
}
    ${StudentLessonFragmentDoc}`;

/**
 * __useGetLessonsForStudentQuery__
 *
 * To run a query within a React component, call `useGetLessonsForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonsForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonsForStudentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLessonsForStudentQuery(baseOptions?: Apollo.QueryHookOptions<GetLessonsForStudentQuery, GetLessonsForStudentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonsForStudentQuery, GetLessonsForStudentQueryVariables>(GetLessonsForStudentDocument, options);
      }
export function useGetLessonsForStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonsForStudentQuery, GetLessonsForStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonsForStudentQuery, GetLessonsForStudentQueryVariables>(GetLessonsForStudentDocument, options);
        }
export function useGetLessonsForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLessonsForStudentQuery, GetLessonsForStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLessonsForStudentQuery, GetLessonsForStudentQueryVariables>(GetLessonsForStudentDocument, options);
        }
export type GetLessonsForStudentQueryHookResult = ReturnType<typeof useGetLessonsForStudentQuery>;
export type GetLessonsForStudentLazyQueryHookResult = ReturnType<typeof useGetLessonsForStudentLazyQuery>;
export type GetLessonsForStudentSuspenseQueryHookResult = ReturnType<typeof useGetLessonsForStudentSuspenseQuery>;
export type GetLessonsForStudentQueryResult = Apollo.QueryResult<GetLessonsForStudentQuery, GetLessonsForStudentQueryVariables>;
export const GetNextLessonForInstructorDocument = gql`
    query getNextLessonForInstructor {
  nextLessonForInstructor {
    ...InstructorLesson
  }
}
    ${InstructorLessonFragmentDoc}`;

/**
 * __useGetNextLessonForInstructorQuery__
 *
 * To run a query within a React component, call `useGetNextLessonForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextLessonForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextLessonForInstructorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNextLessonForInstructorQuery(baseOptions?: Apollo.QueryHookOptions<GetNextLessonForInstructorQuery, GetNextLessonForInstructorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextLessonForInstructorQuery, GetNextLessonForInstructorQueryVariables>(GetNextLessonForInstructorDocument, options);
      }
export function useGetNextLessonForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextLessonForInstructorQuery, GetNextLessonForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextLessonForInstructorQuery, GetNextLessonForInstructorQueryVariables>(GetNextLessonForInstructorDocument, options);
        }
export function useGetNextLessonForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNextLessonForInstructorQuery, GetNextLessonForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNextLessonForInstructorQuery, GetNextLessonForInstructorQueryVariables>(GetNextLessonForInstructorDocument, options);
        }
export type GetNextLessonForInstructorQueryHookResult = ReturnType<typeof useGetNextLessonForInstructorQuery>;
export type GetNextLessonForInstructorLazyQueryHookResult = ReturnType<typeof useGetNextLessonForInstructorLazyQuery>;
export type GetNextLessonForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetNextLessonForInstructorSuspenseQuery>;
export type GetNextLessonForInstructorQueryResult = Apollo.QueryResult<GetNextLessonForInstructorQuery, GetNextLessonForInstructorQueryVariables>;
export const GetLessonsForInstructorDocument = gql`
    query getLessonsForInstructor($input: InstructorLessonSearchInput) {
  lessonsForInstructor(input: $input) {
    ...InstructorLesson
  }
}
    ${InstructorLessonFragmentDoc}`;

/**
 * __useGetLessonsForInstructorQuery__
 *
 * To run a query within a React component, call `useGetLessonsForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonsForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonsForInstructorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLessonsForInstructorQuery(baseOptions?: Apollo.QueryHookOptions<GetLessonsForInstructorQuery, GetLessonsForInstructorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonsForInstructorQuery, GetLessonsForInstructorQueryVariables>(GetLessonsForInstructorDocument, options);
      }
export function useGetLessonsForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonsForInstructorQuery, GetLessonsForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonsForInstructorQuery, GetLessonsForInstructorQueryVariables>(GetLessonsForInstructorDocument, options);
        }
export function useGetLessonsForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLessonsForInstructorQuery, GetLessonsForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLessonsForInstructorQuery, GetLessonsForInstructorQueryVariables>(GetLessonsForInstructorDocument, options);
        }
export type GetLessonsForInstructorQueryHookResult = ReturnType<typeof useGetLessonsForInstructorQuery>;
export type GetLessonsForInstructorLazyQueryHookResult = ReturnType<typeof useGetLessonsForInstructorLazyQuery>;
export type GetLessonsForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetLessonsForInstructorSuspenseQuery>;
export type GetLessonsForInstructorQueryResult = Apollo.QueryResult<GetLessonsForInstructorQuery, GetLessonsForInstructorQueryVariables>;
export const GetLessonForInstructorDocument = gql`
    query getLessonForInstructor($lessonID: Uint64!) {
  lessonForInstructor(id: $lessonID) {
    ...InstructorLesson
  }
}
    ${InstructorLessonFragmentDoc}`;

/**
 * __useGetLessonForInstructorQuery__
 *
 * To run a query within a React component, call `useGetLessonForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonForInstructorQuery({
 *   variables: {
 *      lessonID: // value for 'lessonID'
 *   },
 * });
 */
export function useGetLessonForInstructorQuery(baseOptions: Apollo.QueryHookOptions<GetLessonForInstructorQuery, GetLessonForInstructorQueryVariables> & ({ variables: GetLessonForInstructorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonForInstructorQuery, GetLessonForInstructorQueryVariables>(GetLessonForInstructorDocument, options);
      }
export function useGetLessonForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonForInstructorQuery, GetLessonForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonForInstructorQuery, GetLessonForInstructorQueryVariables>(GetLessonForInstructorDocument, options);
        }
export function useGetLessonForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLessonForInstructorQuery, GetLessonForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLessonForInstructorQuery, GetLessonForInstructorQueryVariables>(GetLessonForInstructorDocument, options);
        }
export type GetLessonForInstructorQueryHookResult = ReturnType<typeof useGetLessonForInstructorQuery>;
export type GetLessonForInstructorLazyQueryHookResult = ReturnType<typeof useGetLessonForInstructorLazyQuery>;
export type GetLessonForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetLessonForInstructorSuspenseQuery>;
export type GetLessonForInstructorQueryResult = Apollo.QueryResult<GetLessonForInstructorQuery, GetLessonForInstructorQueryVariables>;
export const GetLessonAssistancesDocument = gql`
    query getLessonAssistances {
  lessonAssistances {
    ...LessonsAssistance
  }
}
    ${LessonsAssistanceFragmentDoc}`;

/**
 * __useGetLessonAssistancesQuery__
 *
 * To run a query within a React component, call `useGetLessonAssistancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonAssistancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonAssistancesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLessonAssistancesQuery(baseOptions?: Apollo.QueryHookOptions<GetLessonAssistancesQuery, GetLessonAssistancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonAssistancesQuery, GetLessonAssistancesQueryVariables>(GetLessonAssistancesDocument, options);
      }
export function useGetLessonAssistancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonAssistancesQuery, GetLessonAssistancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonAssistancesQuery, GetLessonAssistancesQueryVariables>(GetLessonAssistancesDocument, options);
        }
export function useGetLessonAssistancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLessonAssistancesQuery, GetLessonAssistancesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLessonAssistancesQuery, GetLessonAssistancesQueryVariables>(GetLessonAssistancesDocument, options);
        }
export type GetLessonAssistancesQueryHookResult = ReturnType<typeof useGetLessonAssistancesQuery>;
export type GetLessonAssistancesLazyQueryHookResult = ReturnType<typeof useGetLessonAssistancesLazyQuery>;
export type GetLessonAssistancesSuspenseQueryHookResult = ReturnType<typeof useGetLessonAssistancesSuspenseQuery>;
export type GetLessonAssistancesQueryResult = Apollo.QueryResult<GetLessonAssistancesQuery, GetLessonAssistancesQueryVariables>;
export const CreateLessonForInstructorDocument = gql`
    mutation createLessonForInstructor($courseID: Uint64!, $input: LessonInput!) {
  createLessonForInstructor(courseID: $courseID, input: $input) {
    id
  }
}
    `;
export type CreateLessonForInstructorMutationFn = Apollo.MutationFunction<CreateLessonForInstructorMutation, CreateLessonForInstructorMutationVariables>;

/**
 * __useCreateLessonForInstructorMutation__
 *
 * To run a mutation, you first call `useCreateLessonForInstructorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLessonForInstructorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLessonForInstructorMutation, { data, loading, error }] = useCreateLessonForInstructorMutation({
 *   variables: {
 *      courseID: // value for 'courseID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLessonForInstructorMutation(baseOptions?: Apollo.MutationHookOptions<CreateLessonForInstructorMutation, CreateLessonForInstructorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLessonForInstructorMutation, CreateLessonForInstructorMutationVariables>(CreateLessonForInstructorDocument, options);
      }
export type CreateLessonForInstructorMutationHookResult = ReturnType<typeof useCreateLessonForInstructorMutation>;
export type CreateLessonForInstructorMutationResult = Apollo.MutationResult<CreateLessonForInstructorMutation>;
export type CreateLessonForInstructorMutationOptions = Apollo.BaseMutationOptions<CreateLessonForInstructorMutation, CreateLessonForInstructorMutationVariables>;
export const UpdateLessonForInstructorDocument = gql`
    mutation updateLessonForInstructor($lessonID: Uint64!, $input: LessonInput!) {
  updateLessonForInstructor(lessonID: $lessonID, input: $input) {
    id
  }
}
    `;
export type UpdateLessonForInstructorMutationFn = Apollo.MutationFunction<UpdateLessonForInstructorMutation, UpdateLessonForInstructorMutationVariables>;

/**
 * __useUpdateLessonForInstructorMutation__
 *
 * To run a mutation, you first call `useUpdateLessonForInstructorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLessonForInstructorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLessonForInstructorMutation, { data, loading, error }] = useUpdateLessonForInstructorMutation({
 *   variables: {
 *      lessonID: // value for 'lessonID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLessonForInstructorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLessonForInstructorMutation, UpdateLessonForInstructorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLessonForInstructorMutation, UpdateLessonForInstructorMutationVariables>(UpdateLessonForInstructorDocument, options);
      }
export type UpdateLessonForInstructorMutationHookResult = ReturnType<typeof useUpdateLessonForInstructorMutation>;
export type UpdateLessonForInstructorMutationResult = Apollo.MutationResult<UpdateLessonForInstructorMutation>;
export type UpdateLessonForInstructorMutationOptions = Apollo.BaseMutationOptions<UpdateLessonForInstructorMutation, UpdateLessonForInstructorMutationVariables>;
export const UpsertLessonReportForInstructorDocument = gql`
    mutation upsertLessonReportForInstructor($lessonID: Uint64!, $input: LessonReportInput!) {
  upsertLessonReportForInstructor(lessonID: $lessonID, input: $input) {
    id
  }
}
    `;
export type UpsertLessonReportForInstructorMutationFn = Apollo.MutationFunction<UpsertLessonReportForInstructorMutation, UpsertLessonReportForInstructorMutationVariables>;

/**
 * __useUpsertLessonReportForInstructorMutation__
 *
 * To run a mutation, you first call `useUpsertLessonReportForInstructorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLessonReportForInstructorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLessonReportForInstructorMutation, { data, loading, error }] = useUpsertLessonReportForInstructorMutation({
 *   variables: {
 *      lessonID: // value for 'lessonID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertLessonReportForInstructorMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLessonReportForInstructorMutation, UpsertLessonReportForInstructorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLessonReportForInstructorMutation, UpsertLessonReportForInstructorMutationVariables>(UpsertLessonReportForInstructorDocument, options);
      }
export type UpsertLessonReportForInstructorMutationHookResult = ReturnType<typeof useUpsertLessonReportForInstructorMutation>;
export type UpsertLessonReportForInstructorMutationResult = Apollo.MutationResult<UpsertLessonReportForInstructorMutation>;
export type UpsertLessonReportForInstructorMutationOptions = Apollo.BaseMutationOptions<UpsertLessonReportForInstructorMutation, UpsertLessonReportForInstructorMutationVariables>;
export const DeleteLessonForInstructorDocument = gql`
    mutation deleteLessonForInstructor($lessonID: Uint64!) {
  deleteLessonForInstructor(lessonID: $lessonID)
}
    `;
export type DeleteLessonForInstructorMutationFn = Apollo.MutationFunction<DeleteLessonForInstructorMutation, DeleteLessonForInstructorMutationVariables>;

/**
 * __useDeleteLessonForInstructorMutation__
 *
 * To run a mutation, you first call `useDeleteLessonForInstructorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLessonForInstructorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLessonForInstructorMutation, { data, loading, error }] = useDeleteLessonForInstructorMutation({
 *   variables: {
 *      lessonID: // value for 'lessonID'
 *   },
 * });
 */
export function useDeleteLessonForInstructorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLessonForInstructorMutation, DeleteLessonForInstructorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLessonForInstructorMutation, DeleteLessonForInstructorMutationVariables>(DeleteLessonForInstructorDocument, options);
      }
export type DeleteLessonForInstructorMutationHookResult = ReturnType<typeof useDeleteLessonForInstructorMutation>;
export type DeleteLessonForInstructorMutationResult = Apollo.MutationResult<DeleteLessonForInstructorMutation>;
export type DeleteLessonForInstructorMutationOptions = Apollo.BaseMutationOptions<DeleteLessonForInstructorMutation, DeleteLessonForInstructorMutationVariables>;
export const GetMailSettingDocument = gql`
    query getMailSetting {
  getMailSetting {
    ...MailSetting
  }
}
    ${MailSettingFragmentDoc}`;

/**
 * __useGetMailSettingQuery__
 *
 * To run a query within a React component, call `useGetMailSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailSettingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMailSettingQuery(baseOptions?: Apollo.QueryHookOptions<GetMailSettingQuery, GetMailSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailSettingQuery, GetMailSettingQueryVariables>(GetMailSettingDocument, options);
      }
export function useGetMailSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailSettingQuery, GetMailSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailSettingQuery, GetMailSettingQueryVariables>(GetMailSettingDocument, options);
        }
export function useGetMailSettingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailSettingQuery, GetMailSettingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailSettingQuery, GetMailSettingQueryVariables>(GetMailSettingDocument, options);
        }
export type GetMailSettingQueryHookResult = ReturnType<typeof useGetMailSettingQuery>;
export type GetMailSettingLazyQueryHookResult = ReturnType<typeof useGetMailSettingLazyQuery>;
export type GetMailSettingSuspenseQueryHookResult = ReturnType<typeof useGetMailSettingSuspenseQuery>;
export type GetMailSettingQueryResult = Apollo.QueryResult<GetMailSettingQuery, GetMailSettingQueryVariables>;
export const UpdateMailSettingDocument = gql`
    mutation updateMailSetting($input: MailSettingInput!) {
  updateMailSetting(input: $input) {
    id
  }
}
    `;
export type UpdateMailSettingMutationFn = Apollo.MutationFunction<UpdateMailSettingMutation, UpdateMailSettingMutationVariables>;

/**
 * __useUpdateMailSettingMutation__
 *
 * To run a mutation, you first call `useUpdateMailSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMailSettingMutation, { data, loading, error }] = useUpdateMailSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMailSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMailSettingMutation, UpdateMailSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMailSettingMutation, UpdateMailSettingMutationVariables>(UpdateMailSettingDocument, options);
      }
export type UpdateMailSettingMutationHookResult = ReturnType<typeof useUpdateMailSettingMutation>;
export type UpdateMailSettingMutationResult = Apollo.MutationResult<UpdateMailSettingMutation>;
export type UpdateMailSettingMutationOptions = Apollo.BaseMutationOptions<UpdateMailSettingMutation, UpdateMailSettingMutationVariables>;
export const GetLatestModalDocument = gql`
    query getLatestModal($modalType: ModalType!) {
  latest(modalType: $modalType) {
    ...Modal
  }
}
    ${ModalFragmentDoc}`;

/**
 * __useGetLatestModalQuery__
 *
 * To run a query within a React component, call `useGetLatestModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestModalQuery({
 *   variables: {
 *      modalType: // value for 'modalType'
 *   },
 * });
 */
export function useGetLatestModalQuery(baseOptions: Apollo.QueryHookOptions<GetLatestModalQuery, GetLatestModalQueryVariables> & ({ variables: GetLatestModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestModalQuery, GetLatestModalQueryVariables>(GetLatestModalDocument, options);
      }
export function useGetLatestModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestModalQuery, GetLatestModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestModalQuery, GetLatestModalQueryVariables>(GetLatestModalDocument, options);
        }
export function useGetLatestModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestModalQuery, GetLatestModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestModalQuery, GetLatestModalQueryVariables>(GetLatestModalDocument, options);
        }
export type GetLatestModalQueryHookResult = ReturnType<typeof useGetLatestModalQuery>;
export type GetLatestModalLazyQueryHookResult = ReturnType<typeof useGetLatestModalLazyQuery>;
export type GetLatestModalSuspenseQueryHookResult = ReturnType<typeof useGetLatestModalSuspenseQuery>;
export type GetLatestModalQueryResult = Apollo.QueryResult<GetLatestModalQuery, GetLatestModalQueryVariables>;
export const ReadModalDocument = gql`
    mutation readModal($id: Uint64!) {
  readModal(id: $id)
}
    `;
export type ReadModalMutationFn = Apollo.MutationFunction<ReadModalMutation, ReadModalMutationVariables>;

/**
 * __useReadModalMutation__
 *
 * To run a mutation, you first call `useReadModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readModalMutation, { data, loading, error }] = useReadModalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadModalMutation(baseOptions?: Apollo.MutationHookOptions<ReadModalMutation, ReadModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadModalMutation, ReadModalMutationVariables>(ReadModalDocument, options);
      }
export type ReadModalMutationHookResult = ReturnType<typeof useReadModalMutation>;
export type ReadModalMutationResult = Apollo.MutationResult<ReadModalMutation>;
export type ReadModalMutationOptions = Apollo.BaseMutationOptions<ReadModalMutation, ReadModalMutationVariables>;
export const GetNoticesDocument = gql`
    query getNotices($first: Int!, $after: Uint64) {
  notices(first: $first, after: $after) {
    items {
      ...Notice
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${NoticeFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetNoticesQuery__
 *
 * To run a query within a React component, call `useGetNoticesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoticesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoticesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetNoticesQuery(baseOptions: Apollo.QueryHookOptions<GetNoticesQuery, GetNoticesQueryVariables> & ({ variables: GetNoticesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNoticesQuery, GetNoticesQueryVariables>(GetNoticesDocument, options);
      }
export function useGetNoticesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNoticesQuery, GetNoticesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNoticesQuery, GetNoticesQueryVariables>(GetNoticesDocument, options);
        }
export function useGetNoticesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNoticesQuery, GetNoticesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNoticesQuery, GetNoticesQueryVariables>(GetNoticesDocument, options);
        }
export type GetNoticesQueryHookResult = ReturnType<typeof useGetNoticesQuery>;
export type GetNoticesLazyQueryHookResult = ReturnType<typeof useGetNoticesLazyQuery>;
export type GetNoticesSuspenseQueryHookResult = ReturnType<typeof useGetNoticesSuspenseQuery>;
export type GetNoticesQueryResult = Apollo.QueryResult<GetNoticesQuery, GetNoticesQueryVariables>;
export const GetNoticeDocument = gql`
    query getNotice($id: Uint64!) {
  notice(id: $id) {
    ...Notice
  }
}
    ${NoticeFragmentDoc}`;

/**
 * __useGetNoticeQuery__
 *
 * To run a query within a React component, call `useGetNoticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoticeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoticeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNoticeQuery(baseOptions: Apollo.QueryHookOptions<GetNoticeQuery, GetNoticeQueryVariables> & ({ variables: GetNoticeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNoticeQuery, GetNoticeQueryVariables>(GetNoticeDocument, options);
      }
export function useGetNoticeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNoticeQuery, GetNoticeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNoticeQuery, GetNoticeQueryVariables>(GetNoticeDocument, options);
        }
export function useGetNoticeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNoticeQuery, GetNoticeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNoticeQuery, GetNoticeQueryVariables>(GetNoticeDocument, options);
        }
export type GetNoticeQueryHookResult = ReturnType<typeof useGetNoticeQuery>;
export type GetNoticeLazyQueryHookResult = ReturnType<typeof useGetNoticeLazyQuery>;
export type GetNoticeSuspenseQueryHookResult = ReturnType<typeof useGetNoticeSuspenseQuery>;
export type GetNoticeQueryResult = Apollo.QueryResult<GetNoticeQuery, GetNoticeQueryVariables>;
export const ReadNoticeDocument = gql`
    mutation readNotice($id: Uint64!) {
  readNotice(id: $id)
}
    `;
export type ReadNoticeMutationFn = Apollo.MutationFunction<ReadNoticeMutation, ReadNoticeMutationVariables>;

/**
 * __useReadNoticeMutation__
 *
 * To run a mutation, you first call `useReadNoticeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNoticeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNoticeMutation, { data, loading, error }] = useReadNoticeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadNoticeMutation(baseOptions?: Apollo.MutationHookOptions<ReadNoticeMutation, ReadNoticeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadNoticeMutation, ReadNoticeMutationVariables>(ReadNoticeDocument, options);
      }
export type ReadNoticeMutationHookResult = ReturnType<typeof useReadNoticeMutation>;
export type ReadNoticeMutationResult = Apollo.MutationResult<ReadNoticeMutation>;
export type ReadNoticeMutationOptions = Apollo.BaseMutationOptions<ReadNoticeMutation, ReadNoticeMutationVariables>;
export const ReadAllNoticesDocument = gql`
    mutation readAllNotices {
  readAllNotices
}
    `;
export type ReadAllNoticesMutationFn = Apollo.MutationFunction<ReadAllNoticesMutation, ReadAllNoticesMutationVariables>;

/**
 * __useReadAllNoticesMutation__
 *
 * To run a mutation, you first call `useReadAllNoticesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllNoticesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllNoticesMutation, { data, loading, error }] = useReadAllNoticesMutation({
 *   variables: {
 *   },
 * });
 */
export function useReadAllNoticesMutation(baseOptions?: Apollo.MutationHookOptions<ReadAllNoticesMutation, ReadAllNoticesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadAllNoticesMutation, ReadAllNoticesMutationVariables>(ReadAllNoticesDocument, options);
      }
export type ReadAllNoticesMutationHookResult = ReturnType<typeof useReadAllNoticesMutation>;
export type ReadAllNoticesMutationResult = Apollo.MutationResult<ReadAllNoticesMutation>;
export type ReadAllNoticesMutationOptions = Apollo.BaseMutationOptions<ReadAllNoticesMutation, ReadAllNoticesMutationVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications($first: Int!, $after: String) {
  getNotifications(first: $first, after: $after) {
    items {
      ...Notification
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${NotificationFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables> & ({ variables: GetNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsSuspenseQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const ReadNotificationsDocument = gql`
    mutation readNotifications($first: Int!, $after: String) {
  readNotifications(first: $first, after: $after) {
    result
  }
}
    `;
export type ReadNotificationsMutationFn = Apollo.MutationFunction<ReadNotificationsMutation, ReadNotificationsMutationVariables>;

/**
 * __useReadNotificationsMutation__
 *
 * To run a mutation, you first call `useReadNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationsMutation, { data, loading, error }] = useReadNotificationsMutation({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReadNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ReadNotificationsMutation, ReadNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadNotificationsMutation, ReadNotificationsMutationVariables>(ReadNotificationsDocument, options);
      }
export type ReadNotificationsMutationHookResult = ReturnType<typeof useReadNotificationsMutation>;
export type ReadNotificationsMutationResult = Apollo.MutationResult<ReadNotificationsMutation>;
export type ReadNotificationsMutationOptions = Apollo.BaseMutationOptions<ReadNotificationsMutation, ReadNotificationsMutationVariables>;
export const ReadAllNotificationsDocument = gql`
    mutation readAllNotifications {
  readAllNotifications {
    result
  }
}
    `;
export type ReadAllNotificationsMutationFn = Apollo.MutationFunction<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>;

/**
 * __useReadAllNotificationsMutation__
 *
 * To run a mutation, you first call `useReadAllNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllNotificationsMutation, { data, loading, error }] = useReadAllNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useReadAllNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>(ReadAllNotificationsDocument, options);
      }
export type ReadAllNotificationsMutationHookResult = ReturnType<typeof useReadAllNotificationsMutation>;
export type ReadAllNotificationsMutationResult = Apollo.MutationResult<ReadAllNotificationsMutation>;
export type ReadAllNotificationsMutationOptions = Apollo.BaseMutationOptions<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>;
export const GetNotificationUnreadCountDocument = gql`
    query getNotificationUnreadCount {
  getNotificationUnreadCount {
    count
  }
  noticeUnreadCount
}
    `;

/**
 * __useGetNotificationUnreadCountQuery__
 *
 * To run a query within a React component, call `useGetNotificationUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationUnreadCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationUnreadCountQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>(GetNotificationUnreadCountDocument, options);
      }
export function useGetNotificationUnreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>(GetNotificationUnreadCountDocument, options);
        }
export function useGetNotificationUnreadCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>(GetNotificationUnreadCountDocument, options);
        }
export type GetNotificationUnreadCountQueryHookResult = ReturnType<typeof useGetNotificationUnreadCountQuery>;
export type GetNotificationUnreadCountLazyQueryHookResult = ReturnType<typeof useGetNotificationUnreadCountLazyQuery>;
export type GetNotificationUnreadCountSuspenseQueryHookResult = ReturnType<typeof useGetNotificationUnreadCountSuspenseQuery>;
export type GetNotificationUnreadCountQueryResult = Apollo.QueryResult<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>;
export const OnboardingDocument = gql`
    query onboarding {
  onboarding {
    isShowOnboarding
    isShowProfile
    isCompletedProfile
    isShowProgram
    isCompletedProgram
    isShowStudyReport
    isCompletedStudyReport
    isShowQuestion
    isCompletedQuestion
    isShowSpotLesson
    isCompletedSpotLesson
  }
}
    `;

/**
 * __useOnboardingQuery__
 *
 * To run a query within a React component, call `useOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingQuery, OnboardingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingQuery, OnboardingQueryVariables>(OnboardingDocument, options);
      }
export function useOnboardingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingQuery, OnboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingQuery, OnboardingQueryVariables>(OnboardingDocument, options);
        }
export function useOnboardingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OnboardingQuery, OnboardingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingQuery, OnboardingQueryVariables>(OnboardingDocument, options);
        }
export type OnboardingQueryHookResult = ReturnType<typeof useOnboardingQuery>;
export type OnboardingLazyQueryHookResult = ReturnType<typeof useOnboardingLazyQuery>;
export type OnboardingSuspenseQueryHookResult = ReturnType<typeof useOnboardingSuspenseQuery>;
export type OnboardingQueryResult = Apollo.QueryResult<OnboardingQuery, OnboardingQueryVariables>;
export const GetPaymentIntentsDocument = gql`
    query getPaymentIntents($input: PaymentIntentSearchInput!) {
  getPaymentIntents(input: $input) {
    total
    items {
      ...PaymentIntent
    }
  }
}
    ${PaymentIntentFragmentDoc}`;

/**
 * __useGetPaymentIntentsQuery__
 *
 * To run a query within a React component, call `useGetPaymentIntentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentIntentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentIntentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPaymentIntentsQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentIntentsQuery, GetPaymentIntentsQueryVariables> & ({ variables: GetPaymentIntentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentIntentsQuery, GetPaymentIntentsQueryVariables>(GetPaymentIntentsDocument, options);
      }
export function useGetPaymentIntentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentIntentsQuery, GetPaymentIntentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentIntentsQuery, GetPaymentIntentsQueryVariables>(GetPaymentIntentsDocument, options);
        }
export function useGetPaymentIntentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentIntentsQuery, GetPaymentIntentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentIntentsQuery, GetPaymentIntentsQueryVariables>(GetPaymentIntentsDocument, options);
        }
export type GetPaymentIntentsQueryHookResult = ReturnType<typeof useGetPaymentIntentsQuery>;
export type GetPaymentIntentsLazyQueryHookResult = ReturnType<typeof useGetPaymentIntentsLazyQuery>;
export type GetPaymentIntentsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentIntentsSuspenseQuery>;
export type GetPaymentIntentsQueryResult = Apollo.QueryResult<GetPaymentIntentsQuery, GetPaymentIntentsQueryVariables>;
export const GetPracticeDocument = gql`
    query getPractice($practiceID: ULID!, $userID: Uint64) {
  practice(practiceID: $practiceID) {
    ...PracticeDetail
  }
}
    ${PracticeDetailFragmentDoc}`;

/**
 * __useGetPracticeQuery__
 *
 * To run a query within a React component, call `useGetPracticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticeQuery({
 *   variables: {
 *      practiceID: // value for 'practiceID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useGetPracticeQuery(baseOptions: Apollo.QueryHookOptions<GetPracticeQuery, GetPracticeQueryVariables> & ({ variables: GetPracticeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPracticeQuery, GetPracticeQueryVariables>(GetPracticeDocument, options);
      }
export function useGetPracticeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPracticeQuery, GetPracticeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPracticeQuery, GetPracticeQueryVariables>(GetPracticeDocument, options);
        }
export function useGetPracticeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPracticeQuery, GetPracticeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPracticeQuery, GetPracticeQueryVariables>(GetPracticeDocument, options);
        }
export type GetPracticeQueryHookResult = ReturnType<typeof useGetPracticeQuery>;
export type GetPracticeLazyQueryHookResult = ReturnType<typeof useGetPracticeLazyQuery>;
export type GetPracticeSuspenseQueryHookResult = ReturnType<typeof useGetPracticeSuspenseQuery>;
export type GetPracticeQueryResult = Apollo.QueryResult<GetPracticeQuery, GetPracticeQueryVariables>;
export const GetPracticesDocument = gql`
    query getPractices($input: PracticeSearchInput!) {
  practices(input: $input) {
    items {
      ...PracticeListItem
    }
    total
  }
}
    ${PracticeListItemFragmentDoc}`;

/**
 * __useGetPracticesQuery__
 *
 * To run a query within a React component, call `useGetPracticesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPracticesQuery(baseOptions: Apollo.QueryHookOptions<GetPracticesQuery, GetPracticesQueryVariables> & ({ variables: GetPracticesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPracticesQuery, GetPracticesQueryVariables>(GetPracticesDocument, options);
      }
export function useGetPracticesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPracticesQuery, GetPracticesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPracticesQuery, GetPracticesQueryVariables>(GetPracticesDocument, options);
        }
export function useGetPracticesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPracticesQuery, GetPracticesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPracticesQuery, GetPracticesQueryVariables>(GetPracticesDocument, options);
        }
export type GetPracticesQueryHookResult = ReturnType<typeof useGetPracticesQuery>;
export type GetPracticesLazyQueryHookResult = ReturnType<typeof useGetPracticesLazyQuery>;
export type GetPracticesSuspenseQueryHookResult = ReturnType<typeof useGetPracticesSuspenseQuery>;
export type GetPracticesQueryResult = Apollo.QueryResult<GetPracticesQuery, GetPracticesQueryVariables>;
export const GetPracticeSubmitsDocument = gql`
    query getPracticeSubmits($input: PracticeSubmitSearchInput!) {
  getPracticeSubmits(input: $input) {
    items {
      ...PracticeSubmitList
    }
    total
  }
}
    ${PracticeSubmitListFragmentDoc}`;

/**
 * __useGetPracticeSubmitsQuery__
 *
 * To run a query within a React component, call `useGetPracticeSubmitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeSubmitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticeSubmitsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPracticeSubmitsQuery(baseOptions: Apollo.QueryHookOptions<GetPracticeSubmitsQuery, GetPracticeSubmitsQueryVariables> & ({ variables: GetPracticeSubmitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPracticeSubmitsQuery, GetPracticeSubmitsQueryVariables>(GetPracticeSubmitsDocument, options);
      }
export function useGetPracticeSubmitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPracticeSubmitsQuery, GetPracticeSubmitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPracticeSubmitsQuery, GetPracticeSubmitsQueryVariables>(GetPracticeSubmitsDocument, options);
        }
export function useGetPracticeSubmitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPracticeSubmitsQuery, GetPracticeSubmitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPracticeSubmitsQuery, GetPracticeSubmitsQueryVariables>(GetPracticeSubmitsDocument, options);
        }
export type GetPracticeSubmitsQueryHookResult = ReturnType<typeof useGetPracticeSubmitsQuery>;
export type GetPracticeSubmitsLazyQueryHookResult = ReturnType<typeof useGetPracticeSubmitsLazyQuery>;
export type GetPracticeSubmitsSuspenseQueryHookResult = ReturnType<typeof useGetPracticeSubmitsSuspenseQuery>;
export type GetPracticeSubmitsQueryResult = Apollo.QueryResult<GetPracticeSubmitsQuery, GetPracticeSubmitsQueryVariables>;
export const GetPracticeSubmitsForInstructorDocument = gql`
    query getPracticeSubmitsForInstructor($input: InstructorPracticeSubmitSearchInput!) {
  getPracticeSubmitsForInstructor(input: $input) {
    items {
      ...PracticeSubmitList
    }
    total
  }
}
    ${PracticeSubmitListFragmentDoc}`;

/**
 * __useGetPracticeSubmitsForInstructorQuery__
 *
 * To run a query within a React component, call `useGetPracticeSubmitsForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeSubmitsForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticeSubmitsForInstructorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPracticeSubmitsForInstructorQuery(baseOptions: Apollo.QueryHookOptions<GetPracticeSubmitsForInstructorQuery, GetPracticeSubmitsForInstructorQueryVariables> & ({ variables: GetPracticeSubmitsForInstructorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPracticeSubmitsForInstructorQuery, GetPracticeSubmitsForInstructorQueryVariables>(GetPracticeSubmitsForInstructorDocument, options);
      }
export function useGetPracticeSubmitsForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPracticeSubmitsForInstructorQuery, GetPracticeSubmitsForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPracticeSubmitsForInstructorQuery, GetPracticeSubmitsForInstructorQueryVariables>(GetPracticeSubmitsForInstructorDocument, options);
        }
export function useGetPracticeSubmitsForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPracticeSubmitsForInstructorQuery, GetPracticeSubmitsForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPracticeSubmitsForInstructorQuery, GetPracticeSubmitsForInstructorQueryVariables>(GetPracticeSubmitsForInstructorDocument, options);
        }
export type GetPracticeSubmitsForInstructorQueryHookResult = ReturnType<typeof useGetPracticeSubmitsForInstructorQuery>;
export type GetPracticeSubmitsForInstructorLazyQueryHookResult = ReturnType<typeof useGetPracticeSubmitsForInstructorLazyQuery>;
export type GetPracticeSubmitsForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetPracticeSubmitsForInstructorSuspenseQuery>;
export type GetPracticeSubmitsForInstructorQueryResult = Apollo.QueryResult<GetPracticeSubmitsForInstructorQuery, GetPracticeSubmitsForInstructorQueryVariables>;
export const GetPracticeSubmitDocument = gql`
    query getPracticeSubmit($id: ULID!) {
  getPracticeSubmit(id: $id) {
    ...PracticeSubmit
  }
}
    ${PracticeSubmitFragmentDoc}`;

/**
 * __useGetPracticeSubmitQuery__
 *
 * To run a query within a React component, call `useGetPracticeSubmitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeSubmitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticeSubmitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPracticeSubmitQuery(baseOptions: Apollo.QueryHookOptions<GetPracticeSubmitQuery, GetPracticeSubmitQueryVariables> & ({ variables: GetPracticeSubmitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPracticeSubmitQuery, GetPracticeSubmitQueryVariables>(GetPracticeSubmitDocument, options);
      }
export function useGetPracticeSubmitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPracticeSubmitQuery, GetPracticeSubmitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPracticeSubmitQuery, GetPracticeSubmitQueryVariables>(GetPracticeSubmitDocument, options);
        }
export function useGetPracticeSubmitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPracticeSubmitQuery, GetPracticeSubmitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPracticeSubmitQuery, GetPracticeSubmitQueryVariables>(GetPracticeSubmitDocument, options);
        }
export type GetPracticeSubmitQueryHookResult = ReturnType<typeof useGetPracticeSubmitQuery>;
export type GetPracticeSubmitLazyQueryHookResult = ReturnType<typeof useGetPracticeSubmitLazyQuery>;
export type GetPracticeSubmitSuspenseQueryHookResult = ReturnType<typeof useGetPracticeSubmitSuspenseQuery>;
export type GetPracticeSubmitQueryResult = Apollo.QueryResult<GetPracticeSubmitQuery, GetPracticeSubmitQueryVariables>;
export const GetPracticeSubmitForInstructorDocument = gql`
    query getPracticeSubmitForInstructor($id: ULID!) {
  getPracticeSubmitForInstructor(id: $id) {
    ...InstructorPracticeSubmit
  }
}
    ${InstructorPracticeSubmitFragmentDoc}`;

/**
 * __useGetPracticeSubmitForInstructorQuery__
 *
 * To run a query within a React component, call `useGetPracticeSubmitForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeSubmitForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticeSubmitForInstructorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPracticeSubmitForInstructorQuery(baseOptions: Apollo.QueryHookOptions<GetPracticeSubmitForInstructorQuery, GetPracticeSubmitForInstructorQueryVariables> & ({ variables: GetPracticeSubmitForInstructorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPracticeSubmitForInstructorQuery, GetPracticeSubmitForInstructorQueryVariables>(GetPracticeSubmitForInstructorDocument, options);
      }
export function useGetPracticeSubmitForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPracticeSubmitForInstructorQuery, GetPracticeSubmitForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPracticeSubmitForInstructorQuery, GetPracticeSubmitForInstructorQueryVariables>(GetPracticeSubmitForInstructorDocument, options);
        }
export function useGetPracticeSubmitForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPracticeSubmitForInstructorQuery, GetPracticeSubmitForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPracticeSubmitForInstructorQuery, GetPracticeSubmitForInstructorQueryVariables>(GetPracticeSubmitForInstructorDocument, options);
        }
export type GetPracticeSubmitForInstructorQueryHookResult = ReturnType<typeof useGetPracticeSubmitForInstructorQuery>;
export type GetPracticeSubmitForInstructorLazyQueryHookResult = ReturnType<typeof useGetPracticeSubmitForInstructorLazyQuery>;
export type GetPracticeSubmitForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetPracticeSubmitForInstructorSuspenseQuery>;
export type GetPracticeSubmitForInstructorQueryResult = Apollo.QueryResult<GetPracticeSubmitForInstructorQuery, GetPracticeSubmitForInstructorQueryVariables>;
export const NewPracticeSubmitDocument = gql`
    mutation newPracticeSubmit($input: PracticeSubmitInput!) {
  newPracticeSubmit(input: $input) {
    id
    practiceSubmitDetails {
      id
    }
  }
}
    `;
export type NewPracticeSubmitMutationFn = Apollo.MutationFunction<NewPracticeSubmitMutation, NewPracticeSubmitMutationVariables>;

/**
 * __useNewPracticeSubmitMutation__
 *
 * To run a mutation, you first call `useNewPracticeSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewPracticeSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newPracticeSubmitMutation, { data, loading, error }] = useNewPracticeSubmitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewPracticeSubmitMutation(baseOptions?: Apollo.MutationHookOptions<NewPracticeSubmitMutation, NewPracticeSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewPracticeSubmitMutation, NewPracticeSubmitMutationVariables>(NewPracticeSubmitDocument, options);
      }
export type NewPracticeSubmitMutationHookResult = ReturnType<typeof useNewPracticeSubmitMutation>;
export type NewPracticeSubmitMutationResult = Apollo.MutationResult<NewPracticeSubmitMutation>;
export type NewPracticeSubmitMutationOptions = Apollo.BaseMutationOptions<NewPracticeSubmitMutation, NewPracticeSubmitMutationVariables>;
export const RePracticeSubmitDocument = gql`
    mutation rePracticeSubmit($input: RePracticeSubmitInput!) {
  rePracticeSubmit(input: $input) {
    id
    practiceSubmitDetails {
      id
    }
  }
}
    `;
export type RePracticeSubmitMutationFn = Apollo.MutationFunction<RePracticeSubmitMutation, RePracticeSubmitMutationVariables>;

/**
 * __useRePracticeSubmitMutation__
 *
 * To run a mutation, you first call `useRePracticeSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRePracticeSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rePracticeSubmitMutation, { data, loading, error }] = useRePracticeSubmitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRePracticeSubmitMutation(baseOptions?: Apollo.MutationHookOptions<RePracticeSubmitMutation, RePracticeSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RePracticeSubmitMutation, RePracticeSubmitMutationVariables>(RePracticeSubmitDocument, options);
      }
export type RePracticeSubmitMutationHookResult = ReturnType<typeof useRePracticeSubmitMutation>;
export type RePracticeSubmitMutationResult = Apollo.MutationResult<RePracticeSubmitMutation>;
export type RePracticeSubmitMutationOptions = Apollo.BaseMutationOptions<RePracticeSubmitMutation, RePracticeSubmitMutationVariables>;
export const CreatePracticeSubmitDetailReviewCommentDocument = gql`
    mutation createPracticeSubmitDetailReviewComment($input: PracticeSubmitDetailReviewCommentInput!) {
  createPracticeSubmitDetailReviewComment(input: $input) {
    id
  }
}
    `;
export type CreatePracticeSubmitDetailReviewCommentMutationFn = Apollo.MutationFunction<CreatePracticeSubmitDetailReviewCommentMutation, CreatePracticeSubmitDetailReviewCommentMutationVariables>;

/**
 * __useCreatePracticeSubmitDetailReviewCommentMutation__
 *
 * To run a mutation, you first call `useCreatePracticeSubmitDetailReviewCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePracticeSubmitDetailReviewCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPracticeSubmitDetailReviewCommentMutation, { data, loading, error }] = useCreatePracticeSubmitDetailReviewCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePracticeSubmitDetailReviewCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePracticeSubmitDetailReviewCommentMutation, CreatePracticeSubmitDetailReviewCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePracticeSubmitDetailReviewCommentMutation, CreatePracticeSubmitDetailReviewCommentMutationVariables>(CreatePracticeSubmitDetailReviewCommentDocument, options);
      }
export type CreatePracticeSubmitDetailReviewCommentMutationHookResult = ReturnType<typeof useCreatePracticeSubmitDetailReviewCommentMutation>;
export type CreatePracticeSubmitDetailReviewCommentMutationResult = Apollo.MutationResult<CreatePracticeSubmitDetailReviewCommentMutation>;
export type CreatePracticeSubmitDetailReviewCommentMutationOptions = Apollo.BaseMutationOptions<CreatePracticeSubmitDetailReviewCommentMutation, CreatePracticeSubmitDetailReviewCommentMutationVariables>;
export const UpdatePracticeSubmitDetailReviewCommentDocument = gql`
    mutation updatePracticeSubmitDetailReviewComment($input: UpdatePracticeSubmitDetailReviewCommentInput!) {
  updatePracticeSubmitDetailReviewComment(input: $input) {
    id
  }
}
    `;
export type UpdatePracticeSubmitDetailReviewCommentMutationFn = Apollo.MutationFunction<UpdatePracticeSubmitDetailReviewCommentMutation, UpdatePracticeSubmitDetailReviewCommentMutationVariables>;

/**
 * __useUpdatePracticeSubmitDetailReviewCommentMutation__
 *
 * To run a mutation, you first call `useUpdatePracticeSubmitDetailReviewCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePracticeSubmitDetailReviewCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePracticeSubmitDetailReviewCommentMutation, { data, loading, error }] = useUpdatePracticeSubmitDetailReviewCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePracticeSubmitDetailReviewCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePracticeSubmitDetailReviewCommentMutation, UpdatePracticeSubmitDetailReviewCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePracticeSubmitDetailReviewCommentMutation, UpdatePracticeSubmitDetailReviewCommentMutationVariables>(UpdatePracticeSubmitDetailReviewCommentDocument, options);
      }
export type UpdatePracticeSubmitDetailReviewCommentMutationHookResult = ReturnType<typeof useUpdatePracticeSubmitDetailReviewCommentMutation>;
export type UpdatePracticeSubmitDetailReviewCommentMutationResult = Apollo.MutationResult<UpdatePracticeSubmitDetailReviewCommentMutation>;
export type UpdatePracticeSubmitDetailReviewCommentMutationOptions = Apollo.BaseMutationOptions<UpdatePracticeSubmitDetailReviewCommentMutation, UpdatePracticeSubmitDetailReviewCommentMutationVariables>;
export const GetTeamPricesDocument = gql`
    query getTeamPrices($paymentMethodType: PaymentMethodType!) {
  teamPrices(paymentMethodType: $paymentMethodType) {
    ...TeamPrice
  }
}
    ${TeamPriceFragmentDoc}`;

/**
 * __useGetTeamPricesQuery__
 *
 * To run a query within a React component, call `useGetTeamPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamPricesQuery({
 *   variables: {
 *      paymentMethodType: // value for 'paymentMethodType'
 *   },
 * });
 */
export function useGetTeamPricesQuery(baseOptions: Apollo.QueryHookOptions<GetTeamPricesQuery, GetTeamPricesQueryVariables> & ({ variables: GetTeamPricesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamPricesQuery, GetTeamPricesQueryVariables>(GetTeamPricesDocument, options);
      }
export function useGetTeamPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamPricesQuery, GetTeamPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamPricesQuery, GetTeamPricesQueryVariables>(GetTeamPricesDocument, options);
        }
export function useGetTeamPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamPricesQuery, GetTeamPricesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamPricesQuery, GetTeamPricesQueryVariables>(GetTeamPricesDocument, options);
        }
export type GetTeamPricesQueryHookResult = ReturnType<typeof useGetTeamPricesQuery>;
export type GetTeamPricesLazyQueryHookResult = ReturnType<typeof useGetTeamPricesLazyQuery>;
export type GetTeamPricesSuspenseQueryHookResult = ReturnType<typeof useGetTeamPricesSuspenseQuery>;
export type GetTeamPricesQueryResult = Apollo.QueryResult<GetTeamPricesQuery, GetTeamPricesQueryVariables>;
export const GetPriceDocument = gql`
    query getPrice($id: Uint64!) {
  getPrice(id: $id) {
    id
    product {
      id
      name
      productExtension {
        contractPeriod
        contractPeriodTypeLabel
        isMultiMonthContract
      }
    }
    unitAmountIncludingTax
  }
}
    `;

/**
 * __useGetPriceQuery__
 *
 * To run a query within a React component, call `useGetPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPriceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPriceQuery(baseOptions: Apollo.QueryHookOptions<GetPriceQuery, GetPriceQueryVariables> & ({ variables: GetPriceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPriceQuery, GetPriceQueryVariables>(GetPriceDocument, options);
      }
export function useGetPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPriceQuery, GetPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPriceQuery, GetPriceQueryVariables>(GetPriceDocument, options);
        }
export function useGetPriceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPriceQuery, GetPriceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPriceQuery, GetPriceQueryVariables>(GetPriceDocument, options);
        }
export type GetPriceQueryHookResult = ReturnType<typeof useGetPriceQuery>;
export type GetPriceLazyQueryHookResult = ReturnType<typeof useGetPriceLazyQuery>;
export type GetPriceSuspenseQueryHookResult = ReturnType<typeof useGetPriceSuspenseQuery>;
export type GetPriceQueryResult = Apollo.QueryResult<GetPriceQuery, GetPriceQueryVariables>;
export const GetProductDocument = gql`
    query getProduct($id: Uint64!) {
  getProduct(id: $id) {
    id
    name
    price {
      unitAmountIncludingTax
    }
    productExtension {
      contractPeriod
      contractPeriodTypeLabel
      isMultiMonthContract
    }
  }
}
    `;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables> & ({ variables: GetProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductSuspenseQueryHookResult = ReturnType<typeof useGetProductSuspenseQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetProgramsDocument = gql`
    query getPrograms($input: ProgramSearchInput!, $userID: Uint64) {
  programs(input: $input) {
    items {
      ...Program
    }
  }
}
    ${ProgramFragmentDoc}`;

/**
 * __useGetProgramsQuery__
 *
 * To run a query within a React component, call `useGetProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useGetProgramsQuery(baseOptions: Apollo.QueryHookOptions<GetProgramsQuery, GetProgramsQueryVariables> & ({ variables: GetProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramsQuery, GetProgramsQueryVariables>(GetProgramsDocument, options);
      }
export function useGetProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramsQuery, GetProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramsQuery, GetProgramsQueryVariables>(GetProgramsDocument, options);
        }
export function useGetProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgramsQuery, GetProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProgramsQuery, GetProgramsQueryVariables>(GetProgramsDocument, options);
        }
export type GetProgramsQueryHookResult = ReturnType<typeof useGetProgramsQuery>;
export type GetProgramsLazyQueryHookResult = ReturnType<typeof useGetProgramsLazyQuery>;
export type GetProgramsSuspenseQueryHookResult = ReturnType<typeof useGetProgramsSuspenseQuery>;
export type GetProgramsQueryResult = Apollo.QueryResult<GetProgramsQuery, GetProgramsQueryVariables>;
export const SearchProgramsDocument = gql`
    query searchPrograms($input: ProgramSearchInput!) {
  programs(input: $input) {
    items {
      ...ProgramSearch
    }
  }
}
    ${ProgramSearchFragmentDoc}`;

/**
 * __useSearchProgramsQuery__
 *
 * To run a query within a React component, call `useSearchProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProgramsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchProgramsQuery(baseOptions: Apollo.QueryHookOptions<SearchProgramsQuery, SearchProgramsQueryVariables> & ({ variables: SearchProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchProgramsQuery, SearchProgramsQueryVariables>(SearchProgramsDocument, options);
      }
export function useSearchProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchProgramsQuery, SearchProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchProgramsQuery, SearchProgramsQueryVariables>(SearchProgramsDocument, options);
        }
export function useSearchProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchProgramsQuery, SearchProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchProgramsQuery, SearchProgramsQueryVariables>(SearchProgramsDocument, options);
        }
export type SearchProgramsQueryHookResult = ReturnType<typeof useSearchProgramsQuery>;
export type SearchProgramsLazyQueryHookResult = ReturnType<typeof useSearchProgramsLazyQuery>;
export type SearchProgramsSuspenseQueryHookResult = ReturnType<typeof useSearchProgramsSuspenseQuery>;
export type SearchProgramsQueryResult = Apollo.QueryResult<SearchProgramsQuery, SearchProgramsQueryVariables>;
export const GetProgramDocument = gql`
    query getProgram($programID: Uint64!, $userID: Uint64) {
  program(programID: $programID) {
    ...ProgramDetail
  }
}
    ${ProgramDetailFragmentDoc}`;

/**
 * __useGetProgramQuery__
 *
 * To run a query within a React component, call `useGetProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramQuery({
 *   variables: {
 *      programID: // value for 'programID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useGetProgramQuery(baseOptions: Apollo.QueryHookOptions<GetProgramQuery, GetProgramQueryVariables> & ({ variables: GetProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramQuery, GetProgramQueryVariables>(GetProgramDocument, options);
      }
export function useGetProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramQuery, GetProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramQuery, GetProgramQueryVariables>(GetProgramDocument, options);
        }
export function useGetProgramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgramQuery, GetProgramQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProgramQuery, GetProgramQueryVariables>(GetProgramDocument, options);
        }
export type GetProgramQueryHookResult = ReturnType<typeof useGetProgramQuery>;
export type GetProgramLazyQueryHookResult = ReturnType<typeof useGetProgramLazyQuery>;
export type GetProgramSuspenseQueryHookResult = ReturnType<typeof useGetProgramSuspenseQuery>;
export type GetProgramQueryResult = Apollo.QueryResult<GetProgramQuery, GetProgramQueryVariables>;
export const GetLastStudiedWhileStudyingProgramDocument = gql`
    query getLastStudiedWhileStudyingProgram($userID: Uint64) {
  lastStudiedWhileStudyingProgram {
    ...ProgramDetail
  }
}
    ${ProgramDetailFragmentDoc}`;

/**
 * __useGetLastStudiedWhileStudyingProgramQuery__
 *
 * To run a query within a React component, call `useGetLastStudiedWhileStudyingProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastStudiedWhileStudyingProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastStudiedWhileStudyingProgramQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useGetLastStudiedWhileStudyingProgramQuery(baseOptions?: Apollo.QueryHookOptions<GetLastStudiedWhileStudyingProgramQuery, GetLastStudiedWhileStudyingProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastStudiedWhileStudyingProgramQuery, GetLastStudiedWhileStudyingProgramQueryVariables>(GetLastStudiedWhileStudyingProgramDocument, options);
      }
export function useGetLastStudiedWhileStudyingProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastStudiedWhileStudyingProgramQuery, GetLastStudiedWhileStudyingProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastStudiedWhileStudyingProgramQuery, GetLastStudiedWhileStudyingProgramQueryVariables>(GetLastStudiedWhileStudyingProgramDocument, options);
        }
export function useGetLastStudiedWhileStudyingProgramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLastStudiedWhileStudyingProgramQuery, GetLastStudiedWhileStudyingProgramQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLastStudiedWhileStudyingProgramQuery, GetLastStudiedWhileStudyingProgramQueryVariables>(GetLastStudiedWhileStudyingProgramDocument, options);
        }
export type GetLastStudiedWhileStudyingProgramQueryHookResult = ReturnType<typeof useGetLastStudiedWhileStudyingProgramQuery>;
export type GetLastStudiedWhileStudyingProgramLazyQueryHookResult = ReturnType<typeof useGetLastStudiedWhileStudyingProgramLazyQuery>;
export type GetLastStudiedWhileStudyingProgramSuspenseQueryHookResult = ReturnType<typeof useGetLastStudiedWhileStudyingProgramSuspenseQuery>;
export type GetLastStudiedWhileStudyingProgramQueryResult = Apollo.QueryResult<GetLastStudiedWhileStudyingProgramQuery, GetLastStudiedWhileStudyingProgramQueryVariables>;
export const CreateProgramFeedbackDocument = gql`
    mutation createProgramFeedback($input: ProgramFeedbackInput!) {
  createProgramFeedback(input: $input) {
    id
  }
}
    `;
export type CreateProgramFeedbackMutationFn = Apollo.MutationFunction<CreateProgramFeedbackMutation, CreateProgramFeedbackMutationVariables>;

/**
 * __useCreateProgramFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateProgramFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramFeedbackMutation, { data, loading, error }] = useCreateProgramFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProgramFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgramFeedbackMutation, CreateProgramFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProgramFeedbackMutation, CreateProgramFeedbackMutationVariables>(CreateProgramFeedbackDocument, options);
      }
export type CreateProgramFeedbackMutationHookResult = ReturnType<typeof useCreateProgramFeedbackMutation>;
export type CreateProgramFeedbackMutationResult = Apollo.MutationResult<CreateProgramFeedbackMutation>;
export type CreateProgramFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateProgramFeedbackMutation, CreateProgramFeedbackMutationVariables>;
export const GetProgramSamplesDocument = gql`
    query getProgramSamples($input: ProgramSampleSearchInput!) {
  getProgramSamples(input: $input) {
    items {
      ...ProgramSample
    }
  }
}
    ${ProgramSampleFragmentDoc}`;

/**
 * __useGetProgramSamplesQuery__
 *
 * To run a query within a React component, call `useGetProgramSamplesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramSamplesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramSamplesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProgramSamplesQuery(baseOptions: Apollo.QueryHookOptions<GetProgramSamplesQuery, GetProgramSamplesQueryVariables> & ({ variables: GetProgramSamplesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramSamplesQuery, GetProgramSamplesQueryVariables>(GetProgramSamplesDocument, options);
      }
export function useGetProgramSamplesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramSamplesQuery, GetProgramSamplesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramSamplesQuery, GetProgramSamplesQueryVariables>(GetProgramSamplesDocument, options);
        }
export function useGetProgramSamplesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgramSamplesQuery, GetProgramSamplesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProgramSamplesQuery, GetProgramSamplesQueryVariables>(GetProgramSamplesDocument, options);
        }
export type GetProgramSamplesQueryHookResult = ReturnType<typeof useGetProgramSamplesQuery>;
export type GetProgramSamplesLazyQueryHookResult = ReturnType<typeof useGetProgramSamplesLazyQuery>;
export type GetProgramSamplesSuspenseQueryHookResult = ReturnType<typeof useGetProgramSamplesSuspenseQuery>;
export type GetProgramSamplesQueryResult = Apollo.QueryResult<GetProgramSamplesQuery, GetProgramSamplesQueryVariables>;
export const GetProgramSatisfactionDocument = gql`
    query getProgramSatisfaction($programID: Uint64!) {
  programSatisfaction(programID: $programID) {
    ...ProgramSatisfaction
  }
  program(programID: $programID) {
    ...ProgramForProgramSatisfaction
  }
}
    ${ProgramSatisfactionFragmentDoc}
${ProgramForProgramSatisfactionFragmentDoc}`;

/**
 * __useGetProgramSatisfactionQuery__
 *
 * To run a query within a React component, call `useGetProgramSatisfactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramSatisfactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramSatisfactionQuery({
 *   variables: {
 *      programID: // value for 'programID'
 *   },
 * });
 */
export function useGetProgramSatisfactionQuery(baseOptions: Apollo.QueryHookOptions<GetProgramSatisfactionQuery, GetProgramSatisfactionQueryVariables> & ({ variables: GetProgramSatisfactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramSatisfactionQuery, GetProgramSatisfactionQueryVariables>(GetProgramSatisfactionDocument, options);
      }
export function useGetProgramSatisfactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramSatisfactionQuery, GetProgramSatisfactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramSatisfactionQuery, GetProgramSatisfactionQueryVariables>(GetProgramSatisfactionDocument, options);
        }
export function useGetProgramSatisfactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgramSatisfactionQuery, GetProgramSatisfactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProgramSatisfactionQuery, GetProgramSatisfactionQueryVariables>(GetProgramSatisfactionDocument, options);
        }
export type GetProgramSatisfactionQueryHookResult = ReturnType<typeof useGetProgramSatisfactionQuery>;
export type GetProgramSatisfactionLazyQueryHookResult = ReturnType<typeof useGetProgramSatisfactionLazyQuery>;
export type GetProgramSatisfactionSuspenseQueryHookResult = ReturnType<typeof useGetProgramSatisfactionSuspenseQuery>;
export type GetProgramSatisfactionQueryResult = Apollo.QueryResult<GetProgramSatisfactionQuery, GetProgramSatisfactionQueryVariables>;
export const CreateProgramSatisfactionDocument = gql`
    mutation createProgramSatisfaction($input: ProgramSatisfactionInput!) {
  createProgramSatisfaction(input: $input) {
    ...ProgramSatisfaction
  }
}
    ${ProgramSatisfactionFragmentDoc}`;
export type CreateProgramSatisfactionMutationFn = Apollo.MutationFunction<CreateProgramSatisfactionMutation, CreateProgramSatisfactionMutationVariables>;

/**
 * __useCreateProgramSatisfactionMutation__
 *
 * To run a mutation, you first call `useCreateProgramSatisfactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramSatisfactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramSatisfactionMutation, { data, loading, error }] = useCreateProgramSatisfactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProgramSatisfactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgramSatisfactionMutation, CreateProgramSatisfactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProgramSatisfactionMutation, CreateProgramSatisfactionMutationVariables>(CreateProgramSatisfactionDocument, options);
      }
export type CreateProgramSatisfactionMutationHookResult = ReturnType<typeof useCreateProgramSatisfactionMutation>;
export type CreateProgramSatisfactionMutationResult = Apollo.MutationResult<CreateProgramSatisfactionMutation>;
export type CreateProgramSatisfactionMutationOptions = Apollo.BaseMutationOptions<CreateProgramSatisfactionMutation, CreateProgramSatisfactionMutationVariables>;
export const ApplyPromotionCodeDocument = gql`
    query applyPromotionCode($promotionCode: String!, $priceID: Uint64!) {
  applyPromotionCode(promotionCode: $promotionCode, priceID: $priceID) {
    ...PromotionCodeApplyResult
  }
}
    ${PromotionCodeApplyResultFragmentDoc}`;

/**
 * __useApplyPromotionCodeQuery__
 *
 * To run a query within a React component, call `useApplyPromotionCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyPromotionCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyPromotionCodeQuery({
 *   variables: {
 *      promotionCode: // value for 'promotionCode'
 *      priceID: // value for 'priceID'
 *   },
 * });
 */
export function useApplyPromotionCodeQuery(baseOptions: Apollo.QueryHookOptions<ApplyPromotionCodeQuery, ApplyPromotionCodeQueryVariables> & ({ variables: ApplyPromotionCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplyPromotionCodeQuery, ApplyPromotionCodeQueryVariables>(ApplyPromotionCodeDocument, options);
      }
export function useApplyPromotionCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplyPromotionCodeQuery, ApplyPromotionCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplyPromotionCodeQuery, ApplyPromotionCodeQueryVariables>(ApplyPromotionCodeDocument, options);
        }
export function useApplyPromotionCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplyPromotionCodeQuery, ApplyPromotionCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplyPromotionCodeQuery, ApplyPromotionCodeQueryVariables>(ApplyPromotionCodeDocument, options);
        }
export type ApplyPromotionCodeQueryHookResult = ReturnType<typeof useApplyPromotionCodeQuery>;
export type ApplyPromotionCodeLazyQueryHookResult = ReturnType<typeof useApplyPromotionCodeLazyQuery>;
export type ApplyPromotionCodeSuspenseQueryHookResult = ReturnType<typeof useApplyPromotionCodeSuspenseQuery>;
export type ApplyPromotionCodeQueryResult = Apollo.QueryResult<ApplyPromotionCodeQuery, ApplyPromotionCodeQueryVariables>;
export const GetQuestionsDocument = gql`
    query getQuestions($input: QuestionSearchInput!) {
  getQuestions(input: $input) {
    items {
      ...QuestionList
    }
    total
  }
}
    ${QuestionListFragmentDoc}`;

/**
 * __useGetQuestionsQuery__
 *
 * To run a query within a React component, call `useGetQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionsQuery, GetQuestionsQueryVariables> & ({ variables: GetQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionsQuery, GetQuestionsQueryVariables>(GetQuestionsDocument, options);
      }
export function useGetQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionsQuery, GetQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionsQuery, GetQuestionsQueryVariables>(GetQuestionsDocument, options);
        }
export function useGetQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionsQuery, GetQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionsQuery, GetQuestionsQueryVariables>(GetQuestionsDocument, options);
        }
export type GetQuestionsQueryHookResult = ReturnType<typeof useGetQuestionsQuery>;
export type GetQuestionsLazyQueryHookResult = ReturnType<typeof useGetQuestionsLazyQuery>;
export type GetQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetQuestionsSuspenseQuery>;
export type GetQuestionsQueryResult = Apollo.QueryResult<GetQuestionsQuery, GetQuestionsQueryVariables>;
export const GetQuestionDocument = gql`
    query getQuestion($questionID: Uint64!) {
  getQuestion(id: $questionID) {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;

/**
 * __useGetQuestionQuery__
 *
 * To run a query within a React component, call `useGetQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionQuery({
 *   variables: {
 *      questionID: // value for 'questionID'
 *   },
 * });
 */
export function useGetQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionQuery, GetQuestionQueryVariables> & ({ variables: GetQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionQuery, GetQuestionQueryVariables>(GetQuestionDocument, options);
      }
export function useGetQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionQuery, GetQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionQuery, GetQuestionQueryVariables>(GetQuestionDocument, options);
        }
export function useGetQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionQuery, GetQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionQuery, GetQuestionQueryVariables>(GetQuestionDocument, options);
        }
export type GetQuestionQueryHookResult = ReturnType<typeof useGetQuestionQuery>;
export type GetQuestionLazyQueryHookResult = ReturnType<typeof useGetQuestionLazyQuery>;
export type GetQuestionSuspenseQueryHookResult = ReturnType<typeof useGetQuestionSuspenseQuery>;
export type GetQuestionQueryResult = Apollo.QueryResult<GetQuestionQuery, GetQuestionQueryVariables>;
export const ResolveQuestionDocument = gql`
    mutation resolveQuestion($questionID: Uint64!) {
  resolveQuestion(id: $questionID) {
    id
  }
}
    `;
export type ResolveQuestionMutationFn = Apollo.MutationFunction<ResolveQuestionMutation, ResolveQuestionMutationVariables>;

/**
 * __useResolveQuestionMutation__
 *
 * To run a mutation, you first call `useResolveQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveQuestionMutation, { data, loading, error }] = useResolveQuestionMutation({
 *   variables: {
 *      questionID: // value for 'questionID'
 *   },
 * });
 */
export function useResolveQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ResolveQuestionMutation, ResolveQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveQuestionMutation, ResolveQuestionMutationVariables>(ResolveQuestionDocument, options);
      }
export type ResolveQuestionMutationHookResult = ReturnType<typeof useResolveQuestionMutation>;
export type ResolveQuestionMutationResult = Apollo.MutationResult<ResolveQuestionMutation>;
export type ResolveQuestionMutationOptions = Apollo.BaseMutationOptions<ResolveQuestionMutation, ResolveQuestionMutationVariables>;
export const AddQuestionDocument = gql`
    mutation addQuestion($input: QuestionInput!) {
  addQuestion(input: $input) {
    id
  }
}
    `;
export type AddQuestionMutationFn = Apollo.MutationFunction<AddQuestionMutation, AddQuestionMutationVariables>;

/**
 * __useAddQuestionMutation__
 *
 * To run a mutation, you first call `useAddQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuestionMutation, { data, loading, error }] = useAddQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AddQuestionMutation, AddQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddQuestionMutation, AddQuestionMutationVariables>(AddQuestionDocument, options);
      }
export type AddQuestionMutationHookResult = ReturnType<typeof useAddQuestionMutation>;
export type AddQuestionMutationResult = Apollo.MutationResult<AddQuestionMutation>;
export type AddQuestionMutationOptions = Apollo.BaseMutationOptions<AddQuestionMutation, AddQuestionMutationVariables>;
export const UpdateQuestionDocument = gql`
    mutation updateQuestion($id: Uint64!, $input: QuestionInput!) {
  updateQuestion(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateQuestionMutationFn = Apollo.MutationFunction<UpdateQuestionMutation, UpdateQuestionMutationVariables>;

/**
 * __useUpdateQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionMutation, { data, loading, error }] = useUpdateQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionMutation, UpdateQuestionMutationVariables>(UpdateQuestionDocument, options);
      }
export type UpdateQuestionMutationHookResult = ReturnType<typeof useUpdateQuestionMutation>;
export type UpdateQuestionMutationResult = Apollo.MutationResult<UpdateQuestionMutation>;
export type UpdateQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>;
export const AddQuestionAnswerDocument = gql`
    mutation addQuestionAnswer($questionID: Uint64!, $input: QuestionAnswerInput!, $isEscalation: Boolean!) {
  addQuestionAnswer(
    questionID: $questionID
    input: $input
    isEscalation: $isEscalation
  ) {
    id
  }
}
    `;
export type AddQuestionAnswerMutationFn = Apollo.MutationFunction<AddQuestionAnswerMutation, AddQuestionAnswerMutationVariables>;

/**
 * __useAddQuestionAnswerMutation__
 *
 * To run a mutation, you first call `useAddQuestionAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuestionAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuestionAnswerMutation, { data, loading, error }] = useAddQuestionAnswerMutation({
 *   variables: {
 *      questionID: // value for 'questionID'
 *      input: // value for 'input'
 *      isEscalation: // value for 'isEscalation'
 *   },
 * });
 */
export function useAddQuestionAnswerMutation(baseOptions?: Apollo.MutationHookOptions<AddQuestionAnswerMutation, AddQuestionAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddQuestionAnswerMutation, AddQuestionAnswerMutationVariables>(AddQuestionAnswerDocument, options);
      }
export type AddQuestionAnswerMutationHookResult = ReturnType<typeof useAddQuestionAnswerMutation>;
export type AddQuestionAnswerMutationResult = Apollo.MutationResult<AddQuestionAnswerMutation>;
export type AddQuestionAnswerMutationOptions = Apollo.BaseMutationOptions<AddQuestionAnswerMutation, AddQuestionAnswerMutationVariables>;
export const UpdateQuestionAnswerDocument = gql`
    mutation updateQuestionAnswer($id: Uint64!, $input: QuestionAnswerInput!) {
  updateQuestionAnswer(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateQuestionAnswerMutationFn = Apollo.MutationFunction<UpdateQuestionAnswerMutation, UpdateQuestionAnswerMutationVariables>;

/**
 * __useUpdateQuestionAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionAnswerMutation, { data, loading, error }] = useUpdateQuestionAnswerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionAnswerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionAnswerMutation, UpdateQuestionAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionAnswerMutation, UpdateQuestionAnswerMutationVariables>(UpdateQuestionAnswerDocument, options);
      }
export type UpdateQuestionAnswerMutationHookResult = ReturnType<typeof useUpdateQuestionAnswerMutation>;
export type UpdateQuestionAnswerMutationResult = Apollo.MutationResult<UpdateQuestionAnswerMutation>;
export type UpdateQuestionAnswerMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionAnswerMutation, UpdateQuestionAnswerMutationVariables>;
export const AddQuestionCommentDocument = gql`
    mutation addQuestionComment($questionAnswerID: Uint64!, $input: QuestionCommentInput!) {
  addQuestionComment(questionAnswerID: $questionAnswerID, input: $input) {
    id
  }
}
    `;
export type AddQuestionCommentMutationFn = Apollo.MutationFunction<AddQuestionCommentMutation, AddQuestionCommentMutationVariables>;

/**
 * __useAddQuestionCommentMutation__
 *
 * To run a mutation, you first call `useAddQuestionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuestionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuestionCommentMutation, { data, loading, error }] = useAddQuestionCommentMutation({
 *   variables: {
 *      questionAnswerID: // value for 'questionAnswerID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddQuestionCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddQuestionCommentMutation, AddQuestionCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddQuestionCommentMutation, AddQuestionCommentMutationVariables>(AddQuestionCommentDocument, options);
      }
export type AddQuestionCommentMutationHookResult = ReturnType<typeof useAddQuestionCommentMutation>;
export type AddQuestionCommentMutationResult = Apollo.MutationResult<AddQuestionCommentMutation>;
export type AddQuestionCommentMutationOptions = Apollo.BaseMutationOptions<AddQuestionCommentMutation, AddQuestionCommentMutationVariables>;
export const AddQuestionAnswerEvaluationDocument = gql`
    mutation addQuestionAnswerEvaluation($input: QuestionAnswerEvaluationInput!) {
  addQuestionAnswerEvaluation(input: $input) {
    id
  }
}
    `;
export type AddQuestionAnswerEvaluationMutationFn = Apollo.MutationFunction<AddQuestionAnswerEvaluationMutation, AddQuestionAnswerEvaluationMutationVariables>;

/**
 * __useAddQuestionAnswerEvaluationMutation__
 *
 * To run a mutation, you first call `useAddQuestionAnswerEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuestionAnswerEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuestionAnswerEvaluationMutation, { data, loading, error }] = useAddQuestionAnswerEvaluationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddQuestionAnswerEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<AddQuestionAnswerEvaluationMutation, AddQuestionAnswerEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddQuestionAnswerEvaluationMutation, AddQuestionAnswerEvaluationMutationVariables>(AddQuestionAnswerEvaluationDocument, options);
      }
export type AddQuestionAnswerEvaluationMutationHookResult = ReturnType<typeof useAddQuestionAnswerEvaluationMutation>;
export type AddQuestionAnswerEvaluationMutationResult = Apollo.MutationResult<AddQuestionAnswerEvaluationMutation>;
export type AddQuestionAnswerEvaluationMutationOptions = Apollo.BaseMutationOptions<AddQuestionAnswerEvaluationMutation, AddQuestionAnswerEvaluationMutationVariables>;
export const UpdateQuestionCommentDocument = gql`
    mutation updateQuestionComment($id: Uint64!, $input: QuestionCommentInput!) {
  updateQuestionComment(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateQuestionCommentMutationFn = Apollo.MutationFunction<UpdateQuestionCommentMutation, UpdateQuestionCommentMutationVariables>;

/**
 * __useUpdateQuestionCommentMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionCommentMutation, { data, loading, error }] = useUpdateQuestionCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionCommentMutation, UpdateQuestionCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionCommentMutation, UpdateQuestionCommentMutationVariables>(UpdateQuestionCommentDocument, options);
      }
export type UpdateQuestionCommentMutationHookResult = ReturnType<typeof useUpdateQuestionCommentMutation>;
export type UpdateQuestionCommentMutationResult = Apollo.MutationResult<UpdateQuestionCommentMutation>;
export type UpdateQuestionCommentMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionCommentMutation, UpdateQuestionCommentMutationVariables>;
export const ChangeQuestionFavoriteStatusDocument = gql`
    mutation changeQuestionFavoriteStatus($questionID: Uint64!) {
  changeQuestionFavoriteStatus(questionID: $questionID) {
    userID
  }
}
    `;
export type ChangeQuestionFavoriteStatusMutationFn = Apollo.MutationFunction<ChangeQuestionFavoriteStatusMutation, ChangeQuestionFavoriteStatusMutationVariables>;

/**
 * __useChangeQuestionFavoriteStatusMutation__
 *
 * To run a mutation, you first call `useChangeQuestionFavoriteStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeQuestionFavoriteStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeQuestionFavoriteStatusMutation, { data, loading, error }] = useChangeQuestionFavoriteStatusMutation({
 *   variables: {
 *      questionID: // value for 'questionID'
 *   },
 * });
 */
export function useChangeQuestionFavoriteStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeQuestionFavoriteStatusMutation, ChangeQuestionFavoriteStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeQuestionFavoriteStatusMutation, ChangeQuestionFavoriteStatusMutationVariables>(ChangeQuestionFavoriteStatusDocument, options);
      }
export type ChangeQuestionFavoriteStatusMutationHookResult = ReturnType<typeof useChangeQuestionFavoriteStatusMutation>;
export type ChangeQuestionFavoriteStatusMutationResult = Apollo.MutationResult<ChangeQuestionFavoriteStatusMutation>;
export type ChangeQuestionFavoriteStatusMutationOptions = Apollo.BaseMutationOptions<ChangeQuestionFavoriteStatusMutation, ChangeQuestionFavoriteStatusMutationVariables>;
export const ChangeQuestionAnswerFavoriteStatusDocument = gql`
    mutation changeQuestionAnswerFavoriteStatus($questionAnswerID: Uint64!) {
  changeQuestionAnswerFavoriteStatus(questionAnswerID: $questionAnswerID) {
    userID
  }
}
    `;
export type ChangeQuestionAnswerFavoriteStatusMutationFn = Apollo.MutationFunction<ChangeQuestionAnswerFavoriteStatusMutation, ChangeQuestionAnswerFavoriteStatusMutationVariables>;

/**
 * __useChangeQuestionAnswerFavoriteStatusMutation__
 *
 * To run a mutation, you first call `useChangeQuestionAnswerFavoriteStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeQuestionAnswerFavoriteStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeQuestionAnswerFavoriteStatusMutation, { data, loading, error }] = useChangeQuestionAnswerFavoriteStatusMutation({
 *   variables: {
 *      questionAnswerID: // value for 'questionAnswerID'
 *   },
 * });
 */
export function useChangeQuestionAnswerFavoriteStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeQuestionAnswerFavoriteStatusMutation, ChangeQuestionAnswerFavoriteStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeQuestionAnswerFavoriteStatusMutation, ChangeQuestionAnswerFavoriteStatusMutationVariables>(ChangeQuestionAnswerFavoriteStatusDocument, options);
      }
export type ChangeQuestionAnswerFavoriteStatusMutationHookResult = ReturnType<typeof useChangeQuestionAnswerFavoriteStatusMutation>;
export type ChangeQuestionAnswerFavoriteStatusMutationResult = Apollo.MutationResult<ChangeQuestionAnswerFavoriteStatusMutation>;
export type ChangeQuestionAnswerFavoriteStatusMutationOptions = Apollo.BaseMutationOptions<ChangeQuestionAnswerFavoriteStatusMutation, ChangeQuestionAnswerFavoriteStatusMutationVariables>;
export const NewRegisteredQuestionnaireDocument = gql`
    mutation NewRegisteredQuestionnaire($questionnaireInput: NewRegisteredQuestionnaireInput!) {
  NewRegisteredQuestionnaire(questionnaireInput: $questionnaireInput)
}
    `;
export type NewRegisteredQuestionnaireMutationFn = Apollo.MutationFunction<NewRegisteredQuestionnaireMutation, NewRegisteredQuestionnaireMutationVariables>;

/**
 * __useNewRegisteredQuestionnaireMutation__
 *
 * To run a mutation, you first call `useNewRegisteredQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewRegisteredQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newRegisteredQuestionnaireMutation, { data, loading, error }] = useNewRegisteredQuestionnaireMutation({
 *   variables: {
 *      questionnaireInput: // value for 'questionnaireInput'
 *   },
 * });
 */
export function useNewRegisteredQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<NewRegisteredQuestionnaireMutation, NewRegisteredQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewRegisteredQuestionnaireMutation, NewRegisteredQuestionnaireMutationVariables>(NewRegisteredQuestionnaireDocument, options);
      }
export type NewRegisteredQuestionnaireMutationHookResult = ReturnType<typeof useNewRegisteredQuestionnaireMutation>;
export type NewRegisteredQuestionnaireMutationResult = Apollo.MutationResult<NewRegisteredQuestionnaireMutation>;
export type NewRegisteredQuestionnaireMutationOptions = Apollo.BaseMutationOptions<NewRegisteredQuestionnaireMutation, NewRegisteredQuestionnaireMutationVariables>;
export const RechargeRegisteredQuestionnaireDocument = gql`
    mutation RechargeRegisteredQuestionnaire($questionnaireInput: RechargeRegisteredQuestionnaireInput!) {
  RechargeRegisteredQuestionnaire(questionnaireInput: $questionnaireInput)
}
    `;
export type RechargeRegisteredQuestionnaireMutationFn = Apollo.MutationFunction<RechargeRegisteredQuestionnaireMutation, RechargeRegisteredQuestionnaireMutationVariables>;

/**
 * __useRechargeRegisteredQuestionnaireMutation__
 *
 * To run a mutation, you first call `useRechargeRegisteredQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRechargeRegisteredQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rechargeRegisteredQuestionnaireMutation, { data, loading, error }] = useRechargeRegisteredQuestionnaireMutation({
 *   variables: {
 *      questionnaireInput: // value for 'questionnaireInput'
 *   },
 * });
 */
export function useRechargeRegisteredQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<RechargeRegisteredQuestionnaireMutation, RechargeRegisteredQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RechargeRegisteredQuestionnaireMutation, RechargeRegisteredQuestionnaireMutationVariables>(RechargeRegisteredQuestionnaireDocument, options);
      }
export type RechargeRegisteredQuestionnaireMutationHookResult = ReturnType<typeof useRechargeRegisteredQuestionnaireMutation>;
export type RechargeRegisteredQuestionnaireMutationResult = Apollo.MutationResult<RechargeRegisteredQuestionnaireMutation>;
export type RechargeRegisteredQuestionnaireMutationOptions = Apollo.BaseMutationOptions<RechargeRegisteredQuestionnaireMutation, RechargeRegisteredQuestionnaireMutationVariables>;
export const CreateServiceFeedbackDocument = gql`
    mutation createServiceFeedback($input: ServiceFeedbackInput!) {
  createServiceFeedback(input: $input) {
    feedbackCategory {
      name
    }
  }
}
    `;
export type CreateServiceFeedbackMutationFn = Apollo.MutationFunction<CreateServiceFeedbackMutation, CreateServiceFeedbackMutationVariables>;

/**
 * __useCreateServiceFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateServiceFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceFeedbackMutation, { data, loading, error }] = useCreateServiceFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceFeedbackMutation, CreateServiceFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceFeedbackMutation, CreateServiceFeedbackMutationVariables>(CreateServiceFeedbackDocument, options);
      }
export type CreateServiceFeedbackMutationHookResult = ReturnType<typeof useCreateServiceFeedbackMutation>;
export type CreateServiceFeedbackMutationResult = Apollo.MutationResult<CreateServiceFeedbackMutation>;
export type CreateServiceFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateServiceFeedbackMutation, CreateServiceFeedbackMutationVariables>;
export const GetNextSessionForStudentDocument = gql`
    query getNextSessionForStudent {
  nextSessionForStudent {
    ...SessionListForStudent
  }
}
    ${SessionListForStudentFragmentDoc}`;

/**
 * __useGetNextSessionForStudentQuery__
 *
 * To run a query within a React component, call `useGetNextSessionForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextSessionForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextSessionForStudentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNextSessionForStudentQuery(baseOptions?: Apollo.QueryHookOptions<GetNextSessionForStudentQuery, GetNextSessionForStudentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextSessionForStudentQuery, GetNextSessionForStudentQueryVariables>(GetNextSessionForStudentDocument, options);
      }
export function useGetNextSessionForStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextSessionForStudentQuery, GetNextSessionForStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextSessionForStudentQuery, GetNextSessionForStudentQueryVariables>(GetNextSessionForStudentDocument, options);
        }
export function useGetNextSessionForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNextSessionForStudentQuery, GetNextSessionForStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNextSessionForStudentQuery, GetNextSessionForStudentQueryVariables>(GetNextSessionForStudentDocument, options);
        }
export type GetNextSessionForStudentQueryHookResult = ReturnType<typeof useGetNextSessionForStudentQuery>;
export type GetNextSessionForStudentLazyQueryHookResult = ReturnType<typeof useGetNextSessionForStudentLazyQuery>;
export type GetNextSessionForStudentSuspenseQueryHookResult = ReturnType<typeof useGetNextSessionForStudentSuspenseQuery>;
export type GetNextSessionForStudentQueryResult = Apollo.QueryResult<GetNextSessionForStudentQuery, GetNextSessionForStudentQueryVariables>;
export const GetNextSessionForInstructorDocument = gql`
    query getNextSessionForInstructor {
  nextSessionForInstructor {
    ...SessionInstrForInstructor
  }
}
    ${SessionInstrForInstructorFragmentDoc}`;

/**
 * __useGetNextSessionForInstructorQuery__
 *
 * To run a query within a React component, call `useGetNextSessionForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextSessionForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextSessionForInstructorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNextSessionForInstructorQuery(baseOptions?: Apollo.QueryHookOptions<GetNextSessionForInstructorQuery, GetNextSessionForInstructorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextSessionForInstructorQuery, GetNextSessionForInstructorQueryVariables>(GetNextSessionForInstructorDocument, options);
      }
export function useGetNextSessionForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextSessionForInstructorQuery, GetNextSessionForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextSessionForInstructorQuery, GetNextSessionForInstructorQueryVariables>(GetNextSessionForInstructorDocument, options);
        }
export function useGetNextSessionForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNextSessionForInstructorQuery, GetNextSessionForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNextSessionForInstructorQuery, GetNextSessionForInstructorQueryVariables>(GetNextSessionForInstructorDocument, options);
        }
export type GetNextSessionForInstructorQueryHookResult = ReturnType<typeof useGetNextSessionForInstructorQuery>;
export type GetNextSessionForInstructorLazyQueryHookResult = ReturnType<typeof useGetNextSessionForInstructorLazyQuery>;
export type GetNextSessionForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetNextSessionForInstructorSuspenseQuery>;
export type GetNextSessionForInstructorQueryResult = Apollo.QueryResult<GetNextSessionForInstructorQuery, GetNextSessionForInstructorQueryVariables>;
export const GetSessionsForInstructorDocument = gql`
    query getSessionsForInstructor($input: SessionSearchInput!) {
  sessionsForInstructor(input: $input) {
    ...SessionListForInstructor
  }
}
    ${SessionListForInstructorFragmentDoc}`;

/**
 * __useGetSessionsForInstructorQuery__
 *
 * To run a query within a React component, call `useGetSessionsForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionsForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionsForInstructorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSessionsForInstructorQuery(baseOptions: Apollo.QueryHookOptions<GetSessionsForInstructorQuery, GetSessionsForInstructorQueryVariables> & ({ variables: GetSessionsForInstructorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionsForInstructorQuery, GetSessionsForInstructorQueryVariables>(GetSessionsForInstructorDocument, options);
      }
export function useGetSessionsForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionsForInstructorQuery, GetSessionsForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionsForInstructorQuery, GetSessionsForInstructorQueryVariables>(GetSessionsForInstructorDocument, options);
        }
export function useGetSessionsForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSessionsForInstructorQuery, GetSessionsForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSessionsForInstructorQuery, GetSessionsForInstructorQueryVariables>(GetSessionsForInstructorDocument, options);
        }
export type GetSessionsForInstructorQueryHookResult = ReturnType<typeof useGetSessionsForInstructorQuery>;
export type GetSessionsForInstructorLazyQueryHookResult = ReturnType<typeof useGetSessionsForInstructorLazyQuery>;
export type GetSessionsForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetSessionsForInstructorSuspenseQuery>;
export type GetSessionsForInstructorQueryResult = Apollo.QueryResult<GetSessionsForInstructorQuery, GetSessionsForInstructorQueryVariables>;
export const GetSessionAndSessionReportForInstructorDocument = gql`
    query getSessionAndSessionReportForInstructor($sessionID: ULID!) {
  session(id: $sessionID) {
    ...SessionInstrForInstructor
  }
  sessionReportBySessionIDForInstructor(sessionID: $sessionID) {
    ...SessionReportForInstructor
  }
}
    ${SessionInstrForInstructorFragmentDoc}
${SessionReportForInstructorFragmentDoc}`;

/**
 * __useGetSessionAndSessionReportForInstructorQuery__
 *
 * To run a query within a React component, call `useGetSessionAndSessionReportForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionAndSessionReportForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionAndSessionReportForInstructorQuery({
 *   variables: {
 *      sessionID: // value for 'sessionID'
 *   },
 * });
 */
export function useGetSessionAndSessionReportForInstructorQuery(baseOptions: Apollo.QueryHookOptions<GetSessionAndSessionReportForInstructorQuery, GetSessionAndSessionReportForInstructorQueryVariables> & ({ variables: GetSessionAndSessionReportForInstructorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionAndSessionReportForInstructorQuery, GetSessionAndSessionReportForInstructorQueryVariables>(GetSessionAndSessionReportForInstructorDocument, options);
      }
export function useGetSessionAndSessionReportForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionAndSessionReportForInstructorQuery, GetSessionAndSessionReportForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionAndSessionReportForInstructorQuery, GetSessionAndSessionReportForInstructorQueryVariables>(GetSessionAndSessionReportForInstructorDocument, options);
        }
export function useGetSessionAndSessionReportForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSessionAndSessionReportForInstructorQuery, GetSessionAndSessionReportForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSessionAndSessionReportForInstructorQuery, GetSessionAndSessionReportForInstructorQueryVariables>(GetSessionAndSessionReportForInstructorDocument, options);
        }
export type GetSessionAndSessionReportForInstructorQueryHookResult = ReturnType<typeof useGetSessionAndSessionReportForInstructorQuery>;
export type GetSessionAndSessionReportForInstructorLazyQueryHookResult = ReturnType<typeof useGetSessionAndSessionReportForInstructorLazyQuery>;
export type GetSessionAndSessionReportForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetSessionAndSessionReportForInstructorSuspenseQuery>;
export type GetSessionAndSessionReportForInstructorQueryResult = Apollo.QueryResult<GetSessionAndSessionReportForInstructorQuery, GetSessionAndSessionReportForInstructorQueryVariables>;
export const GetSessionsForStudentDocument = gql`
    query getSessionsForStudent {
  sessionsForStudent {
    ...SessionListForStudent
  }
}
    ${SessionListForStudentFragmentDoc}`;

/**
 * __useGetSessionsForStudentQuery__
 *
 * To run a query within a React component, call `useGetSessionsForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionsForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionsForStudentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSessionsForStudentQuery(baseOptions?: Apollo.QueryHookOptions<GetSessionsForStudentQuery, GetSessionsForStudentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionsForStudentQuery, GetSessionsForStudentQueryVariables>(GetSessionsForStudentDocument, options);
      }
export function useGetSessionsForStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionsForStudentQuery, GetSessionsForStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionsForStudentQuery, GetSessionsForStudentQueryVariables>(GetSessionsForStudentDocument, options);
        }
export function useGetSessionsForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSessionsForStudentQuery, GetSessionsForStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSessionsForStudentQuery, GetSessionsForStudentQueryVariables>(GetSessionsForStudentDocument, options);
        }
export type GetSessionsForStudentQueryHookResult = ReturnType<typeof useGetSessionsForStudentQuery>;
export type GetSessionsForStudentLazyQueryHookResult = ReturnType<typeof useGetSessionsForStudentLazyQuery>;
export type GetSessionsForStudentSuspenseQueryHookResult = ReturnType<typeof useGetSessionsForStudentSuspenseQuery>;
export type GetSessionsForStudentQueryResult = Apollo.QueryResult<GetSessionsForStudentQuery, GetSessionsForStudentQueryVariables>;
export const CreateSessionDocument = gql`
    mutation createSession($coachingID: ULID!, $input: SessionInput!) {
  createSession(coachingID: $coachingID, input: $input) {
    id
  }
}
    `;
export type CreateSessionMutationFn = Apollo.MutationFunction<CreateSessionMutation, CreateSessionMutationVariables>;

/**
 * __useCreateSessionMutation__
 *
 * To run a mutation, you first call `useCreateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionMutation, { data, loading, error }] = useCreateSessionMutation({
 *   variables: {
 *      coachingID: // value for 'coachingID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSessionMutation, CreateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSessionMutation, CreateSessionMutationVariables>(CreateSessionDocument, options);
      }
export type CreateSessionMutationHookResult = ReturnType<typeof useCreateSessionMutation>;
export type CreateSessionMutationResult = Apollo.MutationResult<CreateSessionMutation>;
export type CreateSessionMutationOptions = Apollo.BaseMutationOptions<CreateSessionMutation, CreateSessionMutationVariables>;
export const UpdateSessionDocument = gql`
    mutation updateSession($id: ULID!, $input: SessionInput!) {
  updateSession(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateSessionMutationFn = Apollo.MutationFunction<UpdateSessionMutation, UpdateSessionMutationVariables>;

/**
 * __useUpdateSessionMutation__
 *
 * To run a mutation, you first call `useUpdateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionMutation, { data, loading, error }] = useUpdateSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionMutation, UpdateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSessionMutation, UpdateSessionMutationVariables>(UpdateSessionDocument, options);
      }
export type UpdateSessionMutationHookResult = ReturnType<typeof useUpdateSessionMutation>;
export type UpdateSessionMutationResult = Apollo.MutationResult<UpdateSessionMutation>;
export type UpdateSessionMutationOptions = Apollo.BaseMutationOptions<UpdateSessionMutation, UpdateSessionMutationVariables>;
export const CreateSessionReportDocument = gql`
    mutation createSessionReport($id: ULID!, $input: SessionReportInput!) {
  createSessionReport(id: $id, input: $input) {
    id
  }
}
    `;
export type CreateSessionReportMutationFn = Apollo.MutationFunction<CreateSessionReportMutation, CreateSessionReportMutationVariables>;

/**
 * __useCreateSessionReportMutation__
 *
 * To run a mutation, you first call `useCreateSessionReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionReportMutation, { data, loading, error }] = useCreateSessionReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSessionReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateSessionReportMutation, CreateSessionReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSessionReportMutation, CreateSessionReportMutationVariables>(CreateSessionReportDocument, options);
      }
export type CreateSessionReportMutationHookResult = ReturnType<typeof useCreateSessionReportMutation>;
export type CreateSessionReportMutationResult = Apollo.MutationResult<CreateSessionReportMutation>;
export type CreateSessionReportMutationOptions = Apollo.BaseMutationOptions<CreateSessionReportMutation, CreateSessionReportMutationVariables>;
export const UpdateSessionReportDocument = gql`
    mutation updateSessionReport($id: ULID!, $input: SessionReportInput!) {
  updateSessionReport(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateSessionReportMutationFn = Apollo.MutationFunction<UpdateSessionReportMutation, UpdateSessionReportMutationVariables>;

/**
 * __useUpdateSessionReportMutation__
 *
 * To run a mutation, you first call `useUpdateSessionReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionReportMutation, { data, loading, error }] = useUpdateSessionReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSessionReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionReportMutation, UpdateSessionReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSessionReportMutation, UpdateSessionReportMutationVariables>(UpdateSessionReportDocument, options);
      }
export type UpdateSessionReportMutationHookResult = ReturnType<typeof useUpdateSessionReportMutation>;
export type UpdateSessionReportMutationResult = Apollo.MutationResult<UpdateSessionReportMutation>;
export type UpdateSessionReportMutationOptions = Apollo.BaseMutationOptions<UpdateSessionReportMutation, UpdateSessionReportMutationVariables>;
export const UpdateSpotLessonDocument = gql`
    mutation updateSpotLesson($id: Uint64!, $input: SpotLessonUpdateInput!) {
  updateSpotLesson(id: $id, input: $input)
}
    `;
export type UpdateSpotLessonMutationFn = Apollo.MutationFunction<UpdateSpotLessonMutation, UpdateSpotLessonMutationVariables>;

/**
 * __useUpdateSpotLessonMutation__
 *
 * To run a mutation, you first call `useUpdateSpotLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpotLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpotLessonMutation, { data, loading, error }] = useUpdateSpotLessonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpotLessonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpotLessonMutation, UpdateSpotLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpotLessonMutation, UpdateSpotLessonMutationVariables>(UpdateSpotLessonDocument, options);
      }
export type UpdateSpotLessonMutationHookResult = ReturnType<typeof useUpdateSpotLessonMutation>;
export type UpdateSpotLessonMutationResult = Apollo.MutationResult<UpdateSpotLessonMutation>;
export type UpdateSpotLessonMutationOptions = Apollo.BaseMutationOptions<UpdateSpotLessonMutation, UpdateSpotLessonMutationVariables>;
export const ReserveSpotLessonDocument = gql`
    mutation reserveSpotLesson($input: SpotLessonInput!) {
  reserveSpotLesson(input: $input)
}
    `;
export type ReserveSpotLessonMutationFn = Apollo.MutationFunction<ReserveSpotLessonMutation, ReserveSpotLessonMutationVariables>;

/**
 * __useReserveSpotLessonMutation__
 *
 * To run a mutation, you first call `useReserveSpotLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReserveSpotLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reserveSpotLessonMutation, { data, loading, error }] = useReserveSpotLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReserveSpotLessonMutation(baseOptions?: Apollo.MutationHookOptions<ReserveSpotLessonMutation, ReserveSpotLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReserveSpotLessonMutation, ReserveSpotLessonMutationVariables>(ReserveSpotLessonDocument, options);
      }
export type ReserveSpotLessonMutationHookResult = ReturnType<typeof useReserveSpotLessonMutation>;
export type ReserveSpotLessonMutationResult = Apollo.MutationResult<ReserveSpotLessonMutation>;
export type ReserveSpotLessonMutationOptions = Apollo.BaseMutationOptions<ReserveSpotLessonMutation, ReserveSpotLessonMutationVariables>;
export const CancelSpotLessonDocument = gql`
    mutation cancelSpotLesson($id: Uint64!) {
  cancelSpotLesson(id: $id)
}
    `;
export type CancelSpotLessonMutationFn = Apollo.MutationFunction<CancelSpotLessonMutation, CancelSpotLessonMutationVariables>;

/**
 * __useCancelSpotLessonMutation__
 *
 * To run a mutation, you first call `useCancelSpotLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSpotLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSpotLessonMutation, { data, loading, error }] = useCancelSpotLessonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelSpotLessonMutation(baseOptions?: Apollo.MutationHookOptions<CancelSpotLessonMutation, CancelSpotLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSpotLessonMutation, CancelSpotLessonMutationVariables>(CancelSpotLessonDocument, options);
      }
export type CancelSpotLessonMutationHookResult = ReturnType<typeof useCancelSpotLessonMutation>;
export type CancelSpotLessonMutationResult = Apollo.MutationResult<CancelSpotLessonMutation>;
export type CancelSpotLessonMutationOptions = Apollo.BaseMutationOptions<CancelSpotLessonMutation, CancelSpotLessonMutationVariables>;
export const CompleteSpotLessonForInstructorDocument = gql`
    mutation completeSpotLessonForInstructor($id: Uint64!) {
  completeSpotLessonForInstructor(id: $id)
}
    `;
export type CompleteSpotLessonForInstructorMutationFn = Apollo.MutationFunction<CompleteSpotLessonForInstructorMutation, CompleteSpotLessonForInstructorMutationVariables>;

/**
 * __useCompleteSpotLessonForInstructorMutation__
 *
 * To run a mutation, you first call `useCompleteSpotLessonForInstructorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSpotLessonForInstructorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSpotLessonForInstructorMutation, { data, loading, error }] = useCompleteSpotLessonForInstructorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompleteSpotLessonForInstructorMutation(baseOptions?: Apollo.MutationHookOptions<CompleteSpotLessonForInstructorMutation, CompleteSpotLessonForInstructorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteSpotLessonForInstructorMutation, CompleteSpotLessonForInstructorMutationVariables>(CompleteSpotLessonForInstructorDocument, options);
      }
export type CompleteSpotLessonForInstructorMutationHookResult = ReturnType<typeof useCompleteSpotLessonForInstructorMutation>;
export type CompleteSpotLessonForInstructorMutationResult = Apollo.MutationResult<CompleteSpotLessonForInstructorMutation>;
export type CompleteSpotLessonForInstructorMutationOptions = Apollo.BaseMutationOptions<CompleteSpotLessonForInstructorMutation, CompleteSpotLessonForInstructorMutationVariables>;
export const NonAttendanceSpotLessonForInstructorDocument = gql`
    mutation nonAttendanceSpotLessonForInstructor($id: Uint64!) {
  nonAttendanceSpotLessonForInstructor(id: $id)
}
    `;
export type NonAttendanceSpotLessonForInstructorMutationFn = Apollo.MutationFunction<NonAttendanceSpotLessonForInstructorMutation, NonAttendanceSpotLessonForInstructorMutationVariables>;

/**
 * __useNonAttendanceSpotLessonForInstructorMutation__
 *
 * To run a mutation, you first call `useNonAttendanceSpotLessonForInstructorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNonAttendanceSpotLessonForInstructorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nonAttendanceSpotLessonForInstructorMutation, { data, loading, error }] = useNonAttendanceSpotLessonForInstructorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNonAttendanceSpotLessonForInstructorMutation(baseOptions?: Apollo.MutationHookOptions<NonAttendanceSpotLessonForInstructorMutation, NonAttendanceSpotLessonForInstructorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NonAttendanceSpotLessonForInstructorMutation, NonAttendanceSpotLessonForInstructorMutationVariables>(NonAttendanceSpotLessonForInstructorDocument, options);
      }
export type NonAttendanceSpotLessonForInstructorMutationHookResult = ReturnType<typeof useNonAttendanceSpotLessonForInstructorMutation>;
export type NonAttendanceSpotLessonForInstructorMutationResult = Apollo.MutationResult<NonAttendanceSpotLessonForInstructorMutation>;
export type NonAttendanceSpotLessonForInstructorMutationOptions = Apollo.BaseMutationOptions<NonAttendanceSpotLessonForInstructorMutation, NonAttendanceSpotLessonForInstructorMutationVariables>;
export const GetSpotLessonDocument = gql`
    query getSpotLesson($id: Uint64!) {
  spotLesson(id: $id) {
    ...SpotLesson
  }
}
    ${SpotLessonFragmentDoc}`;

/**
 * __useGetSpotLessonQuery__
 *
 * To run a query within a React component, call `useGetSpotLessonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpotLessonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpotLessonQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSpotLessonQuery(baseOptions: Apollo.QueryHookOptions<GetSpotLessonQuery, GetSpotLessonQueryVariables> & ({ variables: GetSpotLessonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpotLessonQuery, GetSpotLessonQueryVariables>(GetSpotLessonDocument, options);
      }
export function useGetSpotLessonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpotLessonQuery, GetSpotLessonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpotLessonQuery, GetSpotLessonQueryVariables>(GetSpotLessonDocument, options);
        }
export function useGetSpotLessonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpotLessonQuery, GetSpotLessonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpotLessonQuery, GetSpotLessonQueryVariables>(GetSpotLessonDocument, options);
        }
export type GetSpotLessonQueryHookResult = ReturnType<typeof useGetSpotLessonQuery>;
export type GetSpotLessonLazyQueryHookResult = ReturnType<typeof useGetSpotLessonLazyQuery>;
export type GetSpotLessonSuspenseQueryHookResult = ReturnType<typeof useGetSpotLessonSuspenseQuery>;
export type GetSpotLessonQueryResult = Apollo.QueryResult<GetSpotLessonQuery, GetSpotLessonQueryVariables>;
export const GetSpotLessonsDocument = gql`
    query getSpotLessons($input: SpotLessonSearchInput!) {
  spotLessons(input: $input) {
    total
    items {
      ...SpotLesson
    }
  }
}
    ${SpotLessonFragmentDoc}`;

/**
 * __useGetSpotLessonsQuery__
 *
 * To run a query within a React component, call `useGetSpotLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpotLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpotLessonsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSpotLessonsQuery(baseOptions: Apollo.QueryHookOptions<GetSpotLessonsQuery, GetSpotLessonsQueryVariables> & ({ variables: GetSpotLessonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpotLessonsQuery, GetSpotLessonsQueryVariables>(GetSpotLessonsDocument, options);
      }
export function useGetSpotLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpotLessonsQuery, GetSpotLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpotLessonsQuery, GetSpotLessonsQueryVariables>(GetSpotLessonsDocument, options);
        }
export function useGetSpotLessonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpotLessonsQuery, GetSpotLessonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpotLessonsQuery, GetSpotLessonsQueryVariables>(GetSpotLessonsDocument, options);
        }
export type GetSpotLessonsQueryHookResult = ReturnType<typeof useGetSpotLessonsQuery>;
export type GetSpotLessonsLazyQueryHookResult = ReturnType<typeof useGetSpotLessonsLazyQuery>;
export type GetSpotLessonsSuspenseQueryHookResult = ReturnType<typeof useGetSpotLessonsSuspenseQuery>;
export type GetSpotLessonsQueryResult = Apollo.QueryResult<GetSpotLessonsQuery, GetSpotLessonsQueryVariables>;
export const GetSpotLessonCalendarsDocument = gql`
    query getSpotLessonCalendars($from: Time!, $to: Time!, $tagIDs: [Uint64!]!) {
  spotLessonCalendars(from: $from, to: $to, tagIDs: $tagIDs) {
    ...SpotLessonCalendar
  }
}
    ${SpotLessonCalendarFragmentDoc}`;

/**
 * __useGetSpotLessonCalendarsQuery__
 *
 * To run a query within a React component, call `useGetSpotLessonCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpotLessonCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpotLessonCalendarsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      tagIDs: // value for 'tagIDs'
 *   },
 * });
 */
export function useGetSpotLessonCalendarsQuery(baseOptions: Apollo.QueryHookOptions<GetSpotLessonCalendarsQuery, GetSpotLessonCalendarsQueryVariables> & ({ variables: GetSpotLessonCalendarsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpotLessonCalendarsQuery, GetSpotLessonCalendarsQueryVariables>(GetSpotLessonCalendarsDocument, options);
      }
export function useGetSpotLessonCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpotLessonCalendarsQuery, GetSpotLessonCalendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpotLessonCalendarsQuery, GetSpotLessonCalendarsQueryVariables>(GetSpotLessonCalendarsDocument, options);
        }
export function useGetSpotLessonCalendarsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpotLessonCalendarsQuery, GetSpotLessonCalendarsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpotLessonCalendarsQuery, GetSpotLessonCalendarsQueryVariables>(GetSpotLessonCalendarsDocument, options);
        }
export type GetSpotLessonCalendarsQueryHookResult = ReturnType<typeof useGetSpotLessonCalendarsQuery>;
export type GetSpotLessonCalendarsLazyQueryHookResult = ReturnType<typeof useGetSpotLessonCalendarsLazyQuery>;
export type GetSpotLessonCalendarsSuspenseQueryHookResult = ReturnType<typeof useGetSpotLessonCalendarsSuspenseQuery>;
export type GetSpotLessonCalendarsQueryResult = Apollo.QueryResult<GetSpotLessonCalendarsQuery, GetSpotLessonCalendarsQueryVariables>;
export const GetSpotLessonCountDocument = gql`
    query getSpotLessonCount {
  spotLessonCount
}
    `;

/**
 * __useGetSpotLessonCountQuery__
 *
 * To run a query within a React component, call `useGetSpotLessonCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpotLessonCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpotLessonCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSpotLessonCountQuery(baseOptions?: Apollo.QueryHookOptions<GetSpotLessonCountQuery, GetSpotLessonCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpotLessonCountQuery, GetSpotLessonCountQueryVariables>(GetSpotLessonCountDocument, options);
      }
export function useGetSpotLessonCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpotLessonCountQuery, GetSpotLessonCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpotLessonCountQuery, GetSpotLessonCountQueryVariables>(GetSpotLessonCountDocument, options);
        }
export function useGetSpotLessonCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpotLessonCountQuery, GetSpotLessonCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpotLessonCountQuery, GetSpotLessonCountQueryVariables>(GetSpotLessonCountDocument, options);
        }
export type GetSpotLessonCountQueryHookResult = ReturnType<typeof useGetSpotLessonCountQuery>;
export type GetSpotLessonCountLazyQueryHookResult = ReturnType<typeof useGetSpotLessonCountLazyQuery>;
export type GetSpotLessonCountSuspenseQueryHookResult = ReturnType<typeof useGetSpotLessonCountSuspenseQuery>;
export type GetSpotLessonCountQueryResult = Apollo.QueryResult<GetSpotLessonCountQuery, GetSpotLessonCountQueryVariables>;
export const GetNextSpotLessonDocument = gql`
    query getNextSpotLesson {
  nextSpotLesson {
    ...SpotLesson
  }
}
    ${SpotLessonFragmentDoc}`;

/**
 * __useGetNextSpotLessonQuery__
 *
 * To run a query within a React component, call `useGetNextSpotLessonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextSpotLessonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextSpotLessonQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNextSpotLessonQuery(baseOptions?: Apollo.QueryHookOptions<GetNextSpotLessonQuery, GetNextSpotLessonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextSpotLessonQuery, GetNextSpotLessonQueryVariables>(GetNextSpotLessonDocument, options);
      }
export function useGetNextSpotLessonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextSpotLessonQuery, GetNextSpotLessonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextSpotLessonQuery, GetNextSpotLessonQueryVariables>(GetNextSpotLessonDocument, options);
        }
export function useGetNextSpotLessonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNextSpotLessonQuery, GetNextSpotLessonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNextSpotLessonQuery, GetNextSpotLessonQueryVariables>(GetNextSpotLessonDocument, options);
        }
export type GetNextSpotLessonQueryHookResult = ReturnType<typeof useGetNextSpotLessonQuery>;
export type GetNextSpotLessonLazyQueryHookResult = ReturnType<typeof useGetNextSpotLessonLazyQuery>;
export type GetNextSpotLessonSuspenseQueryHookResult = ReturnType<typeof useGetNextSpotLessonSuspenseQuery>;
export type GetNextSpotLessonQueryResult = Apollo.QueryResult<GetNextSpotLessonQuery, GetNextSpotLessonQueryVariables>;
export const GetSpotLessonsForInstructorDocument = gql`
    query getSpotLessonsForInstructor($input: InstructorSpotLessonSearchInput!) {
  spotLessonsForInstructor(input: $input) {
    total
    items {
      ...SpotLesson
    }
  }
}
    ${SpotLessonFragmentDoc}`;

/**
 * __useGetSpotLessonsForInstructorQuery__
 *
 * To run a query within a React component, call `useGetSpotLessonsForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpotLessonsForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpotLessonsForInstructorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSpotLessonsForInstructorQuery(baseOptions: Apollo.QueryHookOptions<GetSpotLessonsForInstructorQuery, GetSpotLessonsForInstructorQueryVariables> & ({ variables: GetSpotLessonsForInstructorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpotLessonsForInstructorQuery, GetSpotLessonsForInstructorQueryVariables>(GetSpotLessonsForInstructorDocument, options);
      }
export function useGetSpotLessonsForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpotLessonsForInstructorQuery, GetSpotLessonsForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpotLessonsForInstructorQuery, GetSpotLessonsForInstructorQueryVariables>(GetSpotLessonsForInstructorDocument, options);
        }
export function useGetSpotLessonsForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpotLessonsForInstructorQuery, GetSpotLessonsForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpotLessonsForInstructorQuery, GetSpotLessonsForInstructorQueryVariables>(GetSpotLessonsForInstructorDocument, options);
        }
export type GetSpotLessonsForInstructorQueryHookResult = ReturnType<typeof useGetSpotLessonsForInstructorQuery>;
export type GetSpotLessonsForInstructorLazyQueryHookResult = ReturnType<typeof useGetSpotLessonsForInstructorLazyQuery>;
export type GetSpotLessonsForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetSpotLessonsForInstructorSuspenseQuery>;
export type GetSpotLessonsForInstructorQueryResult = Apollo.QueryResult<GetSpotLessonsForInstructorQuery, GetSpotLessonsForInstructorQueryVariables>;
export const GetSpotLessonForInstructorDocument = gql`
    query getSpotLessonForInstructor($id: Uint64!) {
  spotLessonForInstructor(id: $id) {
    ...SpotLesson
  }
}
    ${SpotLessonFragmentDoc}`;

/**
 * __useGetSpotLessonForInstructorQuery__
 *
 * To run a query within a React component, call `useGetSpotLessonForInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpotLessonForInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpotLessonForInstructorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSpotLessonForInstructorQuery(baseOptions: Apollo.QueryHookOptions<GetSpotLessonForInstructorQuery, GetSpotLessonForInstructorQueryVariables> & ({ variables: GetSpotLessonForInstructorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpotLessonForInstructorQuery, GetSpotLessonForInstructorQueryVariables>(GetSpotLessonForInstructorDocument, options);
      }
export function useGetSpotLessonForInstructorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpotLessonForInstructorQuery, GetSpotLessonForInstructorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpotLessonForInstructorQuery, GetSpotLessonForInstructorQueryVariables>(GetSpotLessonForInstructorDocument, options);
        }
export function useGetSpotLessonForInstructorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpotLessonForInstructorQuery, GetSpotLessonForInstructorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpotLessonForInstructorQuery, GetSpotLessonForInstructorQueryVariables>(GetSpotLessonForInstructorDocument, options);
        }
export type GetSpotLessonForInstructorQueryHookResult = ReturnType<typeof useGetSpotLessonForInstructorQuery>;
export type GetSpotLessonForInstructorLazyQueryHookResult = ReturnType<typeof useGetSpotLessonForInstructorLazyQuery>;
export type GetSpotLessonForInstructorSuspenseQueryHookResult = ReturnType<typeof useGetSpotLessonForInstructorSuspenseQuery>;
export type GetSpotLessonForInstructorQueryResult = Apollo.QueryResult<GetSpotLessonForInstructorQuery, GetSpotLessonForInstructorQueryVariables>;
export const SetupIntentDocument = gql`
    mutation setupIntent {
  setupIntent
}
    `;
export type SetupIntentMutationFn = Apollo.MutationFunction<SetupIntentMutation, SetupIntentMutationVariables>;

/**
 * __useSetupIntentMutation__
 *
 * To run a mutation, you first call `useSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupIntentMutation, { data, loading, error }] = useSetupIntentMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<SetupIntentMutation, SetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupIntentMutation, SetupIntentMutationVariables>(SetupIntentDocument, options);
      }
export type SetupIntentMutationHookResult = ReturnType<typeof useSetupIntentMutation>;
export type SetupIntentMutationResult = Apollo.MutationResult<SetupIntentMutation>;
export type SetupIntentMutationOptions = Apollo.BaseMutationOptions<SetupIntentMutation, SetupIntentMutationVariables>;
export const SubscriptionDocument = gql`
    query subscription {
  subscription {
    ...StripeSubscription
  }
  scheduledSubscriptionContract {
    ...ScheduledSubscriptionContract
  }
  subscriptionCancellationPeriod {
    ...SubscriptionCancellationPeriod
  }
}
    ${StripeSubscriptionFragmentDoc}
${ScheduledSubscriptionContractFragmentDoc}
${SubscriptionCancellationPeriodFragmentDoc}`;

/**
 * __useSubscriptionQuery__
 *
 * To run a query within a React component, call `useSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
      }
export function useSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
        }
export function useSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
        }
export type SubscriptionQueryHookResult = ReturnType<typeof useSubscriptionQuery>;
export type SubscriptionLazyQueryHookResult = ReturnType<typeof useSubscriptionLazyQuery>;
export type SubscriptionSuspenseQueryHookResult = ReturnType<typeof useSubscriptionSuspenseQuery>;
export type SubscriptionQueryResult = Apollo.QueryResult<SubscriptionQuery, SubscriptionQueryVariables>;
export const GetTeamSubscriptionDocument = gql`
    query getTeamSubscription($teamID: ULID!) {
  teamSubscription(teamID: $teamID) {
    ...StripeSubscription
  }
  teamScheduledSubscriptionContract(teamID: $teamID) {
    ...ScheduledSubscriptionContract
  }
}
    ${StripeSubscriptionFragmentDoc}
${ScheduledSubscriptionContractFragmentDoc}`;

/**
 * __useGetTeamSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetTeamSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamSubscriptionQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *   },
 * });
 */
export function useGetTeamSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GetTeamSubscriptionQuery, GetTeamSubscriptionQueryVariables> & ({ variables: GetTeamSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamSubscriptionQuery, GetTeamSubscriptionQueryVariables>(GetTeamSubscriptionDocument, options);
      }
export function useGetTeamSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamSubscriptionQuery, GetTeamSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamSubscriptionQuery, GetTeamSubscriptionQueryVariables>(GetTeamSubscriptionDocument, options);
        }
export function useGetTeamSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamSubscriptionQuery, GetTeamSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamSubscriptionQuery, GetTeamSubscriptionQueryVariables>(GetTeamSubscriptionDocument, options);
        }
export type GetTeamSubscriptionQueryHookResult = ReturnType<typeof useGetTeamSubscriptionQuery>;
export type GetTeamSubscriptionLazyQueryHookResult = ReturnType<typeof useGetTeamSubscriptionLazyQuery>;
export type GetTeamSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetTeamSubscriptionSuspenseQuery>;
export type GetTeamSubscriptionQueryResult = Apollo.QueryResult<GetTeamSubscriptionQuery, GetTeamSubscriptionQueryVariables>;
export const GetTeamExistSubscriptionDocument = gql`
    query getTeamExistSubscription($teamID: ULID!) {
  teamExistSubscription(teamID: $teamID)
}
    `;

/**
 * __useGetTeamExistSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetTeamExistSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamExistSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamExistSubscriptionQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *   },
 * });
 */
export function useGetTeamExistSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GetTeamExistSubscriptionQuery, GetTeamExistSubscriptionQueryVariables> & ({ variables: GetTeamExistSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamExistSubscriptionQuery, GetTeamExistSubscriptionQueryVariables>(GetTeamExistSubscriptionDocument, options);
      }
export function useGetTeamExistSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamExistSubscriptionQuery, GetTeamExistSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamExistSubscriptionQuery, GetTeamExistSubscriptionQueryVariables>(GetTeamExistSubscriptionDocument, options);
        }
export function useGetTeamExistSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamExistSubscriptionQuery, GetTeamExistSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamExistSubscriptionQuery, GetTeamExistSubscriptionQueryVariables>(GetTeamExistSubscriptionDocument, options);
        }
export type GetTeamExistSubscriptionQueryHookResult = ReturnType<typeof useGetTeamExistSubscriptionQuery>;
export type GetTeamExistSubscriptionLazyQueryHookResult = ReturnType<typeof useGetTeamExistSubscriptionLazyQuery>;
export type GetTeamExistSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetTeamExistSubscriptionSuspenseQuery>;
export type GetTeamExistSubscriptionQueryResult = Apollo.QueryResult<GetTeamExistSubscriptionQuery, GetTeamExistSubscriptionQueryVariables>;
export const GetTeamExistMySubscriptionDocument = gql`
    query getTeamExistMySubscription {
  teamExistMySubscription
}
    `;

/**
 * __useGetTeamExistMySubscriptionQuery__
 *
 * To run a query within a React component, call `useGetTeamExistMySubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamExistMySubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamExistMySubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeamExistMySubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamExistMySubscriptionQuery, GetTeamExistMySubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamExistMySubscriptionQuery, GetTeamExistMySubscriptionQueryVariables>(GetTeamExistMySubscriptionDocument, options);
      }
export function useGetTeamExistMySubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamExistMySubscriptionQuery, GetTeamExistMySubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamExistMySubscriptionQuery, GetTeamExistMySubscriptionQueryVariables>(GetTeamExistMySubscriptionDocument, options);
        }
export function useGetTeamExistMySubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamExistMySubscriptionQuery, GetTeamExistMySubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamExistMySubscriptionQuery, GetTeamExistMySubscriptionQueryVariables>(GetTeamExistMySubscriptionDocument, options);
        }
export type GetTeamExistMySubscriptionQueryHookResult = ReturnType<typeof useGetTeamExistMySubscriptionQuery>;
export type GetTeamExistMySubscriptionLazyQueryHookResult = ReturnType<typeof useGetTeamExistMySubscriptionLazyQuery>;
export type GetTeamExistMySubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetTeamExistMySubscriptionSuspenseQuery>;
export type GetTeamExistMySubscriptionQueryResult = Apollo.QueryResult<GetTeamExistMySubscriptionQuery, GetTeamExistMySubscriptionQueryVariables>;
export const GetTeamUpcomingInvoiceDocument = gql`
    query getTeamUpcomingInvoice($id: ULID!, $input: TeamUpdateSubscriptionFormInput!) {
  teamUpcomingInvoice(teamID: $id, input: $input) {
    nextInvoice {
      ...StripeInvoice
    }
    defaultPrice
    isIncrementalUpdate
  }
}
    ${StripeInvoiceFragmentDoc}`;

/**
 * __useGetTeamUpcomingInvoiceQuery__
 *
 * To run a query within a React component, call `useGetTeamUpcomingInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamUpcomingInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamUpcomingInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTeamUpcomingInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetTeamUpcomingInvoiceQuery, GetTeamUpcomingInvoiceQueryVariables> & ({ variables: GetTeamUpcomingInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamUpcomingInvoiceQuery, GetTeamUpcomingInvoiceQueryVariables>(GetTeamUpcomingInvoiceDocument, options);
      }
export function useGetTeamUpcomingInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamUpcomingInvoiceQuery, GetTeamUpcomingInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamUpcomingInvoiceQuery, GetTeamUpcomingInvoiceQueryVariables>(GetTeamUpcomingInvoiceDocument, options);
        }
export function useGetTeamUpcomingInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamUpcomingInvoiceQuery, GetTeamUpcomingInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamUpcomingInvoiceQuery, GetTeamUpcomingInvoiceQueryVariables>(GetTeamUpcomingInvoiceDocument, options);
        }
export type GetTeamUpcomingInvoiceQueryHookResult = ReturnType<typeof useGetTeamUpcomingInvoiceQuery>;
export type GetTeamUpcomingInvoiceLazyQueryHookResult = ReturnType<typeof useGetTeamUpcomingInvoiceLazyQuery>;
export type GetTeamUpcomingInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetTeamUpcomingInvoiceSuspenseQuery>;
export type GetTeamUpcomingInvoiceQueryResult = Apollo.QueryResult<GetTeamUpcomingInvoiceQuery, GetTeamUpcomingInvoiceQueryVariables>;
export const GetUpcomingInvoiceDocument = gql`
    query getUpcomingInvoice($input: UpdateSubscriptionFormInput!) {
  upcomingInvoice(input: $input) {
    oldPriceInvoice {
      ...StripeInvoice
    }
  }
}
    ${StripeInvoiceFragmentDoc}`;

/**
 * __useGetUpcomingInvoiceQuery__
 *
 * To run a query within a React component, call `useGetUpcomingInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingInvoiceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUpcomingInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetUpcomingInvoiceQuery, GetUpcomingInvoiceQueryVariables> & ({ variables: GetUpcomingInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpcomingInvoiceQuery, GetUpcomingInvoiceQueryVariables>(GetUpcomingInvoiceDocument, options);
      }
export function useGetUpcomingInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpcomingInvoiceQuery, GetUpcomingInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpcomingInvoiceQuery, GetUpcomingInvoiceQueryVariables>(GetUpcomingInvoiceDocument, options);
        }
export function useGetUpcomingInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUpcomingInvoiceQuery, GetUpcomingInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUpcomingInvoiceQuery, GetUpcomingInvoiceQueryVariables>(GetUpcomingInvoiceDocument, options);
        }
export type GetUpcomingInvoiceQueryHookResult = ReturnType<typeof useGetUpcomingInvoiceQuery>;
export type GetUpcomingInvoiceLazyQueryHookResult = ReturnType<typeof useGetUpcomingInvoiceLazyQuery>;
export type GetUpcomingInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetUpcomingInvoiceSuspenseQuery>;
export type GetUpcomingInvoiceQueryResult = Apollo.QueryResult<GetUpcomingInvoiceQuery, GetUpcomingInvoiceQueryVariables>;
export const TeamSubscribeDocument = gql`
    mutation teamSubscribe($input: TeamSubscribeFormInput!) {
  teamSubscribe(input: $input)
}
    `;
export type TeamSubscribeMutationFn = Apollo.MutationFunction<TeamSubscribeMutation, TeamSubscribeMutationVariables>;

/**
 * __useTeamSubscribeMutation__
 *
 * To run a mutation, you first call `useTeamSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamSubscribeMutation, { data, loading, error }] = useTeamSubscribeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTeamSubscribeMutation(baseOptions?: Apollo.MutationHookOptions<TeamSubscribeMutation, TeamSubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeamSubscribeMutation, TeamSubscribeMutationVariables>(TeamSubscribeDocument, options);
      }
export type TeamSubscribeMutationHookResult = ReturnType<typeof useTeamSubscribeMutation>;
export type TeamSubscribeMutationResult = Apollo.MutationResult<TeamSubscribeMutation>;
export type TeamSubscribeMutationOptions = Apollo.BaseMutationOptions<TeamSubscribeMutation, TeamSubscribeMutationVariables>;
export const TeamSwitchCancelAtPeriodEndSubscriptionDocument = gql`
    mutation teamSwitchCancelAtPeriodEndSubscription($id: ULID!) {
  teamSwitchCancelAtPeriodEndSubscription(teamID: $id)
}
    `;
export type TeamSwitchCancelAtPeriodEndSubscriptionMutationFn = Apollo.MutationFunction<TeamSwitchCancelAtPeriodEndSubscriptionMutation, TeamSwitchCancelAtPeriodEndSubscriptionMutationVariables>;

/**
 * __useTeamSwitchCancelAtPeriodEndSubscriptionMutation__
 *
 * To run a mutation, you first call `useTeamSwitchCancelAtPeriodEndSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamSwitchCancelAtPeriodEndSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamSwitchCancelAtPeriodEndSubscriptionMutation, { data, loading, error }] = useTeamSwitchCancelAtPeriodEndSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamSwitchCancelAtPeriodEndSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<TeamSwitchCancelAtPeriodEndSubscriptionMutation, TeamSwitchCancelAtPeriodEndSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeamSwitchCancelAtPeriodEndSubscriptionMutation, TeamSwitchCancelAtPeriodEndSubscriptionMutationVariables>(TeamSwitchCancelAtPeriodEndSubscriptionDocument, options);
      }
export type TeamSwitchCancelAtPeriodEndSubscriptionMutationHookResult = ReturnType<typeof useTeamSwitchCancelAtPeriodEndSubscriptionMutation>;
export type TeamSwitchCancelAtPeriodEndSubscriptionMutationResult = Apollo.MutationResult<TeamSwitchCancelAtPeriodEndSubscriptionMutation>;
export type TeamSwitchCancelAtPeriodEndSubscriptionMutationOptions = Apollo.BaseMutationOptions<TeamSwitchCancelAtPeriodEndSubscriptionMutation, TeamSwitchCancelAtPeriodEndSubscriptionMutationVariables>;
export const TeamUpdateSubscriptionDocument = gql`
    mutation teamUpdateSubscription($teamID: ULID!, $input: TeamUpdateSubscriptionFormInput!) {
  teamUpdateSubscription(teamID: $teamID, input: $input)
}
    `;
export type TeamUpdateSubscriptionMutationFn = Apollo.MutationFunction<TeamUpdateSubscriptionMutation, TeamUpdateSubscriptionMutationVariables>;

/**
 * __useTeamUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useTeamUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamUpdateSubscriptionMutation, { data, loading, error }] = useTeamUpdateSubscriptionMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTeamUpdateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<TeamUpdateSubscriptionMutation, TeamUpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeamUpdateSubscriptionMutation, TeamUpdateSubscriptionMutationVariables>(TeamUpdateSubscriptionDocument, options);
      }
export type TeamUpdateSubscriptionMutationHookResult = ReturnType<typeof useTeamUpdateSubscriptionMutation>;
export type TeamUpdateSubscriptionMutationResult = Apollo.MutationResult<TeamUpdateSubscriptionMutation>;
export type TeamUpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<TeamUpdateSubscriptionMutation, TeamUpdateSubscriptionMutationVariables>;
export const SubscribeDocument = gql`
    mutation subscribe($input: SubscribeFormInput!) {
  subscribe(input: $input)
}
    `;
export type SubscribeMutationFn = Apollo.MutationFunction<SubscribeMutation, SubscribeMutationVariables>;

/**
 * __useSubscribeMutation__
 *
 * To run a mutation, you first call `useSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeMutation, { data, loading, error }] = useSubscribeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeMutation, SubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeMutation, SubscribeMutationVariables>(SubscribeDocument, options);
      }
export type SubscribeMutationHookResult = ReturnType<typeof useSubscribeMutation>;
export type SubscribeMutationResult = Apollo.MutationResult<SubscribeMutation>;
export type SubscribeMutationOptions = Apollo.BaseMutationOptions<SubscribeMutation, SubscribeMutationVariables>;
export const RestoreSubscriptionDocument = gql`
    mutation restoreSubscription {
  switchCancelAtPeriodEndSubscription
}
    `;
export type RestoreSubscriptionMutationFn = Apollo.MutationFunction<RestoreSubscriptionMutation, RestoreSubscriptionMutationVariables>;

/**
 * __useRestoreSubscriptionMutation__
 *
 * To run a mutation, you first call `useRestoreSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreSubscriptionMutation, { data, loading, error }] = useRestoreSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useRestoreSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<RestoreSubscriptionMutation, RestoreSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreSubscriptionMutation, RestoreSubscriptionMutationVariables>(RestoreSubscriptionDocument, options);
      }
export type RestoreSubscriptionMutationHookResult = ReturnType<typeof useRestoreSubscriptionMutation>;
export type RestoreSubscriptionMutationResult = Apollo.MutationResult<RestoreSubscriptionMutation>;
export type RestoreSubscriptionMutationOptions = Apollo.BaseMutationOptions<RestoreSubscriptionMutation, RestoreSubscriptionMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation cancelSubscription($input: WithdrawalQuestionnaireInput!) {
  switchCancelAtPeriodEndSubscription
  sendWithdrawalQuestionnaireInput(input: $input)
}
    `;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const ReleaseSubscriptionScheduleDocument = gql`
    mutation releaseSubscriptionSchedule {
  releaseSubscriptionSchedule
}
    `;
export type ReleaseSubscriptionScheduleMutationFn = Apollo.MutationFunction<ReleaseSubscriptionScheduleMutation, ReleaseSubscriptionScheduleMutationVariables>;

/**
 * __useReleaseSubscriptionScheduleMutation__
 *
 * To run a mutation, you first call `useReleaseSubscriptionScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseSubscriptionScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseSubscriptionScheduleMutation, { data, loading, error }] = useReleaseSubscriptionScheduleMutation({
 *   variables: {
 *   },
 * });
 */
export function useReleaseSubscriptionScheduleMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseSubscriptionScheduleMutation, ReleaseSubscriptionScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseSubscriptionScheduleMutation, ReleaseSubscriptionScheduleMutationVariables>(ReleaseSubscriptionScheduleDocument, options);
      }
export type ReleaseSubscriptionScheduleMutationHookResult = ReturnType<typeof useReleaseSubscriptionScheduleMutation>;
export type ReleaseSubscriptionScheduleMutationResult = Apollo.MutationResult<ReleaseSubscriptionScheduleMutation>;
export type ReleaseSubscriptionScheduleMutationOptions = Apollo.BaseMutationOptions<ReleaseSubscriptionScheduleMutation, ReleaseSubscriptionScheduleMutationVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation updateSubscription($input: UpdateSubscriptionFormInput!) {
  updateSubscription(input: $input)
}
    `;
export type UpdateSubscriptionMutationFn = Apollo.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const GetInvoicesDocument = gql`
    query getInvoices($input: InvoicesSearchInput!) {
  invoices(input: $input) {
    previousCursor
    nextCursor
    hasPrevious
    hasNext
    items {
      ...StripeInvoice
    }
  }
}
    ${StripeInvoiceFragmentDoc}`;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetInvoicesQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables> & ({ variables: GetInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
      }
export function useGetInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export function useGetInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<typeof useGetInvoicesLazyQuery>;
export type GetInvoicesSuspenseQueryHookResult = ReturnType<typeof useGetInvoicesSuspenseQuery>;
export type GetInvoicesQueryResult = Apollo.QueryResult<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetTeamInvoicesDocument = gql`
    query getTeamInvoices($input: TeamInvoicesSearchInput!) {
  teamInvoices(input: $input) {
    previousCursor
    nextCursor
    hasPrevious
    hasNext
    items {
      ...StripeInvoice
    }
  }
}
    ${StripeInvoiceFragmentDoc}`;

/**
 * __useGetTeamInvoicesQuery__
 *
 * To run a query within a React component, call `useGetTeamInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamInvoicesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTeamInvoicesQuery(baseOptions: Apollo.QueryHookOptions<GetTeamInvoicesQuery, GetTeamInvoicesQueryVariables> & ({ variables: GetTeamInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamInvoicesQuery, GetTeamInvoicesQueryVariables>(GetTeamInvoicesDocument, options);
      }
export function useGetTeamInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamInvoicesQuery, GetTeamInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamInvoicesQuery, GetTeamInvoicesQueryVariables>(GetTeamInvoicesDocument, options);
        }
export function useGetTeamInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamInvoicesQuery, GetTeamInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamInvoicesQuery, GetTeamInvoicesQueryVariables>(GetTeamInvoicesDocument, options);
        }
export type GetTeamInvoicesQueryHookResult = ReturnType<typeof useGetTeamInvoicesQuery>;
export type GetTeamInvoicesLazyQueryHookResult = ReturnType<typeof useGetTeamInvoicesLazyQuery>;
export type GetTeamInvoicesSuspenseQueryHookResult = ReturnType<typeof useGetTeamInvoicesSuspenseQuery>;
export type GetTeamInvoicesQueryResult = Apollo.QueryResult<GetTeamInvoicesQuery, GetTeamInvoicesQueryVariables>;
export const GetPaymentMethodsDocument = gql`
    query getPaymentMethods($limit: Int64!) {
  paymentMethods(input: {limit: $limit}) {
    items {
      ...StripePaymentMethod
    }
  }
}
    ${StripePaymentMethodFragmentDoc}`;

/**
 * __useGetPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables> & ({ variables: GetPaymentMethodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
      }
export function useGetPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
        }
export function useGetPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
        }
export type GetPaymentMethodsQueryHookResult = ReturnType<typeof useGetPaymentMethodsQuery>;
export type GetPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsLazyQuery>;
export type GetPaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentMethodsSuspenseQuery>;
export type GetPaymentMethodsQueryResult = Apollo.QueryResult<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>;
export const GetTeamPaymentMethodsDocument = gql`
    query getTeamPaymentMethods($teamID: ULID!, $limit: Int64!) {
  teamPaymentMethods(input: {teamID: $teamID, limit: $limit}) {
    items {
      ...StripePaymentMethod
    }
  }
}
    ${StripePaymentMethodFragmentDoc}`;

/**
 * __useGetTeamPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetTeamPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamPaymentMethodsQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTeamPaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamPaymentMethodsQuery, GetTeamPaymentMethodsQueryVariables> & ({ variables: GetTeamPaymentMethodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamPaymentMethodsQuery, GetTeamPaymentMethodsQueryVariables>(GetTeamPaymentMethodsDocument, options);
      }
export function useGetTeamPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamPaymentMethodsQuery, GetTeamPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamPaymentMethodsQuery, GetTeamPaymentMethodsQueryVariables>(GetTeamPaymentMethodsDocument, options);
        }
export function useGetTeamPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamPaymentMethodsQuery, GetTeamPaymentMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamPaymentMethodsQuery, GetTeamPaymentMethodsQueryVariables>(GetTeamPaymentMethodsDocument, options);
        }
export type GetTeamPaymentMethodsQueryHookResult = ReturnType<typeof useGetTeamPaymentMethodsQuery>;
export type GetTeamPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetTeamPaymentMethodsLazyQuery>;
export type GetTeamPaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useGetTeamPaymentMethodsSuspenseQuery>;
export type GetTeamPaymentMethodsQueryResult = Apollo.QueryResult<GetTeamPaymentMethodsQuery, GetTeamPaymentMethodsQueryVariables>;
export const TeamSelectPaymentMethodDocument = gql`
    mutation teamSelectPaymentMethod($teamID: ULID!, $providerID: String!) {
  teamSelectPaymentMethod(teamID: $teamID, providerID: $providerID)
}
    `;
export type TeamSelectPaymentMethodMutationFn = Apollo.MutationFunction<TeamSelectPaymentMethodMutation, TeamSelectPaymentMethodMutationVariables>;

/**
 * __useTeamSelectPaymentMethodMutation__
 *
 * To run a mutation, you first call `useTeamSelectPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamSelectPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamSelectPaymentMethodMutation, { data, loading, error }] = useTeamSelectPaymentMethodMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      providerID: // value for 'providerID'
 *   },
 * });
 */
export function useTeamSelectPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<TeamSelectPaymentMethodMutation, TeamSelectPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeamSelectPaymentMethodMutation, TeamSelectPaymentMethodMutationVariables>(TeamSelectPaymentMethodDocument, options);
      }
export type TeamSelectPaymentMethodMutationHookResult = ReturnType<typeof useTeamSelectPaymentMethodMutation>;
export type TeamSelectPaymentMethodMutationResult = Apollo.MutationResult<TeamSelectPaymentMethodMutation>;
export type TeamSelectPaymentMethodMutationOptions = Apollo.BaseMutationOptions<TeamSelectPaymentMethodMutation, TeamSelectPaymentMethodMutationVariables>;
export const TeamDeletePaymentMethodDocument = gql`
    mutation teamDeletePaymentMethod($teamID: ULID!, $providerID: String!) {
  teamDeletePaymentMethod(teamID: $teamID, providerID: $providerID)
}
    `;
export type TeamDeletePaymentMethodMutationFn = Apollo.MutationFunction<TeamDeletePaymentMethodMutation, TeamDeletePaymentMethodMutationVariables>;

/**
 * __useTeamDeletePaymentMethodMutation__
 *
 * To run a mutation, you first call `useTeamDeletePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamDeletePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamDeletePaymentMethodMutation, { data, loading, error }] = useTeamDeletePaymentMethodMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      providerID: // value for 'providerID'
 *   },
 * });
 */
export function useTeamDeletePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<TeamDeletePaymentMethodMutation, TeamDeletePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeamDeletePaymentMethodMutation, TeamDeletePaymentMethodMutationVariables>(TeamDeletePaymentMethodDocument, options);
      }
export type TeamDeletePaymentMethodMutationHookResult = ReturnType<typeof useTeamDeletePaymentMethodMutation>;
export type TeamDeletePaymentMethodMutationResult = Apollo.MutationResult<TeamDeletePaymentMethodMutation>;
export type TeamDeletePaymentMethodMutationOptions = Apollo.BaseMutationOptions<TeamDeletePaymentMethodMutation, TeamDeletePaymentMethodMutationVariables>;
export const SelectPaymentMethodDocument = gql`
    mutation selectPaymentMethod($providerID: String!) {
  selectPaymentMethod(providerID: $providerID)
}
    `;
export type SelectPaymentMethodMutationFn = Apollo.MutationFunction<SelectPaymentMethodMutation, SelectPaymentMethodMutationVariables>;

/**
 * __useSelectPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSelectPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectPaymentMethodMutation, { data, loading, error }] = useSelectPaymentMethodMutation({
 *   variables: {
 *      providerID: // value for 'providerID'
 *   },
 * });
 */
export function useSelectPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SelectPaymentMethodMutation, SelectPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectPaymentMethodMutation, SelectPaymentMethodMutationVariables>(SelectPaymentMethodDocument, options);
      }
export type SelectPaymentMethodMutationHookResult = ReturnType<typeof useSelectPaymentMethodMutation>;
export type SelectPaymentMethodMutationResult = Apollo.MutationResult<SelectPaymentMethodMutation>;
export type SelectPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SelectPaymentMethodMutation, SelectPaymentMethodMutationVariables>;
export const DeletePaymentMethodDocument = gql`
    mutation deletePaymentMethod($providerID: String!) {
  deletePaymentMethod(providerID: $providerID)
}
    `;
export type DeletePaymentMethodMutationFn = Apollo.MutationFunction<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;

/**
 * __useDeletePaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMethodMutation, { data, loading, error }] = useDeletePaymentMethodMutation({
 *   variables: {
 *      providerID: // value for 'providerID'
 *   },
 * });
 */
export function useDeletePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>(DeletePaymentMethodDocument, options);
      }
export type DeletePaymentMethodMutationHookResult = ReturnType<typeof useDeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationResult = Apollo.MutationResult<DeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;
export const CheckUpgradeTypesDocument = gql`
    query checkUpgradeTypes {
  checkUpgradeTypes {
    priceID
    subscriptionUpgradeType
    subscriptionType
  }
}
    `;

/**
 * __useCheckUpgradeTypesQuery__
 *
 * To run a query within a React component, call `useCheckUpgradeTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUpgradeTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUpgradeTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckUpgradeTypesQuery(baseOptions?: Apollo.QueryHookOptions<CheckUpgradeTypesQuery, CheckUpgradeTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUpgradeTypesQuery, CheckUpgradeTypesQueryVariables>(CheckUpgradeTypesDocument, options);
      }
export function useCheckUpgradeTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUpgradeTypesQuery, CheckUpgradeTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUpgradeTypesQuery, CheckUpgradeTypesQueryVariables>(CheckUpgradeTypesDocument, options);
        }
export function useCheckUpgradeTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckUpgradeTypesQuery, CheckUpgradeTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckUpgradeTypesQuery, CheckUpgradeTypesQueryVariables>(CheckUpgradeTypesDocument, options);
        }
export type CheckUpgradeTypesQueryHookResult = ReturnType<typeof useCheckUpgradeTypesQuery>;
export type CheckUpgradeTypesLazyQueryHookResult = ReturnType<typeof useCheckUpgradeTypesLazyQuery>;
export type CheckUpgradeTypesSuspenseQueryHookResult = ReturnType<typeof useCheckUpgradeTypesSuspenseQuery>;
export type CheckUpgradeTypesQueryResult = Apollo.QueryResult<CheckUpgradeTypesQuery, CheckUpgradeTypesQueryVariables>;
export const CheckUpgradeDocument = gql`
    query checkUpgrade($priceID: Uint64!) {
  checkUpgrade(priceID: $priceID) {
    priceID
    subscriptionUpgradeType
    startDate
    endDate
    price {
      unitAmount
      product {
        name
      }
      numberOfTickets
      pricePermission {
        ...PricePermission
      }
    }
  }
}
    ${PricePermissionFragmentDoc}`;

/**
 * __useCheckUpgradeQuery__
 *
 * To run a query within a React component, call `useCheckUpgradeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUpgradeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUpgradeQuery({
 *   variables: {
 *      priceID: // value for 'priceID'
 *   },
 * });
 */
export function useCheckUpgradeQuery(baseOptions: Apollo.QueryHookOptions<CheckUpgradeQuery, CheckUpgradeQueryVariables> & ({ variables: CheckUpgradeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUpgradeQuery, CheckUpgradeQueryVariables>(CheckUpgradeDocument, options);
      }
export function useCheckUpgradeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUpgradeQuery, CheckUpgradeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUpgradeQuery, CheckUpgradeQueryVariables>(CheckUpgradeDocument, options);
        }
export function useCheckUpgradeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckUpgradeQuery, CheckUpgradeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckUpgradeQuery, CheckUpgradeQueryVariables>(CheckUpgradeDocument, options);
        }
export type CheckUpgradeQueryHookResult = ReturnType<typeof useCheckUpgradeQuery>;
export type CheckUpgradeLazyQueryHookResult = ReturnType<typeof useCheckUpgradeLazyQuery>;
export type CheckUpgradeSuspenseQueryHookResult = ReturnType<typeof useCheckUpgradeSuspenseQuery>;
export type CheckUpgradeQueryResult = Apollo.QueryResult<CheckUpgradeQuery, CheckUpgradeQueryVariables>;
export const IsUpgradableDocument = gql`
    query isUpgradable {
  isUpgradable
}
    `;

/**
 * __useIsUpgradableQuery__
 *
 * To run a query within a React component, call `useIsUpgradableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUpgradableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUpgradableQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsUpgradableQuery(baseOptions?: Apollo.QueryHookOptions<IsUpgradableQuery, IsUpgradableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsUpgradableQuery, IsUpgradableQueryVariables>(IsUpgradableDocument, options);
      }
export function useIsUpgradableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsUpgradableQuery, IsUpgradableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsUpgradableQuery, IsUpgradableQueryVariables>(IsUpgradableDocument, options);
        }
export function useIsUpgradableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsUpgradableQuery, IsUpgradableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsUpgradableQuery, IsUpgradableQueryVariables>(IsUpgradableDocument, options);
        }
export type IsUpgradableQueryHookResult = ReturnType<typeof useIsUpgradableQuery>;
export type IsUpgradableLazyQueryHookResult = ReturnType<typeof useIsUpgradableLazyQuery>;
export type IsUpgradableSuspenseQueryHookResult = ReturnType<typeof useIsUpgradableSuspenseQuery>;
export type IsUpgradableQueryResult = Apollo.QueryResult<IsUpgradableQuery, IsUpgradableQueryVariables>;
export const GetCurrentStudentDocument = gql`
    query getCurrentStudent {
  currentStudent {
    courses {
      id
      plan {
        name
      }
      startDate
      endDate
      absentStartDate
      absentEndDate
      curriculum
    }
  }
}
    `;

/**
 * __useGetCurrentStudentQuery__
 *
 * To run a query within a React component, call `useGetCurrentStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentStudentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentStudentQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentStudentQuery, GetCurrentStudentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentStudentQuery, GetCurrentStudentQueryVariables>(GetCurrentStudentDocument, options);
      }
export function useGetCurrentStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentStudentQuery, GetCurrentStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentStudentQuery, GetCurrentStudentQueryVariables>(GetCurrentStudentDocument, options);
        }
export function useGetCurrentStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentStudentQuery, GetCurrentStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentStudentQuery, GetCurrentStudentQueryVariables>(GetCurrentStudentDocument, options);
        }
export type GetCurrentStudentQueryHookResult = ReturnType<typeof useGetCurrentStudentQuery>;
export type GetCurrentStudentLazyQueryHookResult = ReturnType<typeof useGetCurrentStudentLazyQuery>;
export type GetCurrentStudentSuspenseQueryHookResult = ReturnType<typeof useGetCurrentStudentSuspenseQuery>;
export type GetCurrentStudentQueryResult = Apollo.QueryResult<GetCurrentStudentQuery, GetCurrentStudentQueryVariables>;
export const GetStudyCalendarDocument = gql`
    query getStudyCalendar($input: StudyCalendarSearchInput!) {
  getStudyCalendar(input: $input) {
    ...StudyCalendar
  }
}
    ${StudyCalendarFragmentDoc}`;

/**
 * __useGetStudyCalendarQuery__
 *
 * To run a query within a React component, call `useGetStudyCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyCalendarQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStudyCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetStudyCalendarQuery, GetStudyCalendarQueryVariables> & ({ variables: GetStudyCalendarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudyCalendarQuery, GetStudyCalendarQueryVariables>(GetStudyCalendarDocument, options);
      }
export function useGetStudyCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudyCalendarQuery, GetStudyCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudyCalendarQuery, GetStudyCalendarQueryVariables>(GetStudyCalendarDocument, options);
        }
export function useGetStudyCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudyCalendarQuery, GetStudyCalendarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudyCalendarQuery, GetStudyCalendarQueryVariables>(GetStudyCalendarDocument, options);
        }
export type GetStudyCalendarQueryHookResult = ReturnType<typeof useGetStudyCalendarQuery>;
export type GetStudyCalendarLazyQueryHookResult = ReturnType<typeof useGetStudyCalendarLazyQuery>;
export type GetStudyCalendarSuspenseQueryHookResult = ReturnType<typeof useGetStudyCalendarSuspenseQuery>;
export type GetStudyCalendarQueryResult = Apollo.QueryResult<GetStudyCalendarQuery, GetStudyCalendarQueryVariables>;
export const GetStudyFavoriteSummaryListDocument = gql`
    query getStudyFavoriteSummaryList {
  getStudyFavoriteSummaryList {
    studyFavoriteCount {
      ...StudyFavoriteSummary
    }
    studyFavoriteCountWeek {
      ...StudyFavoriteSummary
    }
    studyFavoriteCountMonth {
      ...StudyFavoriteSummary
    }
  }
}
    ${StudyFavoriteSummaryFragmentDoc}`;

/**
 * __useGetStudyFavoriteSummaryListQuery__
 *
 * To run a query within a React component, call `useGetStudyFavoriteSummaryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyFavoriteSummaryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyFavoriteSummaryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStudyFavoriteSummaryListQuery(baseOptions?: Apollo.QueryHookOptions<GetStudyFavoriteSummaryListQuery, GetStudyFavoriteSummaryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudyFavoriteSummaryListQuery, GetStudyFavoriteSummaryListQueryVariables>(GetStudyFavoriteSummaryListDocument, options);
      }
export function useGetStudyFavoriteSummaryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudyFavoriteSummaryListQuery, GetStudyFavoriteSummaryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudyFavoriteSummaryListQuery, GetStudyFavoriteSummaryListQueryVariables>(GetStudyFavoriteSummaryListDocument, options);
        }
export function useGetStudyFavoriteSummaryListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudyFavoriteSummaryListQuery, GetStudyFavoriteSummaryListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudyFavoriteSummaryListQuery, GetStudyFavoriteSummaryListQueryVariables>(GetStudyFavoriteSummaryListDocument, options);
        }
export type GetStudyFavoriteSummaryListQueryHookResult = ReturnType<typeof useGetStudyFavoriteSummaryListQuery>;
export type GetStudyFavoriteSummaryListLazyQueryHookResult = ReturnType<typeof useGetStudyFavoriteSummaryListLazyQuery>;
export type GetStudyFavoriteSummaryListSuspenseQueryHookResult = ReturnType<typeof useGetStudyFavoriteSummaryListSuspenseQuery>;
export type GetStudyFavoriteSummaryListQueryResult = Apollo.QueryResult<GetStudyFavoriteSummaryListQuery, GetStudyFavoriteSummaryListQueryVariables>;
export const GetStudyLogDocument = gql`
    query getStudyLog($chapterID: Uint64!) {
  getStudyLog(chapterID: $chapterID) {
    ...StudyLog
  }
}
    ${StudyLogFragmentDoc}`;

/**
 * __useGetStudyLogQuery__
 *
 * To run a query within a React component, call `useGetStudyLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyLogQuery({
 *   variables: {
 *      chapterID: // value for 'chapterID'
 *   },
 * });
 */
export function useGetStudyLogQuery(baseOptions: Apollo.QueryHookOptions<GetStudyLogQuery, GetStudyLogQueryVariables> & ({ variables: GetStudyLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudyLogQuery, GetStudyLogQueryVariables>(GetStudyLogDocument, options);
      }
export function useGetStudyLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudyLogQuery, GetStudyLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudyLogQuery, GetStudyLogQueryVariables>(GetStudyLogDocument, options);
        }
export function useGetStudyLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudyLogQuery, GetStudyLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudyLogQuery, GetStudyLogQueryVariables>(GetStudyLogDocument, options);
        }
export type GetStudyLogQueryHookResult = ReturnType<typeof useGetStudyLogQuery>;
export type GetStudyLogLazyQueryHookResult = ReturnType<typeof useGetStudyLogLazyQuery>;
export type GetStudyLogSuspenseQueryHookResult = ReturnType<typeof useGetStudyLogSuspenseQuery>;
export type GetStudyLogQueryResult = Apollo.QueryResult<GetStudyLogQuery, GetStudyLogQueryVariables>;
export const SaveStudyLogDocument = gql`
    mutation saveStudyLog($chapterID: Uint64!, $understandingLevel: StudyLogUnderstandingLevel!) {
  saveStudyLog(chapterID: $chapterID, understandingLevel: $understandingLevel) {
    ...StudyLog
  }
}
    ${StudyLogFragmentDoc}`;
export type SaveStudyLogMutationFn = Apollo.MutationFunction<SaveStudyLogMutation, SaveStudyLogMutationVariables>;

/**
 * __useSaveStudyLogMutation__
 *
 * To run a mutation, you first call `useSaveStudyLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveStudyLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveStudyLogMutation, { data, loading, error }] = useSaveStudyLogMutation({
 *   variables: {
 *      chapterID: // value for 'chapterID'
 *      understandingLevel: // value for 'understandingLevel'
 *   },
 * });
 */
export function useSaveStudyLogMutation(baseOptions?: Apollo.MutationHookOptions<SaveStudyLogMutation, SaveStudyLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveStudyLogMutation, SaveStudyLogMutationVariables>(SaveStudyLogDocument, options);
      }
export type SaveStudyLogMutationHookResult = ReturnType<typeof useSaveStudyLogMutation>;
export type SaveStudyLogMutationResult = Apollo.MutationResult<SaveStudyLogMutation>;
export type SaveStudyLogMutationOptions = Apollo.BaseMutationOptions<SaveStudyLogMutation, SaveStudyLogMutationVariables>;
export const GetStudyReportDocument = gql`
    query getStudyReport($id: Uint64!, $userID: Uint64) {
  getStudyReport(id: $id) {
    ...StudyReport
  }
}
    ${StudyReportFragmentDoc}`;

/**
 * __useGetStudyReportQuery__
 *
 * To run a query within a React component, call `useGetStudyReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useGetStudyReportQuery(baseOptions: Apollo.QueryHookOptions<GetStudyReportQuery, GetStudyReportQueryVariables> & ({ variables: GetStudyReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudyReportQuery, GetStudyReportQueryVariables>(GetStudyReportDocument, options);
      }
export function useGetStudyReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudyReportQuery, GetStudyReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudyReportQuery, GetStudyReportQueryVariables>(GetStudyReportDocument, options);
        }
export function useGetStudyReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudyReportQuery, GetStudyReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudyReportQuery, GetStudyReportQueryVariables>(GetStudyReportDocument, options);
        }
export type GetStudyReportQueryHookResult = ReturnType<typeof useGetStudyReportQuery>;
export type GetStudyReportLazyQueryHookResult = ReturnType<typeof useGetStudyReportLazyQuery>;
export type GetStudyReportSuspenseQueryHookResult = ReturnType<typeof useGetStudyReportSuspenseQuery>;
export type GetStudyReportQueryResult = Apollo.QueryResult<GetStudyReportQuery, GetStudyReportQueryVariables>;
export const GetStudyReportsDocument = gql`
    query getStudyReports($input: StudyReportSearchInput!, $userID: Uint64) {
  getStudyReports(input: $input) {
    total
    items {
      ...StudyReport
    }
  }
}
    ${StudyReportFragmentDoc}`;

/**
 * __useGetStudyReportsQuery__
 *
 * To run a query within a React component, call `useGetStudyReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyReportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useGetStudyReportsQuery(baseOptions: Apollo.QueryHookOptions<GetStudyReportsQuery, GetStudyReportsQueryVariables> & ({ variables: GetStudyReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudyReportsQuery, GetStudyReportsQueryVariables>(GetStudyReportsDocument, options);
      }
export function useGetStudyReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudyReportsQuery, GetStudyReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudyReportsQuery, GetStudyReportsQueryVariables>(GetStudyReportsDocument, options);
        }
export function useGetStudyReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudyReportsQuery, GetStudyReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudyReportsQuery, GetStudyReportsQueryVariables>(GetStudyReportsDocument, options);
        }
export type GetStudyReportsQueryHookResult = ReturnType<typeof useGetStudyReportsQuery>;
export type GetStudyReportsLazyQueryHookResult = ReturnType<typeof useGetStudyReportsLazyQuery>;
export type GetStudyReportsSuspenseQueryHookResult = ReturnType<typeof useGetStudyReportsSuspenseQuery>;
export type GetStudyReportsQueryResult = Apollo.QueryResult<GetStudyReportsQuery, GetStudyReportsQueryVariables>;
export const GetRelatedStudyReportsDocument = gql`
    query getRelatedStudyReports($input: RelatedStudyReportSearchInput!, $userID: Uint64) {
  getRelatedStudyReports(input: $input) {
    total
    items {
      ...StudyReport
    }
  }
}
    ${StudyReportFragmentDoc}`;

/**
 * __useGetRelatedStudyReportsQuery__
 *
 * To run a query within a React component, call `useGetRelatedStudyReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedStudyReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedStudyReportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useGetRelatedStudyReportsQuery(baseOptions: Apollo.QueryHookOptions<GetRelatedStudyReportsQuery, GetRelatedStudyReportsQueryVariables> & ({ variables: GetRelatedStudyReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelatedStudyReportsQuery, GetRelatedStudyReportsQueryVariables>(GetRelatedStudyReportsDocument, options);
      }
export function useGetRelatedStudyReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelatedStudyReportsQuery, GetRelatedStudyReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelatedStudyReportsQuery, GetRelatedStudyReportsQueryVariables>(GetRelatedStudyReportsDocument, options);
        }
export function useGetRelatedStudyReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRelatedStudyReportsQuery, GetRelatedStudyReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRelatedStudyReportsQuery, GetRelatedStudyReportsQueryVariables>(GetRelatedStudyReportsDocument, options);
        }
export type GetRelatedStudyReportsQueryHookResult = ReturnType<typeof useGetRelatedStudyReportsQuery>;
export type GetRelatedStudyReportsLazyQueryHookResult = ReturnType<typeof useGetRelatedStudyReportsLazyQuery>;
export type GetRelatedStudyReportsSuspenseQueryHookResult = ReturnType<typeof useGetRelatedStudyReportsSuspenseQuery>;
export type GetRelatedStudyReportsQueryResult = Apollo.QueryResult<GetRelatedStudyReportsQuery, GetRelatedStudyReportsQueryVariables>;
export const CreateStudyReportDocument = gql`
    mutation createStudyReport($input: StudyReportInput!) {
  createStudyReport(input: $input) {
    id
  }
}
    `;
export type CreateStudyReportMutationFn = Apollo.MutationFunction<CreateStudyReportMutation, CreateStudyReportMutationVariables>;

/**
 * __useCreateStudyReportMutation__
 *
 * To run a mutation, you first call `useCreateStudyReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudyReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStudyReportMutation, { data, loading, error }] = useCreateStudyReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStudyReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateStudyReportMutation, CreateStudyReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStudyReportMutation, CreateStudyReportMutationVariables>(CreateStudyReportDocument, options);
      }
export type CreateStudyReportMutationHookResult = ReturnType<typeof useCreateStudyReportMutation>;
export type CreateStudyReportMutationResult = Apollo.MutationResult<CreateStudyReportMutation>;
export type CreateStudyReportMutationOptions = Apollo.BaseMutationOptions<CreateStudyReportMutation, CreateStudyReportMutationVariables>;
export const UpdateStudyReportDocument = gql`
    mutation updateStudyReport($id: Uint64!, $input: StudyReportInput!) {
  updateStudyReport(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateStudyReportMutationFn = Apollo.MutationFunction<UpdateStudyReportMutation, UpdateStudyReportMutationVariables>;

/**
 * __useUpdateStudyReportMutation__
 *
 * To run a mutation, you first call `useUpdateStudyReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudyReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudyReportMutation, { data, loading, error }] = useUpdateStudyReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStudyReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudyReportMutation, UpdateStudyReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudyReportMutation, UpdateStudyReportMutationVariables>(UpdateStudyReportDocument, options);
      }
export type UpdateStudyReportMutationHookResult = ReturnType<typeof useUpdateStudyReportMutation>;
export type UpdateStudyReportMutationResult = Apollo.MutationResult<UpdateStudyReportMutation>;
export type UpdateStudyReportMutationOptions = Apollo.BaseMutationOptions<UpdateStudyReportMutation, UpdateStudyReportMutationVariables>;
export const DeleteStudyReportDocument = gql`
    mutation deleteStudyReport($id: Uint64!) {
  deleteStudyReport(id: $id) {
    id
  }
}
    `;
export type DeleteStudyReportMutationFn = Apollo.MutationFunction<DeleteStudyReportMutation, DeleteStudyReportMutationVariables>;

/**
 * __useDeleteStudyReportMutation__
 *
 * To run a mutation, you first call `useDeleteStudyReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudyReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudyReportMutation, { data, loading, error }] = useDeleteStudyReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStudyReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStudyReportMutation, DeleteStudyReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStudyReportMutation, DeleteStudyReportMutationVariables>(DeleteStudyReportDocument, options);
      }
export type DeleteStudyReportMutationHookResult = ReturnType<typeof useDeleteStudyReportMutation>;
export type DeleteStudyReportMutationResult = Apollo.MutationResult<DeleteStudyReportMutation>;
export type DeleteStudyReportMutationOptions = Apollo.BaseMutationOptions<DeleteStudyReportMutation, DeleteStudyReportMutationVariables>;
export const CreateStudyReportCommentDocument = gql`
    mutation createStudyReportComment($studyReportID: Uint64!, $input: StudyReportCommentInput!) {
  createStudyReportComment(studyReportID: $studyReportID, input: $input) {
    id
    content
    createdAt
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type CreateStudyReportCommentMutationFn = Apollo.MutationFunction<CreateStudyReportCommentMutation, CreateStudyReportCommentMutationVariables>;

/**
 * __useCreateStudyReportCommentMutation__
 *
 * To run a mutation, you first call `useCreateStudyReportCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudyReportCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStudyReportCommentMutation, { data, loading, error }] = useCreateStudyReportCommentMutation({
 *   variables: {
 *      studyReportID: // value for 'studyReportID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStudyReportCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateStudyReportCommentMutation, CreateStudyReportCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStudyReportCommentMutation, CreateStudyReportCommentMutationVariables>(CreateStudyReportCommentDocument, options);
      }
export type CreateStudyReportCommentMutationHookResult = ReturnType<typeof useCreateStudyReportCommentMutation>;
export type CreateStudyReportCommentMutationResult = Apollo.MutationResult<CreateStudyReportCommentMutation>;
export type CreateStudyReportCommentMutationOptions = Apollo.BaseMutationOptions<CreateStudyReportCommentMutation, CreateStudyReportCommentMutationVariables>;
export const UpdateStudyReportCommentDocument = gql`
    mutation updateStudyReportComment($id: Uint64!, $input: StudyReportCommentInput!) {
  updateStudyReportComment(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateStudyReportCommentMutationFn = Apollo.MutationFunction<UpdateStudyReportCommentMutation, UpdateStudyReportCommentMutationVariables>;

/**
 * __useUpdateStudyReportCommentMutation__
 *
 * To run a mutation, you first call `useUpdateStudyReportCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudyReportCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudyReportCommentMutation, { data, loading, error }] = useUpdateStudyReportCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStudyReportCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudyReportCommentMutation, UpdateStudyReportCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudyReportCommentMutation, UpdateStudyReportCommentMutationVariables>(UpdateStudyReportCommentDocument, options);
      }
export type UpdateStudyReportCommentMutationHookResult = ReturnType<typeof useUpdateStudyReportCommentMutation>;
export type UpdateStudyReportCommentMutationResult = Apollo.MutationResult<UpdateStudyReportCommentMutation>;
export type UpdateStudyReportCommentMutationOptions = Apollo.BaseMutationOptions<UpdateStudyReportCommentMutation, UpdateStudyReportCommentMutationVariables>;
export const DeleteStudyReportCommentDocument = gql`
    mutation deleteStudyReportComment($id: Uint64!) {
  deleteStudyReportComment(id: $id) {
    id
  }
}
    `;
export type DeleteStudyReportCommentMutationFn = Apollo.MutationFunction<DeleteStudyReportCommentMutation, DeleteStudyReportCommentMutationVariables>;

/**
 * __useDeleteStudyReportCommentMutation__
 *
 * To run a mutation, you first call `useDeleteStudyReportCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudyReportCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudyReportCommentMutation, { data, loading, error }] = useDeleteStudyReportCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStudyReportCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStudyReportCommentMutation, DeleteStudyReportCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStudyReportCommentMutation, DeleteStudyReportCommentMutationVariables>(DeleteStudyReportCommentDocument, options);
      }
export type DeleteStudyReportCommentMutationHookResult = ReturnType<typeof useDeleteStudyReportCommentMutation>;
export type DeleteStudyReportCommentMutationResult = Apollo.MutationResult<DeleteStudyReportCommentMutation>;
export type DeleteStudyReportCommentMutationOptions = Apollo.BaseMutationOptions<DeleteStudyReportCommentMutation, DeleteStudyReportCommentMutationVariables>;
export const CreateStudyReportFavoriteDocument = gql`
    mutation createStudyReportFavorite($studyReportID: Uint64!) {
  createStudyReportFavorite(studyReportID: $studyReportID) {
    ...StudyReportFavorite
  }
}
    ${StudyReportFavoriteFragmentDoc}`;
export type CreateStudyReportFavoriteMutationFn = Apollo.MutationFunction<CreateStudyReportFavoriteMutation, CreateStudyReportFavoriteMutationVariables>;

/**
 * __useCreateStudyReportFavoriteMutation__
 *
 * To run a mutation, you first call `useCreateStudyReportFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudyReportFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStudyReportFavoriteMutation, { data, loading, error }] = useCreateStudyReportFavoriteMutation({
 *   variables: {
 *      studyReportID: // value for 'studyReportID'
 *   },
 * });
 */
export function useCreateStudyReportFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<CreateStudyReportFavoriteMutation, CreateStudyReportFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStudyReportFavoriteMutation, CreateStudyReportFavoriteMutationVariables>(CreateStudyReportFavoriteDocument, options);
      }
export type CreateStudyReportFavoriteMutationHookResult = ReturnType<typeof useCreateStudyReportFavoriteMutation>;
export type CreateStudyReportFavoriteMutationResult = Apollo.MutationResult<CreateStudyReportFavoriteMutation>;
export type CreateStudyReportFavoriteMutationOptions = Apollo.BaseMutationOptions<CreateStudyReportFavoriteMutation, CreateStudyReportFavoriteMutationVariables>;
export const DeleteStudyReportFavoriteDocument = gql`
    mutation deleteStudyReportFavorite($studyReportID: Uint64!) {
  deleteStudyReportFavorite(studyReportID: $studyReportID) {
    id
  }
}
    `;
export type DeleteStudyReportFavoriteMutationFn = Apollo.MutationFunction<DeleteStudyReportFavoriteMutation, DeleteStudyReportFavoriteMutationVariables>;

/**
 * __useDeleteStudyReportFavoriteMutation__
 *
 * To run a mutation, you first call `useDeleteStudyReportFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudyReportFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudyReportFavoriteMutation, { data, loading, error }] = useDeleteStudyReportFavoriteMutation({
 *   variables: {
 *      studyReportID: // value for 'studyReportID'
 *   },
 * });
 */
export function useDeleteStudyReportFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStudyReportFavoriteMutation, DeleteStudyReportFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStudyReportFavoriteMutation, DeleteStudyReportFavoriteMutationVariables>(DeleteStudyReportFavoriteDocument, options);
      }
export type DeleteStudyReportFavoriteMutationHookResult = ReturnType<typeof useDeleteStudyReportFavoriteMutation>;
export type DeleteStudyReportFavoriteMutationResult = Apollo.MutationResult<DeleteStudyReportFavoriteMutation>;
export type DeleteStudyReportFavoriteMutationOptions = Apollo.BaseMutationOptions<DeleteStudyReportFavoriteMutation, DeleteStudyReportFavoriteMutationVariables>;
export const GetStudySummaryDocument = gql`
    query getStudySummary {
  getStudySummary {
    ...StudySummary
  }
}
    ${StudySummaryFragmentDoc}`;

/**
 * __useGetStudySummaryQuery__
 *
 * To run a query within a React component, call `useGetStudySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudySummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStudySummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetStudySummaryQuery, GetStudySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudySummaryQuery, GetStudySummaryQueryVariables>(GetStudySummaryDocument, options);
      }
export function useGetStudySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudySummaryQuery, GetStudySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudySummaryQuery, GetStudySummaryQueryVariables>(GetStudySummaryDocument, options);
        }
export function useGetStudySummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudySummaryQuery, GetStudySummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudySummaryQuery, GetStudySummaryQueryVariables>(GetStudySummaryDocument, options);
        }
export type GetStudySummaryQueryHookResult = ReturnType<typeof useGetStudySummaryQuery>;
export type GetStudySummaryLazyQueryHookResult = ReturnType<typeof useGetStudySummaryLazyQuery>;
export type GetStudySummarySuspenseQueryHookResult = ReturnType<typeof useGetStudySummarySuspenseQuery>;
export type GetStudySummaryQueryResult = Apollo.QueryResult<GetStudySummaryQuery, GetStudySummaryQueryVariables>;
export const GetStudySummaryListDocument = gql`
    query getStudySummaryList {
  getStudySummaryList {
    studyReportTime {
      ...StudySummaryList
    }
    studyReportTimeWeek {
      ...StudySummaryList
    }
    studyReportTimeMonth {
      ...StudySummaryList
    }
  }
}
    ${StudySummaryListFragmentDoc}`;

/**
 * __useGetStudySummaryListQuery__
 *
 * To run a query within a React component, call `useGetStudySummaryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudySummaryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudySummaryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStudySummaryListQuery(baseOptions?: Apollo.QueryHookOptions<GetStudySummaryListQuery, GetStudySummaryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudySummaryListQuery, GetStudySummaryListQueryVariables>(GetStudySummaryListDocument, options);
      }
export function useGetStudySummaryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudySummaryListQuery, GetStudySummaryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudySummaryListQuery, GetStudySummaryListQueryVariables>(GetStudySummaryListDocument, options);
        }
export function useGetStudySummaryListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudySummaryListQuery, GetStudySummaryListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudySummaryListQuery, GetStudySummaryListQueryVariables>(GetStudySummaryListDocument, options);
        }
export type GetStudySummaryListQueryHookResult = ReturnType<typeof useGetStudySummaryListQuery>;
export type GetStudySummaryListLazyQueryHookResult = ReturnType<typeof useGetStudySummaryListLazyQuery>;
export type GetStudySummaryListSuspenseQueryHookResult = ReturnType<typeof useGetStudySummaryListSuspenseQuery>;
export type GetStudySummaryListQueryResult = Apollo.QueryResult<GetStudySummaryListQuery, GetStudySummaryListQueryVariables>;
export const GetStudyTagSummariesDocument = gql`
    query getStudyTagSummaries {
  getStudyTagSummaries {
    ...StudyTagSummary
  }
}
    ${StudyTagSummaryFragmentDoc}`;

/**
 * __useGetStudyTagSummariesQuery__
 *
 * To run a query within a React component, call `useGetStudyTagSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyTagSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyTagSummariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStudyTagSummariesQuery(baseOptions?: Apollo.QueryHookOptions<GetStudyTagSummariesQuery, GetStudyTagSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudyTagSummariesQuery, GetStudyTagSummariesQueryVariables>(GetStudyTagSummariesDocument, options);
      }
export function useGetStudyTagSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudyTagSummariesQuery, GetStudyTagSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudyTagSummariesQuery, GetStudyTagSummariesQueryVariables>(GetStudyTagSummariesDocument, options);
        }
export function useGetStudyTagSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudyTagSummariesQuery, GetStudyTagSummariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudyTagSummariesQuery, GetStudyTagSummariesQueryVariables>(GetStudyTagSummariesDocument, options);
        }
export type GetStudyTagSummariesQueryHookResult = ReturnType<typeof useGetStudyTagSummariesQuery>;
export type GetStudyTagSummariesLazyQueryHookResult = ReturnType<typeof useGetStudyTagSummariesLazyQuery>;
export type GetStudyTagSummariesSuspenseQueryHookResult = ReturnType<typeof useGetStudyTagSummariesSuspenseQuery>;
export type GetStudyTagSummariesQueryResult = Apollo.QueryResult<GetStudyTagSummariesQuery, GetStudyTagSummariesQueryVariables>;
export const GetStudyTagSummaryListDocument = gql`
    query getStudyTagSummaryList {
  getStudyTagSummaryList {
    studyReportTime {
      ...StudyTagSummaryList
    }
    studyReportTimeWeek {
      ...StudyTagSummaryList
    }
    studyReportTimeMonth {
      ...StudyTagSummaryList
    }
  }
}
    ${StudyTagSummaryListFragmentDoc}`;

/**
 * __useGetStudyTagSummaryListQuery__
 *
 * To run a query within a React component, call `useGetStudyTagSummaryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyTagSummaryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyTagSummaryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStudyTagSummaryListQuery(baseOptions?: Apollo.QueryHookOptions<GetStudyTagSummaryListQuery, GetStudyTagSummaryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudyTagSummaryListQuery, GetStudyTagSummaryListQueryVariables>(GetStudyTagSummaryListDocument, options);
      }
export function useGetStudyTagSummaryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudyTagSummaryListQuery, GetStudyTagSummaryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudyTagSummaryListQuery, GetStudyTagSummaryListQueryVariables>(GetStudyTagSummaryListDocument, options);
        }
export function useGetStudyTagSummaryListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudyTagSummaryListQuery, GetStudyTagSummaryListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudyTagSummaryListQuery, GetStudyTagSummaryListQueryVariables>(GetStudyTagSummaryListDocument, options);
        }
export type GetStudyTagSummaryListQueryHookResult = ReturnType<typeof useGetStudyTagSummaryListQuery>;
export type GetStudyTagSummaryListLazyQueryHookResult = ReturnType<typeof useGetStudyTagSummaryListLazyQuery>;
export type GetStudyTagSummaryListSuspenseQueryHookResult = ReturnType<typeof useGetStudyTagSummaryListSuspenseQuery>;
export type GetStudyTagSummaryListQueryResult = Apollo.QueryResult<GetStudyTagSummaryListQuery, GetStudyTagSummaryListQueryVariables>;
export const MySubscriptionContractsDocument = gql`
    query mySubscriptionContracts($input: MySubscriptionContractInput!) {
  mySubscriptionContracts(input: $input) {
    items {
      ...SubscriptionContractForList
    }
    total
  }
}
    ${SubscriptionContractForListFragmentDoc}`;

/**
 * __useMySubscriptionContractsQuery__
 *
 * To run a query within a React component, call `useMySubscriptionContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySubscriptionContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySubscriptionContractsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMySubscriptionContractsQuery(baseOptions: Apollo.QueryHookOptions<MySubscriptionContractsQuery, MySubscriptionContractsQueryVariables> & ({ variables: MySubscriptionContractsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySubscriptionContractsQuery, MySubscriptionContractsQueryVariables>(MySubscriptionContractsDocument, options);
      }
export function useMySubscriptionContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySubscriptionContractsQuery, MySubscriptionContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySubscriptionContractsQuery, MySubscriptionContractsQueryVariables>(MySubscriptionContractsDocument, options);
        }
export function useMySubscriptionContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MySubscriptionContractsQuery, MySubscriptionContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MySubscriptionContractsQuery, MySubscriptionContractsQueryVariables>(MySubscriptionContractsDocument, options);
        }
export type MySubscriptionContractsQueryHookResult = ReturnType<typeof useMySubscriptionContractsQuery>;
export type MySubscriptionContractsLazyQueryHookResult = ReturnType<typeof useMySubscriptionContractsLazyQuery>;
export type MySubscriptionContractsSuspenseQueryHookResult = ReturnType<typeof useMySubscriptionContractsSuspenseQuery>;
export type MySubscriptionContractsQueryResult = Apollo.QueryResult<MySubscriptionContractsQuery, MySubscriptionContractsQueryVariables>;
export const TeamSubscriptionContractsDocument = gql`
    query teamSubscriptionContracts($input: TeamSubscriptionContractInput!) {
  teamSubscriptionContracts(input: $input) {
    items {
      ...SubscriptionContractForList
    }
    total
  }
}
    ${SubscriptionContractForListFragmentDoc}`;

/**
 * __useTeamSubscriptionContractsQuery__
 *
 * To run a query within a React component, call `useTeamSubscriptionContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamSubscriptionContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamSubscriptionContractsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTeamSubscriptionContractsQuery(baseOptions: Apollo.QueryHookOptions<TeamSubscriptionContractsQuery, TeamSubscriptionContractsQueryVariables> & ({ variables: TeamSubscriptionContractsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamSubscriptionContractsQuery, TeamSubscriptionContractsQueryVariables>(TeamSubscriptionContractsDocument, options);
      }
export function useTeamSubscriptionContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamSubscriptionContractsQuery, TeamSubscriptionContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamSubscriptionContractsQuery, TeamSubscriptionContractsQueryVariables>(TeamSubscriptionContractsDocument, options);
        }
export function useTeamSubscriptionContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamSubscriptionContractsQuery, TeamSubscriptionContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamSubscriptionContractsQuery, TeamSubscriptionContractsQueryVariables>(TeamSubscriptionContractsDocument, options);
        }
export type TeamSubscriptionContractsQueryHookResult = ReturnType<typeof useTeamSubscriptionContractsQuery>;
export type TeamSubscriptionContractsLazyQueryHookResult = ReturnType<typeof useTeamSubscriptionContractsLazyQuery>;
export type TeamSubscriptionContractsSuspenseQueryHookResult = ReturnType<typeof useTeamSubscriptionContractsSuspenseQuery>;
export type TeamSubscriptionContractsQueryResult = Apollo.QueryResult<TeamSubscriptionContractsQuery, TeamSubscriptionContractsQueryVariables>;
export const GetTagsDocument = gql`
    query getTags($input: TagSearchInput!) {
  getTags(input: $input) {
    items {
      ...Tag
    }
    total
  }
}
    ${TagFragmentDoc}`;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables> & ({ variables: GetTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsSuspenseQueryHookResult = ReturnType<typeof useGetTagsSuspenseQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const GetTagDocument = gql`
    query getTag($id: Uint64!) {
  getTag(id: $id) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

/**
 * __useGetTagQuery__
 *
 * To run a query within a React component, call `useGetTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTagQuery(baseOptions: Apollo.QueryHookOptions<GetTagQuery, GetTagQueryVariables> & ({ variables: GetTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
      }
export function useGetTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagQuery, GetTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
        }
export function useGetTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagQuery, GetTagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
        }
export type GetTagQueryHookResult = ReturnType<typeof useGetTagQuery>;
export type GetTagLazyQueryHookResult = ReturnType<typeof useGetTagLazyQuery>;
export type GetTagSuspenseQueryHookResult = ReturnType<typeof useGetTagSuspenseQuery>;
export type GetTagQueryResult = Apollo.QueryResult<GetTagQuery, GetTagQueryVariables>;
export const GetTeamDocument = gql`
    query getTeam($id: ULID!) {
  team(id: $id) {
    image
    companyName
    adminEmail
    paymentMethodType
  }
}
    `;

/**
 * __useGetTeamQuery__
 *
 * To run a query within a React component, call `useGetTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamQuery(baseOptions: Apollo.QueryHookOptions<GetTeamQuery, GetTeamQueryVariables> & ({ variables: GetTeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
      }
export function useGetTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamQuery, GetTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
        }
export function useGetTeamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamQuery, GetTeamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
        }
export type GetTeamQueryHookResult = ReturnType<typeof useGetTeamQuery>;
export type GetTeamLazyQueryHookResult = ReturnType<typeof useGetTeamLazyQuery>;
export type GetTeamSuspenseQueryHookResult = ReturnType<typeof useGetTeamSuspenseQuery>;
export type GetTeamQueryResult = Apollo.QueryResult<GetTeamQuery, GetTeamQueryVariables>;
export const UpdateTeamDocument = gql`
    mutation updateTeam($id: ULID!, $input: UpdateTeamInput!) {
  updateTeam(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const GetTeamWithSubscriptionDocument = gql`
    query getTeamWithSubscription($id: ULID!) {
  team(id: $id) {
    id
    paymentMethodType
    teamMembers {
      ...MyTeamMember
    }
  }
  teamSubscription(teamID: $id) {
    providerStatus
  }
}
    ${MyTeamMemberFragmentDoc}`;

/**
 * __useGetTeamWithSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetTeamWithSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamWithSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamWithSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamWithSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GetTeamWithSubscriptionQuery, GetTeamWithSubscriptionQueryVariables> & ({ variables: GetTeamWithSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamWithSubscriptionQuery, GetTeamWithSubscriptionQueryVariables>(GetTeamWithSubscriptionDocument, options);
      }
export function useGetTeamWithSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamWithSubscriptionQuery, GetTeamWithSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamWithSubscriptionQuery, GetTeamWithSubscriptionQueryVariables>(GetTeamWithSubscriptionDocument, options);
        }
export function useGetTeamWithSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamWithSubscriptionQuery, GetTeamWithSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamWithSubscriptionQuery, GetTeamWithSubscriptionQueryVariables>(GetTeamWithSubscriptionDocument, options);
        }
export type GetTeamWithSubscriptionQueryHookResult = ReturnType<typeof useGetTeamWithSubscriptionQuery>;
export type GetTeamWithSubscriptionLazyQueryHookResult = ReturnType<typeof useGetTeamWithSubscriptionLazyQuery>;
export type GetTeamWithSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetTeamWithSubscriptionSuspenseQuery>;
export type GetTeamWithSubscriptionQueryResult = Apollo.QueryResult<GetTeamWithSubscriptionQuery, GetTeamWithSubscriptionQueryVariables>;
export const CreateTeamDocument = gql`
    mutation createTeam($input: TeamInput!) {
  createTeam(input: $input) {
    id
  }
}
    `;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation deleteTeam($id: ULID!) {
  deleteTeam(teamID: $id)
}
    `;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const TeamUpdatePaymentMethodTypeDocument = gql`
    mutation teamUpdatePaymentMethodType($teamID: ULID!, $paymentMethodType: PaymentMethodType!) {
  teamUpdatePaymentMethodType(
    teamID: $teamID
    paymentMethodType: $paymentMethodType
  )
}
    `;
export type TeamUpdatePaymentMethodTypeMutationFn = Apollo.MutationFunction<TeamUpdatePaymentMethodTypeMutation, TeamUpdatePaymentMethodTypeMutationVariables>;

/**
 * __useTeamUpdatePaymentMethodTypeMutation__
 *
 * To run a mutation, you first call `useTeamUpdatePaymentMethodTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamUpdatePaymentMethodTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamUpdatePaymentMethodTypeMutation, { data, loading, error }] = useTeamUpdatePaymentMethodTypeMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      paymentMethodType: // value for 'paymentMethodType'
 *   },
 * });
 */
export function useTeamUpdatePaymentMethodTypeMutation(baseOptions?: Apollo.MutationHookOptions<TeamUpdatePaymentMethodTypeMutation, TeamUpdatePaymentMethodTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeamUpdatePaymentMethodTypeMutation, TeamUpdatePaymentMethodTypeMutationVariables>(TeamUpdatePaymentMethodTypeDocument, options);
      }
export type TeamUpdatePaymentMethodTypeMutationHookResult = ReturnType<typeof useTeamUpdatePaymentMethodTypeMutation>;
export type TeamUpdatePaymentMethodTypeMutationResult = Apollo.MutationResult<TeamUpdatePaymentMethodTypeMutation>;
export type TeamUpdatePaymentMethodTypeMutationOptions = Apollo.BaseMutationOptions<TeamUpdatePaymentMethodTypeMutation, TeamUpdatePaymentMethodTypeMutationVariables>;
export const GetTeamInvitationDocument = gql`
    query getTeamInvitation($id: String!) {
  teamInvitation(id: $id) {
    team {
      companyName
    }
  }
}
    `;

/**
 * __useGetTeamInvitationQuery__
 *
 * To run a query within a React component, call `useGetTeamInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamInvitationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamInvitationQuery(baseOptions: Apollo.QueryHookOptions<GetTeamInvitationQuery, GetTeamInvitationQueryVariables> & ({ variables: GetTeamInvitationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamInvitationQuery, GetTeamInvitationQueryVariables>(GetTeamInvitationDocument, options);
      }
export function useGetTeamInvitationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamInvitationQuery, GetTeamInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamInvitationQuery, GetTeamInvitationQueryVariables>(GetTeamInvitationDocument, options);
        }
export function useGetTeamInvitationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamInvitationQuery, GetTeamInvitationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamInvitationQuery, GetTeamInvitationQueryVariables>(GetTeamInvitationDocument, options);
        }
export type GetTeamInvitationQueryHookResult = ReturnType<typeof useGetTeamInvitationQuery>;
export type GetTeamInvitationLazyQueryHookResult = ReturnType<typeof useGetTeamInvitationLazyQuery>;
export type GetTeamInvitationSuspenseQueryHookResult = ReturnType<typeof useGetTeamInvitationSuspenseQuery>;
export type GetTeamInvitationQueryResult = Apollo.QueryResult<GetTeamInvitationQuery, GetTeamInvitationQueryVariables>;
export const CreateTeamInvitationDocument = gql`
    mutation createTeamInvitation($input: TeamInvitationInput!) {
  createTeamInvitation(input: $input)
}
    `;
export type CreateTeamInvitationMutationFn = Apollo.MutationFunction<CreateTeamInvitationMutation, CreateTeamInvitationMutationVariables>;

/**
 * __useCreateTeamInvitationMutation__
 *
 * To run a mutation, you first call `useCreateTeamInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamInvitationMutation, { data, loading, error }] = useCreateTeamInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamInvitationMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamInvitationMutation, CreateTeamInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamInvitationMutation, CreateTeamInvitationMutationVariables>(CreateTeamInvitationDocument, options);
      }
export type CreateTeamInvitationMutationHookResult = ReturnType<typeof useCreateTeamInvitationMutation>;
export type CreateTeamInvitationMutationResult = Apollo.MutationResult<CreateTeamInvitationMutation>;
export type CreateTeamInvitationMutationOptions = Apollo.BaseMutationOptions<CreateTeamInvitationMutation, CreateTeamInvitationMutationVariables>;
export const GetMyTeamMembersDocument = gql`
    query getMyTeamMembers {
  myTeamMembers {
    ...MyTeamMember
  }
}
    ${MyTeamMemberFragmentDoc}`;

/**
 * __useGetMyTeamMembersQuery__
 *
 * To run a query within a React component, call `useGetMyTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTeamMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>(GetMyTeamMembersDocument, options);
      }
export function useGetMyTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>(GetMyTeamMembersDocument, options);
        }
export function useGetMyTeamMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>(GetMyTeamMembersDocument, options);
        }
export type GetMyTeamMembersQueryHookResult = ReturnType<typeof useGetMyTeamMembersQuery>;
export type GetMyTeamMembersLazyQueryHookResult = ReturnType<typeof useGetMyTeamMembersLazyQuery>;
export type GetMyTeamMembersSuspenseQueryHookResult = ReturnType<typeof useGetMyTeamMembersSuspenseQuery>;
export type GetMyTeamMembersQueryResult = Apollo.QueryResult<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>;
export const JoinTeamMemberDocument = gql`
    mutation joinTeamMember($teamInvitationID: ULID!) {
  joinTeamMember(teamInvitationID: $teamInvitationID) {
    id
    teamID
  }
}
    `;
export type JoinTeamMemberMutationFn = Apollo.MutationFunction<JoinTeamMemberMutation, JoinTeamMemberMutationVariables>;

/**
 * __useJoinTeamMemberMutation__
 *
 * To run a mutation, you first call `useJoinTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinTeamMemberMutation, { data, loading, error }] = useJoinTeamMemberMutation({
 *   variables: {
 *      teamInvitationID: // value for 'teamInvitationID'
 *   },
 * });
 */
export function useJoinTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<JoinTeamMemberMutation, JoinTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinTeamMemberMutation, JoinTeamMemberMutationVariables>(JoinTeamMemberDocument, options);
      }
export type JoinTeamMemberMutationHookResult = ReturnType<typeof useJoinTeamMemberMutation>;
export type JoinTeamMemberMutationResult = Apollo.MutationResult<JoinTeamMemberMutation>;
export type JoinTeamMemberMutationOptions = Apollo.BaseMutationOptions<JoinTeamMemberMutation, JoinTeamMemberMutationVariables>;
export const GetTeamMembersByTeamIdDocument = gql`
    query getTeamMembersByTeamID($input: TeamMemberSearchInput!) {
  getTeamMembersByTeamID(input: $input) {
    items {
      ...TeamMemberList
    }
    total
  }
}
    ${TeamMemberListFragmentDoc}`;

/**
 * __useGetTeamMembersByTeamIdQuery__
 *
 * To run a query within a React component, call `useGetTeamMembersByTeamIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMembersByTeamIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamMembersByTeamIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTeamMembersByTeamIdQuery(baseOptions: Apollo.QueryHookOptions<GetTeamMembersByTeamIdQuery, GetTeamMembersByTeamIdQueryVariables> & ({ variables: GetTeamMembersByTeamIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamMembersByTeamIdQuery, GetTeamMembersByTeamIdQueryVariables>(GetTeamMembersByTeamIdDocument, options);
      }
export function useGetTeamMembersByTeamIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamMembersByTeamIdQuery, GetTeamMembersByTeamIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamMembersByTeamIdQuery, GetTeamMembersByTeamIdQueryVariables>(GetTeamMembersByTeamIdDocument, options);
        }
export function useGetTeamMembersByTeamIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamMembersByTeamIdQuery, GetTeamMembersByTeamIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamMembersByTeamIdQuery, GetTeamMembersByTeamIdQueryVariables>(GetTeamMembersByTeamIdDocument, options);
        }
export type GetTeamMembersByTeamIdQueryHookResult = ReturnType<typeof useGetTeamMembersByTeamIdQuery>;
export type GetTeamMembersByTeamIdLazyQueryHookResult = ReturnType<typeof useGetTeamMembersByTeamIdLazyQuery>;
export type GetTeamMembersByTeamIdSuspenseQueryHookResult = ReturnType<typeof useGetTeamMembersByTeamIdSuspenseQuery>;
export type GetTeamMembersByTeamIdQueryResult = Apollo.QueryResult<GetTeamMembersByTeamIdQuery, GetTeamMembersByTeamIdQueryVariables>;
export const ChangeTeamMemberRoleDocument = gql`
    mutation changeTeamMemberRole($teamMemberID: ULID!, $role: TeamMemberRole!) {
  changeTeamMemberRole(teamMemberID: $teamMemberID, role: $role)
}
    `;
export type ChangeTeamMemberRoleMutationFn = Apollo.MutationFunction<ChangeTeamMemberRoleMutation, ChangeTeamMemberRoleMutationVariables>;

/**
 * __useChangeTeamMemberRoleMutation__
 *
 * To run a mutation, you first call `useChangeTeamMemberRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTeamMemberRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTeamMemberRoleMutation, { data, loading, error }] = useChangeTeamMemberRoleMutation({
 *   variables: {
 *      teamMemberID: // value for 'teamMemberID'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useChangeTeamMemberRoleMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTeamMemberRoleMutation, ChangeTeamMemberRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTeamMemberRoleMutation, ChangeTeamMemberRoleMutationVariables>(ChangeTeamMemberRoleDocument, options);
      }
export type ChangeTeamMemberRoleMutationHookResult = ReturnType<typeof useChangeTeamMemberRoleMutation>;
export type ChangeTeamMemberRoleMutationResult = Apollo.MutationResult<ChangeTeamMemberRoleMutation>;
export type ChangeTeamMemberRoleMutationOptions = Apollo.BaseMutationOptions<ChangeTeamMemberRoleMutation, ChangeTeamMemberRoleMutationVariables>;
export const RemoveTeamMemberDocument = gql`
    mutation removeTeamMember($id: ULID!) {
  removeTeamMember(id: $id)
}
    `;
export type RemoveTeamMemberMutationFn = Apollo.MutationFunction<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>;

/**
 * __useRemoveTeamMemberMutation__
 *
 * To run a mutation, you first call `useRemoveTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamMemberMutation, { data, loading, error }] = useRemoveTeamMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>(RemoveTeamMemberDocument, options);
      }
export type RemoveTeamMemberMutationHookResult = ReturnType<typeof useRemoveTeamMemberMutation>;
export type RemoveTeamMemberMutationResult = Apollo.MutationResult<RemoveTeamMemberMutation>;
export type RemoveTeamMemberMutationOptions = Apollo.BaseMutationOptions<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>;
export const GetTicketsDocument = gql`
    query getTickets {
  tickets {
    ...Ticket
  }
}
    ${TicketFragmentDoc}`;

/**
 * __useGetTicketsQuery__
 *
 * To run a query within a React component, call `useGetTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTicketsQuery(baseOptions?: Apollo.QueryHookOptions<GetTicketsQuery, GetTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTicketsQuery, GetTicketsQueryVariables>(GetTicketsDocument, options);
      }
export function useGetTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTicketsQuery, GetTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTicketsQuery, GetTicketsQueryVariables>(GetTicketsDocument, options);
        }
export function useGetTicketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTicketsQuery, GetTicketsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTicketsQuery, GetTicketsQueryVariables>(GetTicketsDocument, options);
        }
export type GetTicketsQueryHookResult = ReturnType<typeof useGetTicketsQuery>;
export type GetTicketsLazyQueryHookResult = ReturnType<typeof useGetTicketsLazyQuery>;
export type GetTicketsSuspenseQueryHookResult = ReturnType<typeof useGetTicketsSuspenseQuery>;
export type GetTicketsQueryResult = Apollo.QueryResult<GetTicketsQuery, GetTicketsQueryVariables>;
export const GetTimelinesDocument = gql`
    query getTimelines($first: Int!, $after: String, $adminAfter: String) {
  getTimelinesV1(first: $first, after: $after, adminAfter: $adminAfter) {
    items {
      ...TimelineStudyReport
      ...Tweet
    }
    pageInfo {
      ...PageInfo
    }
    adminPageInfo {
      ...PageInfo
    }
  }
}
    ${TimelineStudyReportFragmentDoc}
${TweetFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetTimelinesQuery__
 *
 * To run a query within a React component, call `useGetTimelinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimelinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimelinesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      adminAfter: // value for 'adminAfter'
 *   },
 * });
 */
export function useGetTimelinesQuery(baseOptions: Apollo.QueryHookOptions<GetTimelinesQuery, GetTimelinesQueryVariables> & ({ variables: GetTimelinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimelinesQuery, GetTimelinesQueryVariables>(GetTimelinesDocument, options);
      }
export function useGetTimelinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimelinesQuery, GetTimelinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimelinesQuery, GetTimelinesQueryVariables>(GetTimelinesDocument, options);
        }
export function useGetTimelinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTimelinesQuery, GetTimelinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTimelinesQuery, GetTimelinesQueryVariables>(GetTimelinesDocument, options);
        }
export type GetTimelinesQueryHookResult = ReturnType<typeof useGetTimelinesQuery>;
export type GetTimelinesLazyQueryHookResult = ReturnType<typeof useGetTimelinesLazyQuery>;
export type GetTimelinesSuspenseQueryHookResult = ReturnType<typeof useGetTimelinesSuspenseQuery>;
export type GetTimelinesQueryResult = Apollo.QueryResult<GetTimelinesQuery, GetTimelinesQueryVariables>;
export const GetTimelinesByUserIdDocument = gql`
    query getTimelinesByUserID($first: Int!, $after: String, $userID: Int!) {
  getTimelinesByUserID(first: $first, after: $after, userID: $userID) {
    items {
      ...TimelineStudyReport
      ...Tweet
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${TimelineStudyReportFragmentDoc}
${TweetFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetTimelinesByUserIdQuery__
 *
 * To run a query within a React component, call `useGetTimelinesByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimelinesByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimelinesByUserIdQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useGetTimelinesByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetTimelinesByUserIdQuery, GetTimelinesByUserIdQueryVariables> & ({ variables: GetTimelinesByUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimelinesByUserIdQuery, GetTimelinesByUserIdQueryVariables>(GetTimelinesByUserIdDocument, options);
      }
export function useGetTimelinesByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimelinesByUserIdQuery, GetTimelinesByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimelinesByUserIdQuery, GetTimelinesByUserIdQueryVariables>(GetTimelinesByUserIdDocument, options);
        }
export function useGetTimelinesByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTimelinesByUserIdQuery, GetTimelinesByUserIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTimelinesByUserIdQuery, GetTimelinesByUserIdQueryVariables>(GetTimelinesByUserIdDocument, options);
        }
export type GetTimelinesByUserIdQueryHookResult = ReturnType<typeof useGetTimelinesByUserIdQuery>;
export type GetTimelinesByUserIdLazyQueryHookResult = ReturnType<typeof useGetTimelinesByUserIdLazyQuery>;
export type GetTimelinesByUserIdSuspenseQueryHookResult = ReturnType<typeof useGetTimelinesByUserIdSuspenseQuery>;
export type GetTimelinesByUserIdQueryResult = Apollo.QueryResult<GetTimelinesByUserIdQuery, GetTimelinesByUserIdQueryVariables>;
export const GetTweetDocument = gql`
    query getTweet($id: ULID!) {
  getTweetV1(id: $id) {
    ...Tweet
  }
}
    ${TweetFragmentDoc}`;

/**
 * __useGetTweetQuery__
 *
 * To run a query within a React component, call `useGetTweetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTweetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTweetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTweetQuery(baseOptions: Apollo.QueryHookOptions<GetTweetQuery, GetTweetQueryVariables> & ({ variables: GetTweetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTweetQuery, GetTweetQueryVariables>(GetTweetDocument, options);
      }
export function useGetTweetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTweetQuery, GetTweetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTweetQuery, GetTweetQueryVariables>(GetTweetDocument, options);
        }
export function useGetTweetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTweetQuery, GetTweetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTweetQuery, GetTweetQueryVariables>(GetTweetDocument, options);
        }
export type GetTweetQueryHookResult = ReturnType<typeof useGetTweetQuery>;
export type GetTweetLazyQueryHookResult = ReturnType<typeof useGetTweetLazyQuery>;
export type GetTweetSuspenseQueryHookResult = ReturnType<typeof useGetTweetSuspenseQuery>;
export type GetTweetQueryResult = Apollo.QueryResult<GetTweetQuery, GetTweetQueryVariables>;
export const AddTweetDocument = gql`
    mutation addTweet($input: TweetInput!) {
  addTweet(input: $input) {
    id
  }
}
    `;
export type AddTweetMutationFn = Apollo.MutationFunction<AddTweetMutation, AddTweetMutationVariables>;

/**
 * __useAddTweetMutation__
 *
 * To run a mutation, you first call `useAddTweetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTweetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTweetMutation, { data, loading, error }] = useAddTweetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTweetMutation(baseOptions?: Apollo.MutationHookOptions<AddTweetMutation, AddTweetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTweetMutation, AddTweetMutationVariables>(AddTweetDocument, options);
      }
export type AddTweetMutationHookResult = ReturnType<typeof useAddTweetMutation>;
export type AddTweetMutationResult = Apollo.MutationResult<AddTweetMutation>;
export type AddTweetMutationOptions = Apollo.BaseMutationOptions<AddTweetMutation, AddTweetMutationVariables>;
export const DeleteTweetDocument = gql`
    mutation deleteTweet($tweetID: ULID!) {
  deleteTweet(tweetID: $tweetID) {
    id
  }
}
    `;
export type DeleteTweetMutationFn = Apollo.MutationFunction<DeleteTweetMutation, DeleteTweetMutationVariables>;

/**
 * __useDeleteTweetMutation__
 *
 * To run a mutation, you first call `useDeleteTweetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTweetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTweetMutation, { data, loading, error }] = useDeleteTweetMutation({
 *   variables: {
 *      tweetID: // value for 'tweetID'
 *   },
 * });
 */
export function useDeleteTweetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTweetMutation, DeleteTweetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTweetMutation, DeleteTweetMutationVariables>(DeleteTweetDocument, options);
      }
export type DeleteTweetMutationHookResult = ReturnType<typeof useDeleteTweetMutation>;
export type DeleteTweetMutationResult = Apollo.MutationResult<DeleteTweetMutation>;
export type DeleteTweetMutationOptions = Apollo.BaseMutationOptions<DeleteTweetMutation, DeleteTweetMutationVariables>;
export const AddTweetFavoriteDocument = gql`
    mutation addTweetFavorite($tweetID: ULID!) {
  addTweetFavorite(tweetID: $tweetID) {
    ...TweetFavorite
  }
}
    ${TweetFavoriteFragmentDoc}`;
export type AddTweetFavoriteMutationFn = Apollo.MutationFunction<AddTweetFavoriteMutation, AddTweetFavoriteMutationVariables>;

/**
 * __useAddTweetFavoriteMutation__
 *
 * To run a mutation, you first call `useAddTweetFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTweetFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTweetFavoriteMutation, { data, loading, error }] = useAddTweetFavoriteMutation({
 *   variables: {
 *      tweetID: // value for 'tweetID'
 *   },
 * });
 */
export function useAddTweetFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<AddTweetFavoriteMutation, AddTweetFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTweetFavoriteMutation, AddTweetFavoriteMutationVariables>(AddTweetFavoriteDocument, options);
      }
export type AddTweetFavoriteMutationHookResult = ReturnType<typeof useAddTweetFavoriteMutation>;
export type AddTweetFavoriteMutationResult = Apollo.MutationResult<AddTweetFavoriteMutation>;
export type AddTweetFavoriteMutationOptions = Apollo.BaseMutationOptions<AddTweetFavoriteMutation, AddTweetFavoriteMutationVariables>;
export const DeleteTweetFavoriteDocument = gql`
    mutation deleteTweetFavorite($tweetID: ULID!) {
  deleteTweetFavorite(tweetID: $tweetID) {
    ...TweetFavorite
  }
}
    ${TweetFavoriteFragmentDoc}`;
export type DeleteTweetFavoriteMutationFn = Apollo.MutationFunction<DeleteTweetFavoriteMutation, DeleteTweetFavoriteMutationVariables>;

/**
 * __useDeleteTweetFavoriteMutation__
 *
 * To run a mutation, you first call `useDeleteTweetFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTweetFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTweetFavoriteMutation, { data, loading, error }] = useDeleteTweetFavoriteMutation({
 *   variables: {
 *      tweetID: // value for 'tweetID'
 *   },
 * });
 */
export function useDeleteTweetFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTweetFavoriteMutation, DeleteTweetFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTweetFavoriteMutation, DeleteTweetFavoriteMutationVariables>(DeleteTweetFavoriteDocument, options);
      }
export type DeleteTweetFavoriteMutationHookResult = ReturnType<typeof useDeleteTweetFavoriteMutation>;
export type DeleteTweetFavoriteMutationResult = Apollo.MutationResult<DeleteTweetFavoriteMutation>;
export type DeleteTweetFavoriteMutationOptions = Apollo.BaseMutationOptions<DeleteTweetFavoriteMutation, DeleteTweetFavoriteMutationVariables>;
export const AddTweetCommentDocument = gql`
    mutation addTweetComment($input: TweetCommentInput!) {
  addTweetComment(input: $input) {
    ...TweetComment
  }
}
    ${TweetCommentFragmentDoc}`;
export type AddTweetCommentMutationFn = Apollo.MutationFunction<AddTweetCommentMutation, AddTweetCommentMutationVariables>;

/**
 * __useAddTweetCommentMutation__
 *
 * To run a mutation, you first call `useAddTweetCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTweetCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTweetCommentMutation, { data, loading, error }] = useAddTweetCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTweetCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddTweetCommentMutation, AddTweetCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTweetCommentMutation, AddTweetCommentMutationVariables>(AddTweetCommentDocument, options);
      }
export type AddTweetCommentMutationHookResult = ReturnType<typeof useAddTweetCommentMutation>;
export type AddTweetCommentMutationResult = Apollo.MutationResult<AddTweetCommentMutation>;
export type AddTweetCommentMutationOptions = Apollo.BaseMutationOptions<AddTweetCommentMutation, AddTweetCommentMutationVariables>;
export const DeleteTweetCommentDocument = gql`
    mutation deleteTweetComment($tweetCommentID: ULID!) {
  deleteTweetComment(tweetCommentID: $tweetCommentID) {
    ...TweetComment
  }
}
    ${TweetCommentFragmentDoc}`;
export type DeleteTweetCommentMutationFn = Apollo.MutationFunction<DeleteTweetCommentMutation, DeleteTweetCommentMutationVariables>;

/**
 * __useDeleteTweetCommentMutation__
 *
 * To run a mutation, you first call `useDeleteTweetCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTweetCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTweetCommentMutation, { data, loading, error }] = useDeleteTweetCommentMutation({
 *   variables: {
 *      tweetCommentID: // value for 'tweetCommentID'
 *   },
 * });
 */
export function useDeleteTweetCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTweetCommentMutation, DeleteTweetCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTweetCommentMutation, DeleteTweetCommentMutationVariables>(DeleteTweetCommentDocument, options);
      }
export type DeleteTweetCommentMutationHookResult = ReturnType<typeof useDeleteTweetCommentMutation>;
export type DeleteTweetCommentMutationResult = Apollo.MutationResult<DeleteTweetCommentMutation>;
export type DeleteTweetCommentMutationOptions = Apollo.BaseMutationOptions<DeleteTweetCommentMutation, DeleteTweetCommentMutationVariables>;
export const GetUserForUserPageLayoutDocument = gql`
    query getUserForUserPageLayout($id: Uint64!) {
  user(id: $id) {
    ...UserPageLayout
  }
}
    ${UserPageLayoutFragmentDoc}`;

/**
 * __useGetUserForUserPageLayoutQuery__
 *
 * To run a query within a React component, call `useGetUserForUserPageLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserForUserPageLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserForUserPageLayoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserForUserPageLayoutQuery(baseOptions: Apollo.QueryHookOptions<GetUserForUserPageLayoutQuery, GetUserForUserPageLayoutQueryVariables> & ({ variables: GetUserForUserPageLayoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserForUserPageLayoutQuery, GetUserForUserPageLayoutQueryVariables>(GetUserForUserPageLayoutDocument, options);
      }
export function useGetUserForUserPageLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserForUserPageLayoutQuery, GetUserForUserPageLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserForUserPageLayoutQuery, GetUserForUserPageLayoutQueryVariables>(GetUserForUserPageLayoutDocument, options);
        }
export function useGetUserForUserPageLayoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserForUserPageLayoutQuery, GetUserForUserPageLayoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserForUserPageLayoutQuery, GetUserForUserPageLayoutQueryVariables>(GetUserForUserPageLayoutDocument, options);
        }
export type GetUserForUserPageLayoutQueryHookResult = ReturnType<typeof useGetUserForUserPageLayoutQuery>;
export type GetUserForUserPageLayoutLazyQueryHookResult = ReturnType<typeof useGetUserForUserPageLayoutLazyQuery>;
export type GetUserForUserPageLayoutSuspenseQueryHookResult = ReturnType<typeof useGetUserForUserPageLayoutSuspenseQuery>;
export type GetUserForUserPageLayoutQueryResult = Apollo.QueryResult<GetUserForUserPageLayoutQuery, GetUserForUserPageLayoutQueryVariables>;
export const GetUserProfileDocument = gql`
    query getUserProfile($id: Uint64!) {
  user(id: $id) {
    ...UserProfile
  }
}
    ${UserProfileFragmentDoc}`;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserProfileQuery(baseOptions: Apollo.QueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables> & ({ variables: GetUserProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
      }
export function useGetUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export function useGetUserProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export type GetUserProfileQueryHookResult = ReturnType<typeof useGetUserProfileQuery>;
export type GetUserProfileLazyQueryHookResult = ReturnType<typeof useGetUserProfileLazyQuery>;
export type GetUserProfileSuspenseQueryHookResult = ReturnType<typeof useGetUserProfileSuspenseQuery>;
export type GetUserProfileQueryResult = Apollo.QueryResult<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const GetUserWithProgramsDocument = gql`
    query getUserWithPrograms($id: Uint64!) {
  user(id: $id) {
    ...UserPageLayout
    completedPrograms {
      ...UserProgram
    }
    whileStudyingPrograms {
      ...UserProgram
    }
  }
}
    ${UserPageLayoutFragmentDoc}
${UserProgramFragmentDoc}`;

/**
 * __useGetUserWithProgramsQuery__
 *
 * To run a query within a React component, call `useGetUserWithProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWithProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWithProgramsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserWithProgramsQuery(baseOptions: Apollo.QueryHookOptions<GetUserWithProgramsQuery, GetUserWithProgramsQueryVariables> & ({ variables: GetUserWithProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWithProgramsQuery, GetUserWithProgramsQueryVariables>(GetUserWithProgramsDocument, options);
      }
export function useGetUserWithProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWithProgramsQuery, GetUserWithProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWithProgramsQuery, GetUserWithProgramsQueryVariables>(GetUserWithProgramsDocument, options);
        }
export function useGetUserWithProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserWithProgramsQuery, GetUserWithProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserWithProgramsQuery, GetUserWithProgramsQueryVariables>(GetUserWithProgramsDocument, options);
        }
export type GetUserWithProgramsQueryHookResult = ReturnType<typeof useGetUserWithProgramsQuery>;
export type GetUserWithProgramsLazyQueryHookResult = ReturnType<typeof useGetUserWithProgramsLazyQuery>;
export type GetUserWithProgramsSuspenseQueryHookResult = ReturnType<typeof useGetUserWithProgramsSuspenseQuery>;
export type GetUserWithProgramsQueryResult = Apollo.QueryResult<GetUserWithProgramsQuery, GetUserWithProgramsQueryVariables>;
export const GetCurrentUserWithPermissionsDocument = gql`
    query getCurrentUserWithPermissions {
  currentUserWithPermissions {
    ...CurrentUserWithPermissionList
  }
}
    ${CurrentUserWithPermissionListFragmentDoc}`;

/**
 * __useGetCurrentUserWithPermissionsQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserWithPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserWithPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserWithPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserWithPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserWithPermissionsQuery, GetCurrentUserWithPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserWithPermissionsQuery, GetCurrentUserWithPermissionsQueryVariables>(GetCurrentUserWithPermissionsDocument, options);
      }
export function useGetCurrentUserWithPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserWithPermissionsQuery, GetCurrentUserWithPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserWithPermissionsQuery, GetCurrentUserWithPermissionsQueryVariables>(GetCurrentUserWithPermissionsDocument, options);
        }
export function useGetCurrentUserWithPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserWithPermissionsQuery, GetCurrentUserWithPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserWithPermissionsQuery, GetCurrentUserWithPermissionsQueryVariables>(GetCurrentUserWithPermissionsDocument, options);
        }
export type GetCurrentUserWithPermissionsQueryHookResult = ReturnType<typeof useGetCurrentUserWithPermissionsQuery>;
export type GetCurrentUserWithPermissionsLazyQueryHookResult = ReturnType<typeof useGetCurrentUserWithPermissionsLazyQuery>;
export type GetCurrentUserWithPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserWithPermissionsSuspenseQuery>;
export type GetCurrentUserWithPermissionsQueryResult = Apollo.QueryResult<GetCurrentUserWithPermissionsQuery, GetCurrentUserWithPermissionsQueryVariables>;
export const GetAiUserDocument = gql`
    query getAIUser {
  aiUser {
    ...QuestionUser
  }
}
    ${QuestionUserFragmentDoc}`;

/**
 * __useGetAiUserQuery__
 *
 * To run a query within a React component, call `useGetAiUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAiUserQuery, GetAiUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiUserQuery, GetAiUserQueryVariables>(GetAiUserDocument, options);
      }
export function useGetAiUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiUserQuery, GetAiUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiUserQuery, GetAiUserQueryVariables>(GetAiUserDocument, options);
        }
export function useGetAiUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiUserQuery, GetAiUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiUserQuery, GetAiUserQueryVariables>(GetAiUserDocument, options);
        }
export type GetAiUserQueryHookResult = ReturnType<typeof useGetAiUserQuery>;
export type GetAiUserLazyQueryHookResult = ReturnType<typeof useGetAiUserLazyQuery>;
export type GetAiUserSuspenseQueryHookResult = ReturnType<typeof useGetAiUserSuspenseQuery>;
export type GetAiUserQueryResult = Apollo.QueryResult<GetAiUserQuery, GetAiUserQueryVariables>;
export const WithdrawDocument = gql`
    mutation withdraw($questionnaireInput: WithdrawalQuestionnaireInput!) {
  withdraw(questionnaireInput: $questionnaireInput)
}
    `;
export type WithdrawMutationFn = Apollo.MutationFunction<WithdrawMutation, WithdrawMutationVariables>;

/**
 * __useWithdrawMutation__
 *
 * To run a mutation, you first call `useWithdrawMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawMutation, { data, loading, error }] = useWithdrawMutation({
 *   variables: {
 *      questionnaireInput: // value for 'questionnaireInput'
 *   },
 * });
 */
export function useWithdrawMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawMutation, WithdrawMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawMutation, WithdrawMutationVariables>(WithdrawDocument, options);
      }
export type WithdrawMutationHookResult = ReturnType<typeof useWithdrawMutation>;
export type WithdrawMutationResult = Apollo.MutationResult<WithdrawMutation>;
export type WithdrawMutationOptions = Apollo.BaseMutationOptions<WithdrawMutation, WithdrawMutationVariables>;
export const UpdateLastAccessDocument = gql`
    mutation updateLastAccess($smrc: String) {
  updateLastAccess(smrc: $smrc)
}
    `;
export type UpdateLastAccessMutationFn = Apollo.MutationFunction<UpdateLastAccessMutation, UpdateLastAccessMutationVariables>;

/**
 * __useUpdateLastAccessMutation__
 *
 * To run a mutation, you first call `useUpdateLastAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLastAccessMutation, { data, loading, error }] = useUpdateLastAccessMutation({
 *   variables: {
 *      smrc: // value for 'smrc'
 *   },
 * });
 */
export function useUpdateLastAccessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLastAccessMutation, UpdateLastAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLastAccessMutation, UpdateLastAccessMutationVariables>(UpdateLastAccessDocument, options);
      }
export type UpdateLastAccessMutationHookResult = ReturnType<typeof useUpdateLastAccessMutation>;
export type UpdateLastAccessMutationResult = Apollo.MutationResult<UpdateLastAccessMutation>;
export type UpdateLastAccessMutationOptions = Apollo.BaseMutationOptions<UpdateLastAccessMutation, UpdateLastAccessMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UserInput!) {
  updateUser(input: $input) {
    id
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const RegisterDocument = gql`
    mutation register($input: UserRegisterInput!) {
  register(input: $input) {
    id
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const OAuthRegisterDocument = gql`
    mutation oAuthRegister($input: OAuthUserRegisterInput!) {
  oAuthRegister(input: $input) {
    ...CurrentUser
  }
}
    ${CurrentUserFragmentDoc}`;
export type OAuthRegisterMutationFn = Apollo.MutationFunction<OAuthRegisterMutation, OAuthRegisterMutationVariables>;

/**
 * __useOAuthRegisterMutation__
 *
 * To run a mutation, you first call `useOAuthRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOAuthRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oAuthRegisterMutation, { data, loading, error }] = useOAuthRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOAuthRegisterMutation(baseOptions?: Apollo.MutationHookOptions<OAuthRegisterMutation, OAuthRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OAuthRegisterMutation, OAuthRegisterMutationVariables>(OAuthRegisterDocument, options);
      }
export type OAuthRegisterMutationHookResult = ReturnType<typeof useOAuthRegisterMutation>;
export type OAuthRegisterMutationResult = Apollo.MutationResult<OAuthRegisterMutation>;
export type OAuthRegisterMutationOptions = Apollo.BaseMutationOptions<OAuthRegisterMutation, OAuthRegisterMutationVariables>;